/**
 * EVO — i18n.
 *
 * TZ §4 uchta tilni talab qiladi: uz / ru / en.
 * MVP_PLAN §4.6 dagi qat'iy qoida: «tekstlar kodga yozilmaydi, tarjima keyin qo'shilsa ham».
 *
 * Shuning uchun bu fayl 1-kundan bor va JSX'da bironta qattiq yozilgan matn qolmaydi.
 * Kalitni unutish MUMKIN EMAS: `uz` lug'ati yagona manba, `TranslationKey` undan
 * chiqariladi, `t('...')` noto'g'ri kalit bilan kompilyatsiya qilinmaydi.
 *
 * ru/en tarjimalari ALOHIDA FAYLLARDA (`i18n.ru.ts`, `i18n.en.ts`) va ular
 * qisman to'ldirilishi mumkin — topilmagan kalit `uz` ga qaytadi. Bu
 * ataylab: yarim tarjima qilingan ekran bo'sh ekrandan yaxshi.
 */
import { ru } from './i18n.ru';
import { en } from './i18n.en';

export const LOCALES = ['uz', 'ru', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'uz';

/**
 * O'zbekcha lug'at — yagona to'liq manba (source of truth).
 * Yangi kalit AVVAL shu yerga qo'shiladi, keyin ishlatiladi.
 */
const uz = {
  // --- Umumiy ---
  /*
   * ╔══════════════════════════════════════════════════════════════════════╗
   * ║ BU YERDA NOM KALITLARI YO'Q — ATAYLAB (2026-08-15)                   ║
   * ║                                                                      ║
   * ║ `app.name`, `app.brandSuffix` va `app.tagline` OLIB TASHLANDI.       ║
   * ║ Egasi ekrandagi nom yozuvlarini olib tashlashni so'radi: yon menyuda ║
   * ║ ham, kirish ekranida ham endi FAQAT EMBLEMA turadi. Ya'ni bu uchta   ║
   * ║ kalitni o'qiydigan birorta ekran qolmadi.                            ║
   * ║                                                                      ║
   * ║ Ular «kelajakda kerak bo'lar» deb qoldirilmadi: o'qilmaydigan kalit  ║
   * ║ tarjima qilinaveradi, ro'yxatda o'rin egallaydi va bir kun kimdir    ║
   * ║ uni «ishlatilyapti» deb o'ylab, unga tayanadi. Kerak bo'lsa qaytarish║
   * ║ — bir qator.                                                         ║
   * ║                                                                      ║
   * ║ Nom butunlay yo'qolgani yo'q: u brauzer tabida turadi va u yerda     ║
   * ║ statik matn (`index.html` → `<title>Alight — Electrical</title>`).   ║
   * ║                                                                      ║
   * ║ ⚠️ QUTIDAGI QR KODLARGA TEGILMADI. Ular `EVO-XXXXXXXXXX-X`           ║
   * ║ ko'rinishida FIZIK mahsulotga bosilgan (`usta` ilovasidagi           ║
   * ║ `scan.manual.placeholder`). Kod — ma'lumot, nom emas.                ║
   * ╚══════════════════════════════════════════════════════════════════════╝
   */
  'month.1': 'Yanvar',
  'month.2': 'Fevral',
  'month.3': 'Mart',
  'month.4': 'Aprel',
  'month.5': 'May',
  'month.6': 'Iyun',
  'month.7': 'Iyul',
  'month.8': 'Avgust',
  'month.9': 'Sentyabr',
  'month.10': 'Oktyabr',
  'month.11': 'Noyabr',
  'month.12': 'Dekabr',
  'norm.title': 'Intizom normativi',
  'norm.standard': 'Kompaniya standarti',
  'norm.overridden': '{count} ta oy o‘zgartirilgan',
  'norm.month': 'Oy',
  'norm.purchase': 'Xarid / qoldiq, %',
  'norm.payment': 'To‘lov / xarid, %',
  'norm.collection': 'To‘lov / (qoldiq+xarid), %',
  'norm.reset': 'Standartga qaytarish',
  'norm.invalid': 'Foiz formati noto‘g‘ri: 0..5000, ikkitagacha kasr xona.',
  'norm.hint': 'BO‘SH katak — kompaniya standarti qo‘llanadi (kulrangda ko‘rinib turadi) va u kelasi yil o‘zgarganda bu mijozda ham o‘zi o‘zgaradi. To‘ldirilgan katak esa faqat o‘sha oyni bosadi — «bu dilerning dekabri boshqacha» degan istisno shunday yoziladi. Normativ hisobotda ishlatiladi: «Hisobotlar → Mijoz intizomi».',
  'common.loading': 'Yuklanmoqda…',
  'common.save': 'Saqlash',
  'common.cancel': 'Bekor qilish',
  'common.edit': 'Tahrirlash',
  'common.close': 'Yopish',
  'common.retry': 'Qayta urinish',
  'common.search': 'Qidirish',
  'common.prev': 'Oldingi',
  'common.next': 'Keyingi',

  // --- Qayerda bor? (kompaniya bo'ylab qoldiq) ---
  'availability.title': 'Qayerda bor?',
  'availability.hint':
    'Barcha filial va bosh ombordagi qoldiq. Sizning filialingizda tugagan tovar boshqa omborda bo‘lishi mumkin — shu yerdan ko‘rasiz.',
  'availability.search': 'Mahsulot',
  'availability.searchPlaceholder': 'Kod yoki nom…',
  'availability.scarceOnly': 'Faqat tugab qolganlar',
  'availability.totalAvailable': 'Jami mavjud',
  'availability.inTransit': 'Yo‘lda',
  'availability.transitShort': 'yo‘lda',
  'availability.scarce': 'Tugab qolgan',
  'availability.empty': 'Mahsulot topilmadi',
  'availability.emptyHint': 'Kod yoki nomni tekshiring. Qoldig‘i nolga teng tovarlar ro‘yxatga kirmaydi.',
  'availability.total': '{count} ta mahsulot',
  'common.noData': "Ma'lumot yo'q",
  'common.error': 'Xatolik',
  'common.unknownError': "Noma'lum xatolik yuz berdi",
  'common.networkError': "Serverga ulanib bo'lmadi. Internetni tekshiring.",
  'common.today': 'Bugun',
  'common.yes': 'Ha',
  'common.no': "Yo'q",
  'common.back': 'Orqaga',
  'common.create': 'Yaratish',
  'common.creating': 'Yaratilmoqda…',
  'common.saving': 'Saqlanmoqda…',
  'common.saved': 'Saqlandi',
  'common.reload': 'Qayta yuklash',
  'common.clear': 'Tozalash',
  'common.notSet': 'Belgilanmagan',
  'common.reason': 'Sabab',
  'common.optional': 'ixtiyoriy',
  'common.remove': 'O‘chirish',
  'common.apply': 'Qo‘llash',
  'common.refresh': 'Yangilash',
  'common.of': '{done} / {total}',

  // --- Qidiruv (GAP_ANALYSIS §A2, §C3) ---
  'search.hint': "«/» tugmasi qidiruvga o'tkazadi",
  'search.clear': 'Qidiruvni tozalash',
  'search.searching': 'Qidirilmoqda…',
  'search.noResults': 'Hech narsa topilmadi',
  'search.openResult': 'Ochish',

  /*
   * --- Buyruq paneli (Ctrl+K) — TZ v8.0 §8, TZ v4.0 §7 ---
   *
   * «/» tugmasi EKRAN ICHIDAGI qidiruvniki (`search.hint`, yuqorida) va u
   * o'zgarmaydi. Global panel faqat Ctrl+K bilan ochiladi — ikkita tugmaga
   * ikkita aniq ma'no.
   */
  'search.commandOpen': 'Global qidiruv (Ctrl+K)',
  'search.commandTitle': 'Global qidiruv',
  'search.commandPlaceholder':
    'Hujjat raqami, SKU, barkod, mijoz, telefon… — masalan SO-2026-00042',
  'search.commandHint': 'Kamida 2 ta belgi kiriting',
  'search.commandKeys': '↑ ↓ — tanlash · Enter — ochish · Esc — yopish',
  'search.commandFailed': 'Qidiruvni bajarib bo‘lmadi. Qayta urinib ko‘ring.',
  'search.recentTitle': 'Oxirgi ochilganlar',
  'search.sectionsTitle': 'Bo‘limlar',
  // --- Klaviatura tugmalari (`components/shortcuts-help.tsx`) ---
  'keys.title': 'Klaviatura tugmalari',
  'keys.hint': 'Bu oynani istalgan joyda «?» bosib ochasiz.',
  'keys.palette': 'Qidiruv va bo‘limlar oynasi',
  'keys.help': 'Shu oynani ochish',
  'keys.focusSearch': 'Ekrandagi qidiruvga o‘tish',
  'keys.completeSale': 'Sotuvni YAKUNLASH — pul harakati bo‘ladi',
  'keys.newSale': 'Yangi sotuv boshlash',
  'keys.openRow': 'Satrni ochish',
  'keys.addRow': 'Yangi satr qo‘shish',
  'keys.close': 'Oynani yopish',
  'keys.move': 'Ro‘yxatda yuqoriga/pastga',
  'keys.where.anywhere': 'hamma joyda',
  'keys.where.outsideField': 'maydondan tashqarida',
  'keys.where.listScreens': 'ro‘yxat ekranlarida',
  'keys.where.directSale': 'to‘g‘ridan-to‘g‘ri sotuv',
  'keys.where.tables': 'jadvallarda',
  'keys.where.editTables': 'tahrirlanadigan jadvalda',
  'keys.where.dialogs': 'oynalarda',
  'keys.where.lists': 'ro‘yxatlarda',
  'search.inactive': 'faol emas',

  // Natija guruhlari sarlavhalari (`lib/search.ts` — SEARCH_TYPE_LABELS)
  'search.type.product': 'Mahsulotlar',
  'search.type.customer': 'Mijozlar',
  'search.type.supplier': "Ta'minotchilar",
  'search.type.salesOrder': 'Sotuv buyurtmalari',
  'search.type.purchaseOrder': 'Xarid buyurtmalari',
  'search.type.shipment': 'Konteynerlar',
  'search.type.invoice': 'Hisob-fakturalar',
  'search.type.payment': "To'lovlar",
  'search.type.return': 'Qaytarishlar',
  'search.type.installer': 'Ustalar',
  /*
   * Guruh sarlavhasi BORADIGAN EKRAN nomi bilan bir xil (`nav.*`), hujjat
   * turining rasmiy nomi bilan emas: `DLV-…` — «yuk xati», lekin bosilganda
   * «Yetkazishlar» ekrani ochiladi va ikki xil nom foydalanuvchini
   * «men boshqa joyga tushdim» degan fikrga olib borardi.
   */
  'search.type.delivery': 'Yetkazishlar',
  'search.type.creditNote': 'Kredit-notalar',
  'search.type.expense': 'Filial xarajatlari',
  'search.type.goodsReceipt': 'Tovar qabuli',
  'search.type.employee': 'Xodimlar',

  // --- Forma ---
  'form.required': "Bu maydon to'ldirilishi shart",
  'form.hasErrors': 'Formada xatolar bor — belgilangan maydonlarni tekshiring',

  // --- Mahsulot ---
  'product.title': 'Mahsulotlar',

  // --- Ma'lumotnoma boshqaruvi (`routes/reference`, 2026-08-15) ---
  'ref.categories': 'Kategoriyalar',
  'ref.brands': 'Brendlar',
  'ref.uoms': 'O‘lchov birliklari',
  'ref.newTitle': 'Yangi yozuv',
  'ref.editTitle': 'Yozuvni tahrirlash',
  'ref.code': 'Kod',
  'ref.name': 'Nomi',
  'ref.parent': 'Ota kategoriya',
  'ref.parentRoot': '— ildiz (ota yo‘q) —',
  'ref.status': 'Holat',
  'ref.active': 'Faol',
  'ref.archivedBadge': 'Arxivda',
  'ref.archive': 'Arxivlash',
  'ref.restore': 'Tiklash',
  'ref.showArchived': 'Arxivlanganlarni ham ko‘rsatish',
  'ref.total': 'Jami: {count}',
  'ref.empty': 'Hozircha yozuv yo‘q — yuqoridagi forma bilan qo‘shing',
  'ref.created': 'Qo‘shildi',
  'ref.updated': 'Saqlandi',
  'ref.archived': 'Arxivlandi',
  'ref.restored': 'Tiklandi',
  'ref.archiveHint':
    'Yozuvlar O‘CHIRILMAYDI, arxivlanadi: unga bog‘langan mahsulotlar o‘z kategoriyasini va brendini ko‘rsatib turishi kerak, aks holda o‘tgan yilgi hisobot boshqacha chiqardi. Arxivlangan yozuv yangi tanlovlarda ko‘rinmaydi.',
  'product.new': 'Yangi mahsulot',
  'product.newTitle': 'Yangi mahsulot yaratish',
  'product.searchPlaceholder': "SKU, nom yoki eski 1C kodi bo'yicha qidirish",
  'product.sku': 'SKU',
  'product.name': 'Nomi',
  'product.nameUz': "Nomi (o'zbekcha)",
  'product.nameRu': 'Nomi (ruscha)',
  'product.nameEn': 'Nomi (inglizcha)',
  'product.category': 'Kategoriya',
  'product.brand': 'Brend',
  /*
   * Katalog filtrlari va fayldan yuklash (2026-08-15).
   *
   * «Barchasi» — bo'sh tanlov, ya'ni filtrsiz. U ATAYLAB «—» emas: bo'sh
   * chiziqcha «tanlanmagan» degan ma'no beradi va operator ro'yxat
   * to'liqmi yoki filtrlanganmi ekanini bilmasdi.
   */
  'product.categoryAll': 'Barcha kategoriyalar',
  'product.brandAll': 'Barcha brendlar',
  'product.importFile': 'Fayldan yuklash',
  'product.uom': "O'lchov birligi",
  'product.availableStock': 'Erkin qoldiq',
  'product.avgCost': "O'rtacha tannarx",
  'product.avgCostHint':
    "Tannarx ombor harakatlaridan hisoblanadi va qo'lda kiritilmaydi.",
  'product.costBlock': 'Tannarx',
  'product.description': 'Tavsif',
  'product.weightKg': "Og'irlik, kg",
  'product.volumeM3': 'Hajm, m³',
  'product.minStock': 'Minimal qoldiq',
  'product.maxStock': 'Maksimal qoldiq',
  'product.reorderPoint': 'Qayta buyurtma nuqtasi',
  'product.vatRate': 'QQS stavkasi, %',
  /* Bo'sh katak «nol» emas — «standartni qo'y». Placeholder shuni aytadi. */
  'product.vatRatePlaceholder': 'Standart (Sozlamalardan)',
  'product.vatRateHint':
    "Narx QQS BILAN ko'rsatiladi — soliq narxning ustiga qo'shilmaydi, undan ajratib olinadi. 12% da 11 200 so'mlik tovarda soliq 1 200 so'm. Eksport va imtiyozli tovarda 0 qoldiring: 0 «to'ldirilmagan» emas, «soliqsiz» degani.",
  'product.isSellable': 'Sotiladi',
  'product.isPurchasable': 'Xarid qilinadi',
  'product.attributes': 'Xususiyatlar',
  'product.aliases': 'Muqobil kodlar',
  'product.aliasesHint':
    "Eski 1C, ta'minotchi yoki qadoq kodi. Xodim uni yana oylab teradi — kiritilmasa qidiruv bo'sh chiqadi va dublikat tug'iladi.",
  'product.alias': 'Kod',
  'product.aliasType': 'Turi',
  'product.aliasSource': 'Manba',
  'product.aliasAdd': "Kod qo'shish",
  'product.aliasRemove': "Kodni o'chirish",
  'product.aliasType.legacy': 'Eski tizim',
  'product.aliasType.adines': 'Adines',
  'product.aliasType.1c': '1C',
  'product.aliasType.supplier': "Ta'minotchi",
  'product.aliasType.custom': 'Boshqa',
  'product.status': 'Holat',
  'product.active': 'Faol',
  'product.archived': 'Arxivlangan',
  'product.version': 'Versiya',
  'product.updatedAt': "Oxirgi o'zgarish",
  'product.empty': 'Mahsulot topilmadi',
  'product.emptyHint': "Katalog hali bo'sh yoki filtr juda tor.",
  'product.emptySearch': "«{q}» bo'yicha mahsulot topilmadi",
  'product.emptySearchHint':
    "Eski kod bilan ham urinib ko'ring — qidiruv lotin va kirill yozuvini bir xil ko'radi.",
  'product.loadError': "Mahsulotlar ro'yxatini yuklab bo'lmadi",
  'product.notFound': 'Mahsulot topilmadi yoki sizga ko\'rinmaydi',
  'product.selectCategory': 'Kategoriyani tanlang',
  'product.noBrand': 'Brendsiz',
  'product.saved': "O'zgarishlar saqlandi",
  'product.created': 'Mahsulot yaratildi',
  'product.editTitle': 'Mahsulotni tahrirlash',

  // Optimistik qulf — 409
  'product.conflict.title': 'Yozuv boshqa foydalanuvchi tomonidan o\'zgartirilgan',
  'product.conflict.body':
    "Siz bu kartochkani ochib turganingizda kimdir uni saqlab ulgurdi. Sizning o'zgarishlaringiz YOZILMADI — eski ma'lumot ustidan yozib yubormaslik uchun. Yangi holatni yuklang va tahrirni qaytadan kiriting.",
  'product.conflict.reload': 'Yangi holatni yuklash',

  // Yaqin dublikat — 422 (GAP_ANALYSIS §A2)
  'product.duplicate.title': "Shunga o'xshash mahsulot allaqachon bor",
  'product.duplicate.body':
    "Quyidagilar katalogda mavjud. Avval ularni tekshiring: bir mahsulot ikkita SKU bilan yozilsa, qoldiq va tannarx ikkiga bo'linib ketadi.",
  'product.duplicate.force': 'Baribir yaratish',
  'product.duplicate.cancel': 'Bekor qilish va tekshirish',
  'product.skuExists': 'Bunday SKU allaqachon mavjud — boshqa kod tanlang',

  // --- Mijoz ---
  'customer.title': 'Mijozlar',
  'customer.searchPlaceholder': 'Kod, nom yoki telefon',
  'customer.searchHint':
    "Telefonni xohlagan ko'rinishda yozing: +998 90 123-45-67 ham, 901234567 ham topadi.",
  'customer.newTitle': 'Yangi mijoz',
  'customer.newHint': 'Kredit limiti, shartnoma shartlari va intizom normativi bu yerda EMAS — ular kartochka ochilgandan keyin, o‘z bo‘limlarida qo‘yiladi va boshqa ruxsat talab qiladi. Saqlagandan so‘ng ekran kartochkaga o‘tadi.',
  'customer.codeHint': 'Takrorlanmas kod. Keyin o‘zgartirib bo‘lmaydi — u hujjatlarda havola bo‘lib turadi.',
  'customer.priceList': 'Narx ro‘yxati',
  'customer.priceListDefault': '— standart ro‘yxat —',
  'customer.code': 'Kod',
  'customer.name': 'Nomi',
  'customer.type': 'Turi',
  'customer.type.retail': 'Chakana',
  'customer.type.wholesale': 'Ulgurji',
  'customer.type.dealer': 'Diler',
  'customer.type.key_account': 'Yirik mijoz',
  'customer.phone': 'Telefon',
  'customer.email': 'Email',
  'customer.address': 'Manzil',
  'customer.taxId': 'STIR',
  'customer.profile': "Umumiy ma'lumot",
  'customer.contacts': 'Kontaktlar',
  'customer.contactsEmpty': 'Kontakt kiritilmagan',
  'customer.contactsOrg': 'Tashkilot rekvizitlari',
  'customer.contactsPeople': 'Vakillar',
  'customer.contactsPeopleHint':
    "Buyurtmani bir kishi beradi, to'lovni boshqasi qiladi — kimga qo'ng'iroq qilish kerakligi shu yerda.",
  'customer.contactPrimary': 'Asosiy',
  'customer.contactsLoadError': "Kontaktlarni yuklab bo'lmadi",
  'customer.credit': 'Kredit shartlari',
  'customer.creditLimit': 'Kredit limiti',
  'customer.creditLimitNone': 'Limit belgilanmagan',
  'customer.creditEdit': "Kredit shartlarini o'zgartirish",
  'customer.creditEditTitle': 'Kredit shartlari',
  'customer.creditEditHint':
    "Limit — mijozga qancha qarzga tovar berish mumkinligi. Uni oshirishdan oldin mijozning JORIY qarzini «Mijoz qarzi (AR)» hisobotidan tekshiring: limit va qarz ikki xil raqam.",
  'customer.creditLimitAmount': 'Limit summasi',
  'customer.creditLimitCurrency': 'Limit valyutasi',
  'customer.creditLimitZeroHint': "0 — limitsiz emas, «qarzga berilmaydi» degani.",
  'customer.creditTermDays': "To'lov muddati (kun)",
  'customer.creditTermDaysHint': "0 — faqat oldindan to'lov. Eng ko'pi 365 kun.",
  'customer.creditAmountInvalid': "Summa manfiy bo'lmagan son bo'lishi kerak",
  'customer.creditTermInvalid': "Muddat 0 va 365 orasidagi butun son bo'lishi kerak",
  'customer.creditNoChanges': "Hech narsa o'zgartirilmadi",
  'customer.creditSaved': 'Kredit shartlari saqlandi',
  'customer.paymentTerms': "To'lov muddati",
  'customer.paymentTermsDays': '{days} kun',
  'customer.paymentTermsPrepaid': "Faqat oldindan to'lov",
  'customer.blocked': 'Bloklangan',
  'customer.notBlocked': 'Faol',
  'customer.archived': 'Arxivlangan',
  'customer.blockReason': 'Bloklash sababi',
  'customer.block': 'Bloklash',
  'customer.unblock': 'Blokdan chiqarish',
  'customer.blockTitle': 'Mijozni bloklash',
  'customer.unblockTitle': 'Mijozni blokdan chiqarish',
  'customer.blockHint':
    "Bloklangan mijoz ro'yxatda qoladi va qarzi hisoblanadi, lekin unga yangi buyurtma rasmiylashtirib bo'lmaydi.",
  'customer.blockReasonRequired': "Sabab kamida 3 ta belgidan iborat bo'lishi kerak",
  'customer.blockReasonWhy':
    "«Nega bloklangan?» degan savol bir haftadan keyin albatta beriladi — sabab audit jurnalida qoladi.",
  'customer.empty': 'Mijoz topilmadi',
  'customer.emptyHint': "Ro'yxat bo'sh yoki mijozlar sizga biriktirilmagan.",
  'customer.emptySearch': "«{q}» bo'yicha mijoz topilmadi",
  'customer.loadError': "Mijozlar ro'yxatini yuklab bo'lmadi",
  'customer.notFound': "Mijoz topilmadi yoki sizga ko'rinmaydi",

  // Kurs farqi siyosati — enum EMAS, jumla (DATA_MODEL §1.4, GAP_ANALYSIS §A6)
  'customer.fxPolicy': 'Kurs farqi kimga tushadi',
  'customer.fxPolicy.payment_date.short': "To'lov kunidagi kurs",
  'customer.fxPolicy.sale_date.short': 'Sotuv kunidagi kurs',
  'customer.fxPolicy.payment_date.full':
    "Dollardagi qarz so'mda to'langanda TO'LOV KUNIDAGI kurs qo'llanadi — kurs o'zgarishidan kelib chiqqan farqni MIJOZ qoplaydi.",
  'customer.fxPolicy.sale_date.full':
    "Dollardagi qarz so'mda to'langanda SOTUV KUNIDAGI kurs qotiriladi — kurs o'zgarishidan kelib chiqqan farqni KOMPANIYA o'z zimmasiga oladi.",

  // --- Auth ---
  /*
   * Kirish ekranida FAQAT kirishga tegishli matnlar qoldi.
   *
   * Bu yerda «Xitoydan import → real tannarx → ombor → sotuv → pul»
   * zanjiri va va'da matni turardi. Egasi ularni olib tashlashni so'radi
   * (2026-08-17): ekranni har kuni O'Z xodimlari ochadi va ularga
   * dasturning nima qilishini tushuntirish kerak emas.
   */
  'auth.login.title': 'Tizimga kirish',
  'auth.login.subtitle': 'Email va parolingizni kiriting',
  'auth.email': 'Email',
  'auth.email.placeholder': 'ism@kompaniya.uz',
  'auth.password': 'Parol',
  'auth.password.placeholder': 'Parolingiz',
  'auth.submit': 'Kirish',
  'auth.submitting': 'Kirilmoqda…',
  'auth.error.invalidCredentials': "Email yoki parol noto'g'ri",
  'auth.error.required': "Email va parol to'ldirilishi shart",
  'auth.logout': 'Chiqish',
  'auth.sessionExpired': 'Sessiya muddati tugadi. Qaytadan kiring.',
  'auth.restoring': 'Sessiya tiklanmoqda…',

  // --- Kurs vidjeti ---
  'fx.title': 'Kunlik kurs',
  'fx.rateLine': '1 USD = {rate}',
  'fx.missing': 'Bugungi kurs kiritilmagan',
  'fx.missingHint': 'Kurssiz kiritilgan hujjatlar keyin qayta hisoblanmaydi.',
  'fx.stale': 'Oxirgi kurs: {date}',
  'fx.edit': 'Kursni kiritish',
  'fx.editTitle': 'Bugungi kursni kiritish',
  'fx.loading': 'Kurs yuklanmoqda…',
  'fx.editHint':
    "Kiritilgandan keyingi hujjatlar shu kursni MUHRLAB oladi va keyin qayta hisoblanmaydi. Kurs noto'g'ri bo'lsa, hujjatni bekor qilib qayta yozish kerak bo'ladi.",
  'fx.uzsLabel': "1 USD = ? so'm (sotuv va kassa)",
  'fx.cnyLabel': '1 USD = ? ¥ (xarid, Xitoy zavodlari)',
  'fx.saved': 'Kurs saqlandi: {currencies}',
  'fx.noChange': "Qiymat o'zgarmadi",

  // --- Layout / navigatsiya ---
  'nav.skipToContent': 'Asosiy qismga o‘tish',
  'nav.menu': 'Menyu',
  'nav.branch': 'Filial',

  // Hisobotlar markazi (`routes/reports/hub.tsx`) — har hisobot O'ZI javob
  // beradigan savol bilan turadi, chunki «ABC» yoki «RFM» degan nom
  // foydalanuvchiga hech narsa aytmaydi.
  'nav.reportsHub': 'Hisobotlar markazi',
  'reportsHub.lead': 'Har bir hisobot bitta savolga javob beradi. Savolni tanlang — hisobot o‘zi ochiladi.',
  'reportsHub.searchPlaceholder': 'Hisobot yoki savol bo‘yicha qidirish',
  'reportsHub.empty': 'Bu so‘rov bo‘yicha hisobot topilmadi.',
  'reportsHub.themeSales': 'Savdo va mijozlar',
  'reportsHub.themeStock': 'Ombor va tovar',
  'reportsHub.themeMoney': 'Pul va qarz',
  'reportsHub.themeImport': 'Import va ta‘minot',
  'reportsHub.themeAccounting': 'Buxgalteriya',
  'reportsHub.themeOther': 'Boshqa',
  'reportsHub.hintSales': 'Qancha sotdik — kun, oy, filial, menejer va tovar kesimida.',
  'reportsHub.hintAgentActivity': 'Qaysi agent qancha ishladi va kimlar umuman harakat qilmadi.',
  'reportsHub.hintProfit': 'Sotuvdan qancha yalpi foyda qoldi — tannarx ayirilgandan keyin.',
  'reportsHub.hintRfm': 'Qaysi mijoz yaqinda, tez-tez va ko‘p sotib oladi — kimga e’tibor kerak.',
  'reportsHub.hintLtv': 'Bitta mijoz butun ish davomida qancha foyda keltirgan.',
  'reportsHub.hintCustomerProfit': 'Qaysi mijoz haqiqatda foydali, qaysi biri chegirma bilan zarar qilyapti.',
  'reportsHub.hintStock': 'Hozir qayerda qancha tovar bor — barcha filial va bosh ombor.',
  'reportsHub.hintStockValue': 'Omborda qancha pul qotib turibdi.',
  'reportsHub.hintDeadStock': 'Qaysi tovar uzoq vaqtdan beri qimirlamayapti.',
  'reportsHub.hintStockAge': 'Tovar omborda qancha vaqtdan beri yotibdi.',
  'reportsHub.hintAbc': 'Qaysi tovarlar aylanmaning asosiy qismini beradi — e’tibor shularga.',
  'reportsHub.hintXyz': 'Qaysi tovar barqaror sotiladi, qaysi biri to‘lqinli — zaxira shunga qarab.',
  'reportsHub.hintReorder': 'Nimani hoziroq buyurtma qilish kerak — tugab qolmasin.',
  'reportsHub.hintArAging': 'Kim qancha qarzdor va qarz necha kundan beri turibdi.',
  'reportsHub.hintCashFlow': 'Pul qayerdan kirdi, qayerga chiqdi — DDS maqolalari bo‘yicha.',
  'reportsHub.hintShipmentProfit': 'Qaysi yuk foyda keltirdi, qaysi biri zarar — tannarx bilan birga.',
  'reportsHub.hintContainer': 'Konteyner joyi qanchalik samarali ishlatilgan.',
  'reportsHub.hintSupplierScore': 'Qaysi zavod muddatida yetkazadi, qaysi biri kechiktiradi.',
  'reportsHub.hintIncomeStatement': 'Davr yakunida foyda yoki zarar — daromad va xarajat kesimida.',
  'reportsHub.hintBalanceSheet': 'Kompaniyada nima bor va kimga qarzdormiz — sana holatiga.',
  'reportsHub.hintEquity': 'Egasining ulushi qanday o‘zgardi.',
  'reportsHub.hintJournals': 'Har bir provodka — qaysi hujjatdan kelgani bilan.',
  'reportsHub.hintPeriods': 'Qaysi oy yopilgan, qaysi biri hali ochiq.',
  'nav.allBranches': 'Barcha filiallar',
  'nav.group.general': 'Umumiy',
  'nav.group.masterData': "Ma'lumotnoma",
  'nav.group.warehouse': 'Ombor',
  /* Bo'lim nomida «partner», «ta'minotchi tenant» kabi ichki atamalar YO'Q:
     bu yerga qaraydigan odam uchun fakt bitta — unga yuk kelyapti. */
  'nav.group.supply': "Ta'minot",
  'nav.incomingSupply': 'Kiruvchi yuk',
  'nav.group.procurement': 'Xarid va import',
  'nav.group.sales': 'Savdo',
  'nav.group.finance': 'Moliya',
  'nav.group.reports': 'Hisobotlar',
  'nav.group.system': 'Tizim',

  'nav.dashboard': 'Bosh sahifa',
  'nav.reference': 'Kategoriya va brendlar',
  'nav.products': 'Mahsulotlar',
  'nav.customers': 'Mijozlar',
  'nav.suppliers': "Ta'minotchilar",
  'nav.pricelists': 'Narx ro‘yxatlari',
  'nav.stock': 'Qoldiq',
  'nav.receipts': 'Kirim',
  'nav.issue': 'Chiqim',
  'nav.transfers': 'Ko‘chirish',
  'nav.counts': 'Inventarizatsiya',
  'nav.movements': 'Ombor daftari',
  'nav.purchaseOrders': 'Xarid buyurtmalari',
  'nav.shipments': 'Konteynerlar',
  'nav.costing': 'Tannarx bo‘limi',
  'nav.landedCost': 'Tannarx hisobi',
  'nav.salesOrders': 'Buyurtmalar',
  'nav.invoices': 'Hisob-fakturalar',
  'nav.returns': 'Qaytarishlar',
  'nav.returnsQuarantine': 'Karantin (QC)',
  'nav.payments': "To'lovlar",
  'nav.receivables': 'Mijoz qarzi (AR)',
  'nav.payables': "Ta'minotchi qarzi (AP)",
  'nav.supplierPayments': "Ta'minotchiga to‘lov",
  'nav.cashAccounts': 'Kassa va bank',
  'nav.fxRates': 'Valyuta kurslari',
  'nav.reportStock': 'Ombor qoldig‘i',
  'nav.reportStockValue': 'Ombor qiymati',
  'nav.reportSales': 'Savdo',
  'nav.reportProfit': 'Yalpi foyda',
  'nav.reportDiscipline': 'Mijoz intizomi',
  'nav.reportArAging': 'AR aging',
  'nav.reportApAging': 'AP aging',
  'nav.reportCashFlow': 'Pul harakati',
  'nav.reportDeadStock': 'Sekin harakatlanuvchi tovar',
  'nav.reportShipmentProfit': 'Konteyner rentabelligi',
  'nav.reportReorder': 'Qachon buyurtma berish',
  // --- Tahlil hisobotlari (TZ v4.0 §28 / CR-007) ---
  'nav.reportAbc': 'ABC tahlili',
  'nav.reportXyz': 'XYZ tahlili',
  'nav.reportRfm': 'RFM — mijozlar segmentatsiyasi',
  'nav.reportLtv': 'Mijozning umr qiymati (LTV)',
  'nav.reportSupplierScore': 'Ta’minotchi ko‘rsatkichi',
  'nav.reportContainer': 'Konteyner samaradorligi',
  'nav.reportStockAge': 'Ombor yoshi',
  'nav.reportCustomerProfit': 'Mijoz foydaliligi',
  'nav.users': 'Foydalanuvchilar',
  'nav.group.security': 'Xavfsizlik',
  'nav.settings': 'Sozlamalar',

  // --- Dashboard ---
  'dashboard.title': 'Bosh sahifa',
  'dashboard.welcome': 'Xush kelibsiz, {name}',
  'dashboard.subtitle': 'Ko‘rsatkichlar sizning ruxsatlaringiz bo‘yicha ko‘rsatiladi.',
  'dashboard.yourRole': 'Rolingiz',
  'dashboard.yourPermissions': 'Ruxsatlar soni',
  'dashboard.openReport': 'Hisobotni ochish →',
  'dashboard.empty': 'Sizga ko‘rsatiladigan ko‘rsatkich yo‘q',
  'dashboard.emptyHint':
    'Bu kutilgan holat bo‘lishi mumkin: har kartochka o‘z ruxsatini talab qiladi. Yon menyudagi ekranlar sizga ochiq.',

  'dashboard.salesToday': 'Bugungi savdo',
  'dashboard.salesTodayHint': 'Jo‘natilgan (posted) yuk xatlari bo‘yicha',
  'dashboard.salesMonth': 'Shu oy savdosi',
  'dashboard.salesLines': '{count} ta satr',
  'dashboard.grossProfitMonth': 'Yalpi foyda (shu oy)',
  // Izoh plitkada BIR QATOR: uzun matn «…jo‘natish sanasi bo‘y…» bo‘lib
  // so‘z o‘rtasidan qirqilardi. Yechim `title` emas, QISQA matn: hisoblash
  // usuli («jo‘natish sanasi bo‘yicha») hisobotning o‘zida yozilgan.
  'dashboard.grossProfitHint': 'Tushum − tannarx',
  'dashboard.arTotal': 'Mijoz qarzi (AR)',
  'dashboard.arHint': 'To‘lanmagan hisob-fakturalar qoldig‘i',
  'dashboard.arOverdue': 'Shundan kechikkan: {amount}',
  'dashboard.arCustomers': '{count} ta mijoz',
  'dashboard.stockValue': 'Ombor qiymati',
  'dashboard.stockValueHint': 'Landed cost bo‘yicha, {count} ta ombor',
  'dashboard.inTransitValue': 'Yo‘ldagi tovar qiymati',
  'dashboard.inTransitHint': 'Konteynerdagi, hali qabul qilinmagan tovar',
  'dashboard.inTransitQty': 'Yo‘ldagi miqdor: {qty}',
  'dashboard.inTransitTodo':
    'Qoldiq hisoboti yo‘ldagi tovarning MIQDORINI beradi, qiymatini emas.',
  'dashboard.stockSummary': 'Ombor qoldig‘i',
  'dashboard.stockSummaryHint': 'Qoldig‘i bor pozitsiyalar',
  'dashboard.stockSkuCount': '{count} ta SKU',
  'dashboard.deadStock': 'Sekin harakatlanuvchi tovar',
  'dashboard.deadStockHint': '{days} kundan beri chiqim bo‘lmagan',
  'dashboard.deadStockCount': '{count} ta pozitsiya',
  'dashboard.pendingTasks': 'Kutilayotgan ombor ishlari',
  'dashboard.pendingTasksHint': 'Qabul qilinmagan ko‘chirish va yopilmagan sanoq',
  'dashboard.pendingTransfers': 'Qabul qilinmagan ko‘chirish: {count} ta',
  'dashboard.pendingCounts': 'Ochiq inventarizatsiya: {count} ta',
  'dashboard.openTransfers': 'Ko‘chirishlarni ochish →',
  'dashboard.topCustomers': 'Eng yirik mijozlar',
  'dashboard.topCustomersHint': 'Shu oy tushumi bo‘yicha, birinchi beshtasi',
  'dashboard.cashFlowMonth': 'Pul harakati (shu oy)',
  'dashboard.cashFlowHint': 'Kirim − chiqim',
  'dashboard.cashIn': 'Kirim: {amount}',
  'dashboard.cashOut': 'Chiqim: {amount}',
  'dashboard.lastContainer': 'Oxirgi konteyner',
  'dashboard.lastContainerHint': 'Xarajat ulushi tovar narxiga nisbatan',

  // --- LOGISTIKA QATORI ---
  //
  // Bu ikki kalit ilgarigi «Oxirgi konteyner» va «Yo‘ldagi tovar qiymati»
  // plitkalarining o‘rniga keldi. Farq matnda emas, VAZNDA: endi bu bitta
  // qator va u yo‘lda tovar BO‘LGANDAGINA chiziladi.
  'dashboard.logistics.inTransit': 'Yo‘ldagi tovar',
  'dashboard.logistics.lastContainer': 'Oxirgi konteyner: {docNo}',

  // --- Davr tanlagich ---
  'period.title': 'Davr',
  'period.today': 'Bugun',
  'period.thisWeek': 'Shu hafta',
  'period.thisMonth': 'Shu oy',
  'period.lastMonth': 'O‘tgan oy',
  'period.thisYear': 'Shu yil',
  'period.from': 'Boshlanish',
  'period.to': 'Tugash',

  // --- Hisobotlar (umumiy) ---
  'report.export': 'Excel‘ga chiqarish',
  'report.exportHint':
    'Fayl ekrandagi satrlardan quriladi — serverga qo‘shimcha so‘rov yuborilmaydi.',
  /**
   * Excel varag‘ining ikkinchi qatori — fayl o‘zini tanitadi.
   *
   * «Fayl yaratildi» ATAYLAB, «ma’lumot shakllandi» emas: sana mijozda
   * olinadi va u faylni yasash vaqti. Ikkalasi deyarli har doim bir xil,
   * lekin «deyarli» — matn shu farqni yashirmasligi kerak.
   */
  'report.exportSubtitle': 'Fayl yaratildi: {at} · Satrlar: {count}',
  'report.exportEmpty': 'Chiqarish uchun satr yo‘q',
  'report.exportFailed': 'Faylni yuklab bo‘lmadi',
  'report.print': 'PDF',
  'report.printHint': 'Chop etish oynasi ochiladi — u yerda «Saqlash → PDF» bor',
  'report.generatedAt': 'Shakllandi: {at}',
  'report.currency': 'Valyuta: {currency}',
  /*
   * Blankada tashkilot nomi o'rniga chiqadi. ATAYLAB ko'zga tashlanadigan:
   * jim qolgan blanka nuqsonni yashirardi, «ALIGHT ELECTRICAL» ga qaytish
   * esa begona varaqqa bizning nomimizni qo'yardi (`lib/letterhead.ts`).
   */
  'report.orgUnknown': '⚠️ Tashkilot nomi aniqlanmadi',
  'report.asOf': 'Holat sanasi',
  'report.total': 'Jami',
  'report.loadError': 'Hisobotni yuklab bo‘lmadi',
  'report.empty': 'Bu shartlar bo‘yicha ma’lumot yo‘q',
  'report.emptyHint': 'Davrni kengaytiring yoki filtrni tekshiring.',
  'report.valueHidden':
    'Pul qiymati ustunlari sizga ko‘rsatilmaydi — bu ruxsat masalasi, xato emas.',

  /*
   * ==========================================================================
   * KAM MA'LUMOT SABABLARI — barcha tahlil hisobotlarida BIR XIL matn
   * ==========================================================================
   * Server sabab KODINI qaytaradi (`no_data`, `single_purchase`, …), ekran
   * uni jumlaga aylantiradi. Kalitlar umumiy, chunki sabab ham umumiy: bir
   * xil holat ikki ekranda ikki xil tushuntirilsa, foydalanuvchi ularni
   * boshqa-boshqa muammo deb o'ylardi.
   *
   * Har jumla NIMA QILISH kerakligini ham aytadi — «ma'lumot yetarli emas»
   * degan quruq xabar odamni javobsiz qoldiradi.
   */
  'report.insufficient.no_data': 'Ma’lumot yo‘q — bu davrda hech qanday harakat topilmadi.',
  'report.insufficient.single_purchase':
    'Davrda bitta xarid — chastota o‘lchanmaydi. Takrorlanish uchun kamida ikkita xarid kerak.',
  'report.insufficient.too_few_periods':
    'Kuzatuv davrlari yetarli emas — tovar tarixi qisqa. Barqarorlikni o‘lchash uchun uzoqroq oyna tanlang yoki tovar aylanmasini kuting.',
  'report.insufficient.too_few_peers':
    'Taqqoslash bazasi kichik — kvintil ballari ma’noli bo‘lishi uchun mijozlar soni yetarli emas.',
  'report.insufficient.short_history':
    'Hamkorlik tarixi qisqa — oylik qiymat ekstrapolyatsiya bo‘lardi, shuning uchun berilmadi.',
  'report.insufficient.zero_base': 'Baza nol — foiz yoki ulushni hisoblab bo‘lmaydi.',
  'report.insufficient.ambiguous_source':
    'Manba bir nechta — ko‘rsatkichni bittasiga bog‘lab bo‘lmaydi.',

  // 12. ABC tahlili
  'report.abc.title': 'ABC tahlili',
  'report.abc.description':
    'Tovarlar tushum bo‘yicha A/B/C guruhlarga bo‘linadi. Har satrda o‘sha tovarda bugun qotib turgan pul ham bor — eng qimmatli satr C guruhida, lekin ombori to‘la turgan tovar.',
  'report.abc.thresholds': 'Chegara',
  'report.abc.preset': '{a}/{b}/{c}',
  'report.abc.rank': '№',
  'report.abc.class': 'Guruh',
  'report.abc.revenue': 'Tushum',
  'report.abc.share': 'Ulush',
  'report.abc.cumulative': 'To‘plangan',
  'report.abc.quantity': 'Miqdor',
  'report.abc.grossProfit': 'Yalpi foyda',
  'report.abc.margin': 'Marja',
  'report.abc.stockValue': 'Omborda qotgan pul',
  'report.abc.groupCount': '{count} ta tovar',

  // 13. XYZ tahlili
  'report.xyz.title': 'XYZ tahlili',
  'report.xyz.description':
    'Talab qanchalik barqaror. X — bashorat qilinadi, Z — tasodifiy va katta xavfsizlik zaxirasi talab qiladi. ABC bilan birga o‘qiladi: AX — muhim va barqaror, CZ — arzimas va tasodifiy.',
  'report.xyz.class': 'XYZ',
  'report.xyz.combined': 'ABC-XYZ',
  'report.xyz.cv': 'Variatsiya',
  'report.xyz.periods': 'Davrlar',
  'report.xyz.periodsValue': '{observed} ({active} ta sotuvli)',
  'report.xyz.totalQty': 'Jami talab',
  'report.xyz.mean': 'O‘rtacha',
  'report.xyz.stdDev': 'Og‘ish',
  'report.xyz.reason': 'Izoh',
  'report.xyz.lookback': 'Kuzatuv oynasi',
  'report.xyz.bucket': 'Davr',
  'report.xyz.bucket.week': 'Hafta',
  'report.xyz.bucket.month': 'Oy',
  'report.xyz.matrix': 'ABC × XYZ matritsasi (tovarlar soni)',
  'report.xyz.matrixHint':
    'AX — avtomatik buyurtma, kam zaxira yetadi. AZ — muhim, lekin tasodifiy: katta xavfsizlik zaxirasi. CZ — zaxira saqlamaslik mumkin.',

  // 14. RFM
  'report.rfm.title': 'RFM — mijozlar segmentatsiyasi',
  'report.rfm.description':
    'Oxirgi xarid (R), chastota (F) va summa (M) bo‘yicha mijozlar. Ballar NISBIY: «boshqa mijozlaringizga nisbatan qayerda». Shuning uchun ball yonida xom qiymatlar ham turadi.',
  'report.rfm.code': 'Kod',
  'report.rfm.customer': 'Mijoz',
  'report.rfm.segment': 'Segment',
  'report.rfm.rfmCode': 'RFM',
  'report.rfm.r': 'R',
  'report.rfm.f': 'F',
  'report.rfm.m': 'M',
  'report.rfm.recencyDays': 'Oxirgi xariddan beri',
  'report.rfm.purchases': 'Xaridlar',
  'report.rfm.monetary': 'Summa',
  'report.rfm.lastPurchase': 'Oxirgi xarid',
  'report.rfm.reason': 'Izoh',
  'report.rfm.segments': 'Segmentlar bo‘yicha taqsimot',
  'report.rfm.segment.champion': 'Eng qimmatli',
  'report.rfm.segment.loyal': 'Sodiq',
  'report.rfm.segment.potential': 'Istiqbolli',
  'report.rfm.segment.at_risk': 'Xavf ostida',
  'report.rfm.segment.lost': 'Yo‘qolgan',
  'report.rfm.segment.needs_attention': 'E’tibor kerak',
  'report.rfm.segment.unscored': 'Ball berilmagan',

  // 15. LTV
  'report.ltv.title': 'Mijozning umr qiymati (LTV)',
  'report.ltv.description':
    'Mijoz hamkorlik davomida qancha yalpi foyda keltirgan (vozvratdan keyin). Bu PROGNOZ emas — fakt: mijozning kelajakdagi «umri» taxminga asoslanardi, bu yerdagi raqam esa haqiqiy savdolardan chiqadi.',
  'report.ltv.code': 'Kod',
  'report.ltv.customer': 'Mijoz',
  'report.ltv.value': 'LTV',
  'report.ltv.monthly': 'Oyiga',
  'report.ltv.revenue': 'Tushum',
  'report.ltv.grossProfit': 'Yalpi foyda',
  'report.ltv.returns': 'Vozvrat',
  'report.ltv.orders': 'Buyurtmalar',
  'report.ltv.avgOrder': 'O‘rtacha chek',
  'report.ltv.lifespan': 'Hamkorlik',
  'report.ltv.firstOrder': 'Birinchi xarid',
  'report.ltv.lastOrder': 'Oxirgi xarid',
  'report.ltv.minLifespan': 'Oylik qiymat uchun eng qisqa tarix',

  // 16. Ta'minotchi ko'rsatkichi
  'report.supplier.title': 'Ta’minotchi ko‘rsatkichi',
  'report.supplier.description':
    'Zavod qanchalik ishonchli: va’da qilingan muddat va fakt, brak (vozvratdan), qabuldagi kamomad va narx tendensiyasi. Arzon ta’minotchi har doim ham arzon emas.',
  'report.supplier.code': 'Kod',
  'report.supplier.name': 'Ta’minotchi',
  'report.supplier.score': 'Ishonchlilik',
  'report.supplier.onTime': 'O‘z vaqtida',
  'report.supplier.promisedLead': 'Va’da (kun)',
  'report.supplier.actualLead': 'Fakt (kun)',
  'report.supplier.bias': 'Farq (kun)',
  'report.supplier.defect': 'Brak',
  'report.supplier.defectQty': 'Brak miqdori',
  'report.supplier.shortage': 'Kamomad',
  'report.supplier.priceChange': 'Narx o‘zgarishi',
  'report.supplier.priceChangeHint':
    'Taqqoslash uchun ikkinchi davr ma’lumoti yo‘q — oynani kengaytiring.',
  'report.supplier.orders': 'Buyurtmalar',
  'report.supplier.ordersValue': '{received} / {total}',
  'report.supplier.soleSource': 'Brak bog‘lanadigan tovarlar',
  'report.supplier.soleSourceValue': '{sole} / {total}',
  'report.supplier.lookback': 'Kuzatuv oynasi',
  'report.supplier.unattributed':
    '{qty} dona brak hech qaysi ta’minotchiga bog‘lanmadi — bu tovarlarning bir nechta faol ta’minotchisi bor. Qaysi zavod aybdorligini aytish uchun tovarga yagona ta’minotchi belgilang.',

  // 17. Konteyner samaradorligi
  'report.container.title': 'Konteyner samaradorligi',
  'report.container.description':
    'Reja va fakt: ETA/ATA farqi, xarajatning tovar narxidagi ulushi va kechikish tarixi. «Bu konteyner foyda berdimi» degan savolga rentabellik hisoboti javob beradi, bu esa oqimni baholaydi.',
  'report.container.docNo': 'Hujjat',
  'report.container.containerNo': 'Konteyner',
  'report.container.supplier': 'Ta’minotchi',
  'report.container.eta': 'ETA (reja)',
  'report.container.ata': 'ATA (fakt)',
  'report.container.delay': 'Kechikish (kun)',
  'report.container.delayValue': '{days} kun',
  'report.container.notMeasured': 'O‘lchanmadi: ETA yoki fakt sanasi yo‘q',
  'report.container.plannedTransit': 'Reja yo‘l (kun)',
  'report.container.actualTransit': 'Fakt yo‘l (kun)',
  'report.container.purchaseValue': 'Tovar narxi',
  'report.container.cost': 'Xarajatlar',
  'report.container.costShare': 'Xarajat ulushi',
  'report.container.qty': 'Miqdor',
  'report.container.lookback': 'Kuzatuv oynasi',
  'report.container.unmeasured': '{count} tasida kechikish o‘lchanmadi',
  'report.container.delayChart': 'Kechikish tarixi (ETA bo‘yicha)',
  'report.container.delayChartHint':
    'Ustunlar faqat KECHIKISHNI ko‘rsatadi: o‘z vaqtida yoki erta kelgan konteyner bo‘sh joy bo‘lib qoladi, o‘lchanmaganlari esa chizmaga umuman kirmaydi. Aniq qiymat ustun ustiga sichqonchani olib kelganda ko‘rinadi.',
  'report.container.costTypes': 'Xarajat turlari bo‘yicha',

  // 18. Ombor yoshi
  'report.stockAge.title': 'Ombor yoshi',
  'report.stockAge.description':
    'Qoldiq necha kundan beri javonda yotibdi. Yosh FIFO qatlamlari bo‘yicha hisoblanadi — «oxirgi kirim sanasidan beri» degan sodda variant sekin aylanadigan tovarni yashirardi.',
  'report.stockAge.onHand': 'Qoldiq',
  'report.stockAge.avgAge': 'O‘rtacha yosh',
  'report.stockAge.oldest': 'Eng eski qatlam',
  'report.stockAge.unknown': 'Yoshi noma’lum',
  'report.stockAge.unknownHint':
    'Bu miqdor uchun kirim yozuvi topilmadi — u dastur ishga tushirilganda ko‘chirilgan yoki qo‘lda kiritilgan boshlang‘ich qoldiq.',
  'report.stockAge.unknownAlert':
    '{positions} ta pozitsiyada jami {qty} dona qoldiqning yoshi aniqlanmadi — kirim yozuvi topilmadi. Bu miqdor «eng eski» guruhga QO‘SHILMAGAN.',
  'report.stockAge.value': 'Qiymati',
  'report.stockAge.chart': 'Yosh guruhlari bo‘yicha qoldiq',

  // 19. Mijoz foydaliligi
  'report.profitability.title': 'Mijoz foydaliligi',
  'report.profitability.description':
    'Tushum − tannarx − chegirma − vozvrat. «Foydali emas» degan xulosa ko‘pincha chegirma va vozvratdan chiqadi va u yalpi foyda hisobotida ko‘rinmaydi.',
  'report.profitability.code': 'Kod',
  'report.profitability.customer': 'Mijoz',
  'report.profitability.netProfit': 'Sof foyda',
  'report.profitability.margin': 'Sof marja',
  'report.profitability.listRevenue': 'Tushum (ro‘yxat narxida)',
  'report.profitability.discount': 'Chegirma',
  'report.profitability.discountPct': 'Chegirma %',
  'report.profitability.cogs': 'Tannarx',
  'report.profitability.bonusCost': 'Bonus tannarxi',
  'report.profitability.returns': 'Vozvrat',
  'report.profitability.orders': 'Buyurtmalar',
  'report.profitability.quantity': 'Miqdor',
  'report.profitability.excludesTitle': 'Bu hisobotga KIRMAGAN xarajatlar',

  // 1. Ombor qoldig'i
  'report.stock.title': 'Ombor qoldig‘i',
  'report.stock.description':
    'Har ombor va har SKU bo‘yicha qoldiq. «Bu tovar bormi?» degan savolga javob.',
  'report.stock.warehouse': 'Ombor',
  'report.stock.onHand': 'Qoldiq',
  'report.stock.reserved': 'Band',
  'report.stock.available': 'Erkin',
  'report.stock.inTransit': 'Yo‘lda',
  'report.stock.avgCost': 'O‘rtacha tannarx',
  'report.stock.totalValue': 'Qiymati',

  // 2. Ombor qiymati
  'report.stockValuation.title': 'Ombor qiymati',
  'report.stockValuation.description':
    'Ombordagi tovarga qotib qolgan pul, landed cost bo‘yicha. Ombor kesimida.',
  'report.stockValuation.skuCount': 'SKU soni',
  'report.stockValuation.totalQty': 'Jami miqdor',
  'report.stockValuation.totalValue': 'Jami qiymat',
  'report.stockValuation.warehouseName': 'Ombor nomi',

  // 3. Savdo
  'report.sales.title': 'Savdo',
  'report.sales.description':
    'Tushum jo‘natilgan yuk xatlari bo‘yicha hisoblanadi, hisob-faktura bo‘yicha emas — tovar ombordan chiqqan payt haqiqiy sotuv hisoblanadi.',
  'report.sales.chartLabel': 'Kunlik tushum',
  'report.sales.groupBy': 'Kesim',
  'report.sales.groupBy.day': 'Kun',
  'report.sales.groupBy.customer': 'Mijoz',
  'report.sales.groupBy.product': 'Mahsulot',
  'report.sales.groupBy.agent': 'Sotuvchi',
  'report.sales.date': 'Sana',
  'report.sales.customer': 'Mijoz',
  'report.sales.sku': 'SKU',
  'report.sales.productName': 'Nomi',
  'report.sales.agent': 'Sotuvchi',
  'report.sales.agentUnnamed': 'Xodim #{id}',
  'report.sales.agentNote':
    'Sotuvchi kesimida hisobot faqat xodim ID sini qaytaradi, ismini emas.',
  'report.sales.revenue': 'Tushum',
  'report.sales.quantity': 'Miqdor',
  'report.sales.lineCount': 'Satr',

  // 3b. Agent faoliyati
  'report.agent.title': 'Agent faoliyati',
  'report.agent.description':
    'Har bir xodim davr ichida nechta buyurtma kiritgan, nechta har xil mijozga va qanchaga. Dalada kiritilgan buyurtmalar uchun tashrif joyi ham tekshiriladi.',
  'report.agent.agent': 'Agent',
  'report.agent.agentUnnamed': 'Xodim #{id}',
  'report.agent.agentUnknown': 'Xodim ko‘rsatilmagan',
  'report.agent.orderCount': 'Buyurtma',
  'report.agent.customerCount': 'Mijoz',
  'report.agent.totalBase': 'Jami savdo',
  'report.agent.avgOrderBase': 'O‘rtacha buyurtma',
  'report.agent.fieldOrderCount': 'Dalada kiritilgan',
  'report.agent.measurable': 'O‘lchash mumkin',
  'report.agent.missing': 'O‘lchab bo‘lmadi',
  'report.agent.confirmed': 'Tasdiqlangan tashrif',
  'report.agent.confirmedOf': '{measurable} tadan {confirmed} tasi',
  'report.agent.pct': 'Tasdiqlangan, %',
  'report.agent.pctUnmeasured': 'o‘lchanmadi',
  'report.agent.filterAgent': 'Agent',
  'report.agent.filterAgentAll': 'Barchasi',
  'report.agent.filterAgentHint':
    'Ro‘yxat hisobotning o‘z satrlaridan quriladi: davrda buyurtma kiritgan xodimlar.',
  'report.agent.radius': 'Tashrif tasdiqlangan deb hisoblanadigan radius: {meters} m',
  'report.agent.radiusHint':
    'Mijozning saqlangan nuqtasidan shu masofa ichida kiritilgan buyurtma «tasdiqlangan» hisoblanadi.',
  'report.agent.caveatTitle': 'Bu ko‘rsatkich — qurol emas',
  'report.agent.caveatBody':
    'Past foiz agent yolg‘on aytdi degani EMAS. Telefonda joylashuvga ruxsat berilmagan bo‘lishi, bino ichida GPS ishlamasligi yoki do‘konning saqlangan nuqtasi eskirgan bo‘lishi mumkin. Raqam savol tug‘diradi, javob bermaydi — avval sababini so‘rang.',
  'report.agent.scopeNote':
    'Ko‘lam rolga bog‘liq: sotuvchi faqat o‘z satrini ko‘radi, cheklov serverda qo‘yiladi.',
  'report.agent.unmeasuredNote':
    '«O‘lchanmadi» va «0%» BIR XIL EMAS: birinchisida o‘lchanadigan buyurtma umuman bo‘lmagan, ikkinchisida o‘lchandi va bironta ham tasdiqlanmadi.',

  // 4-5. Yalpi foyda
  'report.profit.title': 'Yalpi foyda',
  'report.profit.description':
    'Foyda = tushum − tannarx. Tannarx tovar ombordan chiqqan paytda qotib qoladi, keyin o‘zgarmaydi.',
  'report.profit.by': 'Kesim',
  'report.profit.by.product': 'Mahsulot',
  'report.profit.by.customer': 'Mijoz',
  'report.profit.code': 'Kod',
  'report.profit.name': 'Nomi',
  'report.profit.quantity': 'Miqdor',
  'report.profit.revenue': 'Tushum',
  'report.profit.cogs': 'Tannarx',
  'report.profit.bonusCost': 'Bonus tannarxi',
  'report.profit.bonusHint':
    'Bonus satrlar tushumga 0 qo‘shadi, lekin tannarxni TO‘LIQ ayiradi — bu yashirin chegirma va foydani kamaytiradi.',
  'report.profit.grossProfit': 'Yalpi foyda',
  'report.profit.marginPct': 'Marja',

  // 6. AR aging

  // --- Mijoz intizomi hisoboti (2026-08-15) ---
  'disc.title': 'Mijoz intizomi — reja va fakt',
  'disc.description':
    'Bitta dilerning oyma-oy xulq-atvori: qancha oldi, qancha to‘ladi va bu kelishilgan rejaga mos keldimi.',
  'disc.customer': 'Mijoz',
  'disc.pickCustomer': 'Hisobot uchun mijozni tanlang — u bitta diler bo‘yicha quriladi.',
  'disc.failingCount': '{month}: {count} ta diler nisbatlardan og‘gan (xarid yoki to‘lov).',
  'disc.mustPay': 'Majburiy to‘lov',
  'disc.shortfall': 'Yetishmayapti',
  'disc.lastPayment': 'Oxirgi to‘lov',
  'disc.neverPaid': 'to‘lamagan',
  'disc.collectTotal':
    '{month}: undirilishi kerak — {amount} ({count} ta diler). Ro‘yxat eng katta summadan boshlanadi.',
  'disc.allGood': '{month}: barcha dilerlar rejani bajardi.',
  'disc.overviewHint': 'Ro‘yxat serverda saralangan: avval bajarilmagan nisbatlar soni, keyin qarz summasi. Ya‘ni birinchi qator — bugun gaplashish kerak bo‘lgan diler. Mijoz nomini bosing — o‘sha dilerning oyma-oy kartochkasi ochiladi.',
  'disc.bucket': 'Kesim',
  'disc.bucketMonth': 'Oylik',
  'disc.bucketWeek': 'Haftalik',
  'disc.weekLabel': '{week}-hafta',
  'disc.weekNote': 'Haftalik kesimda foizlar BAHOLANMAYDI (rang berilmaydi): normativ oylik — «shu oyda xaridingizning 95% ini to‘lang» degani, u haftalik majburiyat emas. Hafta qatorlari pul oy ichida QACHON kelganini ko‘rsatadi; hukm oylik kesimda chiqadi.',
  'disc.month': 'Oy',
  'disc.opening': 'Oy boshiga qarz',
  'disc.sales': 'Savdo',
  'disc.payment': 'To‘lov',
  'disc.returned': 'Qaytarish',
  'disc.discount': 'Chegirma',
  'disc.writeOff': 'Hisobdan chiqarilgan',
  'disc.closing': 'Oy oxiriga qarz',
  'disc.purchase': 'Xarid / o‘tgan oy qoldig‘i',
  'disc.paymentRatio': 'To‘lov / xarid',
  'disc.collection': 'To‘lov / (qoldiq + xarid)',
  'disc.planPurchase': 'Reja: xarid %',
  'disc.factPurchase': 'Fakt: xarid %',
  'disc.planPayment': 'Reja: to‘lov %',
  'disc.factPayment': 'Fakt: to‘lov %',
  'disc.planCollection': 'Reja: undirish %',
  'disc.factCollection': 'Fakt: undirish %',
  'disc.hint':
    'Katakdagi son — FAKT foizi, sichqoncha ostida reja ham ko‘rinadi. Yashil — reja bajarildi, sariq — rejaning yarmidan ko‘pi, qizil — undan kam. Reja nol bo‘lgan oyda rang berilmaydi. Oy oxiriga qarz = oy boshiga qarz + savdo − to‘lov − qaytarish − chegirma − hisobdan chiqarilgan, va u keyingi oyning boshlang‘ich qarzi bo‘ladi.',
  'report.arAging.title': 'Mijoz qarzi (AR aging)',
  'report.arAging.description':
    'Qarz yoshi bo‘yicha taqsimlangan. 90 kundan oshgan qarz — undirish emas, yo‘qotish ehtimoli.',
  'report.arAging.code': 'Kod',
  'report.arAging.customer': 'Mijoz',
  'report.arAging.notDue': 'Muddati kelmagan',
  'report.arAging.d0_30': '0–30 kun',
  'report.arAging.d31_60': '31–60 kun',
  'report.arAging.d61_90': '61–90 kun',
  'report.arAging.d90plus': '90+ kun',
  'report.arAging.total': 'Jami qarz',
  'report.arAging.overdue': 'Kechikkan qarz',
  'report.arAging.oldestDue': 'Eng eski muddat',
  'report.arAging.invoiceCount': 'Faktura',
  'report.arAging.creditLimit': 'Kredit limiti',

  // 7. Pul harakati
  'report.cashFlow.title': 'Pul harakati',
  'report.cashFlow.description': 'Kassa va bank bo‘yicha kunlik kirim-chiqim, modda kesimida.',
  'report.cashFlow.date': 'Sana',
  'report.cashFlow.category': 'Modda',
  'report.cashFlow.in': 'Kirim',
  'report.cashFlow.out': 'Chiqim',
  'report.cashFlow.net': 'Sof',

  // 8. Dead stock
  'report.deadStock.title': 'Sekin harakatlanuvchi tovar',
  'report.deadStock.description':
    'Qoldig‘i bor, lekin uzoq vaqt chiqim bo‘lmagan tovar. Bu — pul aylanmasidan chiqib ketgan mablag‘.',
  'report.deadStock.threshold': 'Harakatsizlik chegarasi',
  'report.deadStock.days': '{days} kun',
  'report.deadStock.daysIdle': 'Harakatsiz',
  'report.deadStock.lastOutbound': 'Oxirgi chiqim',
  'report.deadStock.never': 'Umuman chiqmagan',
  'report.deadStock.onHand': 'Qoldiq',
  'report.deadStock.value': 'Qiymati',

  // 9. SKU landed cost tarkibi
  'report.landedCost.title': 'SKU tannarx tarkibi',
  'report.landedCost.description':
    '«Nega bu panel {example} turadi?» — javob quyidagi xarajat satrlarida. Har SKU tannarxi xarajat turigacha ochiladi.',
  'report.landedCost.shipment': 'Yuk #{id}',
  'report.landedCost.sku': 'SKU',
  'report.landedCost.quantity': 'Miqdor',
  'report.landedCost.purchaseUnitCost': 'Tovar narxi (dona)',
  'report.landedCost.landedUnitCost': 'Xarajat (dona)',
  'report.landedCost.totalUnitCost': 'Jami tannarx (dona)',
  'report.landedCost.costType': 'Xarajat turi',
  'report.landedCost.costName': 'Izoh',
  'report.landedCost.allocMethod': 'Taqsimlash',
  'report.landedCost.allocRatio': 'Ulush (koeffitsiyent)',
  'report.landedCost.allocatedBase': 'Summa',
  'report.landedCost.uncategorized': 'Turi ko‘rsatilmagan',
  'report.landedCost.empty': 'Bu yuk uchun taqsimlangan xarajat topilmadi',
  'report.landedCost.emptyHint':
    'Landed cost hali ishga tushirilmagan yoki yukda xarajat satri yo‘q.',
  'report.landedCost.backToShipments': '← Konteynerlar ro‘yxati',
  'report.landedCost.skuBreakdown': 'Xarajat tarkibi',
  'report.landedCost.skuTotal': '{sku}: {qty} dona × {cost}',

  // 10. Konteyner rentabelligi
  'report.shipment.title': 'Konteyner rentabelligi',
  'report.shipment.description':
    '«Bu konteyner foyda berdimi?» — import biznesining asosiy savoli. Har yuk bo‘yicha tovar narxi, xarajat va ularning nisbati.',
  'report.shipment.landedExplainer':
    'Xarajat ulushi — eng MUHIM ustun. U taqsimlangan xarajatning tovar narxiga nisbati: 109% degani navlon, bojxona, sertifikat va qolgani birgalikda tovarning o‘zidan ham qimmatga tushgan. Xitoy invoysidagi narxga qarab narx aytish shuning uchun ishlamaydi.',
  'report.shipment.docNo': 'Hujjat',
  'report.shipment.containerNo': 'Konteyner',
  'report.shipment.eta': 'ETA',
  'report.shipment.ata': 'Keldi',
  'report.shipment.delay': 'Kechikish',
  'report.shipment.delayDays': '+{days} kun',
  'report.shipment.earlyDays': '−{days} kun',
  'report.shipment.onTime': 'O‘z vaqtida',
  'report.shipment.lcStatus': 'Tannarx holati',
  'report.shipment.skuCount': 'SKU',
  'report.shipment.receivedQty': 'Qabul qilindi',
  'report.shipment.shortageQty': 'Kamomad',
  'report.shipment.purchaseValue': 'Tovar qiymati',
  'report.shipment.landedValue': 'Xarajatlar',
  'report.shipment.totalCost': 'Jami tannarx',
  'report.shipment.landedPct': 'Xarajat ulushi',
  'report.shipment.openBreakdown': 'Tarkibi',
  'report.shipment.rowHint': 'Satrni bosing — o‘sha konteynerdagi har SKU tannarxining tarkibi ochiladi.',
  'report.shipment.filterAll': 'Barcha konteynerlar',
  'report.shipment.empty': 'Konteyner topilmadi',
  'report.shipment.emptyHint': 'Hali birorta yuk qabul qilinmagan bo‘lishi mumkin.',

  // 11. Qachon buyurtma berish kerak (GAP_ANALYSIS §A4)
  'report.reorder.title': 'Qachon buyurtma berish kerak',
  'report.reorder.description':
    'Lead time 120-150 kun. «Tovar tugadi → buyurtma beraman» qoidasi to‘rt oylik uzilish demak — qaror tovar tugashidan ancha oldin qabul qilinishi kerak.',
  'report.reorder.formula':
    'Kunlik o‘rtacha = oxirgi {lookback} kunlik SOTUV chiqimi ÷ {lookback}. Qoplama = (qoldiq + yo‘ldagi) ÷ kunlik o‘rtacha. Qoplama lead time + xavfsizlik zaxirasidan kam bo‘lsa — buyurtma vaqti keldi. Transfer va namuna chiqimi talabga kirmaydi: ular sotuv emas.',
  'report.reorder.lookbackDays': 'Talab davri, kun',
  'report.reorder.safetyDays': 'Xavfsizlik zaxirasi, kun',
  'report.reorder.leadTimeDays': 'Standart lead time, kun',
  'report.reorder.leadTimeHint':
    'Ta’minotchida haqiqiy lead time ko‘rsatilgan bo‘lsa, o‘sha ishlatiladi; bu qiymat faqat qolganlari uchun.',
  'report.reorder.onHand': 'Qoldiq',
  'report.reorder.inTransit': 'Yo‘lda',
  'report.reorder.sold': 'Sotildi (davr)',
  'report.reorder.dailyAverage': 'Kunlik o‘rtacha',
  'report.reorder.daysOfCover': 'Qoplama, kun',
  'report.reorder.leadTime': 'Lead time',
  'report.reorder.suggestedQty': 'Tavsiya etilgan miqdor',
  'report.reorder.status': 'Holat',
  'report.reorder.status.order_now': 'BUYURTMA BERING',
  'report.reorder.status.ok': 'Yetarli',
  'report.reorder.status.no_demand': 'Talab yo‘q',
  'report.reorder.noDemandHint':
    'Davr ichida umuman sotilmagan: qoplama hisoblanmaydi. Bu «yetarli» degani emas — bu «bu tovar harakatlanmayapti» degani.',
  'report.reorder.empty': 'Xarid qilinadigan mahsulot topilmadi',
  'report.reorder.emptyHint':
    'Katalogda «xarid qilinadi» belgisi qo‘yilgan faol mahsulot yo‘q bo‘lishi mumkin.',

  // --- Bosh sahifa: puls, diqqat, KPI ---
  //
  // Kalitlar `dashboard.pulse.*` va `dashboard.attention.*` — mavjud
  // `dashboard.*` kalitlari saqlanadi. Ular kartochka MATNI, bular esa
  // ZONA sarlavhalari: ikkalasi bir-birini almashtirmaydi.
  'dashboard.pulse.title': 'Savdo pulsi',
  'dashboard.pulse.thisMonth': 'Shu oy',
  'dashboard.pulse.today': 'Bugun',
  'dashboard.pulse.orders': '{count} ta satr',
  'dashboard.pulse.chartLabel': 'Kunlik tushum, shu oy',
  'dashboard.pulse.comparedTo': 'o‘tgan oyning shu kunigacha',
  'dashboard.pulse.noSales': 'Shu oyda hali sotuv yo‘q',
  'dashboard.attention.title': 'Diqqat talab qiladi',
  'dashboard.attention.allClear': 'Shoshilinch ish yo‘q',
  'dashboard.attention.allClearHint': 'Kechikkan qarz, qabul qilinmagan ko‘chirish va tugab qolgan tovar yo‘q.',
  'dashboard.attention.transfers': 'Qabul qilinmagan ko‘chirish',
  'dashboard.attention.discipline': 'Rejani bajarmagan dilerlar',
  'dashboard.attention.arOverdue': 'Muddati o‘tgan qarz',
  'dashboard.attention.reorder': 'Buyurtma berish vaqti keldi',
  'dashboard.attention.deadStock': 'Sekin harakatlanuvchi tovar',
  'dashboard.attention.counts': 'Ochiq inventarizatsiya',
  'dashboard.attention.items': '{count} ta',
  /*
   * Sanog'i noma'lum qator — «0 ta» EMAS.
   *
   * So'rov xato bilan qaytganda ekran ish yo'qligini BILMAYDI, shuning
   * uchun uni «yo'q» deb ko'rsatish yolg'on bo'lardi (`attention-block.tsx`).
   */
  'dashboard.attention.unknown': 'Yuklab bo‘lmadi',
  'dashboard.topProducts': 'Eng ko‘p sotilgan mahsulotlar',
  'dashboard.share': 'Ulush',

  // --- Avtomatik qayta zakaz (replenishment) ---
  //
  // Hisobotdan (yuqoridagi `report.reorder.*`) farqi: bu yerda natija
  // SAQLANADI va hujjatga aylanadi. Shuning uchun kalitlar ham alohida —
  // «tavsiya» va «tahlil» bir xil so'z bilan atalsa, foydalanuvchi qaysi
  // biri qog'ozga tushishini bilmay qoladi.
  'nav.reorderRuns': 'Avtomatik qayta zakaz',
  'reorder.title': 'Avtomatik qayta zakaz',
  'reorder.description':
    'Kategoriya jadvali bo‘yicha tizim o‘zi tahlil qiladi: nima tugayapti, qancha kerak va qaysi zavoddan. Natija qoralama xarid buyurtmasi bo‘lib chiqadi — tasdiqlashni odam qiladi.',
  'reorder.new': 'Yangi tahlil',
  'reorder.runDue': 'Navbatdagilarni tekshirish',
  'reorder.docNo': 'Hujjat',
  'reorder.runDate': 'Sana',
  'reorder.category': 'Kategoriya',
  'reorder.categoryAll': 'Barcha kategoriyalar',
  'reorder.lineCount': 'Satrlar',
  'reorder.suggestedCount': 'Buyurtmaga',
  'reorder.poCount': 'Qoralama PO',
  'reorder.status': 'Holat',
  'reorder.status.draft': 'Yangi',
  'reorder.status.reviewed': 'Ko‘rildi',
  'reorder.status.ordered': 'Buyurtma berildi',
  'reorder.status.cancelled': 'Bekor qilindi',
  'reorder.empty': 'Hali tahlil qilinmagan',
  'reorder.emptyHint':
    'Birinchi tahlilni «Yangi tahlil» tugmasi bilan ishga tushiring yoki kategoriyaga qayta ko‘rish davrini belgilang.',
  'reorder.filterStatus': 'Holat bo‘yicha',

  // --- Xodimlar: komissiya, KPI, bonus (TZ v8.0 §25, §19) ------------------
  // Kalitlar `hr.*` prefiksi bilan: «komissiya» so'zi hisobotlarda ham
  // uchraydi, lekin bu yerdagi raqam TO'LOV MAJBURIYATI va uni boshqa
  // kontekstdagi matn bilan almashtirib yuborish mumkin emas.
  'nav.staff': 'Xodimlar',
  'nav.commission': 'Komissiya',
  'nav.kpi': 'KPI — reja va fakt',

  'hr.commission.title': 'Komissiya',
  'hr.commission.description':
    'Davr bo‘yicha komissiya hisoblanadi, ko‘rib chiqiladi va YOPILADI. Yopilgandan keyin natija o‘zgarmaydi — xato topilsa tuzatish hisobi yaratiladi.',
  'hr.commission.new': 'Davrni hisoblash',
  'hr.commission.preview': 'Avval sinab ko‘rish',
  'hr.commission.docNo': 'Hujjat',
  'hr.commission.period': 'Davr',
  'hr.commission.employees': 'Xodim',
  'hr.commission.totalNet': 'To‘lanadi',
  'hr.commission.totalDeduction': 'Chegirma',
  'hr.commission.status': 'Holat',
  'hr.commission.status.draft': 'Qoralama',
  'hr.commission.status.reviewed': 'Ko‘rildi',
  'hr.commission.status.closed': 'Yopildi',
  'hr.commission.status.cancelled': 'Bekor qilindi',
  'hr.commission.runType.regular': 'Odatiy',
  'hr.commission.runType.adjustment': 'Tuzatish',
  'hr.commission.empty': 'Hali komissiya hisoblanmagan',
  'hr.commission.emptyHint':
    'Avval qoida yozilishi kerak (stavka yoki zinapoya), keyin davrni hisoblang. Hisoblash hech kimga pul to‘lamaydi — u qoralama yaratadi.',
  'hr.commission.filterStatus': 'Holat bo‘yicha',

  'hr.commission.form.title': 'Davr bo‘yicha hisoblash',
  'hr.commission.form.hint':
    'Avval «sinab ko‘rish» ni bosing: u HECH NARSA yozmaydi va kimga qancha tushishini ko‘rsatadi. Haqiqiy hisob esa davrni band qiladi — bir oy uchun bitta odatiy hisob bo‘ladi.',
  'hr.commission.form.month': 'Oy',
  'hr.commission.form.notes': 'Izoh',
  'hr.commission.form.dryRun': 'Sinab ko‘rish (yozilmaydi)',
  'hr.commission.form.submit': 'Hisoblash',
  'hr.commission.dryRunTitle': 'Sinov natijasi — saqlanmadi',
  'hr.commission.dryRunHint':
    'Bu raqamlar bazaga yozilmagan. Qoidani o‘zgartirib qayta sinab ko‘rishingiz mumkin.',

  // Kartochka
  'hr.commission.detail.title': 'Komissiya hisobi',
  'hr.commission.employee': 'Xodim',
  'hr.commission.rule': 'Qoida',
  'hr.commission.basis': 'Asos',
  'hr.commission.basis.revenue': 'Tushum',
  'hr.commission.basis.gross_profit': 'Yalpi foyda',
  'hr.commission.basis.collection': 'Yig‘ilgan pul',
  'hr.commission.basisAmount': 'Asos summasi',
  'hr.commission.deductionBasis': 'Asosdan chegirma',
  'hr.commission.netBasis': 'Sof asos',
  'hr.commission.rawCommission': 'Chegirmasiz',
  'hr.commission.deduction': 'Chegirma narxi',
  'hr.commission.net': 'To‘lanadi',
  'hr.commission.rate': 'Haqiqiy stavka',
  'hr.commission.orders': 'Zakaz',
  'hr.commission.customers': 'Mijoz',
  'hr.commission.newCustomers': 'Yangi mijoz',
  'hr.commission.hiddenBasis': 'Ko‘rsatilmaydi',
  'hr.commission.hiddenBasisHint':
    'Yalpi foyda asosidagi qoidada asos summasi — bu marja. U sizning rolingizga ochilmaydi (TZ §60). To‘lanadigan summa esa har doim ko‘rinadi.',
  'hr.commission.review': 'Ko‘rib chiqildi',
  'hr.commission.close': 'Davrni YOPISH',
  'hr.commission.closeConfirm':
    'Yopilgandan keyin natija O‘ZGARMAYDI. Xato topilsa tuzatish hisobi yaratiladi. Davom etasizmi?',
  'hr.commission.closedAt': 'Yopildi',
  'hr.commission.correctsRun': 'Tuzatadigan hisob',
  'hr.commission.reviewFirst':
    'Yopishdan oldin hisob ko‘rib chiqilishi kerak — bu qaytarib bo‘lmaydigan amal.',

  // Bayroqlar — har biri NIMA QILISH KERAKLIGINI aytadi, rang emas
  'hr.commission.flag.negative_basis': 'Chegirma asosdan katta',
  'hr.commission.flag.negative_basisHint':
    'Vozvrat va bekor qilishlar sotuvdan oshgan. Komissiya nolda kesildi — manfiy komissiya yozilmaydi, chunki bu oylikdan ushlab qolish va u alohida qaror.',
  'hr.commission.flag.cap_hit': 'Cheklovga urildi',
  'hr.commission.flag.cap_hitHint':
    'Qoidadagi maksimum summa qo‘llandi. Xodim undan ko‘proq ishlagan bo‘lishi mumkin.',
  'hr.commission.flag.below_min_basis': 'Minimal asosdan past',
  'hr.commission.flag.below_min_basisHint':
    'Qoidada minimal chegara bor va asos undan past — komissiya to‘lanmaydi.',
  'hr.commission.flag.high_deduction': 'Chegirma juda katta',
  'hr.commission.flag.high_deductionHint':
    'Chegirmalar komissiyaning yarmidan ko‘pini yedi. Bu deyarli har doim sotuv emas, boshqa muammo: do‘kon to‘lamayapti, tovar bilan muammo bor, yoki zakazlar soxta.',
  'hr.commission.flag.zero_commission': 'Komissiya nol',
  'hr.commission.flag.zero_commissionHint':
    'Asos bor edi, lekin chegirmalar yoki qoida sharti tufayli to‘lov chiqmadi.',
  'hr.commission.flag.no_documents': 'Hisoblanadigan hujjat yo‘q',
  'hr.commission.flag.no_documentsHint':
    'Bu «nol to‘landi» EMAS. Asosga birorta hujjat tushmagan: zakazlar hali qoralama holatida bo‘lishi yoki to‘lov kelmagan bo‘lishi mumkin. Javob qoidada emas, jarayonda.',

  // Satrga tushish
  'hr.commission.sources': 'Qaysi hujjatlardan',
  'hr.commission.sources.hint':
    'Har raqam ostida hujjat turadi. Yig‘indi asos bilan aynan mos kelishi hisob paytida tekshirilgan.',
  'hr.commission.sources.kind': 'Turi',
  'hr.commission.sources.doc': 'Hujjat',
  'hr.commission.sources.date': 'Sana',
  'hr.commission.sources.amount': 'Summa',
  'hr.commission.sources.earning': 'Asosga',
  'hr.commission.sources.return': 'Vozvrat',
  'hr.commission.sources.cancellation': 'Bekor qilingan',
  'hr.commission.sources.overdue': 'Muddati o‘tgan',
  'hr.commission.sources.empty': 'Manba hujjat yo‘q',
  'hr.commission.sources.hidden':
    'Yalpi foyda asosida manba ro‘yxati ham marja hisoblanadi va ko‘rsatilmaydi.',

  // Qoidalar
  'hr.rule.title': 'Komissiya qoidalari',
  'hr.rule.code': 'Kod',
  'hr.rule.name': 'Nomi',
  'hr.rule.target': 'Kimga',
  'hr.rule.targetAll': 'Barcha xodimlar',
  'hr.rule.method': 'Usul',
  'hr.rule.method.percent': 'Foiz',
  'hr.rule.method.tiered': 'Zinapoya',
  'hr.rule.method.fixed': 'Qat’iy summa',
  'hr.rule.tiers': 'Zinapoyalar',
  'hr.rule.cap': 'Cheklov',
  'hr.rule.deductions': 'Chegirmalar',
  'hr.rule.empty': 'Komissiya qoidasi yozilmagan',
  'hr.rule.emptyHint':
    'Qoidasiz hisob hech kimga satr yaratmaydi. Qoida rol yoki aniq xodim uchun yoziladi.',

  // KPI
  'hr.kpi.title': 'KPI — reja va fakt',
  'hr.kpi.description':
    'Fakt komissiya hisobi bilan BIR VAQTDA va bir xil raqamdan hisoblanadi. Ular ajralib ketmasligi uchun alohida hisob yo‘q.',
  'hr.kpi.metric': 'Ko‘rsatkich',
  'hr.kpi.plan': 'Reja',
  'hr.kpi.actual': 'Fakt',
  'hr.kpi.achievement': 'Bajarilish',
  'hr.kpi.noPlan': 'Reja qo‘yilmagan',
  'hr.kpi.noPlanHint':
    'Reja yo‘q — bu «bajarilmadi» degani EMAS. Bajarilish foizi ham ko‘rsatilmaydi.',
  'hr.kpi.met': 'Bajarildi',
  'hr.kpi.notMet': 'Bajarilmadi',
  'hr.kpi.empty': 'Bu davr uchun KPI hisoblanmagan',
  'hr.kpi.emptyHint':
    'KPI komissiya hisobi bilan birga yoziladi. Avval davrni hisoblang.',
  'hr.kpi.metric.sales_volume': 'Sotuv hajmi',
  'hr.kpi.metric.gross_profit': 'Yalpi foyda',
  'hr.kpi.metric.collection': 'Yig‘ilgan pul',
  'hr.kpi.metric.new_customers': 'Yangi mijozlar',
  'hr.kpi.metric.repeat_customers': 'Takroriy mijozlar',
  'hr.kpi.metric.avg_order': 'O‘rtacha chek',
  'hr.kpi.metric.order_count': 'Zakazlar soni',
  'hr.kpi.metric.return_rate': 'Vozvrat ulushi',
  'hr.kpi.returnRateHint':
    'Bu ko‘rsatkichda KAM bo‘lgani yaxshi: rejadan past bajarilish — yaxshi natija.',
  'hr.kpi.month': 'Oy',
  'hr.kpi.employee': 'Xodim',
  'hr.kpi.allEmployees': 'Barcha xodimlar',

  // Yangi tahlil oynasi
  'reorder.form.title': 'Yangi tahlil',
  'reorder.form.hint':
    'Parametr berilmasa kategoriya sozlamasidan olinadi. Ular natija bilan BIRGA saqlanadi — kategoriya keyin o‘zgarsa ham, bu tahlil o‘z farazlari bilan o‘qiladi.',
  'reorder.form.lookbackDays': 'Talab davri, kun',
  'reorder.form.coverDays': 'Qoplash davri, kun',
  'reorder.form.safetyDays': 'Xavfsizlik zaxirasi, kun',
  'reorder.form.includeInTransit': 'Yo‘ldagi tovar hisobga olinsin',
  'reorder.form.includeInTransitHint':
    'Odatda — ha. Zavod muddatlarni bir necha marta buzgan davrda olib tashlanadi: yo‘lda deb yozilgan konteynerga ishonch yo‘qolganda uni qoldiq deb sanash yangi bo‘shliq yaratadi.',
  'reorder.form.notes': 'Izoh',
  'reorder.form.submit': 'Tahlilni ishga tushirish',
  'reorder.form.duplicate':
    'Bu kategoriya bo‘yicha bugun tahlil allaqachon qilingan. Uni oching yoki ertaga qayta ishga tushiring.',

  // Navbatdagilar
  'reorder.due.title': 'Navbati kelgan kategoriyalar',
  'reorder.due.hint':
    'Avval hech narsa yozilmaydi — faqat ro‘yxat ko‘rsatiladi. Tasdiqlaganingizdan keyin har biri bo‘yicha alohida tahlil yaratiladi.',
  'reorder.due.none': 'Bugun birorta kategoriyaning navbati kelmagan',
  'reorder.due.every': 'Har {days} kunda',
  'reorder.due.lastRun': 'Oxirgi tahlil',
  'reorder.due.never': 'Hech qachon',
  'reorder.due.run': '{count} ta kategoriya bo‘yicha tahlil qilish',
  'reorder.due.created': '{count} ta tahlil yaratildi',

  // Tahlil kartochkasi
  'reorder.detail.params': 'Farazlar',
  'reorder.detail.paramsValue':
    'Talab davri {lookback} kun · qoplash {cover} kun · zaxira {safety} kun · yo‘ldagi tovar: {inTransit}',
  'reorder.detail.review': 'Ko‘rildi deb belgilash',
  'reorder.detail.createOrders': 'Qoralama buyurtmalarni yaratish',
  'reorder.detail.createOrdersHint':
    'Ta’minotchilar bo‘yicha guruhlanadi. Hujjatlar QORALAMA bo‘lib qoladi — 3–4 oylik majburiyatni tizim o‘zi qabul qila olmaydi.',
  'reorder.detail.ordersCreated': '{count} ta qoralama buyurtma yaratildi',
  'reorder.detail.skipped':
    'Buyurtmaga tushmadi: rad etilgan {rejected} · ta’minotchisiz {noSupplier} · miqdori nol {zeroQty}',
  'reorder.detail.missingPrice': '{count} ta satr narxsiz',
  'reorder.detail.alreadyOrdered': 'Bu tahlil bo‘yicha buyurtmalar allaqachon yaratilgan',
  'reorder.detail.openPo': 'Buyurtmani ochish',

  // Satrlar
  'reorder.line.sku': 'SKU',
  'reorder.line.name': 'Nomi',
  'reorder.line.onHand': 'Qoldiq',
  'reorder.line.inTransit': 'Yo‘lda',
  'reorder.line.inTransitHint':
    'Tasdiqlangan xarid buyurtmalarining qolgan qismi: zavodda ishlab chiqarilayotgan va konteynerda kelayotgan tovar.',
  'reorder.line.reserved': 'Band',
  'reorder.line.sold': 'Sotildi',
  'reorder.line.dailyAvg': 'Kunlik o‘rtacha',
  'reorder.line.leadTime': 'Lead time',
  'reorder.line.target': 'Kerak',
  'reorder.line.suggested': 'Buyurtma',
  'reorder.line.supplier': 'Ta’minotchi',
  'reorder.line.noSupplier': 'Ta’minotchi yo‘q',
  'reorder.line.edit': 'To‘g‘rilash',
  'reorder.line.reject': 'Rad etish',
  'reorder.line.rejected': 'Rad etilgan',
  'reorder.line.restore': 'Qaytarish',
  'reorder.line.rejectReason': 'Rad etish sababi',
  'reorder.line.rejectReasonHint': 'Kamida 3 belgi. Sabab hujjatda qoladi.',
  'reorder.line.onlySuggested': 'Faqat buyurtma qilinadiganlar',
  'reorder.line.empty': 'Satr yo‘q',

  // Bayroqlar
  'reorder.flag.negative_stock': 'Qoldiq manfiy',
  'reorder.flag.negative_stockHint':
    'Bu tovar allaqachon sotib bo‘lingan — ro‘yxatda birinchi turadi.',
  'reorder.flag.no_supplier': 'Ta’minotchi yo‘q',
  'reorder.flag.no_supplierHint':
    'Mahsulotga faol ta’minotchi biriktirilmagan — buyurtmaga tushmaydi.',
  'reorder.flag.no_price': 'Narx noma’lum',
  'reorder.flag.no_priceHint':
    'Qoralamada narx 0 bilan turadi. Buyurtma to‘xtatilmaydi: bitta narxsiz SKU tufayli 4 oylik buyurtmani kechiktirish — biz oldini olmoqchi bo‘lgan hodisaning o‘zi.',
  'reorder.flag.above_formula': 'Formuladan ko‘p',
  'reorder.flag.above_formulaHint': 'Sabab: MOQ (minimal partiya) yoki odam to‘g‘rilagan.',
  'reorder.flag.below_formula': 'Formuladan kam',
  'reorder.flag.below_formulaHint': 'Miqdorni odam qo‘lda kamaytirgan.',
  'reorder.flag.draft_po': 'Tasdiqlanmagan qoralama bor',
  'reorder.flag.draft_poHint':
    'Bu SKU bo‘yicha turgan qoralama bor va u hisobga KIRMAGAN (majburiyat emas). Javob yangi buyurtma emas, o‘shani tasdiqlash bo‘lishi mumkin.',

  // --- Jadval ---
  'table.rowsPerPage': 'Sahifadagi satrlar',
  'table.page': '{page} / {total}',
  'table.first': 'Birinchi',
  'table.previous': 'Oldingi',
  'table.next': 'Keyingi',
  'table.last': 'Oxirgi',
  'table.empty': 'Satr topilmadi',
  'table.sortAsc': 'O‘sish bo‘yicha',
  'table.sortDesc': 'Kamayish bo‘yicha',
  'table.total': 'Jami: {count}',
  'table.addRow': 'Yangi satr (Enter)',
  'table.loadError': "Ma'lumotni yuklab bo'lmadi",
  'table.pending': 'Ekran hali tayyor emas',
  // --- Ko‘p satrni birdan qayta ishlash (`data-table.tsx`) ---
  'table.selectedCount': '{count} ta satr tanlandi',
  'table.selectAll': 'Sahifadagi hammasini tanlash',
  'table.selectRow': 'Satrni tanlash',
  'table.expandRow': 'Ichini ochish',
  'table.collapseRow': 'Ichini yopish',
  'bulk.progress': 'Bajarilyapti: {done} / {total}',
  'bulk.partial': 'Bajarildi: {ok} · Bajarilmadi: {failed}',
  'bulk.allDone': 'Hammasi bajarildi: {count}',
  'bulk.failedHint':
    'Bajarilmaganlarini birma-bir oching — har biri o‘z sababi bilan to‘xtagan.',
  'table.columns': 'Ustunlar',
  'table.columnsAll': "Hammasini ko'rsatish",
  'table.columnsLast': "Kamida bitta ustun ko'rinib turishi kerak",
  'table.clearSearch': 'Qidiruvni tozalash',

  // --- Tanlagichlar (ProductPicker / CustomerPicker / WarehouseSelect) ---
  'picker.product': 'Mahsulot',
  'picker.productPlaceholder': 'SKU yoki nom',
  'picker.productEmpty': 'Mahsulot topilmadi — eski kod bilan ham urinib ko‘ring',
  'picker.productNoStock': 'Qoldiq yo‘q',
  'picker.customer': 'Mijoz',
  'picker.customerPlaceholder': 'Kod, nom yoki telefon',
  'picker.customerEmpty': 'Mijoz topilmadi',
  'warehouse.title': 'Ombor',
  'warehouse.select': 'Omborni tanlang',
  'warehouse.all': 'Barcha omborlar',
  'warehouse.from': 'Qaysi ombordan',
  'warehouse.to': 'Qaysi omborga',

  // --- Ombor: umumiy ---
  'inv.qty': 'Miqdor',
  'inv.unitCost': 'Birlik tannarx',
  'inv.lotNo': 'Partiya (lot)',
  'inv.notes': 'Izoh',
  'inv.occurredAt': 'Hujjat sanasi',
  'inv.occurredAtHint':
    'Kechagi hujjatni bugun kiritish odatiy holat — sana haqiqiy voqea kunini ko‘rsatishi kerak.',
  'inv.product': 'Mahsulot',
  'inv.sku': 'SKU',
  'inv.name': 'Nomi',
  'inv.warnings': 'Ogohlantirishlar',
  'inv.done': 'Bajarildi',
  'inv.lineAdd': 'Satr qo‘shish',
  'inv.lineRemove': 'Satrni o‘chirish',
  'inv.selectWarehouseFirst': 'Avval omborni tanlang',
  'inv.docNo': 'Hujjat',
  'inv.status': 'Holat',
  'inv.date': 'Sana',

  // --- Ombor: qoldiq ---
  'stock.title': 'Ombor qoldig‘i',
  'stock.description':
    'Joriy qoldiq. Har satr daftarga olib boradi: «bu raqam qayerdan chiqdi?» degan savolga javob bir bosishda.',
  'stock.searchPlaceholder': 'SKU yoki nom bo‘yicha qidirish',
  'stock.onHand': 'Qoldiq',
  'stock.reserved': 'Band',
  'stock.available': 'Erkin',
  'stock.inTransit': 'Yo‘lda',
  'stock.avgCost': 'O‘rtacha tannarx',
  'stock.totalValue': 'Qiymati',
  'stock.updatedAt': 'Oxirgi harakat',
  'stock.includeZero': 'Nol qoldiqlarni ham ko‘rsatish',
  'stock.includeZeroHint':
    'Bir marta kirib butunlay sotilgan SKU abadiy nol qator bo‘lib qoladi — shuning uchun ular odatda yashiriladi.',
  'stock.empty': 'Qoldiq topilmadi',
  'stock.emptyHint': 'Filtrni kengaytiring yoki nol qoldiqlarni yoqing.',
  'stock.loadError': 'Qoldiqni yuklab bo‘lmadi',
  'stock.valueHidden':
    'Tannarx va qiymat ustunlari sizga ko‘rsatilmaydi — bu ruxsat masalasi, xato emas.',
  'stock.categoryGap':
    'Bu ekranda kategoriya bo‘yicha kesim yo‘q. Kategoriya kesimi «Ombor qoldig‘i» hisobotida.',
  'stock.openReport': 'Qoldiq hisoboti →',
  'stock.rowHint': 'Satrni bosing — o‘sha mahsulot va ombor bo‘yicha daftar ochiladi.',

  // --- Ombor: daftar (movements) ---
  'movement.title': 'Ombor daftari',
  'movement.description':
    'Har bir kirim va chiqim. Qoldiqdagi istalgan raqam shu yerda satrma-satr ochiladi — hisob bo‘yicha bahs shu jadvalda tugaydi.',
  'movement.occurredAt': 'Vaqti',
  'movement.txnType': 'Turi',
  'movement.txnTypeAll': 'Barcha turlar',
  'movement.quantity': 'Miqdor',
  'movement.balanceQty': 'Qoldiq (keyin)',
  'movement.unitCost': 'Birlik tannarx',
  'movement.totalCost': 'Summa',
  'movement.avgCostAfter': 'O‘rtacha (keyin)',
  'movement.source': 'Manba',
  'movement.sourceAll': 'Barcha hujjatlar',
  'movement.sourceRef': '{table} — hujjat #{id}',
  'movement.reversal': 'Storno',
  'movement.reversed': 'Stornolangan',
  'movement.empty': 'Harakat topilmadi',
  'movement.emptyHint': 'Davrni kengaytiring yoki mahsulot filtrini olib tashlang.',
  'movement.loadError': 'Daftarni yuklab bo‘lmadi',
  'movement.filterProduct': 'Mahsulot bo‘yicha',
  'movement.clearFilters': 'Filtrlarni tozalash',

  'txn.receipt': 'Kirim',
  'txn.issue': 'Chiqim',
  'txn.transfer_in': 'Ko‘chirish (kirim)',
  'txn.transfer_out': 'Ko‘chirish (chiqim)',
  'txn.adjustment': 'Tuzatish',
  'txn.count': 'Inventarizatsiya',
  'txn.return_in': 'Mijoz qaytardi',
  'txn.return_out': 'Ta’minotchiga qaytdi',
  'txn.revaluation': 'Qayta baholash',
  'txn.sample': 'Namuna',
  'txn.display': 'Vitrina',
  'txn.trial_out': 'Sinovga berildi',
  'txn.trial_in': 'Sinovdan qaytdi',

  'src.manual': 'Qo‘lda',
  'src.stock_transfer_lines': 'Omborlar aro ko‘chirish',
  'src.stock_count_lines': 'Inventarizatsiya',
  'src.delivery_lines': 'Yuk xati',
  'src.goods_receipt_lines': 'Qabul (import)',
  'src.sales_return_lines': 'Tovar qaytishi',
  'src.partner_supply_notices': 'Ta‘minot xabarnomasi',
  'src.unknown': 'Boshqa hujjat',

  // --- Ombor: qo'lda kirim ---
  'receipt.title': 'Qo‘lda kirim',
  'receipt.description':
    'Import qabulidan TASHQARI kirimlar: mijoz qaytargan tovar, sinovdan qaytgan namuna, qo‘lda topilgan qoldiq.',
  'receipt.txnType': 'Kirim turi',
  'receipt.submit': 'Kirimni yozish',
  'receipt.costWhy':
    'Tannarx MAJBURIY: usiz o‘rtacha tannarx hisoblanmaydi va keyingi chiqimning COGS i noto‘g‘ri chiqadi.',
  'receipt.done': 'Kirim yozildi: {qty} {sku}',
  'receipt.importHint':
    'Konteyner qabuli bu ekran orqali kiritilmaydi — u xarid hujjatidan (goods receipt) keladi va tannarxni landed cost hisoblaydi.',

  // --- Ombor: qo'lda chiqim ---
  'issue.title': 'Qo‘lda chiqim',
  'issue.description':
    'Sotuvdan TASHQARI chiqimlar: namuna, vitrina, sinovga berish, ta’minotchiga qaytarish.',
  'issue.txnType': 'Chiqim turi',
  'issue.submit': 'Chiqimni yozish',
  'issue.noCost':
    'Chiqimda tannarx kiritilmaydi: u JORIY o‘rtacha bo‘yicha baholanadi. Chiqim narxini qo‘lda berish foydani «tuzatish» yo‘lini ochardi.',
  'issue.done': 'Chiqim yozildi: {qty} {sku}',
  'issue.available': 'Erkin qoldiq: {qty}',

  // --- Ombor: ko'chirish ---
  'transfer.title': 'Omborlararo ko‘chirish',
  'transfer.description':
    'Chiqim DARHOL yoziladi: tovar jismonan yo‘lda va uni manba ombor qoldig‘ida ko‘rsatib turish yolg‘on bo‘lardi. Kirim esa qabul qilinganda.',
  'transfer.new': 'Yangi ko‘chirish',
  'transfer.create': 'Ko‘chirishni yaratish',
  'transfer.sameWarehouse': 'Manba va qabul qiluvchi ombor bir xil bo‘lishi mumkin emas',
  'transfer.lines': 'Satrlar',
  'transfer.receive': 'Qabul qilish',
  'transfer.partialHint':
    'Yetib kelmagan satrga NOL yozing — yetishmagan miqdor hujjatda qoladi va ogohlantirishga tushadi.',
  'transfer.receiveFull': 'Hammasini to‘liq qabul qilish',
  'transfer.receivePartial': 'Qisman qabul',
  'transfer.receivedQty': 'Qabul qilindi',
  'transfer.sentQty': 'Jo‘natildi',
  'transfer.status.in_transit': 'Yo‘lda',
  'transfer.status.received': 'Qabul qilindi',
  'transfer.status.cancelled': 'Bekor qilingan',
  'transfer.list': 'Ko‘chirish hujjatlari',
  'transfer.statusAll': 'Barcha holatlar',
  'transfer.lineCount': 'Satr',
  'transfer.totalQty': 'Jami miqdor',
  'transfer.createdBy': 'Kim yaratdi',
  'transfer.empty': 'Ko‘chirish hujjati topilmadi',
  'transfer.emptyHint': 'Filtrni kengaytiring yoki yangi ko‘chirish yarating.',
  'transfer.loadError': 'Ko‘chirish hujjatlarini yuklab bo‘lmadi',
  'transfer.pending': 'Qabul kutilmoqda: {count}',
  'transfer.pendingNone': 'Qabul kutayotgan ko‘chirish yo‘q',
  'transfer.openDoc': 'Hujjatni ochish',
  'transfer.closeDoc': 'Hujjatni yopish',
  'transfer.created': 'Ko‘chirish yaratildi: {docNo}',
  'transfer.receivedOk': '{docNo} qabul qilindi',
  'transfer.ledger': 'Ko‘chirish harakatlari (daftardan)',

  // --- Ombor: inventarizatsiya ---
  'count.title': 'Inventarizatsiya',
  'count.description':
    'Sanoqni omborchi kiritadi, TASDIQLASHNI esa boshqa xodim bajaradi. O‘zi sanab, o‘zi tasdiqlagan kamomad hech kimga ko‘rinmaydi.',
  'count.new': 'Yangi varaq',
  'count.create': 'Varaqni yaratish',
  'count.type': 'Sanoq turi',
  'count.type.full': 'To‘liq (butun ombor)',
  'count.type.cycle': 'Tsiklik (tanlangan SKU)',
  'count.type.blind': 'Ko‘r sanoq (tizim qoldig‘i ko‘rinmaydi)',
  'count.typeHint':
    '«Ko‘r sanoq» da tizim qoldig‘i sanovchiga ko‘rsatilmaydi. Sonni ko‘rgan xodim beixtiyor o‘shanga moslab yozadi va sanoq ma’nosini yo‘qotadi.',
  'count.products': 'Sanaladigan mahsulotlar',
  'count.productsHint':
    'Bo‘sh qoldirilsa — omborda qatori bor BARCHA mahsulot varaqqa tushadi (to‘liq inventarizatsiya).',
  'count.systemQty': 'Tizim',
  'count.countedQty': 'Sanaldi',
  'count.varianceQty': 'Farq',
  'count.varianceValue': 'Farq qiymati',
  'count.reason': 'Sabab',
  'count.reasonRequired': 'Farq bor satrda sabab ko‘rsatilishi kerak',
  'count.saveLines': 'Satrlarni saqlash',
  'count.post': 'Tasdiqlash va daftarga yozish',
  'count.postHint':
    'Tasdiqlangandan keyin farqlar ombor daftariga yoziladi va qaytarib bo‘lmaydi.',
  'count.created': 'Varaq yaratildi: {docNo}',
  'count.saved': 'Satrlar saqlandi',
  'count.posted': '{docNo} tasdiqlandi va daftarga yozildi',
  'count.approveElsewhere':
    'Varaqni siz tasdiqlay olmaysiz — bu ataylab: o‘zi sanab, o‘zi tasdiqlagan kamomad hech kimga ko‘rinmaydi. Satrlarni saqlang va moliyachi/rahbarga xabar bering.',
  'count.list': 'Inventarizatsiya hujjatlari',
  'count.kind': 'Hujjat turi',
  'count.kind.all': 'Hammasi',
  'count.kind.count': 'Inventarizatsiya (CNT)',
  'count.kind.adjustment': 'Korrektirovka (ADJ)',
  'count.kindHint':
    'Sanoq va korrektirovka bitta jadvalda saqlanadi va faqat hujjat raqami prefiksi bilan farqlanadi. Ularni aralashtirib ko‘rsatish «bu hujjat qayerdan keldi?» degan savolni tug‘diradi.',
  'count.statusAll': 'Barcha holatlar',
  'count.lineCount': 'Satr',
  'count.varianceLines': 'Farqli satr',
  'count.createdBy': 'Kim yaratdi',
  'count.empty': 'Inventarizatsiya hujjati topilmadi',
  'count.emptyHint': 'Filtrni kengaytiring yoki yangi varaq yarating.',
  'count.loadError': 'Inventarizatsiya hujjatlarini yuklab bo‘lmadi',
  'count.open': 'Ochiq varaqlar: {count}',
  'count.openDoc': 'Varaqni ochish',
  'count.closeDoc': 'Varaqni yopish',
  'count.detailLoadError': 'Varaqni yuklab bo‘lmadi',
  'count.blindSystemHidden':
    'Ko‘r sanoq: tizim qoldig‘i ekranda KO‘RSATILMAYDI. Server uni o‘qish javobida yuboradi, lekin sanoq ma’nosini saqlash uchun ekran uni chizmaydi.',
  'count.varianceValueHint':
    'Farqning pul qiymati aynan shu ekranda ko‘rsatiladi — bu alohida beriladigan tor huquq, boshqa hech qayerda tannarx ochilmaydi.',
  'count.status.draft': 'Kiritilmoqda',
  'count.status.counted': 'Sanaldi',
  'count.status.posted': 'Tasdiqlangan',
  'count.status.cancelled': 'Bekor qilingan',

  'variance.damaged': 'Shikastlangan',
  'variance.lost': 'Yo‘qolgan',
  'variance.miscount': 'Noto‘g‘ri sanalgan',
  'variance.theft': 'O‘g‘irlik',
  'variance.found': 'Ortiqcha topildi',
  'variance.expired': 'Muddati o‘tgan',
  'variance.other': 'Boshqa',
  'variance.select': 'Sababni tanlang',

  // --- Savdo: buyurtmalar ro'yxati ---
  'so.title': 'Sotuv buyurtmalari',
  'so.new': 'Yangi buyurtma',
  'so.searchPlaceholder': 'Hujjat raqami yoki mijoz',
  'so.docNo': 'Hujjat',
  'so.customer': 'Mijoz',
  'so.orderDate': 'Sana',
  'so.deliveryDate': 'Yetkazish',
  'so.total': 'Summa',
  'so.paymentMethod': 'To‘lov',
  'so.status': 'Holat',
  'so.statusAll': 'Barcha holatlar',
  'so.empty': 'Buyurtma topilmadi',
  'so.emptyHint': 'Filtrni kengaytiring yoki yangi buyurtma yarating.',
  'so.loadError': 'Buyurtmalarni yuklab bo‘lmadi',
  'so.onlyPreorder': 'Faqat pre-order satri borlari',
  'so.onlyPreorderHint':
    'Yo‘ldagi konteynerdan sotilgan buyurtmalar. Konteyner ETA si siljisa, aynan shular ta’sirlanadi.',

  'so.status.draft': 'Qoralama',
  'so.status.submitted': 'Yuborilgan',
  'so.status.confirmed': 'Tasdiqlangan',
  'so.status.partially_delivered': 'Qisman jo‘natilgan',
  'so.status.delivered': 'Jo‘natilgan',
  'so.status.invoiced': 'Hisob-faktura chiqarilgan',
  'so.status.closed': 'Yopilgan',
  'so.status.cancelled': 'Bekor qilingan',

  'so.pay.cash': 'Naqd',
  'so.pay.transfer': 'O‘tkazma',
  'so.pay.mixed': 'Aralash',

  /*
   * KANAL YORLIQLARI — xodim tilida, tizim tilida emas.
   *
   * Ustunda `erp` / `agent` / `portal` / `pos` turadi, lekin omborchi uchun
   * ma'noli farq boshqa: buyurtmani OFISDAGI odam kiritdimi, dala AGENTI
   * telefondan yubordimi, mijoz O'ZI kabinetdan tashladimi, yoki bu do'kon
   * KASSASIDAGI sotuvmi. `erp` so'zi hech qanday xodimga hech narsa
   * aytmaydi — «Ofis» aytadi.
   */
  'so.source': 'Kanal',
  'so.source.erp': 'Ofis',
  'so.source.agent': 'Agent',
  'so.source.portal': 'Onlayn',
  'so.source.pos': 'Kassa',

  // «Xil» — DONA emas, TUR: 30 dona bitta lampa — bu 1 xil.
  'so.kinds': 'Satr',
  'so.kindsHint':
    'Buyurtmadagi satrlar soni — qator ochilganda ko‘rinadigan qatorlar. Miqdor emas.',
  'so.linesLoadError': 'Satrlarni yuklab bo‘lmadi',
  'so.linesEmpty': 'Bu buyurtmada satr yo‘q',
  'so.openCard': 'Kartochkani ochish',

  // --- Savdo: yangi buyurtma ---
  'so.newTitle': 'Yangi sotuv buyurtmasi',
  'so.header': 'Buyurtma sarlavhasi',
  'so.currency': 'Valyuta',
  'so.paymentTermDays': 'To‘lov muddati, kun',
  'so.notes': 'Izoh',
  'so.submit': 'Buyurtmani yaratish',
  'so.customerRequired': 'Mijoz tanlanishi shart',
  'so.warehouseRequired': 'Ombor tanlanishi shart',
  'so.linesRequired': 'Kamida bitta to‘liq satr kerak',
  'so.created': 'Buyurtma yaratildi: {docNo}',

  'so.keyboardTitle': 'Klaviatura bilan kiritish',
  'so.keyboardHint':
    'Tab — keyingi katak, Enter — yangi satr, Escape — satrni tozalash. Mahsulot maydonida ↓/↑ ro‘yxat bo‘ylab yuradi, Tab esa faol qatorni tanlab miqdorga o‘tadi. Sichqoncha kerak emas.',

  /*
   * RO'YXATDAN JOYLASH (`components/bulk-line-paste.tsx`, 2026-08-15).
   *
   * Kalitlar `so.` emas, `bulk.`: panel savdo buyurtmasiga bog'liq emas va
   * xarid buyurtmasi, qabul, ko'chirish ekranlariga ham qo'yiladi. `so.`
   * prefiksi bilan boshlansa, ikkinchi ekranda «savdo» kalitini o'qish
   * g'alati bo'lardi.
   */
  'bulk.open': 'Ro‘yxatdan joylash',
  'bulk.title': 'Ro‘yxatni joylashtiring',
  'bulk.hint':
    'Har qator: KOD, miqdor, narx. Ustunlar TAB yoki «;» bilan ajratiladi (Excel’dan nusxa olsangiz o‘zi shunday bo‘ladi). Narx bo‘sh qoldirilsa — mijozning shartnoma narxi olinadi.',
  'bulk.placeholder': 'LMP-001\t10\nPNL-060\t25\t24.50',
  'bulk.hintNoPrice': 'Har qator: KOD, miqdor. Ustunlar TAB yoki «;» bilan ajratiladi (Excel’dan nusxa olsangiz o‘zi shunday bo‘ladi). Bu hujjatda narx kiritilmaydi — u serverda aniqlanadi.',
  'bulk.placeholderNoPrice': 'LMP-001\t10\nPNL-060\t25',
  'bulk.rows': '{count} ta qator',
  'bulk.apply': 'Qo‘shish',
  'bulk.resolving': 'Kodlar tekshirilmoqda…',
  'bulk.tooMany':
    'Bir marotabada {max} tagacha qator. Ro‘yxatni bo‘lib joylashtiring — qolgani yo‘qolmaydi.',
  'bulk.invalid':
    '{count} ta qatorda xato (qatorlar: {lines}). Kod bo‘sh, miqdor noldan katta emas yoki narx formati noto‘g‘ri.',
  'bulk.unknownTitle': 'Bu kodlar topilmadi',
  'bulk.unknownBody':
    '{skus} — qolganlari qo‘shildi. Kodni tekshiring yoki mahsulotni avval katalogga kiriting.',
  'bulk.noneResolved': 'Birorta ham kod topilmadi — ro‘yxat qo‘shilmadi',
  'so.lines': 'Satrlar',
  'so.lineNo': '№',
  'so.lineQty': 'Miqdor',
  'so.lineListPrice': 'Ro‘yxat narxi',
  'so.linePrice': 'Narx',
  'so.lineAmount': 'Summa',
  'so.lineDiscount': 'Chegirma',
  'so.lineType': 'Ta’minot',
  'so.linePriceSource': 'Narx manbai',
  'so.lineBonus': 'Bonus',
  'so.lineRemove': 'Satrni o‘chirish',
  'so.lineAdd': 'Satr qo‘shish (Enter)',
  'so.priceLoading': 'Narx aniqlanmoqda…',
  'so.priceMissing': 'Narx topilmadi — qo‘lda kiriting',

  'price.customer_price': 'Mijoz narxi',
  'price.price_list': 'Narx ro‘yxati',
  'price.manual': 'Qo‘lda',
  'price.sourceHint.customer_price': 'Mijoz bilan kelishilgan maxsus narx',
  'price.sourceHint.price_list': '«{code}» narx ro‘yxatidan',
  'price.sourceHint.manual': 'Qo‘lda kiritilgan narx — nazarda tutilgan chegirma {pct}%',

  'so.fulfillment.stock': 'Omborda',
  'so.fulfillment.preorder': 'Yo‘lda (pre-order)',
  'so.preorderShipment': 'Konteyner',
  'so.preorderShipmentRequired': 'Pre-order satr uchun konteyner tanlanishi shart',
  'so.preorderSelectShipment': 'Konteynerni tanlang',
  'so.preorderEta': 'ETA {date}',
  'so.preorderFree': 'erkin {qty}',
  'so.preorderNoShipment': 'Bu mahsulot ochiq konteynerlarda yo‘q',
  'so.preorderNoAccess':
    'Konteyner ro‘yxatini ko‘rish huquqi sizda yo‘q — pre-order satr kirita olmaysiz. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'so.promisedDate': 'Va’da qilingan sana',
  'so.promisedDateHint':
    'Mijozga aytilgan sana. Konteyner ETA si siljisa, aynan shu satr bo‘yicha ogohlantiriladi.',
  'so.preorderWhy':
    'Lead time 120-150 kun: mijoz hali Xitoydan chiqmagan tovarni sotib oladi. Bu istisno emas, biznesning yarmi — shuning uchun satrda «omborda» va «yo‘lda» ni ADASHTIRIB bo‘lmaydi.',
  'so.mixSummary': '{stock} satr omborda, {preorder} satr yo‘lda',

  'so.bonusHint':
    'Bonus satr narxi 0, lekin TANNARXI real: bu tovar kompaniyaga pulga tushadi va marjadan ayriladi. Bonus — yashirin chegirma.',
  'so.bonusCostWarning': 'Bonus: narx 0, tannarx esa saqlanadi',
  'so.bonusValue': 'Bonus qiymati (ro‘yxat narxida)',

  'so.totals': 'Jami',
  'so.subtotal': 'Satrlar summasi',
  'so.discountTotal': 'Chegirma',
  'so.grandTotal': 'To‘lanadigan summa',
  'so.totalPreview': 'Oldindan hisob — yakuniy summa serverdan qaytadi',
  'so.lineCount': '{count} ta satr',

  'so.paymentChanged': 'To‘lov usuli o‘zgardi: {from} → {to}',
  'so.paymentChangedBody':
    'Har satr QAYTA narxlandi. Naqd va o‘tkazma narxi 3-7% farq qiladi va bu farq jimgina yo‘qolib ketmasligi kerak — quyida nima o‘zgargani turibdi.',
  'so.repricing': 'Satrlar qayta narxlanmoqda…',
  'so.repricedNone': 'Bironta satr narxi o‘zgarmadi.',
  'so.repricedManualKept':
    'Qo‘lda kiritilgan narxlarga tegilmadi — ular kelishuv natijasi, avtomatik tuzatilmaydi.',
  'so.repricedOld': 'Eski narx',
  'so.repricedNew': 'Yangi narx',
  'so.repricedDelta': 'Farq',
  'so.repricedLost': 'Bu to‘lov usulida narx topilmadi',
  'so.dismiss': 'Yopish',

  'so.credit': 'Kredit holati',
  'so.creditLimit': 'Limit',
  'so.creditDebt': 'Joriy qarz',
  'so.creditAvailable': 'Bo‘sh limit',
  'so.creditOverdue': 'Kechikkan',
  'so.creditBlockedCustomer': 'Mijoz BLOKLANGAN — bu buyurtma tasdiqlanmaydi',
  'so.creditWillExceed':
    'Buyurtma summasi bo‘sh limitdan oshadi. Tasdiqlashda kredit tekshiruvi to‘xtatadi.',
  'so.creditNoLimit': 'Limit belgilanmagan',
  'so.creditCurrencyNote':
    'Taqqoslash faqat USD buyurtmalarda ko‘rsatiladi: qarz USD da yuritiladi, boshqa valyutadagi summa esa server kursida hisoblanadi.',
  'so.creditLoadError': 'Mijoz qarzini yuklab bo‘lmadi',

  // --- Savdo: buyurtma kartochkasi ---
  'so.detailTitle': 'Buyurtma {docNo}',
  'so.confirm': 'Tasdiqlash',
  'so.confirmHint':
    'Tasdiqlashda kredit limiti tekshiriladi va tovar rezervga olinadi.',
  'so.confirmed': 'Buyurtma tasdiqlandi',
  'so.cancel': 'Bekor qilish',
  'so.cancelTitle': 'Buyurtmani bekor qilish',
  'so.cancelReason': 'Bekor qilish sababi',
  'so.cancelReasonRequired': 'Sabab kamida 3 ta belgidan iborat bo‘lishi kerak',
  'so.cancelled': 'Buyurtma bekor qilindi',
  'so.createDelivery': 'Yuk xati yaratish',
  'so.createDeliveryHint':
    'Yuk xati yaratiladi, lekin POST QILINMAYDI: u chop etiladi, mashinaga yuklanadi va tovar chiqqach omborchi tasdiqlaydi.',
  'so.deliveryCreated': 'Yuk xati yaratildi: {docNo}',
  'so.createInvoice': 'Hisob-faktura yaratish',
  'so.createInvoiceHint':
    'Hisob-faktura FAKTDA chiqqan tovarga yoziladi — post qilingan yuk xati satrlaridan quriladi.',
  'so.invoiceCreated': 'Hisob-faktura yaratildi: {docNo}',
  'so.deliveries': 'Yuk xatlari',
  'so.invoices': 'Hisob-fakturalar',
  'so.noDeliveries': 'Yuk xati yo‘q',
  'so.noInvoices': 'Hisob-faktura yo‘q',
  'so.notFound': 'Buyurtma topilmadi yoki sizga ko‘rinmaydi',
  'so.deliveredQty': 'Jo‘natildi',

  'so.creditCheck': 'Kredit tekshiruvi',
  'so.creditCheck.passed': 'O‘tdi',
  'so.creditCheck.blocked': 'To‘xtatilgan',
  'so.creditBlockedBody':
    'Bu buyurtma kredit limiti tufayli to‘xtab turibdi. U bekor qilinmagan — muzokara uchun ochiq: mijoz to‘lov qilsa yoki rahbar limitdan o‘tkazsa, tasdiqlash davom etadi.',
  'so.creditCheck.overridden': 'LIMITDAN O‘TKAZILGAN',
  'so.creditOverriddenTitle': 'Bu buyurtma kredit limitidan O‘TKAZIB yuborilgan',
  'so.creditOverriddenBody':
    'Mijozning ochiq qarzi limitdan oshgan, lekin xodim buyurtmani ongli ravishda o‘tkazgan. Sabab audit jurnalida saqlanadi. Bu qarorni ko‘rinmas qilib qo‘yish mumkin emas — qarz undirilmasa, javob shu satrdan boshlanadi.',
  'so.overrideTitle': 'Kredit limitidan o‘tkazish',
  'so.overrideReason': 'Sabab',
  'so.overrideReasonRequired': 'Sabab kamida 5 ta belgidan iborat bo‘lishi kerak',
  'so.overrideSubmit': 'Sabab bilan tasdiqlash',
  'so.overrideNoPermission':
    'Kredit limitidan o‘tkazish uchun ruxsatingiz yo‘q. Rahbarga murojaat qiling.',

  'so.margin': 'Marja',
  'so.marginCogs': 'Tannarx',
  'so.marginProfit': 'Yalpi foyda',
  'so.marginPct': 'Marja, %',
  'so.marginBonusCost': 'Bonus tannarxi',
  'so.marginHidden': 'Marja ko‘rsatkichlari sizga ochilmaydi — bu ruxsat masalasi.',

  // --- Savdo: yetkazishlar va haydovchiga biriktirish ---
  'dlv.title': 'Yetkazishlar',
  'dlv.description':
    'Bugun nima yetkaziladi va kim olib ketadi. Yuk xati chiqarilgach unga haydovchi biriktiriladi — mashinani omborchi yuklaydi, demak kimga berishni ham u biladi.',
  'dlv.docNo': 'Yuk xati',
  'dlv.salesOrder': 'Buyurtma',
  'dlv.date': 'Sana',
  'dlv.status': 'Hujjat holati',
  'dlv.status.draft': 'Qoralama',
  'dlv.status.posted': 'Chiqarilgan',
  'dlv.status.cancelled': 'Bekor qilingan',
  'dlv.statusAll': 'Barcha holatlar',
  'dlv.driver': 'Haydovchi',
  'dlv.driverAll': 'Barcha haydovchilar',
  'dlv.driverStatus': 'Yetkazish holati',
  'dlv.driverStatus.unassigned': 'Biriktirilmagan',
  'dlv.driverStatus.pending': 'Kutilmoqda',
  'dlv.driverStatus.delivered': 'Yetkazildi',
  'dlv.driverStatus.failed': 'Yetkazilmadi',
  'dlv.filterUnassigned': 'Faqat biriktirilmaganlar',
  'dlv.filterUnassignedHint':
    'Ertalabki ish shu ro‘yxatdan boshlanadi: hali hech kimga berilmagan yetkazishlar.',
  'dlv.filterDate': 'Yetkazish sanasi',
  'dlv.searchPlaceholder': 'Yuk xati yoki buyurtma raqami',
  'dlv.empty': 'Yetkazish topilmadi',
  'dlv.emptyHint': 'Sana yoki holat filtrini kengaytiring.',
  'dlv.loadError': 'Yetkazishlar ro‘yxatini yuklab bo‘lmadi',
  'dlv.actions': 'Amal',
  'dlv.assign': 'Biriktirish',
  'dlv.reassign': 'Almashtirish',
  'dlv.unassign': 'Olib tashlash',
  'dlv.assignTitle': '{docNo} — haydovchiga biriktirish',
  'dlv.assignDriverPlaceholder': 'Haydovchini tanlang',
  'dlv.assignMany': '{count} ta yetkazishga biriktirish',
  'dlv.assignVehicle': 'Mashina raqami',
  'dlv.assignVehicleHint':
    'Ixtiyoriy. Yuklayotgan mashinani hozir ko‘rib turibsiz — keyin alohida ekranda kiritish deyarli hech qachon bajarilmaydi.',
  'dlv.assignSubmit': 'Biriktirish',
  'dlv.assigned': '{docNo} — {driver} ga biriktirildi',
  'dlv.unassignDone': '{docNo} — biriktirish olib tashlandi',
  'dlv.unassignHint':
    'Olib tashlansa haydovchi ismi ham, mashina raqami ham tozalanadi: ular biriktirishda shu haydovchidan yozilgan edi.',
  'dlv.assignedAt': 'Biriktirilgan',
  'dlv.driversEmpty':
    'Faol dastavkachi yo‘q. Biriktirish uchun avval xodimga dastavkachi roli berilishi kerak — buni administrator qiladi.',
  'dlv.driversLoadError': 'Haydovchilar ro‘yxatini yuklab bo‘lmadi',
  'dlv.notAssignable': 'O‘zgarmaydi',
  'dlv.notAssignableHint':
    'Bekor qilingan hujjat yoki yakunlangan yetkazish qayta biriktirilmaydi — bu tarixni qayta yozish bo‘lardi.',
  'dlv.failReason': 'Yetkazilmagan sabab',
  'dlv.receivedBy': 'Qabul qilgan',
  'dlv.deliveredAt': 'Yetkazilgan vaqt',
  'dlv.cashTitle': 'Haydovchilar qo‘lidagi naqd pul',
  'dlv.cashHint':
    'Bu TO‘LOV EMAS: mijoz qarzini kamaytirmaydi va kassaga tushmagan. Pul topshirilganda to‘lovni moliyachi yaratadi — aynan o‘shanda qarz yopiladi.',
  'dlv.cashEmpty': 'Bu davrda haydovchilarda naqd pul yig‘ilmagan',
  'dlv.cashLoadError': 'Naqd pul ma’lumotini yuklab bo‘lmadi',
  'dlv.cashDeliveries': '{count} ta yetkazish',
  'dlv.cashTotal': 'Jami',
  'dlv.cashAmount': 'Summa',

  // --- Mijoz kabineti foydalanuvchilari (portal.manage) ---
  'customer.tab.card': 'Kartochka',
  'customer.tab.portal': 'Kabinet foydalanuvchilari',
  'pu.title': 'Mijoz kabineti foydalanuvchilari',
  'pu.description':
    'Do‘kon xodimlari kabinetga TELEFON raqami bilan kiradi. Har xodimga alohida hisob ochiladi: kim buyurtma berganini keyin aniqlash uchun.',
  'pu.empty': 'Bu mijozda kabinet foydalanuvchisi yo‘q',
  'pu.emptyHint': 'Kabinet ochilsa, do‘konchi buyurtmani o‘zi kiritadi va qarzini ko‘radi.',
  'pu.loadError': 'Kabinet foydalanuvchilarini yuklab bo‘lmadi',
  'pu.phone': 'Telefon',
  'pu.fullName': 'Ism',
  'pu.position': 'Lavozimi',
  'pu.positionHint': 'Do‘kondagi vazifasi: egasi, sotuvchi, buxgalter. Erkin matn.',
  'pu.canOrder': 'Zakaz berish',
  'pu.canOrder.yes': 'Zakaz bera oladi',
  'pu.canOrder.no': 'Faqat ko‘rish',
  'pu.canOrderHint':
    '«Faqat ko‘rish» — bloklash EMAS: odam kabinetga kiradi, katalogni, qarzini va buyurtmalar tarixini ko‘radi, lekin yangi buyurtma yubora olmaydi. Do‘kon buxgalteri uchun aynan shu kerak.',
  'pu.status': 'Holat',
  'pu.active': 'Faol',
  'pu.blocked': 'Bloklangan',
  'pu.mustChange': 'Parolni almashtirishi kerak',
  'pu.invitedAt': 'Ochilgan',
  'pu.lastLoginAt': 'Oxirgi kirish',
  'pu.neverLoggedIn': 'Hali kirmagan',
  'pu.new': 'Kabinet ochish',
  'pu.newTitle': 'Yangi kabinet foydalanuvchisi',
  'pu.phoneHint':
    'Ixtiyoriy formatda yozing (+998 90 123-45-67 ham bo‘ladi) — server uni bitta ko‘rinishga keltiradi.',
  'pu.phoneRequired': 'Telefon raqami kamida 9 ta belgidan iborat bo‘lishi kerak',
  'pu.fullNameRequired': 'Ism kamida 2 ta belgidan iborat bo‘lishi kerak',
  'pu.submit': 'Ochish va parol berish',
  'pu.block': 'Bloklash',
  'pu.unblock': 'Ochish',
  'pu.blockTitle': '{name} — kabinetni bloklash',
  'pu.blockReasonRequired': 'Bloklash sababi kamida 3 ta belgidan iborat bo‘lishi kerak',
  'pu.blockReasonWhy':
    'Sabab auditda qoladi: «bu hisob nega yopilgan?» degan savol bir oy o‘tib muqarrar chiqadi.',
  'pu.blockDone': '{name} — kabinet bloklandi',
  'pu.unblockDone': '{name} — kabinet ochildi',
  'pu.reset': 'Parolni tiklash',
  'pu.resetHint':
    'Eski parol darhol ishlamay qoladi va ochiq sessiyalar uziladi. Yangi parolni do‘konchiga o‘zingiz yetkazasiz.',
  'pu.secretTitle': 'Vaqtinchalik parol — BIR MARTA ko‘rsatiladi',
  'pu.secretBody':
    'Bu parolni hozir yozib oling yoki do‘konchiga ayting. Bazada faqat uning xeshi saqlanadi, ya’ni server uni QAYTA BERMAYDI: bu oyna yopilgach yagona yo‘l — parolni qaytadan tiklash.',
  'pu.secretFor': '{name} · {phone}',
  'pu.secretAck': 'Yozib oldim',
  'pu.actions': 'Amal',
  'pu.created': '{name} uchun kabinet ochildi',
  'pu.resetDone': '{name} uchun yangi parol berildi',

  // --- Xarid: buyurtmalar (PO) ---
  'po.title': 'Xarid buyurtmalari',
  'po.description':
    "Xitoy zavodiga berilgan buyurtma. Satrlar zavod valyutasida (CNY), yonida esa HUJJAT kursi bo'yicha dollar ekvivalenti — bugungi kurs bo'yicha emas.",
  'po.new': 'Yangi buyurtma',
  'po.newTitle': 'Yangi xarid buyurtmasi',
  'po.detailTitle': 'Xarid buyurtmasi {docNo}',
  'po.searchPlaceholder': "Hujjat raqami yoki ta'minotchi",
  'po.docNo': 'Hujjat',
  'po.supplier': "Ta'minotchi",
  'po.supplierRequired': "Ta'minotchi tanlanishi shart",
  'po.legalEntity': 'Yuridik shaxs',
  'po.orderDate': 'Buyurtma sanasi',
  'po.expectedDate': 'Kutilayotgan sana',
  'po.expectedDateHint':
    'Fabrikadan kutilayotgan sana. Lead time 120-150 kun — reja shu asosda quriladi.',
  'po.currency': 'Valyuta',
  'po.status': 'Holat',
  'po.statusAll': 'Barcha holatlar',
  'po.notes': 'Izoh',
  'po.lines': 'Satrlar',
  'po.lineQty': 'Miqdor',
  'po.lineUnitPrice': 'Narx ({currency}/dona)',
  'po.lineAmount': 'Summa ({currency})',
  'po.lineBase': 'USD ekvivalenti',
  'po.received': 'Qabul qilindi',
  'po.outstanding': 'Kutilmoqda',
  'po.total': 'Jami ({currency})',
  'po.totalBase': 'Jami (USD)',
  'po.fxRate': 'Hujjat kursi',
  'po.fxRateLine': '1 USD = {rate} {currency}',
  'po.fxRateWhy':
    "USD ekvivalenti HUJJAT kursi bilan hisoblangan, bugungi kurs bilan emas. Buyurtma 4 oy oldin berilgan bo'lsa, o'shandagi kurs bugungi qiymatga aloqador emas — kurs hujjatga yozib qo'yiladi va o'zgarmaydi.",
  'po.priceHidden':
    'Narx va summa ustunlari sizga ko‘rsatilmaydi — sizda ta‘minotchi ma‘lumotlarini ko‘rish huquqi yo‘q. Bu ruxsat masalasi, xato emas; kerak bo‘lsa rahbaringizga murojaat qiling.',
  'po.submit': 'Buyurtmani yaratish',
  'po.created': 'Buyurtma yaratildi: {docNo}',
  'po.approve': 'Tasdiqlash',
  'po.approveTitle': 'Buyurtmani tasdiqlash',
  'po.approveHint':
    "Tasdiqlangandan keyin buyurtma fabrikaga ketgan hisoblanadi va satrlarni o'zgartirib bo'lmaydi: hujjat kelayotgan tovardan ajralib qolsa, farq qabulda «kamomad» bo'lib ko'rinadi, aslida esa hujjat noto'g'ri.",
  'po.approveNotes': 'Izoh (auditga tushadi)',
  'po.approved': 'Buyurtma tasdiqlandi',
  'po.approvedAt': 'Tasdiqlangan',
  'po.notApprovable': "Bu holatda tasdiqlash mumkin emas — faqat qoralama va yuborilgan buyurtma tasdiqlanadi.",
  'po.cancel': 'Bekor qilish',
  'po.cancelTitle': 'Buyurtmani bekor qilish',
  'po.cancelHint':
    "Bekor qilingan buyurtma «kutilayotgan tovar» ro'yxatidan chiqadi va uni qaytarib bo'lmaydi. Tovar allaqachon kelgan bo'lsa (qabul post qilingan) bekor qilish MUMKIN EMAS — hujjatni bekor qilish ombordagi qoldiqni va hisoblangan tannarxni yo'q qilmaydi.",
  'po.cancelReason': 'Sabab (majburiy, auditga tushadi)',
  'po.cancelReasonHint': "Kamida 3 belgi. «Nima uchun bekor qilindi?» degan savolga javob shu yerda qoladi.",
  'po.cancelConfirm': 'Ha, bekor qilinsin',
  'po.cancelled': 'Buyurtma bekor qilindi',
  'po.cancelledTitle': 'Buyurtma bekor qilingan',
  'po.notCancellable':
    "Bu holatda bekor qilish mumkin emas — tovar allaqachon qabul qilingan yoki hujjat yopilgan.",
  'po.linesRequired': "Kamida bitta to'liq satr kerak",
  'po.empty': 'Buyurtma topilmadi',
  'po.emptyHint': 'Filtrni kengaytiring yoki yangi buyurtma yarating.',
  'po.loadError': "Xarid buyurtmalarini yuklab bo'lmadi",
  'po.notFound': "Buyurtma topilmadi yoki sizga ko'rinmaydi",
  'po.includeCancelled': "Bekor qilinganlarni ham ko'rsatish",
  'po.noSuppliers': "Ta'minotchilar ro'yxati bo'sh yoki sizga ochiq emas",

  'po.status.draft': 'Qoralama',
  'po.status.submitted': 'Yuborilgan',
  'po.status.approved': 'Tasdiqlangan',
  'po.status.in_production': 'Ishlab chiqarishda',
  'po.status.shipped': "Jo'natilgan",
  'po.status.partially_received': 'Qisman qabul qilingan',
  'po.status.received': 'Qabul qilingan',
  'po.status.closed': 'Yopilgan',
  'po.status.cancelled': 'Bekor qilingan',

  // --- Xarid: konteynerlar ---
  'shp.title': 'Konteynerlar',
  'shp.description':
    "Yo'ldagi va kelgan yuklar. Har satrda ETA va haqiqat, tannarx holati hamda ENG MUHIMI — konteynerdan qancha sotilgani.",
  'shp.new': 'Yangi konteyner',
  'shp.newTitle': 'Yangi konteyner',
  'shp.detailTitle': 'Konteyner {docNo}',
  'shp.searchPlaceholder': 'Hujjat yoki konteyner raqami',
  'shp.docNo': 'Hujjat',
  'shp.containerNo': 'Konteyner',
  'shp.blNo': 'Konosament (BL)',
  'shp.departurePort': "Jo'nash porti",
  'shp.arrivalPort': 'Kelish porti',
  'shp.etd': 'ETD (reja)',
  'shp.eta': 'ETA (reja)',
  'shp.atd': "Jo'nadi (fakt)",
  'shp.ata': 'Keldi (fakt)',
  'shp.delay': 'Kechikish',
  'shp.delayDays': '+{days} kun',
  'shp.earlyDays': '−{days} kun',
  'shp.onTime': "O'z vaqtida",
  'shp.noAta': 'Hali kelmagan',
  'shp.delayHint':
    "Kechikish — ta'minotchi ishonchliligining yagona o'lchovi. 120-150 kunlik reja aynan shu ustunga tayanadi.",
  'shp.status': 'Holat',
  'shp.statusAll': 'Barcha holatlar',
  'shp.lcStatus': 'Tannarx holati',
  'shp.lcStatusAll': 'Barcha tannarx holatlari',
  'shp.notes': 'Izoh',
  'shp.lines': 'Satrlar',
  'shp.lineQty': 'Miqdor',
  'shp.sold': 'Sotilgan',
  'shp.free': 'Erkin',
  'shp.soldPct': 'Sotilgan ulushi',
  /*
   * `shp.weightKg` MATNI 0055 da «Brutto» ga o'zgardi, KALIT esa o'sha
   * qoldi — u bazadagi `weight_kg` ustunini ko'rsatadi va o'sha ustun
   * har doim brutto bo'lgan (faqat hech qayerda shunday yozilmagan edi).
   *
   * Ikki og'irlik ustuni yonma-yon turganda «Og'irlik» degan yorliq
   * qaysi biri ekanini aytmaydi va operator ularni almashtirib to'ldiradi.
   */
  'shp.weightKg': 'Brutto, kg/dona',
  'shp.netWeightKg': 'Netto, kg/dona',
  'shp.volumeM3': 'Hajm, m³/dona',
  'shp.dimHint':
    "Bu FAKTIK o'lchov: qadoq boshqacha bo'lsa mahsulot kartochkasidagidan farq qiladi. Bo'sh qoldirilsa, taqsimlash mahsulot ma'lumotnomasidan oladi. BRUTTO — o'ram bilan (yo'lkira shu bo'yicha taqsimlanadi), NETTO — tovarning o'zi (bojxona deklaratsiyasi uchun).",
  // --- Bojxona jamisi (0055) ---
  'shp.customsTitle': 'Bojxona jamisi',
  'shp.customsHint':
    "1 ta partiya yuk — 1 ta hujjat: bu raqamlar deklaratsiyaga shu holicha yoziladi. Jami SATRLARDAN hisoblanadi (miqdor × bir dona qiymati), shuning uchun jadvaldagi ustunni ko'zda qo'shib chiqish boshqa natija beradi.",
  'shp.totalQty': 'Jami dona',
  'shp.totalCartons': 'Jami karobka',
  'shp.totalGross': 'Jami brutto, kg',
  'shp.totalNet': 'Jami netto, kg',
  'shp.totalVolume': 'Jami hajm, m³',
  'shp.customsIncompleteTitle': "Jami to'liq emas",
  'shp.customsIncompleteBody':
    "O'lchovi kiritilmagan satrlar: brutto — {gross} ta, netto — {net} ta, hajm — {volume} ta. Ular jamiga UMUMAN kirmagan, ya'ni deklaratsiyaga kam raqam ketishi mumkin. Fakturadagi N.W. va G.W. ustunlarini tekshiring.",
  'shp.presoldTitle': 'Konteyner kelmasdan sotilgan',
  'shp.presoldBody':
    "Bu yukdan {sku} 100% sotilgan — erkin qoldiq nol. Konteyner kelmasdan hammasi sotilgan bo'lsa, KAM buyurtma qilingan: pul stolda qolgan. Keyingi buyurtma miqdorini shu satrga qarab belgilang.",
  'shp.presoldBadge': "To'liq sotilgan",
  'shp.underOrdered': "Kam buyurtma qilingan — {count} ta SKU bo'yicha erkin qoldiq yo'q",
  'shp.linesUnavailable': "Satrlarni yuklab bo'lmadi — «sotilgan/erkin» ko'rsatilmaydi",
  'shp.empty': 'Konteyner topilmadi',
  'shp.emptyHint': 'Filtrni kengaytiring yoki yopilganlarni yoqing.',
  'shp.includeClosed': "Yopilganlarni ham ko'rsatish",
  'shp.loadError': "Konteynerlarni yuklab bo'lmadi",
  'shp.notFound': "Konteyner topilmadi yoki sizga ko'rinmaydi",
  'shp.created': 'Konteyner yaratildi: {docNo}',
  'shp.submit': 'Konteynerni yaratish',
  'shp.advanceStatus': 'Holatni {status} ga o‘tkazish',
  'shp.statusChanged': 'Holat o‘zgartirildi: {status}',
  'shp.openReceipt': 'Tovarni qabul qilish',
  'shp.openProfit': 'Rentabellik hisoboti',

  'shp.status.planned': 'Rejalashtirilgan',
  'shp.status.in_transit': "Yo'lda",
  'shp.status.at_customs': 'Bojxonada',
  'shp.status.cleared': 'Bojxonadan chiqdi',
  'shp.status.received': 'Qabul qilingan',
  'shp.status.closed': 'Yopilgan',

  'lcs.pending': 'Hisoblanmagan',
  'lcs.estimated': 'Taxminiy',
  'lcs.final': 'Yakuniy',

  // --- Xarid: konteyner kartochkasi (tablar) ---
  'shp.tab.lines': 'Satrlar',
  'shp.tab.costs': 'Xarajatlar',
  'shp.tab.landedCost': 'Tannarx hisobi',

  // --- Xarid: xarajatlar ---
  'cost.title': 'Konteyner xarajatlari',
  'cost.description':
    "Navlon, bojxona, broker, sertifikat. Har xarajat O'Z valyutasida kiritiladi va O'Z sanasidagi kurs bo'yicha dollarga o'tkaziladi.",
  'cost.add': "Xarajat qo'shish",
  'cost.type': 'Xarajat turi',
  'cost.typeSelect': 'Turini tanlang',
  'cost.description2': 'Izoh',
  'cost.amount': 'Summa',
  'cost.currency': 'Valyuta',
  'cost.fxRate': 'Kurs',
  'cost.amountBase': 'USD ekvivalenti',
  'cost.incurredDate': 'Xarajat sanasi',
  'cost.incurredDateHint':
    'Kurs AYNAN shu sanadan olinadi. Boj UZS da to‘lanadi va boj sanasidagi kurs bilan hisoblanadi — bugungi kurs bilan emas.',
  'cost.documentRef': 'Hujjat raqami',
  'cost.isEstimate': 'Taxminiy (hujjat hali kelmagan)',
  'cost.isEstimateHint':
    "Taxminiy xarajat bilan tannarx «estimate» sifatida hisoblanadi va tovar sotuvga chiqadi. Hujjatlar kelgach «final» qayta hisob qilinadi.",
  'cost.estimateBadge': 'Taxminiy',
  'cost.supplier': 'Kimga to‘lanadi',
  'cost.supplierHint':
    'Bo‘sh qoldiring: boj va yig‘im davlatga to‘lanadi, nasiya bo‘lmaydi',
  'cost.supplierNone': 'Hech kimga (boj, yig‘im)',
  'cost.supplierAssign': 'Kontragentni belgilash',
  'cost.supplierSaved': 'Kontragent yozildi',
  'cost.invoicedBadge': 'Invoys keldi',
  'cost.invoicedLocked':
    'Bu qator bo‘yicha invoys tan olingan — kontragent va summa endi o‘zgarmaydi.',
  'cost.allocMethod': 'Taqsimlash usuli',
  'cost.allocRecommended': 'Tavsiya: {method}',
  'cost.allocOverridden': 'Tavsiyadan farq qiladi',
  'cost.allocWhy':
    'Taqsimlash usuli — MOLIYA qarori, dasturchi tanlovi emas. LED tovarlari yengil, lekin hajmli: dengiz yukini og‘irlik bo‘yicha taqsimlash yirik plafonni sun‘iy arzon, kichik lampani sun‘iy qimmat qiladi. Namunaviy konteynerda bitta noto‘g‘ri tanlov $448 ni noto‘g‘ri SKU ga ko‘chiradi.',
  'cost.totalBase': 'Jami xarajat (USD)',
  'cost.added': "Xarajat qo'shildi",
  'cost.empty': 'Bu konteynerda xarajat kiritilmagan',
  'cost.emptyHint': "Xarajatsiz tannarx hisobi tovar narxining o'zini beradi — bu to'liq tannarx emas.",
  'cost.loadError': "Xarajatlarni yuklab bo'lmadi",
  'cost.amountRequired': "Summa noldan katta bo'lishi kerak",
  'cost.typeRequired': 'Xarajat turi tanlanishi shart',
  'cost.noEditPermission':
    'Xarajat qo‘shish huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',

  'alloc.value': 'Qiymat bo‘yicha',
  'alloc.quantity': 'Miqdor bo‘yicha',
  'alloc.weight': 'Og‘irlik bo‘yicha',
  'alloc.volume': 'Hajm bo‘yicha',
  'alloc.manual': 'Qo‘lda',
  'alloc.hint.value': "Sug'urta, boj, bank komissiyasi — qiymatga proporsional",
  'alloc.hint.quantity': 'Dona bo‘yicha yig‘im, sertifikat',
  'alloc.hint.weight': 'Ichki transport, avia yuk — og‘irlik bo‘yicha',
  'alloc.hint.volume': 'Konteyner yuki va saqlash — joy hajm bo‘yicha sotiladi',
  'alloc.hint.manual': 'Bitta SKU ga tegishli xarajat — ulushni operator kiritadi',

  // --- Tannarx bo'limining ish maydoni (`/procurement/costing`) ---
  //
  // Bo'limning butun ishi bitta ekranda: konteyner tanlanadi → faktura
  // yuklanadi → xarajatlar va ularning taqsimlash usuli qo'yiladi →
  // har mahsulotning TANNARXI chiqadi.
  'costing.title': 'Tannarx bo‘limi',
  'costing.intro':
    "Konteyner tanlang: zavod fakturasini yuklang, xarajatlarni kiriting va har mahsulotning tannarxini ko‘ring. Xarajat kub, kg, soni yoki qiymat bo‘yicha taqsimlanadi — usul har xarajat qatorida tanlanadi.",
  'costing.selectPrompt': 'Ishni boshlash uchun yuqoridagi ro‘yxatdan konteyner tanlang.',
  'costing.containers': 'Konteynerlar',
  'costing.docNo': 'Hujjat',
  'costing.container': 'Konteyner',
  'costing.lcStatus': 'Tannarx holati',
  'costing.lineCount': 'Satr',
  'costing.costCount': 'Xarajat',
  'costing.costTotal': 'Xarajat jami',
  'costing.eta': 'Kelishi (ETA)',
  'costing.noContainers': 'Konteyner topilmadi',
  'costing.open': 'Ochish',
  'costing.estimateCount': '{count} taxminiy',
  'costing.totalRow': 'JAMI',
  'costing.archived': 'Arxivlangan',

  'costing.basis.receipt': 'Qabul bo‘yicha — post qilinadi',
  'costing.basis.shipment': 'Jo‘natma bo‘yicha — kutilayotgan, post qilinmaydi',
  'costing.basis.none': 'Hisoblanmadi',
  'costing.rate': '{currency} kursi {rate} ({date})',

  'costing.totalQty': 'Jami soni',
  'costing.totalCartons': 'Karobka',
  'costing.totalVolume': 'Jami hajm',
  'costing.totalWeight': 'Jami og‘irlik',
  'costing.purchaseBase': 'Xitoy narxi (USD)',
  'costing.costsBase': 'Xarajatlar (USD)',

  'costing.runType': 'Hisob turi',
  'costing.runType.estimate': 'Taxminiy (estimate)',
  'costing.runType.final': 'Yakuniy (final)',
  'costing.runTypeHint':
    'Taxminiy — hujjatlar to‘liq kelmaguncha. Yakuniy — barcha hujjat kelgach; farq ombor qiymatiga va sotilgan qismi COGS ga tushadi.',

  'costing.result': 'NATIJA — har mahsulotning tannarxi',
  'costing.resultHint':
    'Har xarajat ustunida ikki raqam: shu tovarga tushgan summa va uning taqsimlash bazasidagi ulushi. Ulush aynan o‘sha xarajatning usuliga mos (hajm bo‘yicha taqsimlansa — hajm ulushi).',
  'costing.sku': 'Mahsulot',
  'costing.qty': 'Soni',
  'costing.bases': 'Taqsimlash bazasi',
  'costing.chinaPrice': 'Xitoy narxi',
  'costing.landedUnit': 'Xarajat / dona',
  'costing.totalUnitCost': 'TANNARX / dona',
  'costing.landedPct': 'Xarajat ulushi',
  'costing.noLines': 'Satr yo‘q — avval fakturani yuklang',
  'costing.cartons': '{count} karobka · {dims} sm',
  'costing.valueShare': 'qiymat {pct}',

  'costing.balance': 'Yig‘indi tekshiruvi',
  'costing.balanceHint':
    'Har xarajat uchun: kiritilgan summa va satrlarga taqsimlangan summa. Farq NOL bo‘lishi shart — yaxlitlash qoldig‘i yo‘qolmaydi, u eng katta satrga yuklanadi.',
  'costing.cost': 'Xarajat',
  'costing.entered': 'Kiritilgan',
  'costing.allocated': 'Taqsimlangan',
  'costing.diff': 'Farq',
  'costing.balanced': 'Teng ✓',
  'costing.unbalanced': 'TENG EMAS',
  'costing.noCosts': 'Xarajat kiritilmagan',
  'costing.costs': 'Xarajatlar va taqsimlash usuli',

  'costing.import': 'Zavod fakturasini yuklash',
  'costing.importHint':
    'Excel yoki CSV. Ustunlar sarlavha bo‘yicha avtomatik tanildi. Avval «Oldindan ko‘rish» — bazaga hech narsa yozilmaydi; xatosiz bo‘lsagina «Yozish» ochiladi.',
  'costing.import.file': 'Faktura fayli',
  'costing.import.mode': 'Rejim',
  'costing.import.append': 'Qo‘shish',
  'costing.import.replace': 'Almashtirish (eski satrlar o‘chadi)',
  'costing.import.po': 'Xarid buyurtmasi ID',
  'costing.import.poHint':
    'Ko‘rsatilsa: satrlar buyurtmaga bog‘lanadi va fakturadagi yuan narxi buyurtmadagi bilan solishtiriladi.',
  'costing.import.preview': 'Oldindan ko‘rish',
  'costing.import.commit': 'Yozish',
  'costing.import.template': 'Shablon (.xlsx)',
  'costing.import.done': '{created} satr yozildi, {removed} satr o‘chirildi',
  'costing.import.rows': 'Qatorlar',
  'costing.import.recognized': 'Tanildi',
  'costing.import.unknown': 'Noma’lum kod',
  'costing.import.missingDims': 'O‘lchamsiz',
  'costing.import.errors': 'Xatolar',
  'costing.import.columns': 'Varaq «{sheet}», sarlavha {headerRow}-qator. Tanilgan ustunlar: {columns}',
  'costing.import.unmapped': 'Tanilmagan ustunlar: {columns}',
  'costing.import.row': 'Qator',
  /*
   * Ustun yorlig'i «og'irlik» EMAS, aynan «brutto» va «netto» (0055):
   * fakturada bu ikki ustun yonma-yon turadi va ularni almashtirib
   * bog'lash — eng ehtimolli import xatosi.
   */
  'costing.import.grossKg': 'Brutto, kg',
  'costing.import.netKg': 'Netto, kg',
  'costing.import.issues': 'Xato / ogohlantirish',
  'costing.import.ok': 'Toza',

  'costing.runs': 'Tannarx hisoblari',
  'costing.run.done': '{runType} hisobi post qilindi. Ombor qiymati: {value}',
  'costing.run.needsReceipt':
    'Post qilish uchun qabul hujjati kerak: xarajat HAQIQATDA kelgan miqdorga taqsimlanadi, kutilganiga emas.',
  'costing.run.estimate': 'Taxminiy tannarxni post qilish',
  'costing.run.final': 'Yakuniy tannarxni post qilish',
  'costing.run.hint': 'Post qilingandan keyin tuzatish — teskarilash va qayta baholash degani.',
  'costing.run.type': 'Turi',
  'costing.run.date': 'Sana',
  'costing.run.status': 'Holat',
  'costing.run.none': 'Hali hisoblanmagan',

  'costing.defaults': 'Xarajat turining standart usuli',
  'costing.defaultsHint':
    '«Rastamovka odatda kg bo‘yicha» — bir marta qo‘yiladi va yangi xarajat qo‘shilganda avtomatik tanlanadi. Mavjud konteynerlarning tannarxi O‘ZGARMAYDI.',
  'costing.defaultAlloc': 'Standart taqsimlash',

  // --- Xarid: landed cost ---
  'lc.title': 'Tannarx hisobi (landed cost)',
  'lc.description':
    "«Bu tovar omborga qanchaga tushdi?» — savolning yagona to'g'ri javobi. Xitoy invoysidagi narx javobning yarmi ham emas.",
  'lc.preview': 'Oldindan hisoblash',
  'lc.previewAgain': 'Qayta hisoblash',
  'lc.previewHint':
    "Bu hisob HECH NARSA saqlamaydi. Post qilingandan keyin tuzatish teskarilash va qayta baholash degani, oradagi har bir sotuv esa noto'g'ri tannarx bilan yozilib ulguradi — shuning uchun avval ko'riladi, keyin yoziladi.",
  'lc.purchaseBase': 'Tovar qiymati (USD)',
  'lc.costsBase': 'Xarajatlar (USD)',
  'lc.inventoryValue': 'Jami ombor qiymati (USD)',
  'lc.landedPct': 'Xarajat ulushi',
  'lc.landedPctBig':
    'Xarajat tovar narxining {pct}% ini tashkil qiladi',
  'lc.landedPctOver100':
    "Xarajat TOVARDAN QIMMAT. Navlon, bojxona, sertifikat va qolgani birgalikda tovarning o'zidan ham ko'proq turadi. Xitoy invoysidagi narxga qarab narx aytish shuning uchun ishlamaydi.",
  'lc.landedPctExample':
    '{sku}: Xitoy narxi {purchase}, omborga tushishi {total} — farq {pct}.',
  'lc.landedPctUnder100':
    "Xarajat ulushi — taqsimlangan xarajatning tovar narxiga nisbati. Narx belgilashda tovar narxi emas, JAMI TANNARX asos qilinadi.",
  'lc.purchaseRate': 'Tovar kursi ({currency})',
  'lc.purchaseRateHint':
    'Kurs QABUL SANASI bo‘yicha olinadi: tovar aynan shu kuni aktivga aylanadi. Buyurtma sanasi 4 oy oldin va o‘shandagi kurs bugungi aktiv qiymatiga aloqador emas.',
  'lc.receiptDate': 'Qabul sanasi',
  'lc.sku': 'SKU',
  'lc.quantity': 'Kelgan miqdor',
  'lc.expectedQuantity': 'Kutilgan',
  'lc.shortage': 'Kamomad',
  'lc.purchaseUnitCost': 'Tovar narxi (dona)',
  'lc.landedUnitCost': 'Xarajat (dona)',
  'lc.totalUnitCost': 'Jami tannarx (dona)',
  'lc.linePct': 'Landed %',
  'lc.purchaseTotal': 'Tovar summasi',
  'lc.landedTotal': 'Xarajat summasi',
  'lc.warnings': 'Ogohlantirishlar',
  'lc.empty': 'Hisoblash uchun ma’lumot yo‘q',
  'lc.emptyHint':
    "Tannarx QABUL QILINGAN tovarga hisoblanadi: bu konteyner bo'yicha hali qabul hujjati yo'q bo'lsa, hisoblash uchun satr ham yo'q.",
  'lc.loadError': "Tannarxni hisoblab bo'lmadi",

  'lc.compare': 'Taqsimlash usullarini solishtirish',
  'lc.compareHint':
    "Xarajat qatorining usulini shu yerda VAQTINCHA almashtiring va farqni ko'ring. Hech narsa saqlanmaydi — bu «agar boshqacha qilsak nima bo'lardi» savoliga javob.",
  'lc.compareRun': 'Solishtirish',
  'lc.compareReset': 'Asl usullarga qaytarish',
  'lc.compareBase': 'Joriy usul',
  'lc.compareAlt': 'Tanlangan usul',
  'lc.deltaUnit': 'Farq (dona)',
  'lc.deltaTotal': 'Farq (jami)',
  'lc.deltaZeroSum':
    "Farqlar yig'indisi AYNAN NOL: usulni almashtirish umumiy xarajatni o'zgartirmaydi, faqat SKU lar orasida ko'chiradi. Yig'indi nol bo'lmasa — hisobda xato bor.",
  'lc.deltaMoved':
    "Bitta usul tanlovi {amount} ni «{from}» satridan olib boshqa SKU larga ko'chiradi.",
  'lc.deltaNone': "Tanlangan usul natijani o'zgartirmadi",
  'lc.deltaWhy':
    "Bu — butun tizimdagi eng qimmat bitta tanlov. Panel tannarxi 6.3% ga past, lenta tannarxi 6.8% ga baland chiqadi va IKKALASI HAM noto'g'ri narxlanadi.",

  'lc.runType': 'Hisob turi',
  'lc.runType.estimate': 'Taxminiy (estimate)',
  'lc.runType.final': 'Yakuniy (final)',
  'lc.runTypeHint':
    "Tovar odatda hujjatlardan oldin keladi. «Taxminiy» — ma'lum xarajatlar taqsimlanadi va tovar sotuvga chiqadi. «Yakuniy» — barcha hujjat kelgach eski hisob teskarilanadi va farq hisoblanadi.",
  'lc.runDate': 'Hujjat sanasi',
  'lc.run': 'Hisoblash va daftarga yozish',
  'lc.runConfirm':
    "Tannarx ombor daftariga yoziladi va qoldiq qayta baholanadi. Bu amal audit jurnalida qoladi.",
  'lc.runNotes': 'Izoh',
  'lc.ran': 'Tannarx hisoblandi va yozildi (run #{runId})',
  'lc.noRunPermission':
    'Tannarxni hisoblash huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lc.cogsVariance': 'Sotilgan tovar bo‘yicha farq (COGS variance)',
  'lc.cogsVarianceHint':
    "Bu summa omborga QAYTMAYDI: sotilgan tovarning tannarxi orqaga qaytarib o'zgartirilmaydi, aks holda yopilgan davrning foydasi qayta yoziladi. Farq joriy davrga tushadi.",

  'lc.runs': 'Hisoblash tarixi',
  'lc.runNo': 'Run #{id}',
  'lc.runStatus': 'Holat',
  'lc.runPostedAt': 'Yozilgan',
  'lc.runTotal': 'Jami xarajat',
  'lc.runReversalOf': '#{id} ni teskariladi',
  'lc.runsEmpty': 'Hali hisoblanmagan',
  'lc.reverse': 'Teskarilash',
  'lc.reverseTitle': 'Tannarx hisobini teskarilash',
  'lc.reverseReason': 'Teskarilash sababi',
  'lc.reverseReasonRequired': "Sabab kamida 3 ta belgidan iborat bo'lishi kerak",
  'lc.reverseHint':
    "Teskarilash tannarxni, marjani va BARCHA hisobotlarni o'zgartiradi. «Nega?» degan savol albatta beriladi — sabab audit jurnalida qoladi.",
  'lc.reversed': 'Hisob teskarilandi',
  'lc.noReversePermission':
    'Hisobni teskarilash huquqi sizda yo‘q — u faqat administrator va moliyachida. Kerak bo‘lsa ularga murojaat qiling.',

  'lc.breakdown': 'Xarajat tarkibi',
  'lc.costName': 'Xarajat',
  'lc.allocBasis': 'Baza',
  'lc.allocRatio': 'Ulush',
  'lc.allocated': 'Summa (USD)',
  'lc.roundingAbsorbed': 'Yaxlitlash farqi shu satrga qo‘shilgan',
  'lc.roundingHint':
    "Taqsimlashda tiyinning ulushi yo'qolmasligi uchun yaxlitlash farqi eng katta bazaga ega satrga qo'shiladi. Yig'indi xarajatga AYNAN teng bo'lishi shart.",
  'lc.noViewPermission':
    'Tannarx hisobini ko‘rish huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',

  // --- Xarid: tovar qabuli ---
  'gr.title': 'Tovar qabuli',
  'gr.description':
    "Konteynerdan tovar qabul qilish. Landed cost HAQIQATDA KELGAN miqdorga taqsimlanadi — kamomad qolgan donalarning tannarxini OSHIRADI.",
  'gr.new': 'Yangi qabul',
  'gr.newTitle': 'Konteynerdan qabul qilish',
  'gr.detailTitle': 'Qabul {docNo}',
  'gr.docNo': 'Hujjat',
  'gr.shipment': 'Konteyner',
  'gr.shipmentSelect': 'Konteynerni tanlang',
  'gr.shipmentRequired': 'Konteyner tanlanishi shart',
  'gr.purchaseOrder': 'Xarid buyurtmasi',
  'gr.warehouse': 'Ombor',
  'gr.receiptDate': 'Qabul sanasi',
  'gr.receiptDateHint':
    'Qabul sanasi — CNY→USD konvertatsiyasining KURS SANASI: tovar aynan shu kuni aktivga aylanadi.',
  'gr.status': 'Holat',
  'gr.statusAll': 'Barcha holatlar',
  'gr.status.draft': 'Qoralama',
  'gr.status.posted': 'Daftarga yozilgan',
  'gr.status.cancelled': 'Bekor qilingan',
  'gr.lines': 'Satrlar',
  'gr.expectedQuantity': 'Kutilgan',
  'gr.quantity': 'Haqiqatda keldi',
  'gr.shortage': 'Kamomad',
  'gr.excess': 'Ortiqcha',
  'gr.shortageReason': 'Kamomad sababi',
  'gr.shortageReasonRequired': 'Kamomad bor satrda sabab ko‘rsatilishi kerak',
  'gr.claimStatus': 'Da’vo holati',
  'gr.claimAmount': 'Da’vo summasi',
  'gr.claimNote': 'Da’vo izohi',
  'gr.shortageWhy':
    'Tannarx KELGAN miqdorga taqsimlanadi, kutilganiga emas. Ya‘ni 500 dona kutilib 480 kelsa, xarajat 480 donaga bo‘linadi va har bir dona qimmatlashadi. Kutilganiga taqsimlash kelmagan tovarni «bepul» qilib ko‘rsatardi.',
  'gr.claimWhy':
    "Kamomadning PULI qayerga ketishini da'vo holati belgilaydi: «qabul qilindi» — ta'minotchi qaytaradi va bu xarajat emas; «rad etildi» yoki «yo'q» — summa DAVR ZARARIGA yoziladi, tannarxga EMAS. Aks holda qolgan donalar sun'iy qimmatlashadi va keyingi partiya bilan solishtirib bo'lmaydi.",
  'gr.post': 'Daftarga yozish',
  'gr.postHint':
    "Yozilgandan keyin tovar ombor qoldig'iga tushadi va tannarx hisobiga tayyor bo'ladi.",
  'gr.posted': '{docNo} daftarga yozildi',
  'gr.created': 'Qabul yaratildi: {docNo}',
  'gr.submit': 'Qabulni yaratish',
  'gr.linesRequired': "Kamida bitta satr kerak",
  'gr.noPoLine':
    "Bu satrda xarid buyurtmasi satri yo'q: narx (CNY) aynan PO satridan olinadi va usiz tannarxni hisoblab bo'lmaydi.",
  'gr.empty': 'Qabul hujjati topilmadi',
  'gr.emptyHint': 'Filtrni kengaytiring yoki konteynerdan yangi qabul yarating.',
  'gr.loadError': "Qabullarni yuklab bo'lmadi",
  'gr.notFound': "Qabul hujjati topilmadi yoki sizga ko'rinmaydi",
  'gr.pickShipment': 'Avval konteynerni tanlang',
  'gr.loadLines': 'Konteyner satrlarini yuklash',
  'gr.linesFromShipment': 'Satrlar tanlangan konteynerdan olindi — kelgan miqdorni tuzating.',
  'gr.costHidden': "Tannarx ustunlari sizga ko'rsatilmaydi — bu ruxsat masalasi, xato emas.",

  'shortage.shortage': 'Kam keldi',
  'shortage.damaged': 'Shikastlangan',
  'shortage.wrong_item': 'Boshqa tovar',
  'shortage.excess': 'Ortiqcha keldi',
  'claim.none': 'Da’vo yo‘q',
  'claim.pending': 'Tayyorlanmoqda',
  'claim.sent': 'Yuborilgan',
  'claim.accepted': 'Qabul qilingan',
  'claim.rejected': 'Rad etilgan',
  'claim.closed': 'Yopilgan',

  // --- Import (1C / Excel) ---
  'imp.title': '1C va Excel import',
  'imp.description':
    "Import to'rt bosqichli: yuklash → ustunlarni moslash → tekshirish → kiritish. Har bosqich natijasini KO'RIB bo'lgach keyingisiga o'tiladi.",
  'imp.whyStaged':
    "Real fayllarda sarlavha 3-qatorda bo'ladi, raqamlar matn bo'lib keladi va bitta katakda «100 dona» yozilgan bo'ladi. «Faylni tanladingiz — import qilindi» degan bitta tugma bunday fayl bilan yo yiqiladi, yo eng yomoni — 4 000 qatorni jimgina noto'g'ri kiritadi.",
  'imp.step1': 'Fayl',
  'imp.step2': 'Ustunlar',
  'imp.step3': 'Tekshiruv',
  'imp.step4': 'Kiritish',
  'imp.stepOf': '{n}-bosqich',

  'imp.entityType': 'Nima import qilinmoqda',
  'imp.entity.product': 'Mahsulotlar',
  'imp.entity.customer': 'Mijozlar',
  'imp.entity.supplier': "Ta'minotchilar",
  /*
   * Ochilish qoldig'i turlari (0056). Yorliqda «(ochilish)» ATAYLAB turibdi:
   * bu turlar bir MARTA, ko'chirish kunida ishlatiladi. Belgisiz «Qarzlar»
   * degan band har kuni ochiladigan bo'lim bilan adashtirilardi.
   */
  'imp.entity.stock': "Ombor qoldig'i (ochilish)",
  'imp.entity.ar': 'Mijoz qarzi (ochilish)',
  'imp.entity.ap': "Ta'minotchi qarzi (ochilish)",
  'imp.entity.price': 'Narxlar',
  'imp.entityHint':
    "Bitta fayl — BITTA tur. Turni sarlavhalarga qarab taxmin qilib bo'lmaydi: mijozlar ro'yxati «Kod | Nomi» bilan ta'minotchilar ro'yxatidan farq qilmaydi, noto'g'ri jadvalga tushgan 4 000 qatorni esa keyin ajratish deyarli imkonsiz.",
  // --- Ochilish qoldig'i (0056) ---
  'imp.openingTitle': "Ochilish qoldig'i — ikkita shart",
  'imp.openingBody':
    "1) TARTIB: avval mahsulotlar, mijozlar va ta'minotchilar ko'chirilgan bo'lishi shart — qoldiq va qarz fayllari ularga havola qiladi. 2) DAFTAR: bu yerdagi yuklash daftarga PROVODKA YOZMAYDI. Ochilish provodkasini buxgalter «Buxgalteriya → Provodkalar» bo'limida bir marta qo'lda kiritadi (qaysi kapital hisobiga tushishi — uning qarori).",
  'imp.template': 'Shablonni yuklab olish',
  'imp.templateHint':
    "Shablonda to'g'ri ustun nomlari va bitta namuna qator bor. U bilan to'ldirilgan fayl birinchi urinishdayoq to'liq moslanadi — ustun nomlarini taxmin qilish shart emas.",
  'imp.templateFailed': "Shablonni yuklab bo'lmadi",
  'imp.file': 'Fayl (.xlsx yoki .csv)',
  'imp.upload': 'Yuklash',
  'imp.uploading': 'Yuklanmoqda…',
  'imp.fileRequired': 'Fayl tanlanishi shart',
  'imp.uploadFailed': "Faylni yuklab bo'lmadi",

  'imp.sheets': 'Fayldagi varaqlar',
  'imp.sheet': 'Varaq',
  'imp.selectedSheet': 'Tanlangan varaq',
  'imp.rowCount': '{count} qator',
  'imp.headerRow': 'Sarlavha qatori',
  'imp.headerRowDetected': 'Aniqlangan: {row}-qator',
  'imp.headerRowHint':
    "Sarlavha qatorini avtomatik aniqlash — TAXMIN. Xato aniqlangan sarlavha butun faylni yaroqsiz qiladi, shuning uchun uni qo'lda tuzatish mumkin.",
  'imp.detectedColumns': 'Aniqlangan ustunlar',

  'imp.mappingTitle': 'Ustunlarni moslash',
  'imp.mappingHint':
    "Chapda — Alight maydoni, o'ngda — fayldagi ustun. Avtomatik taklif allaqachon qo'yilgan; uni tekshiring va kerak bo'lsa o'zgartiring.",
  'imp.evoField': 'Alight maydoni',
  'imp.fileColumn': 'Fayl ustuni',
  'imp.columnNone': '— moslanmagan —',
  'imp.required': 'majburiy',
  'imp.suggested': 'avtomatik taklif',
  'imp.defaultValue': 'Sobit qiymat',
  'imp.defaultHint':
    "Faylda ustun umuman bo'lmasa (masalan «tur» yozilmagan, chunki hammasi ulgurji) — qiymatni bir marta shu yerda ko'rsating.",
  'imp.applyMapping': 'Moslashni saqlash',
  'imp.mappingSaved': 'Moslash saqlandi',
  'imp.previewTitle': 'Natija namunasi (birinchi qatorlar)',
  'imp.previewRow': 'Qator {n}',
  'imp.skippedRows': 'Sarlavhagacha tashlab yuborilgan qatorlar: {count}',
  'imp.requiredMissing': "Majburiy maydonlar moslanmagan: {fields}",

  'imp.validate': 'Tekshirish',
  'imp.validating': 'Tekshirilmoqda…',
  'imp.validateHint':
    "Tekshirish istalgancha marta bajarilaveradi va hech narsa yozmaydi. Faylni tuzatib qayta yuklash o'rniga — moslashni tuzatib qayta tekshirish.",
  'imp.totalRows': 'Jami qator',
  'imp.validRows': "To'g'ri",
  'imp.errorRows': 'Xato',
  'imp.warningRows': 'Ogohlantirish',
  'imp.topErrors': 'Eng ko‘p uchragan xatolar',
  'imp.rowNo': 'Qator',
  'imp.rowStatus': 'Holat',
  'imp.rowMessage': 'Xabar',
  'imp.rowData': 'Fayldagi qiymat',
  'imp.filterAll': 'Barcha qatorlar',
  'imp.filterErrors': 'Faqat xatolar',
  'imp.filterWarnings': 'Faqat ogohlantirishlar',
  'imp.filterValid': "Faqat to'g'ri qatorlar",
  'imp.warningNotError':
    'Ogohlantirish xato EMAS. Yaqin dublikat («Lyustra 60W» va «Lyustra 80W») — ikkita haqiqiy mahsulot va ikkalasi ham kirishi kerak. Bunday qator «to‘g‘ri» bo‘lib qoladi va «Kiritish» bosqichida bazaga tushadi; ogohlantirish faqat diqqatni tortadi.',
  'imp.rowsEmpty': 'Bu filtr bo‘yicha qator yo‘q',
  'imp.rowsLoadError': "Qatorlarni yuklab bo'lmadi",

  'imp.commit': 'Bazaga kiritish',
  'imp.committing': 'Kiritilmoqda…',
  'imp.commitHint':
    "Faqat «to'g'ri» qatorlar kiritiladi va hammasi BITTA tranzaksiyada: yarim import qolib ketmaydi.",
  'imp.commitBlocked': "Kiritish uchun avval tekshiruvdan o'ting",
  'imp.committed': '{count} qator kiritildi',
  'imp.commitFailed': "Kiritib bo'lmadi",
  'imp.imported': 'Kiritilgan',

  'imp.rollback': 'Qaytarish (rollback)',
  'imp.rollbackTitle': 'Import partiyasini qaytarish',
  'imp.rollbackReason': 'Qaytarish sababi',
  'imp.rollbackReasonRequired': "Sabab kamida 3 ta belgidan iborat bo'lishi kerak",
  'imp.rollbackHint':
    "Qaytarish — bazadan yozuv O'CHIRISH, ya'ni «master data hech qachon o'chirilmaydi» qoidasidan yagona istisno. Bir haftadan keyin «nega qaytarilgan?» degan savol albatta beriladi.",
  'imp.rolledBack': 'Partiya qaytarildi',
  'imp.rollbackFailed': "Qaytarib bo'lmadi",

  'imp.batches': 'Import partiyalari',
  'imp.batchNo': 'Partiya #{id}',
  'imp.fileName': 'Fayl',
  'imp.createdAt': 'Yaratilgan',
  'imp.batchStatus': 'Holat',
  'imp.open': 'Ochish',
  'imp.newBatch': 'Yangi import',
  'imp.batchesEmpty': 'Hali import qilinmagan',
  'imp.batchesLoadError': "Partiyalarni yuklab bo'lmadi",

  'imp.status.uploaded': 'Yuklangan',
  'imp.status.validated': 'Tekshirilgan',
  'imp.status.dry_run': 'Sinov',
  'imp.status.committed': 'Kiritilgan',
  'imp.status.rolled_back': 'Qaytarilgan',
  'imp.rowStatus.pending': 'Kutilmoqda',
  'imp.rowStatus.valid': "To'g'ri",
  'imp.rowStatus.error': 'Xato',
  'imp.rowStatus.imported': 'Kiritilgan',
  'imp.rowStatus.skipped': 'Tashlab yuborilgan',

  // --- Sozlamalar: umumiy ---
  'settings.title': 'Sozlamalar',
  'settings.usersTitle': 'Foydalanuvchilar',
  'settings.rolesTitle': 'Rollar va ruxsatlar',
  'settings.priceListsTitle': 'Narx ro‘yxatlari',
  'settings.cashAccountsTitle': 'Kassa va bank hisoblari',
  'settings.systemTitle': 'Tizim sozlamalari',
  'settings.auditTitle': 'Audit jurnali',

  // --- Sozlamalar: foydalanuvchilar ---
  'usr.description':
    "Foydalanuvchi, rol va ko'lam. Rol yoki parol o'zgarsa — o'sha xodimning BARCHA sessiyalari bekor qilinadi.",
  'usr.sessionsRevokedWarning':
    'DIQQAT: rol, ko‘lam yoki parol o‘zgartirilsa, foydalanuvchining barcha ochiq sessiyalari darhol bekor qilinadi va u qaytadan kirishi kerak bo‘ladi. Bu texnik tafsilot emas — aks holda u ochiq turgan oynada eski ruxsatlar bilan ishlashda davom etardi, ya‘ni rolni pasaytirish ma‘nosini yo‘qotardi.',
  'usr.sessionsRevokedDone': 'Sessiyalar bekor qilindi ({count})',
  'usr.new': 'Yangi foydalanuvchi',
  'usr.fullName': 'F.I.Sh.',
  'usr.email': 'Email',
  'usr.phone': 'Telefon',
  'usr.password': 'Parol',
  'usr.passwordHint':
    "Kamida {min} belgi. Uzunlik murakkablikdan muhimroq: majburiy belgi qoidalari odamlarni taxmin qilinadigan parollarga majbur qiladi.",
  'usr.passwordTooShort': 'Parol kamida {min} belgi bo‘lishi kerak',
  'usr.locale': 'Til',
  'usr.role': 'Rol',
  'usr.roleSelect': 'Rolni tanlang',
  'usr.scope': 'Ko‘lam',
  'usr.scopeType': 'Ko‘lam turi',
  'usr.scope.all': 'Butun tashkilot',
  'usr.scope.branch': 'Filial',
  'usr.scope.warehouse': 'Ombor',
  'usr.scopeId': 'Ko‘lam obyekti',
  'usr.scopeHint':
    "Ko'lam «qaysi ma'lumot ko'rinadi» ni belgilaydi: omborchi faqat o'z omborini, sotuvchi o'z filialini ko'radi.",
  // --- Tashkiliy tuzilma: filial, ombor, kassa (Sozlamalar → Tashkilot) ---
  'org.title': 'Tashkiliy tuzilma',
  'org.description':
    'Filiallar, ularning omborlari va kassalari. Yangi filial ochilsa — ombori va kassasi bilan birga ochiladi, aks holda unda savdo qilib bo‘lmaydi.',
  'org.newBranch': 'Yangi filial',
  'org.wizardTitle': 'Yangi filial ochish',
  'org.wizardHint':
    'Filial, uning ombori va kassasi BITTA amalda yaratiladi. Ombor va kassa kodlari bo‘sh qoldirilsa, filial kodidan hosil qilinadi.',
  'org.branchCode': 'Filial kodi',
  'org.branchCodeHint':
    'Katta harf, raqam va tire: SAMARQAND. Kod keyin O‘ZGARTIRILMAYDI — u hujjatlarda chop etiladi.',
  'org.branchName': 'Filial nomi',
  'org.address': 'Manzil',
  'org.phone': 'Telefon',
  'org.legalEntity': 'Yuridik shaxs',
  'org.warehouseCode': 'Ombor kodi',
  'org.warehouseName': 'Ombor nomi',
  'org.cashCode': 'Kassa kodi',
  'org.cashName': 'Kassa nomi',
  'org.optional': 'ixtiyoriy',
  'org.create': 'Filialni ochish',
  'org.creating': 'Ochilmoqda…',
  'org.setupDone': 'Filial ochildi: {code}',
  'org.setupDetails': 'Ombor: {warehouse} · Kassa: {cash} ({currency})',
  'org.nextStep': 'Keyingi qadam',
  'org.goToUsers': 'Xodim biriktirish',
  'org.branch': 'Filial',
  'org.warehouses': 'Omborlar',
  'org.cashAccounts': 'Kassalar',
  'org.staff': 'Xodimlar',
  'org.staffCount': '{count} ta xodim',
  'org.noStaff': 'Xodim biriktirilmagan',
  'org.noStaffHint':
    'Bu filialda hech kim ishlamaydi — unda hujjat paydo bo‘lmaydi. Sozlamalar → Foydalanuvchilar bo‘limida xodimga filial ko‘lamini bering.',
  'org.stockValue': 'Qoldiq qiymati',
  'org.warehouseCount': '{count} ta ombor',
  'org.positions': '{count} pozitsiya',
  'org.empty': 'Bo‘sh',
  'org.archived': 'Arxivlangan',
  'org.archive': 'Arxivlash',
  'org.archiveBranchHint':
    'Filial O‘CHIRILMAYDI — unga bog‘langan hujjatlar tarixi qoladi. Arxivlashdan oldin qoldiq boshqa filialga ko‘chirilishi va xodimlar boshqa filialga o‘tkazilishi kerak.',
  'org.archiveWarehouseHint':
    'Qoldig‘i bor omborni arxivlab bo‘lmaydi — tovar hisobotlardan yo‘qolardi.',
  'org.archiveCashHint': 'Qoldig‘i bor kassani arxivlab bo‘lmaydi.',
  'org.branchArchived': 'Filial arxivlandi: {code}',
  'org.warehouseArchived': 'Ombor arxivlandi: {code}',
  'org.cashArchived': 'Kassa arxivlandi: {code}',
  'org.newWarehouse': 'Ombor qo‘shish',
  'org.warehouseCreated': 'Ombor yaratildi: {code}',
  'org.whType': 'Turi',
  'org.whType.main': 'Asosiy',
  'org.whType.transit': 'Transit (yo‘ldagi tovar)',
  'org.whType.quarantine': 'Karantin (ko‘rik)',
  'org.whTypeHint':
    'Transit ombori butun kompaniyaga bitta — u markazda. Karantin filialga bitta va faqat ko‘rik talab qiladigan qaytarishlar uchun kerak.',
  'org.unassignedCash': 'Filialga biriktirilmagan kassalar',
  'org.unassignedCashHint':
    'Markaziy va valyuta kassalari shu yerda qoladi. Filial kassasini ro‘yxatdan tanlab biriktiring.',
  'org.attach': 'Biriktirish',
  'org.detach': 'Bog‘lanishni uzish',
  'org.attached': 'Kassa filialga biriktirildi',
  'org.selectBranch': 'Filialni tanlang',
  'org.save': 'Saqlash',
  'org.saved': 'Saqlandi',
  'org.edit': 'Tahrirlash',
  'org.loadError': 'Tashkiliy tuzilmani yuklab bo‘lmadi',

  'usr.status': 'Holat',
  'usr.active': 'Faol',
  'usr.inactive': 'Bloklangan',
  'usr.lastLogin': 'Oxirgi kirish',
  'usr.neverLoggedIn': 'Kirmagan',
  'usr.create': 'Yaratish',
  'usr.created': 'Foydalanuvchi yaratildi: {email}',
  'usr.setRole': 'Rolni o‘zgartirish',
  'usr.roleChanged': 'Rol o‘zgartirildi: {role}',
  'usr.setScope': 'Ko‘lamni o‘zgartirish',
  'usr.scopeChanged': 'Ko‘lam o‘zgartirildi',
  'usr.resetPassword': 'Parolni tiklash',
  'usr.resetPasswordTitle': 'Yangi parol belgilash',
  'usr.passwordReset': 'Parol o‘zgartirildi',
  'usr.newPasswordHint':
    "Yangi parol javobda QAYTARILMAYDI: uni siz kiritasiz va xodimga o'zingiz yetkazasiz.",
  'usr.activate': 'Faollashtirish',
  'usr.deactivate': 'Bloklash',
  'usr.activated': 'Foydalanuvchi faollashtirildi',
  'usr.deactivated': 'Foydalanuvchi bloklandi',
  'usr.sessions': 'Sessiyalar',
  'usr.sessionsTitle': '{name} — sessiyalar',
  'usr.sessionAgent': 'Qurilma',
  'usr.sessionIp': 'IP',
  'usr.sessionCreated': 'Boshlangan',
  'usr.sessionExpires': 'Amal qiladi',
  'usr.sessionRevoked': 'Bekor qilingan',
  'usr.sessionActive': 'Faol',
  'usr.revokeSessions': 'Barcha sessiyalarni bekor qilish',
  'usr.sessionsEmpty': 'Sessiya yo‘q',
  'usr.self':
    "Bu — SIZNING yozuvingiz. O'z rolingizni, ko'lamingizni va faolligingizni o'zgartira olmaysiz: aks holda admin o'zini tasodifan huquqsiz qoldirishi mumkin.",
  'usr.noRoleAssign':
    'Rol va ko‘lamni o‘zgartirish huquqi sizda yo‘q — u faqat administratorda. Kerak bo‘lsa administratorga murojaat qiling.',
  'usr.empty': 'Foydalanuvchi topilmadi',
  'usr.loadError': "Foydalanuvchilarni yuklab bo'lmadi",

  // --- Sozlamalar: rollar ---
  /*
   * Ta'rif 0057 dan keyin O'ZGARDI: ekran endi `role.manage` egasi uchun
   * TAHRIRLANADI. «Faqat o'qish» degan eski matn qoldirilsa, admin ekranga
   * kirib tugmalarni ko'rardi-yu, yuqorida «bu yerda hech narsa
   * o'zgartirilmaydi» degan yozuv turardi.
   */
  'role.description':
    'Rol → ruxsat matritsasi. `role.manage` ruxsati bo‘lsa — har bo‘lim va funksiyani shu yerda ochib yoki yopib qo‘yasiz; bo‘lmasa ekran faqat o‘qish uchun ochiladi.',
  'role.code': 'Kod',
  'role.name': 'Nomi',
  'role.users': 'Foydalanuvchi',
  'role.permissions': 'Ruxsat',
  'role.module': 'Modul',
  'role.permissionCode': 'Ruxsat kodi',
  'role.granted': 'Berilgan',
  'role.notGranted': 'Yo‘q',
  'role.select': 'Rolni tanlang',
  /*
   * Rol NOMLARI — yuqori panelda va foydalanuvchi ro'yxatida.
   *
   * Kod (`warehouse`) inglizcha va u BAZADAGI qiymat; ekranda esa odam
   * o'qiydigan nom turishi kerak. Ikkalasi bir joyda: kod o'zgarmaydi,
   * nom esa tarjima qilinadi.
   */
  'role.label.admin': 'Administrator',
  'role.label.manager': 'Rahbar',
  'role.label.finance': 'Moliyachi',
  'role.label.warehouse': 'Omborchi',
  'role.label.sales': 'Sotuvchi',
  'nav.language': 'Til',
  /*
   * Mavzu tugmasining yozuvi KEYINGI holatni aytadi, joriysini emas —
   * belgi joriy holatni allaqachon ko'rsatib turibdi (`theme-switch.tsx`).
   */
  'nav.theme.toDark': "Qorong'i mavzuga o'tish",
  'nav.theme.toLight': "Yorug' mavzuga o'tish",
  'role.matrixHint':
    'Ustunlar — rollar, satrlar — ruxsatlar. Bu jadval kelishilgan ruxsatlar ro‘yxati bilan bir xil bo‘lishi kerak; farq bo‘lsa haqiqat BAZADA.',
  'role.loadError': "Rollarni yuklab bo'lmadi",
  'role.empty': 'Rol topilmadi',

  // --- Sozlamalar: rollarni TAHRIRLASH (0057) ---
  'role.editHint':
    'Rolni tanlang, keyin bo‘limlar ichidagi funksiyalarni belgilang. Saqlash bosilgunicha hech nima o‘zgarmaydi. O‘zgarish darhol kuchga kiradi — o‘sha roldagi odam keyingi bosishidayoq yangi ruxsat bilan ishlaydi.',
  'role.viewEditor': 'Tahrirlash',
  'role.viewMatrix': 'Butun matritsa',
  'role.new': 'Yangi rol',
  'role.newCode': 'Kod',
  'role.newCodeHint': 'faqat kichik lotin harflari, raqam va tire; 2–32 belgi',
  'role.newName': 'Nomi',
  'role.newDescription': 'Izoh',
  'role.created': '«{code}» roli ochildi. U hozircha BO‘SH — funksiyalarni quyida belgilang.',
  'role.codeInvalid': 'Kod noto‘g‘ri: faqat kichik lotin harflari, raqam va tire (2–32 belgi)',
  'role.deleteConfirm':
    '«{name}» roli butunlay o‘chirilsinmi? Uning barcha ruxsat bog‘lamlari ham o‘chadi va buni qaytarib bo‘lmaydi.',
  'role.deleted': '«{code}» roli o‘chirildi',
  'role.systemHint':
    'Tizim rollari o‘chirilmaydi — ular dastur ichida nomi bo‘yicha ishlatiladi. Ruxsatlarini o‘zgartirish esa mumkin.',
  'role.selectHint': 'Tahrirlash uchun yuqoridagi rollardan birini tanlang.',
  'role.permissionsOf': '«{name}» roli: bo‘limlar va funksiyalar',
  'role.summary': '{modules} ta bo‘lim, {permissions} ta funksiya',
  'role.filter': 'Bo‘lim yoki funksiya bo‘yicha qidirish',
  'role.filterEmpty': 'Qidiruvga mos funksiya topilmadi',
  'role.selectAll': 'Hammasini belgilash',
  'role.clearAll': 'Hammasini olib tashlash',
  'role.pendingChanges': '{added} ta beriladi, {removed} ta olinadi',
  'role.noChanges': 'O‘zgarish yo‘q',
  'role.savedResult': 'Saqlandi: {added} ta berildi, {removed} ta olindi. Rolda jami {granted} ta ruxsat.',
  'role.locked': 'Bu ruxsat o‘zingizda yo‘q — uni rolga bera olmaysiz',
  'role.lockedBanner':
    'Bu rolda o‘zingizda YO‘Q {count} ta ruxsat bor ({codes}). Server bunday to‘plamni qaytarib yozishga yo‘l qo‘ymaydi, shuning uchun rolni saqlash yopiq. Uni shu ruxsatlarga ega odam tahrirlashi kerak.',
  'role.catalogueError': 'Bo‘limlar va funksiyalar ro‘yxatini yuklab bo‘lmadi',
  'role.err.escalation': 'O‘zingizda yo‘q ruxsatni bera olmaysiz',
  'role.err.lockout': 'Oxirgi administratorni qulflab qo‘yib bo‘lmaydi',
  'role.err.systemRole': 'Tizim rolini o‘chirib bo‘lmaydi',
  'role.err.inUse': 'Rolda foydalanuvchi bor',

  // --- Sozlamalar: narx ro'yxatlari ---
  'pl.description':
    "Narx ro'yxati bo'lmasa birorta buyurtma narxlanmaydi. To'lov usuli — eng muhim ustun: naqd va o'tkazma narxi 3-7% farq qiladi.",
  'pl.paymentWhy':
    'Naqd va o‘tkazma — IKKI XIL narx. Farq 3-7% va u jimgina yo‘qoladi: sotuvchi «naqd» deb kelishadi, hujjat esa o‘tkazma ro‘yxatidan yozilib ketadi. Shuning uchun to‘lov usuli ro‘yxatning ko‘rinadigan joyida turadi.',
  'pl.new': 'Yangi narx ro‘yxati',
  'pl.code': 'Kod',
  'pl.name': 'Nomi',
  'pl.currency': 'Valyuta',
  'pl.paymentMethod': 'To‘lov usuli',
  'pl.payment.any': 'Har qanday',
  'pl.payment.cash': 'Naqd',
  'pl.payment.transfer': 'O‘tkazma',
  'pl.isDefault': 'Asosiy ro‘yxat',
  'pl.isDefaultHint':
    "Asosiy ro'yxat FAQAT BITTA bo'lishi mumkin: ikkitasi bo'lsa narx tanlash tartibi noaniq bo'ladi va bir mahsulot ikki xil narxda sotiladi.",
  'pl.validFrom': 'Amal qiladi',
  'pl.validTo': 'Tugash sanasi',
  'pl.itemCount': 'Satr',
  'pl.status': 'Holat',
  'pl.create': 'Yaratish',
  'pl.created': 'Narx ro‘yxati yaratildi: {code}',
  'pl.items': 'Narx satrlari',
  'pl.itemsOf': '{name} — narx satrlari',
  'pl.sku': 'SKU',
  'pl.product': 'Mahsulot',
  'pl.price': 'Narx',
  'pl.minQty': 'Minimal miqdor',
  'pl.minQtyHint': 'Hajm bo‘yicha pog‘ona: shu miqdordan boshlab ushbu narx amal qiladi.',
  'pl.itemsEmpty': 'Bu ro‘yxatda narx satri yo‘q',
  'pl.selectList': "Chapdan narx ro'yxatini tanlang",
  'pl.bulk': 'Ommaviy kiritish',
  'pl.bulkTitle': 'Excel’dan narxlarni ko‘chirish',
  'pl.bulkHint':
    "Excel'dan ustunlarni nusxalab shu yerga qo'ying. Har qator: SKU, narx va (ixtiyoriy) minimal miqdor — TAB yoki nuqtali vergul bilan ajratilgan.",
  'pl.bulkPlaceholder': 'LED-PNL-600\t18.00\nLED-BLB-09\t1.50\t100',
  'pl.bulkParsed': '{count} qator tanildi',
  'pl.bulkUnknownSku': 'Katalogda topilmadi: {sku}',
  'pl.bulkInvalid': 'Qator {n}: narx yoki SKU noto‘g‘ri',
  'pl.bulkApply': 'Kiritish',
  'pl.bulkDone': 'Jami {total}: yangi {created}, yangilangan {updated}',
  'pl.bulkEmpty': 'Kiritish uchun qator yo‘q',
  'pl.loadError': "Narx ro'yxatlarini yuklab bo'lmadi",
  'pl.noEdit':
    'Narx ro‘yxatini tahrirlash huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',

  // --- Sozlamalar: kassa va bank ---
  'cash.description':
    "Kassa va bank hisoblari. Ularsiz birorta to'lov yozilmaydi. Har hisob O'Z valyutasida — so'm kassasi va dollar kassasi ikki alohida yozuv.",
  'cash.new': 'Yangi hisob',
  'cash.code': 'Kod',
  'cash.name': 'Nomi',
  'cash.type': 'Turi',
  'cash.type.cash': 'Kassa',
  'cash.type.bank': 'Bank',
  'cash.currency': 'Valyuta',
  'cash.legalEntity': 'Yuridik shaxs',
  'cash.bankName': 'Bank nomi',
  'cash.accountNo': 'Hisob raqami',
  'cash.balance': 'Qoldiq',
  'cash.status': 'Holat',
  'cash.create': 'Yaratish',
  'cash.created': 'Hisob yaratildi: {code}',
  'cash.archive': 'Arxivlash',
  'cash.archived': 'Hisob arxivlandi',
  'cash.archiveHint':
    "Qoldig'i bor hisobni arxivlab bo'lmaydi: pul hisobotdan yo'qoladi, lekin operatsiyalarda qoladi va kassa buxgalteriya bilan farq qiladi.",
  'cash.empty': 'Hisob topilmadi',
  'cash.loadError': "Hisoblarni yuklab bo'lmadi",
  'cash.noEdit': 'Hisob yaratish huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',

  // --- Sozlamalar: tizim ---
  'cfg.description':
    "Biznes qoidalarining sozlanadigan qiymatlari. Ular kodda emas, bazada: ularni BIZNES o'zgartiradi va har o'zgarish auditga tushadi.",
  'cfg.key': 'Kalit',
  'cfg.value': 'Qiymat',
  'cfg.dataType': 'Turi',
  'cfg.about': 'Nima uchun kerak',
  'cfg.edit': 'O‘zgartirish',
  'cfg.saved': '«{key}» saqlandi',
  'cfg.invalidNumber': 'Faqat son kiritiladi',
  'cfg.invalidJson': 'JSON formati noto‘g‘ri',
  'cfg.moneyAsText':
    'Pul va foiz qiymatlari MATN bo‘lib saqlanadi — son ko‘rinishida saqlansa qiymat yaxlitlanadi va tiyin darajasida xato beradi.',
  'cfg.typeMismatch':
    "Bazadagi qiymat turi e'lon qilingan turdan («{declared}») farq qiladi. Muharrir haqiqiy turga qarab tanlandi.",
  'cfg.empty': 'Sozlama topilmadi',
  'cfg.loadError': "Sozlamalarni yuklab bo'lmadi",
  'cfg.boolTrue': 'Yoqilgan',
  'cfg.boolFalse': 'O‘chirilgan',

  // --- Xavfsizlik: hodisalar jurnali ---
  'audit.occurredAt': 'Vaqti',
  'audit.actor': 'Kim',
  'audit.actorIp': 'IP',
  'audit.entity': 'Hujjat',
  'audit.entityTable': 'Hujjat turi',
  'audit.entityId': 'Yozuv ID',
  'audit.action': 'Amal',
  'audit.changes': 'O‘zgarishlar',
  'audit.field': 'Maydon',
  'audit.oldValue': 'Eski',
  'audit.newValue': 'Yangi',
  'audit.noChanges': 'Maydon o‘zgarishi yo‘q',
  'audit.limit': 'Yozuv soni',
  'audit.unknownActor': 'Xodim #{id}',
  'audit.system': 'Tizim',
  'audit.empty': 'Yozuv topilmadi',
  'audit.loadError': "Audit jurnalini yuklab bo'lmadi",
  'audit.clearFilters': 'Filtrlarni tozalash',
  'audit.action.insert': 'Yaratildi',
  'audit.action.update': 'O‘zgartirildi',
  'audit.action.delete': 'O‘chirildi',
  'audit.action.login': 'Kirdi',
  'audit.action.logout': 'Chiqdi',
  'audit.description': 'Bitta ro‘yxatda: hujjat o‘zgarishlari, kirish-chiqish, chop etish va ruxsat rad etishlari. Har yozuvda — qaysi akaunt, qaysi IP va qanaqa qurilmadan.',
  'audit.filtersError': 'Filtrlar ro‘yxatini yuklab bo‘lmadi — hujjat turlari bo‘yicha tanlov ishlamaydi',
  'audit.total': '{count} ta yozuv',
  'audit.device': 'Qurilma',
  'audit.rawUserAgent': 'Xom User-Agent: {value}',
  'audit.filterAction': 'Amal',
  'audit.filterActionHint': 'Bir nechtasini birdan tanlash mumkin. Hech biri tanlanmasa — hammasi.',
  'audit.groupDocument': 'Hujjatga tegilgan',
  'audit.groupAccess': 'Kirish va boshqa hodisalar',
  'audit.actionAll': 'Hammasi',
  'audit.action.override': 'Chetlab o‘tildi',
  'audit.action.loginFailed': 'Kirish rad etildi',
  'audit.action.permissionDenied': 'Ruxsat rad etildi',
  'audit.action.export': 'Eksport qilindi',
  'audit.action.print': 'Chop etildi',
  'audit.action.unknown': 'Noma’lum amal ({code})',
  'audit.editWindow.override': 'Tuzatish oynasidan chetlashildi',
  'audit.editWindow.overrideHint': '24 soatlik tuzatish oynasi tugagan edi. Amal `correction.override` ruxsati bilan ATAYLAB o‘tkazilgan — qoida buzilmadi, undan chetlashildi.',
  'audit.editWindow.within': 'Tuzatish oynasi ichida',
  'audit.event': 'Hodisa',
  'audit.device.notRecorded': 'Qurilma yozilmagan',
  'audit.device.notRecordedHint': 'Bu yozuv qurilma qayd etila boshlangunga qadar yaratilgan — dalilning o‘zi yo‘q.',
  'audit.device.unrecognized': 'Tanilmadi',
  'audit.device.unrecognizedHint': 'Qurilma satri BOR, lekin naqshlarga mos kelmadi. Xom satr shu yerda.',
  'audit.device.desktop': 'kompyuter',
  'audit.device.mobile': 'telefon',
  'audit.device.tablet': 'planshet',
  'audit.device.bot': 'skript',
  'audit.device.unknownKind': 'noma’lum turdagi',
  'audit.allTables': 'Barcha hujjat turlari',
  'audit.tableUntranslated': 'Nomi yo‘q: {code}',
  'audit.tableUntranslatedHint': 'Bu hujjat turining nomi hali yozilmagan — ekranda dasturchi kodi turibdi. Kodning o‘zi ko‘rsatilmoqda, chunki uni «Boshqa hujjat» ga almashtirish qaysi hujjat ekanini butunlay yo‘qotardi.',
  'audit.untranslatedCount': '{count} ta hujjat turi tarjimasiz',
  'audit.table.accountingPeriods': 'Buxgalteriya davri',
  'audit.table.approvalDelegations': 'Tasdiqlash vakolati',
  'audit.table.approvalRequests': 'Tasdiqlash so‘rovi',
  'audit.table.approvalRules': 'Tasdiqlash qoidasi',
  'audit.table.bonusEntries': 'Bonus yozuvi',
  'audit.table.branches': 'Filial',
  'audit.table.cashAccounts': 'Kassa hisobi',
  'audit.table.cashFlowItems': 'DDS moddasi',
  'audit.table.cashTransactions': 'Kassa harakati',
  'audit.table.charityAppropriations': 'Xayriya ajratmasi',
  'audit.table.charityPayouts': 'Xayriya to‘lovi',
  'audit.table.commissionRules': 'Komissiya qoidasi',
  'audit.table.commissionRuns': 'Komissiya hisoblash',
  'audit.table.costTypes': 'Xarajat turi',
  'audit.table.creditNotes': 'Kredit-nota',
  'audit.table.customerContacts': 'Mijoz kontakti',
  'audit.table.customerPrices': 'Mijoz narxi',
  'audit.table.customerUsers': 'Mijoz kabineti foydalanuvchisi',
  'audit.table.customers': 'Mijoz',
  'audit.table.dailyRates': 'Kunlik valyuta kursi',
  'audit.table.dayClosings': 'Kun yopilishi',
  'audit.table.dealerRebateTiers': 'Diler chegirma bosqichi',
  'audit.table.dealerUsers': 'Diler foydalanuvchisi',
  'audit.table.dealers': 'Diler',
  'audit.table.deliveries': 'Yuk xati',
  'audit.table.documents': 'Hujjat (skan, sertifikat)',
  'audit.table.employeeAdvances': 'Xodimga avans',
  'audit.table.employeeDebts': 'Xodim qarzi',
  'audit.table.employees': 'Xodim',
  'audit.table.expenses': 'Xarajat',
  'audit.table.fxRevaluations': 'Valyutani qayta baholash',
  'audit.table.goodsReceipts': 'Tovar qabuli',
  'audit.table.installers': 'Usta',
  'audit.table.inventoryTransactions': 'Ombor harakati',
  'audit.table.invoices': 'Hisob-faktura',
  'audit.table.journals': 'Buxgalteriya provodkasi',
  'audit.table.kpiPlans': 'KPI rejasi',
  'audit.table.landedCostRuns': 'Tannarx hisobi',
  'audit.table.payments': 'To‘lov',
  'audit.table.payrollRuns': 'Ish haqi hisoblash',
  'audit.table.poPaymentTerms': 'Xarid to‘lov sharti',
  'audit.table.priceListItems': 'Narx ro‘yxati satri',
  'audit.table.priceLists': 'Narx ro‘yxati',
  'audit.table.printTemplates': 'Chop etish shabloni',
  'audit.table.productPoints': 'Mahsulot bali (usta)',
  'audit.table.products': 'Mahsulot',
  'audit.table.purchaseOrders': 'Xarid buyurtmasi',
  'audit.table.qrBatches': 'QR partiyasi',
  'audit.table.qrCodes': 'QR kodi',
  'audit.table.redemptions': 'Sovg‘aga almashtirish',
  'audit.table.reorderRunLines': 'Qayta zakaz satri',
  'audit.table.reorderRuns': 'Qayta zakaz tahlili',
  'audit.table.rewards': 'Sovg‘a',
  'audit.table.salesOrders': 'Sotuv buyurtmasi',
  'audit.table.salesReturnLines': 'Vozvrat satri',
  'audit.table.salesReturns': 'Vozvrat',
  'audit.table.sessions': 'Sessiya',
  'audit.table.settings': 'Tizim sozlamasi',
  'audit.table.shipmentCosts': 'Konteyner xarajati',
  'audit.table.shipments': 'Konteyner',
  'audit.table.stockCounts': 'Ombor sanog‘i',
  'audit.table.stockTransfers': 'Omborlararo ko‘chirish',
  'audit.table.supplierInvoices': 'Ta’minotchi invoysi',
  'audit.table.suppliers': 'Ta’minotchi',
  'audit.table.tenants': 'Tashkilot',
  'audit.table.userRoles': 'Foydalanuvchi roli',
  'audit.table.users': 'Foydalanuvchi',
  'audit.table.warehouses': 'Ombor',
  'audit.field.status': 'Holat',
  'audit.field.amount': 'Summa',
  'audit.field.amountBase': 'Summa (asosiy valyutada)',
  'audit.field.totalAmount': 'Jami summa',
  'audit.field.totalBase': 'Jami (asosiy valyutada)',
  'audit.field.balanceBase': 'Qoldiq (asosiy valyutada)',
  'audit.field.balanceAmount': 'Qoldiq',
  'audit.field.vatAmount': 'QQS summasi',
  'audit.field.vatBase': 'QQS (asosiy valyutada)',
  'audit.field.vatRate': 'QQS stavkasi',
  'audit.field.listAmount': 'Ro‘yxatdagi narx',
  'audit.field.discountAmount': 'Chegirma',
  'audit.field.priceAmount': 'Narx',
  'audit.field.unitCost': 'Birlik tannarxi',
  'audit.field.quantity': 'Miqdor',
  'audit.field.currency': 'Valyuta',
  'audit.field.currencyCode': 'Valyuta kodi',
  'audit.field.rate': 'Kurs',
  'audit.field.fxRate': 'Valyuta kursi',
  'audit.field.fxRateManual': 'Kurs qo‘lda kiritilgan',
  'audit.field.rateDate': 'Kurs sanasi',
  'audit.field.docNo': 'Hujjat raqami',
  'audit.field.invoiceNo': 'Faktura raqami',
  'audit.field.deliveryNo': 'Yuk xati raqami',
  'audit.field.batchNo': 'Partiya raqami',
  'audit.field.lineCount': 'Satrlar soni',
  'audit.field.codeCount': 'Kodlar soni',
  'audit.field.format': 'Format',
  'audit.field.mode': 'Rejim',
  'audit.field.method': 'Usul',
  'audit.field.paymentMethod': 'To‘lov usuli',
  'audit.field.paymentTermDays': 'To‘lov muddati (kun)',
  'audit.field.dueDate': 'To‘lov muddati',
  'audit.field.invoiceDate': 'Faktura sanasi',
  'audit.field.orderDate': 'Buyurtma sanasi',
  'audit.field.receiptDate': 'Qabul sanasi',
  'audit.field.incurredDate': 'Xarajat sanasi',
  'audit.field.businessDate': 'Ish kuni',
  'audit.field.validFrom': 'Amal qilish boshlanishi',
  'audit.field.postedAt': 'Daftarga yozilgan vaqt',
  'audit.field.occurredAt': 'Sodir bo‘lgan vaqt',
  'audit.field.name': 'Nomi',
  'audit.field.nameUz': 'Nomi (o‘zbekcha)',
  'audit.field.nameRu': 'Nomi (ruscha)',
  'audit.field.fullName': 'To‘liq ismi',
  'audit.field.legalName': 'Yuridik nomi',
  'audit.field.code': 'Kod',
  'audit.field.sku': 'Artikul',
  'audit.field.phone': 'Telefon',
  'audit.field.address': 'Manzil',
  'audit.field.notes': 'Izoh',
  'audit.field.description': 'Tavsif',
  'audit.field.reason': 'Sabab',
  'audit.field.reasonCode': 'Sabab kodi',
  'audit.field.reversalReason': 'Storno sababi',
  'audit.field.reversalDocNo': 'Storno hujjati',
  'audit.field.writeoffReason': 'Hisobdan chiqarish sababi',
  'audit.field.overrideReason': 'Chetlab o‘tish sababi',
  'audit.field.differenceReason': 'Farq sababi',
  'audit.field.isActive': 'Faol',
  'audit.field.isBlocked': 'Bloklangan',
  'audit.field.isDefault': 'Sukut bo‘yicha',
  'audit.field.isSellable': 'Sotiladi',
  'audit.field.isPurchasable': 'Sotib olinadi',
  'audit.field.creditLimitAmount': 'Kredit limiti',
  'audit.field.creditLimitBase': 'Kredit limiti (asosiy valyutada)',
  'audit.field.creditLimitCurrency': 'Kredit limiti valyutasi',
  'audit.field.outstandingBase': 'Ochiq qarz (asosiy valyutada)',
  'audit.field.creditCheckResult': 'Kredit tekshiruvi natijasi',
  'audit.field.creditOverrideBy': 'Limitdan kim chetlab o‘tdi',
  'audit.field.privilegeEscalationDenied': 'Huquqni oshirishga urinish rad etildi',
  'audit.field.sessionsRevoked': 'Bekor qilingan sessiyalar',
  'audit.field.role': 'Rol',
  'audit.field.locale': 'Til',
  'audit.field.document': 'Hujjat',
  'audit.field.missingFields': 'Yetishmayotgan maydonlar',
  'audit.field.salaryAmount': 'Ish haqi',
  'audit.field.position': 'Lavozim',
  'audit.field.employeeNo': 'Tabel raqami',
  'audit.field.hiredAt': 'Ishga qabul sanasi',
  'audit.field.firedAt': 'Ishdan bo‘shash sanasi',
  'audit.field.containerNo': 'Konteyner raqami',
  'audit.field.vehicleNo': 'Avtomobil raqami',
  'audit.field.driverName': 'Haydovchi',
  'audit.field.eta': 'Kutilayotgan kelish',
  'audit.field.etd': 'Kutilayotgan jo‘nash',
  'audit.field.ata': 'Haqiqiy kelish',
  'audit.field.weightKg': 'Og‘irlik (kg)',
  'audit.field.volumeM3': 'Hajm (m³)',
  'audit.field.cashBalance': 'Kassa qoldig‘i',
  'audit.field.cashIn': 'Kirim',
  'audit.field.cashOut': 'Chiqim',
  'audit.field.countedAmount': 'Sanalgan summa',
  'audit.field.openingBalance': 'Boshlang‘ich qoldiq',
  'audit.field.expectedBalance': 'Kutilgan qoldiq',
  'audit.field.difference': 'Farq',
  'audit.field.inventoryValue': 'Ombor qiymati',
  'audit.field.txnType': 'Harakat turi',
  'audit.field.accountType': 'Hisob turi',
  'audit.field.customerType': 'Mijoz turi',
  'audit.field.orderSource': 'Buyurtma manbayi',
  'audit.field.source': 'Manba',

  // ==========================================================================
  // USTA DASTURI (loyalty) — LOYALTY_SPEC v1.0
  //
  // Matnlarning ohangi ataylab boshqacha: bu ekranlarda har raqam
  // MAJBURIYAT (kompaniya qarzi) yoki FIRIBGARLIK signali. Ikkalasi ham
  // izohsiz o'qilmaydi — «1000 ball» hech narsani anglatmaydi, «1000 ball =
  // $11 qarz» esa anglatadi.
  // ==========================================================================

  // ==========================================================================
  // DILLER KANALI VA BONUS (TZ v8.0 §31)
  //
  // Ohang usta dasturinikiga o'xshash va sabab ham o'sha: har raqam yo
  // MAJBURIYAT (kompaniya qarzi), yo KASSADAN CHIQQAN pul. «2.71 USD» hech
  // narsani anglatmaydi, «271 USD hajmdan 1% = 2.71 USD» esa anglatadi.
  // ==========================================================================

  // --- Dillerlar ---
  'dlr.description':
    'Diller — mustaqil savdogar: bizdan tovar oladi, o‘z omborida saqlaydi va o‘z mijozlariga sotadi. Uning savdosi bizning hisobotlarimizga KIRMAYDI; biz undan faqat xarid hajmini ko‘ramiz va shu hajmdan rebate hisoblaymiz.',
  'dlr.channelTitle': 'Diller mijoz sifatida ham yashaydi',
  'dlr.channelWhy':
    'Har diller BIZNING mijozimizga bog‘lanadi va bu majburiy: yillik bonus (rebate) unga chiqarilgan hisob-fakturalar yig‘indisidan hisoblanadi. Mijozsiz diller kartasining bonusi har doim nol chiqardi.',
  'dlr.openBonus': 'Bonus hisoblariga o‘tish',
  'dlr.code': 'Kod',
  'dlr.name': 'Nomi',
  'dlr.customer': 'Mijoz',
  'dlr.customerPick': 'Mijozni tanlang',
  'dlr.customerHint': 'Rebate asosi shu mijozga chiqarilgan hisob-fakturalardan olinadi.',
  'dlr.territory': 'Hudud',
  'dlr.contract': 'Shartnoma',
  'dlr.until': '{date} gacha',
  'dlr.status': 'Holat',
  'dlr.statusActive': 'Faol',
  'dlr.statusSuspended': 'To‘xtatilgan',
  'dlr.statusTerminated': 'Bekor qilingan',
  'dlr.filterAll': 'Hammasi',
  'dlr.suspend': 'To‘xtatish',
  'dlr.activate': 'Faollashtirish',
  'dlr.terminate': 'Shartnomani bekor qilish',
  'dlr.finalState': 'Yakuniy holat — qaytarilmaydi',
  'dlr.new': 'Yangi diller',
  'dlr.create': 'Dillerni yaratish',
  'dlr.createdMsg': 'Diller yaratildi: {code}',
  'dlr.noManage':
    'Diller kartasini o‘zgartirish huquqi sizda yo‘q — bu tijorat qarori va moliyachida bunday huquq yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'dlr.searchPlaceholder': 'Kod, nom yoki hudud',
  'dlr.empty': 'Diller topilmadi',
  'dlr.emptyHint': 'Yangi diller qo‘shish uchun pastdagi formadan foydalaning.',
  'dlr.loadError': 'Dillerlar ro‘yxatini yuklab bo‘lmadi',
  /*
   * `dlr.searchLabel` O'CHIRILDI — dillerlar ekrani `common.search` ni
   * ishlatadi (`routes/dealers/dealers-list.tsx`), xuddi bonus hisoblari va
   * bonus daftari kabi. Ikkinchi «Qidiruv» kaliti hech qayerdan
   * chaqirilmasdi, lekin uchala tilda ham turardi va tarjimon uni har
   * safar qayta tarjima qilardi. Yorliq umumiy bo'lgani ATAYLAB: bir xil
   * qidiruv maydoni uch ekranda uch xil nomlansa, foydalanuvchi ularni
   * boshqa-boshqa vosita deb o'qirdi. Faqat PLACEHOLDER ekranga xos
   * (`dlr.searchPlaceholder`) — chunki u nimani yozish kerakligini aytadi.
   */

  // --- Bonus hisoblari ---
  'bns.description':
    'Bonus ikki tomonga to‘lanadi: dillerga yillik xarid hajmidan foiz (rebate), ustaga esa o‘rnatgan mahsuloti uchun ball. Ikkalasi ham oxirida BITTA narsaga aylanadi — kassadan chiqadigan pul, shuning uchun bitta ro‘yxatda.',
  'bns.pointValue': 'Ball kursi',
  'bns.pointValueIs': '1 ball = {value} USD',
  'bns.pointValueWhy':
    'Kurs sovg‘a katalogidan hosila qilinadi: barcha faol sovg‘alarning tannarxi ÷ ularning ball narxi. Ya‘ni ballning haqiqiy qiymati katalog bilan birga o‘zgaradi va to‘lov paytidagi kurs hujjatga YOZIB OLINADI.',
  'bns.pointValueUnknown':
    'Ball kursini hisoblab bo‘lmadi: sovg‘a katalogida tannarxi kiritilgan faol sovg‘a yo‘q. Usta bonusini naqdga chiqarish uchun avval tannarxlarni kiriting (Usta dasturi → Sovg‘a katalogi).',
  'bns.partyType': 'Kim',
  'bns.partyDealer': 'Diller',
  'bns.partyInstaller': 'Usta',
  'bns.code': 'Kod / telefon',
  'bns.name': 'Nomi',
  'bns.points': 'Ball',
  'bns.accrued': 'Hisoblangan',
  'bns.paid': 'To‘langan',
  'bns.balance': 'Qoldiq',
  'bns.balanceFilter': 'Qoldiq',
  'bns.onlyWithBalance': 'Faqat qoldig‘i borlar',
  'bns.filterAll': 'Hammasi',
  'bns.blocked': 'Bloklangan',
  'bns.accrue': 'Rebate hisoblash',
  'bns.accruedMsg': '{docNo}: {amount} USD hisoblandi',
  'bns.payout': 'Naqdga chiqarish',
  'bns.payoutTitle': '{name} — bonusni naqdga chiqarish',
  'bns.payoutConfirm': 'To‘lash',
  'bns.payoutWarn':
    'Bu amal KASSADAN PUL CHIQARADI va u qaytarilmaydi. Harakat DDS maqolasi bilan yoziladi va kassa qoldig‘i darhol kamayadi.',
  'bns.cashAccount': 'Kassa',
  'bns.cashPick': 'Kassani tanlang',
  'bns.cashHint': 'Valyuta kassadan olinadi, kurs esa to‘lov sanasidan.',
  'bns.amountUsd': 'Summa (USD)',
  'bns.amountHint': 'Qoldiq: {balance} USD. Bo‘lib to‘lash mumkin.',
  'bns.pointsToCash': 'Naqdga chiqariladigan ball',
  'bns.pointsHint': 'Balansda {balance} ball. Ball darhol yechiladi.',
  'bns.notes': 'Izoh',
  'bns.paidMsg': '{docNo}: {amount} {currency} to‘landi',
  'bns.noPayout':
    'Bonusni naqdga chiqarish huquqi sizda yo‘q — u kassadan pul chiqarish bilan teng va faqat moliyachi hamda administratorda. Kerak bo‘lsa ularga murojaat qiling.',
  'bns.searchPlaceholder': 'Diller kodi, usta telefoni yoki nomi',
  'bns.empty': 'Bonus hisobi topilmadi',
  'bns.loadError': 'Bonus hisoblarini yuklab bo‘lmadi',
  'bns.ledgerHint': 'Har bir hisoblanish va to‘lov daftarda qoladi.',
  'bns.openLedger': 'Bonus daftarini ochish',

  // --- Bonus daftari ---
  'bnl.description':
    'Bonus daftari — hisoblanish va to‘lovlarning o‘zgarmas tarixi. Yozuv o‘chirilmaydi va tahrirlanmaydi: bonus kompaniyaning majburiyati, to‘lov esa kassadan chiqqan pul.',
  'bnl.immutable':
    'Daftar O‘ZGARMAS. Tuzatish faqat teskari yozuv bilan qilinadi va u alohida, qayd etilgan amal.',
  'bnl.docNo': 'Hujjat',
  'bnl.occurredAt': 'Vaqti',
  'bnl.entryType': 'Turi',
  'bnl.typeAccrual': 'Hisoblandi',
  'bnl.typePayout': 'To‘landi',
  'bnl.basis': 'Asos',
  'bnl.pointsUnit': 'ball',
  'bnl.amountBase': 'Summa (USD)',
  'bnl.amount': 'Kassa summasi',
  'bnl.balanceAfter': 'Keyingi qoldiq',
  'bnl.reversal': 'Teskari yozuv',
  'bnl.searchPlaceholder': 'Hujjat raqami',
  'bnl.empty': 'Daftar bo‘sh',
  'bnl.loadError': 'Bonus daftarini yuklab bo‘lmadi',

  // --- Umumiy tushunchalar ---
  'loy.points': 'Ball',
  'loy.pointsUnit': '{points} ball',
  'loy.actions': 'Amallar',
  'loy.sku': 'SKU',
  'loy.product': 'Mahsulot',
  'loy.pointValue': 'Ball qiymati',
  'loy.pointValueUnit': '{value} / 1 ball',
  'loy.pointValueBasis':
    '{rewards} ta faol sovg‘a: jami tannarx {cost} ÷ jami {points} ball',
  'loy.pointValueWhy':
    'Ball qiymati KATALOGDAN hosila qilinadi: sovg‘alarning umumiy tannarxi ÷ umumiy ball narxi. Ya‘ni katalog o‘zgarsa, yig‘ilgan ballning pul qiymati ham o‘zgaradi — ball miqdori esa o‘zgarmaydi.',
  'loy.pointValueMissing': 'BALL QIYMATI HISOBLANMAYDI',
  'loy.pointValueMissingBody':
    'Katalogda tannarxi kiritilgan faol sovg‘a yo‘q. Bu holatda bu ekrandagi HAMMA pul raqami noma‘lum: «150 ball qarz» degan yozuv byudjet uchun hech narsa bermaydi. Avval sovg‘a katalogida sovg‘aning tannarxini kiriting.',
  'loy.pointValueZeroRewards':
    'Qiymat NOL sovg‘adan hosil qilingan — ya‘ni u qiymat emas. Sovg‘a katalogida tannarxni kiriting.',
  'loy.pointValueSample':
    'Bu qiymat NAMUNA: vaqtinchalik misol sifatida qo‘yilgan va haqiqiysi bilan almashtirilishi shart. Marketing tasdiqlagach u sovg‘a katalogi orqali aniqlanadi.',

  // --- Dastur holati (landing) ---
  'loy.title': 'Usta dasturi — dastur holati',
  'loy.description':
    'Usta LED mahsulotni o‘rnatib QR kodni skanerlaydi va ball yig‘adi. Har bir ball — KOMPANIYANING QARZI: pul chiqmagan, tovar ketmagan, lekin va‘da qilingan. Bu ekran o‘sha qarzni ko‘rsatadi.',
  'loy.outstanding': 'Ochilmagan majburiyat',
  'loy.outstandingHint': 'Ustalar qo‘lidagi ball — istalgan kun sovg‘a so‘raladi',
  'loy.outstandingInstallers': '{withBalance} ta ustada ball bor ({total} tadan)',
  'loy.pending': 'Navbatdagi almashtirishlar',
  'loy.pendingHint': 'So‘ralgan yoki tasdiqlangan, hali topshirilmagan sovg‘alar',
  'loy.pendingCount': '{count} ta so‘rov',
  'loy.awaiting': 'Skaner kutilmoqda',
  'loy.awaitingHint': 'Tovar SOTILGAN, usta hali skanerlamagan',
  'loy.awaitingCodes': '{codes} ta faollashgan kod',
  'loy.awaitingWhy':
    'Bu — POTENSIAL majburiyat, xato emas. Kod faqat tovar sotilganda faollashadi, ya‘ni bu ballar berilishi KAFOLATLANGAN: usta shunchaki hali skanerlamagan. Byudjetda ular allaqachon hisobga olinishi kerak.',
  'loy.awaitingByProduct': 'Mahsulot kesimi',
  'loy.awaitingEmpty': 'Faollashgan, skanerlanmagan kod yo‘q',
  'loy.codes': 'Kodlar',
  'loy.pointsPerCode': 'Ball / kod',
  'loy.missingRuleBadge': 'Qoida yo‘q',
  'loy.missingRuleWarn':
    '{count} ta mahsulotda faollashgan kod bor, lekin BUGUNGI ball qoidasi yo‘q. Bu kodlar skanerlanganda ball berilmaydi va usta «QR ishlamayapti» deb qo‘ng‘iroq qiladi.',
  'loy.totalOwed': 'Jami majburiyat',
  'loy.totalOwedHint': 'Balans + navbat + skaner kutayotgan ballar',
  'loy.quickLinks': 'Dastur ekranlari',
  'loy.fraudSignals': 'Nazorat navbatida {count} ta signal',
  'loy.fraudNone': 'Nazorat navbati bo‘sh',
  'loy.loadError': 'Dastur holatini yuklab bo‘lmadi',
  'loy.installersTotal': 'Ro‘yxatdagi ustalar',

  // --- Ball qoidalari ---
  'lpr.title': 'Ball qoidalari',
  'lpr.description':
    'Har mahsulot uchun bitta quti qancha ball beradi. Qoidasi YO‘Q mahsulot ball bermaydi va uning kodi umuman skanerlanmaydi.',
  'lpr.frozenWhy':
    'Berilgan ball SKANERLASH PAYTIDA qotib qoladi. Qoidani keyin o‘zgartirsangiz, o‘tgan skanerlar qayta hisoblanmaydi — aks holda usta yig‘gan balli har hafta o‘zgarib turardi.',
  'lpr.versionedWhy':
    'Qoida TAHRIRLANMAYDI, sana bo‘yicha VERSIYALANADI (narx ro‘yxati bilan bir xil naqsh): aksiya uchun yangi qator qo‘shiladi. Shuning uchun bu ekranda «tahrirlash» tugmasi yo‘q.',
  'lpr.points': 'Ball',
  'lpr.validFrom': 'Amal qiladi',
  'lpr.validTo': 'Tugash sanasi',
  'lpr.validToHint': 'Bo‘sh qoldirilsa — muddatsiz. Aksiya uchun tugash sanasini ko‘rsating.',
  'lpr.notes': 'Izoh',
  'lpr.state': 'Holat',
  'lpr.state.active': 'Amalda',
  'lpr.state.future': 'Kelajakda',
  'lpr.state.expired': 'Muddati o‘tgan',
  'lpr.showAll': 'Barcha versiyalarni ko‘rsatish',
  'lpr.showAllHint':
    'Odatda faqat BUGUN amal qilayotgan qoidalar ko‘rsatiladi: bitta mahsulotda vaqt o‘tishi bilan o‘nlab versiya yig‘iladi va ular javobni ko‘mib tashlaydi.',
  'lpr.new': 'Yangi qoida',
  'lpr.create': 'Qoidani yaratish',
  'lpr.created': '{sku} — {points} ball ({from} dan)',
  'lpr.productRequired': 'Mahsulot tanlanishi shart',
  'lpr.pointsInvalid': 'Ball 0 dan 1 000 000 gacha butun son bo‘lishi kerak',
  'lpr.zeroAllowed':
    '0 ga RUXSAT bor va u qoidaning YO‘QLIGIDAN farq qiladi: 0 — «bu mahsulot uchun ataylab ball berilmaydi», yo‘qligi esa — «sozlash unutilgan».',
  'lpr.noEdit':
    'Ball qoidasini o‘zgartirish huquqi sizda yo‘q — u faqat administrator va rahbarda. Ball kursi MARKETING qarori, moliya emas; kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lpr.missingTitle': 'Ball qoidasi yo‘q mahsulotlar: {count}',
  'lpr.missingBody':
    'Bu mahsulotlarni skanerlash RAD ETILADI — sabab: «Ball qoidasi yo‘q». Usta esa «QR ishlamayapti» deb qo‘ng‘iroq qiladi va sabab bir soat qidiriladi — shuning uchun ro‘yxat shu yerda turadi.',
  'lpr.missingNone': 'Barcha sotiladigan mahsulotda bugungi ball qoidasi bor.',
  'lpr.missingLoadError':
    'Qoidasiz mahsulotlar ro‘yxatini yuklab bo‘lmadi.',
  'lpr.missingOrder':
    'Tartib SHOSHILINCHLIK bo‘yicha: yuqorida faollashgan kodi ko‘p bo‘lgan mahsulot turadi. Faollashgan kod «tovar sotilgan» degani, ya‘ni usta ayni damda skanerlashga urinib rad javobi olayotgan bo‘lishi mumkin.',
  'lpr.activatedCodes': 'Faollashgan kod',
  'lpr.missingUrgent': '{count} tasida faollashgan kod bor',
  'lpr.missingUrgentHint':
    'Tovar sotilgan, kod faollashgan, qoida esa yo‘q — skaner rad etiladi.',
  'lpr.missingScanning': 'Skanerlanmoqda bo‘lishi mumkin',
  'lpr.missingRest': 'Yana {count} ta mahsulotda qoida yo‘q — ular kam shoshilinch.',
  'lpr.stats.active': 'Amaldagi qoida',
  'lpr.stats.future': 'Kelajakdagi',
  'lpr.stats.expired': 'Muddati o‘tgan',
  'lpr.stats.missing': 'Qoidasiz mahsulot',
  'lpr.empty': 'Ball qoidasi topilmadi',
  'lpr.emptyHint': 'Filtrni kengaytiring yoki birinchi qoidani yarating.',
  'lpr.loadError': 'Ball qoidalarini yuklab bo‘lmadi',
  'lpr.filterProduct': 'Mahsulot bo‘yicha',
  'lpr.clearFilter': 'Filtrni tozalash',

  // --- QR partiyalar ---
  'lqr.title': 'QR partiyalar',
  'lqr.description':
    'Har quti uchun UNIKAL kod. Kod «Omborda» holatida tug‘iladi va SKANERLANMAYDI — u faqat tovar sotilganda faollashadi.',
  'lqr.lifecycleWhy':
    'created → (tovar sotildi) → activated → (usta skanerladi) → scanned. Faollashuv yuk xatiga bog‘langan, ya‘ni omborda turgan tovarga ball berib bo‘lmaydi va stiker rulosi qo‘lga tushsa ham faqat SOTILGANI qadar ball olinadi.',
  'lqr.batchNo': 'Partiya',
  'lqr.quantity': 'Kodlar soni',
  'lqr.printedAt': 'Eksport qilingan',
  'lqr.notPrinted': 'Eksport qilinmagan',
  'lqr.notes': 'Izoh',
  'lqr.st.created': 'Omborda',
  'lqr.st.activated': 'Sotilgan',
  'lqr.st.scanned': 'Skanerlangan',
  'lqr.st.void': 'Bekor',
  'lqr.new': 'Yangi partiya',
  'lqr.createSubmit': 'Partiyani yaratish',
  'lqr.createdMsg': '{batchNo}: {quantity} ta kod yaratildi',
  'lqr.quantityHint': '1 dan {max} gacha. Ortiqcha nol chop etish byudjetini yeb qo‘yadi.',
  'lqr.quantityInvalid': 'Miqdor 1 dan {max} gacha butun son bo‘lishi kerak',
  'lqr.noGenerate':
    'Kod chiqarish va eksport qilish huquqi sizda yo‘q — u faqat administrator va rahbarda. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lqr.export': 'Kodlarni eksport qilish',
  'lqr.exportTitle': 'Eksport — bu o‘qish emas, KOD CHIQARISH bilan teng amal',
  'lqr.exportBody':
    'Javob — partiyaning BARCHA kodlari ochiq matnda. Ularni olgan odam tovar sotilishi bilan hamma ballni yig‘ib olishi mumkin, ya‘ni bu fayl qimmatbaho qog‘oz.',
  'lqr.exportAudited':
    'Bu amalning O‘ZI audit jurnaliga «eksport» bo‘lib tushadi va partiyaning «eksport qilingan» sanasi belgilanadi. Faylni saqlamasangiz ham yozuv qoladi — bekor qilib bo‘lmaydi.',
  'lqr.exportUnderstood': 'Tushundim: amal auditga tushadi va sana belgilanadi',
  'lqr.exportReprint':
    'DIQQAT: bu partiya {date} da allaqachon eksport qilingan. Ikkinchi eksport «yana chop etamiz» degani va u auditda shubhali ko‘rinadi — sababini izohda qoldiring.',
  'lqr.exportConfirm': 'Ha, {count} ta kodni eksport qilaman',
  'lqr.exportDone': '{batchNo}: {count} ta kod faylga chiqarildi',
  'lqr.exportFailed': 'Kodlarni eksport qilib bo‘lmadi',
  'lqr.exportFileHint':
    'Fayl serverdan kelgan AYNAN shu kodlardan quriladi — ikkinchi so‘rov yuborilmaydi. Ustunlar: tartib raqami, kod, holat, mahsulot artikuli (SKU) va partiya raqami. Fayl sarlavhasi — serial;code;status;sku;batch_no',
  'lqr.empty': 'QR partiya topilmadi',
  'lqr.emptyHint': 'Hali birorta partiya yaratilmagan bo‘lishi mumkin.',
  'lqr.loadError': 'QR partiyalarni yuklab bo‘lmadi',

  // --- Stiker zaxirasi ---
  'lst.title': 'Stiker zaxirasi',
  'lst.why':
    'Yuk xati post qilinganda shu mahsulotning kodlari faollashadi. Kod YETMASA yetkazish TO‘XTAMAYDI — faqat jurnalga ogohlantirish yoziladi, ya‘ni tovar stikersiz ketadi va usta skanerlaydigan narsa topmaydi. Bu jim xato aynan shu yerda ko‘rinadi.',
  'lst.created': 'Qolgan zaxira',
  'lst.productStock': 'Mahsulot zaxirasi',
  'lst.order':
    'Tartib zaxira bo‘yicha o‘sish: yuqorida tugayotgan mahsulot turadi.',
  'lst.rest': 'Yana {count} ta mahsulot ro‘yxatda.',
  'lst.emptyWarn':
    '{count} ta mahsulotda kod ZAXIRASI YO‘Q: keyingi yetkazishda ularning qutilariga stiker tushmaydi. Yangi partiya yarating.',
  'lst.lowWarn':
    '{count} ta mahsulotda zaxira {threshold} tadan kam — partiya chop etish va yopishtirish vaqt oladi, buyurtmani oldindan bering.',
  'lst.badgeEmpty': 'Zaxira yo‘q',
  'lst.badgeLow': 'Zaxira kam',
  'lst.empty': 'Bironta mahsulotda QR kod yaratilmagan',
  'lst.loadError': 'Stiker zaxirasini yuklab bo‘lmadi',

  // --- Sovg'a katalogi ---
  'lrw.title': 'Sovg‘a katalogi',
  'lrw.description':
    'Ball nimaga almashtiriladi. Tannarx — sovg‘aning KOMPANIYAGA narxi; aynan u ballning haqiqiy qiymatini belgilaydi.',
  'lrw.code': 'Kod',
  'lrw.name': 'Nomi',
  'lrw.pointsCost': 'Ball narxi',
  'lrw.costBase': 'Tannarx (USD)',
  'lrw.costBaseHint':
    'Kompaniyaga tushadigan xarajat. Kiritilmasa bu sovg‘a ball qiymatini hisoblashga QATNASHMAYDI.',
  'lrw.stockQty': 'Qoldiq',
  'lrw.stockUnlimited': 'Cheksiz',
  'lrw.stockHint': 'Bo‘sh qoldirilsa — cheksiz (sertifikat kabi). 0 — tugagan.',
  'lrw.status': 'Holat',
  'lrw.active': 'Faol',
  'lrw.inactive': 'O‘chirilgan',
  'lrw.derivedValue': 'Ball qiymati (hosila)',
  'lrw.average': 'Katalog o‘rtachasi: {value}',
  'lrw.averageMissing': 'Katalog o‘rtachasini hisoblab bo‘lmadi — tannarx kiritilmagan',
  'lrw.divergeWhy':
    'Nisbat IZCHIL bo‘lishi kerak. Agar bitta sovg‘a boshqalardan foydali bo‘lsa, usta buni albatta hisoblab chiqadi va katalogning qolgani ishlatilmaydi. Har satrdagi «ball qiymati» = tannarx ÷ ball narxi; o‘rtachadan ±{pct}% dan ko‘proq chetlangan satr belgilanadi.',
  'lrw.divergeAlert':
    '{count} ta sovg‘a katalog o‘rtachasidan ±{pct}% dan ko‘proq farq qiladi — ballning haqiqiy kursi shu satrlar bo‘yicha belgilanadi.',
  'lrw.flag.high': 'O‘rtachadan foydali',
  'lrw.flag.highHint': 'Usta ayni shu sovg‘ani tanlaydi — ball kursi amalda shu satr bo‘yicha.',
  'lrw.flag.low': 'O‘rtachadan zaif',
  'lrw.flag.lowHint': 'Bu sovg‘a amalda so‘ralmaydi — katalogda o‘lik pozitsiya.',
  'lrw.flag.unknown': 'Tannarxsiz',
  'lrw.new': 'Yangi sovg‘a',
  'lrw.create': 'Sovg‘ani yaratish',
  'lrw.createdMsg': 'Sovg‘a yaratildi: {code}',
  'lrw.edit': 'Tahrirlash',
  'lrw.editTitle': '{name} — tahrirlash',
  'lrw.saved': 'Sovg‘a saqlandi: {name}',
  'lrw.codeImmutable':
    'Kod TAHRIRLANMAYDI: u barqaror identifikator va uni o‘zgartirish almashtirish tarixini uzadi.',
  'lrw.deactivate': 'O‘chirish',
  'lrw.activate': 'Faollashtirish',
  'lrw.deactivateHint':
    'O‘chirilgan sovg‘a ustaga ko‘rinmaydi, lekin eski so‘rovlar joyida qoladi va ball qiymati hisobidan ham chiqadi.',
  'lrw.moneyAsText':
    'Tannarx va qoldiq ANIQ saqlanadi: ular yaxlitlanadigan songa o‘girilmaydi, chunki bu yerda 0.01 ham ahamiyatli.',
  'lrw.invalidMoney': 'Summa noto‘g‘ri formatda (masalan «12.5000»)',
  'lrw.invalidPoints': 'Ball narxi 1 dan katta butun son bo‘lishi kerak',
  'lrw.codeRequired': 'Kod va nom to‘ldirilishi shart',
  'lrw.noEdit':
    'Sovg‘a katalogini o‘zgartirish huquqi sizda yo‘q. Katalog — MARKETING byudjeti; kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lrw.empty': 'Sovg‘a topilmadi',
  'lrw.loadError': 'Sovg‘a katalogini yuklab bo‘lmadi',

  // --- Almashtirishlar ---
  'lrd.title': 'Sovg‘a almashtirishlari',
  'lrd.description':
    'Usta yuborgan so‘rovlar. Tasdiqlash → topshirish; rad etish ballni QAYTARADI.',
  'lrd.deductedWhy':
    'Ball so‘rov paytida ALLAQACHON yechilgan — aks holda usta bir xil ballni ikki sovg‘aga so‘rab yuborardi. Ya‘ni «tasdiqlash» pul harakati emas, «rad etish» esa bepul EMAS: rad etilganda ball teskari yozuv bilan ustaga qaytadi va uning balansi darhol oshadi.',
  'lrd.separationWhy':
    '«So‘ralgan» dan to‘g‘ridan-to‘g‘ri «Topshirilgan» ga o‘tilmaydi: so‘rovni tasdiqlovchi va sovg‘ani topshiruvchi bir odam bo‘lmasligi kerak, aks holda omborchi o‘ziga sovg‘a yozib olishi mumkin.',
  'lrd.docNo': 'Hujjat',
  'lrd.installer': 'Usta',
  'lrd.reward': 'Sovg‘a',
  'lrd.pointsCost': 'Ball',
  'lrd.status': 'Holat',
  'lrd.statusAll': 'Barcha holatlar',
  'lrd.requestedAt': 'So‘rov sanasi',
  'lrd.issuedAt': 'Topshirilgan',
  'lrd.rejectReason': 'Rad etish sababi',
  'lrd.deliveryNote': 'Yetkazish izohi',
  'lrd.status.requested': 'So‘ralgan',
  'lrd.status.approved': 'Tasdiqlangan',
  'lrd.status.issued': 'Topshirilgan',
  'lrd.status.rejected': 'Rad etilgan',
  'lrd.status.cancelled': 'Bekor qilingan',
  'lrd.approve': 'Tasdiqlash',
  'lrd.approved': '{docNo} tasdiqlandi — endi sovg‘ani topshirish mumkin',
  'lrd.issue': 'Topshirish',
  'lrd.issueNote': 'Topshirish izohi (telefon, manzil)',
  'lrd.issued': '{docNo} topshirildi — YAKUNIY holat',
  'lrd.reject': 'Rad etish',
  'lrd.rejectTitle': 'So‘rovni rad etish',
  'lrd.rejectHint':
    'Sabab MAJBURIY va usta uni ko‘radi: sababsiz rad etilgan so‘rov darhol qaytadan yuboriladi va navbat yana to‘ladi.',
  'lrd.rejectReasonRequired': 'Sabab kamida 3 ta belgidan iborat bo‘lishi kerak',
  'lrd.rejected': '{docNo} rad etildi — {points} ball ustaga qaytarildi (yangi balans {balance})',
  'lrd.noApprove':
    'So‘rovlarni tasdiqlash huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lrd.empty': 'Almashtirish so‘rovi topilmadi',
  'lrd.emptyHint': 'Holat filtrini kengaytiring.',
  'lrd.loadError': 'Almashtirishlarni yuklab bo‘lmadi',
  'lrd.filterInstaller': 'Usta #{id} bo‘yicha filtr',
  'lrd.clearFilter': 'Filtrni tozalash',

  // --- Ustalar ---
  'lin.title': 'Ustalar',
  'lin.description':
    'Dasturda ro‘yxatdan o‘tgan ustalar, ball balansi va oxirgi harakati.',
  'lin.notUserWhy':
    'Usta dasturdan faqat kod skanerlash uchun foydalanadi va Alight ga kira olmaydi. Shuning uchun bu ekranda unga rol ham, ruxsat ham berilmaydi — faqat bloklash bor.',
  'lin.policyMore': 'Batafsil',
  'lin.blockPolicy':
    'Blok shubha asosida qo‘yiladi va tekshiruv uni rad etishi mumkin, yig‘ilgan ball esa kompaniyaning ustaga qarzi. Shuning uchun bloklashda ballga tegilmaydi. Noto‘g‘ri berilgan ballni qaytarib olish — alohida amal: nazorat navbatidan kerakli skanerni topib, uni teskarilash kerak.',
  'lin.phone': 'Telefon',
  'lin.name': 'F.I.Sh.',
  'lin.balance': 'Balans',
  'lin.earned': 'Yig‘ilgan',
  'lin.redeemed': 'Sarflangan',
  'lin.lastScan': 'Oxirgi skaner',
  'lin.neverScanned': 'Skanerlamagan',
  'lin.lastLogin': 'Oxirgi kirish',
  'lin.createdAt': 'Ro‘yxatdan o‘tgan',
  'lin.status': 'Holat',
  'lin.active': 'Faol',
  'lin.blocked': 'Bloklangan',
  'lin.verified': 'Tasdiqlangan',
  'lin.block': 'Bloklash',
  'lin.unblock': 'Blokdan chiqarish',
  'lin.blockTitle': '{name} — bloklash',
  'lin.unblockTitle': '{name} — blokdan chiqarish',
  'lin.blockReason': 'Bloklash sababi',
  'lin.blockReasonRequired': 'Sabab kiritilishi shart — u auditga tushadi',
  'lin.blockKeepsPoints':
    'Bloklash skanerlashni to‘xtatadi — yig‘ilgan ball ustada qoladi.',
  'lin.blockedOk': '{name} bloklandi. Balansi o‘zgarmadi: {balance} ball.',
  'lin.unblockedOk': '{name} blokdan chiqarildi',
  'lin.noBlock':
    'Sizda ustani bloklash huquqi yo‘q — shuning uchun satrlarda bu tugma ko‘rinmaydi. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lin.filterAll': 'Hammasi',
  'lin.filterActive': 'Faqat faollar',
  'lin.filterBlocked': 'Faqat bloklanganlar',
  'lin.searchPlaceholder': 'Ism yoki telefon',
  'lin.openRedemptions': 'Almashtirishlari →',
  'lin.openFraud': 'Nazorat navbati →',
  'lin.empty': 'Usta topilmadi',
  'lin.emptyHint': 'Filtrni kengaytiring yoki qidiruvni tozalang.',
  'lin.loadError': 'Ustalarni yuklab bo‘lmadi',
  'lin.notFound': 'Usta topilmadi yoki sizga ko‘rinmaydi',
  'lin.openCard': 'Kartochka →',
  'lin.unblockHint':
    'Blokdan chiqarilgach usta yana skanerlay oladi. Blok davrida skanerlanmagan kodlar yo‘qolmaydi — ular hamon faol va keyin skanerlanishi mumkin.',

  // --- Usta kartochkasi ---
  'lid.back': '← Ustalar ro‘yxati',
  'lid.telegram': 'Telegram ulangan',
  'lid.balanceHint': 'Kompaniyaning shu ustaga qarzi',
  'lid.earnedTotal': 'Yig‘ilgan: {points}',
  'lid.redeemedTotal': 'Sarflangan: {points}',
  'lid.scanCount': 'Muvaffaqiyatli skanerlar',
  'lid.scanCountHint': 'Ball berilgan kodlar soni',
  'lid.rejectedCount': 'Rad etilgan urinishlar',
  'lid.rejectedCountHint':
    'O‘zi ayblov EMAS: halol usta ham noto‘g‘ri kod teradi. Qaror nazorat navbatida, kesimlar bilan birga qabul qilinadi.',
  'lid.ledger': 'Ball daftari',
  'lid.ledgerWhy':
    'Daftar O‘ZGARMAS: yozuv o‘chirilmaydi va tuzatilmaydi, faqat TESKARI yozuv qo‘shiladi. Shuning uchun «storno» (bu yozuvning o‘zi teskari) va «stornolangan» (bu yozuv keyin teskarilangan) — ikki xil belgi. Manba ustuni skaner uchun SKU ni, almashtirish uchun sovg‘a nomini ko‘rsatadi.',
  'lid.ledgerEmpty': 'Daftar bo‘sh — bu usta hali ball yig‘magan',
  'lid.ledgerLimit': 'Oxirgi 200 yozuv ko‘rsatiladi.',
  'lid.occurredAt': 'Vaqti',
  'lid.direction': 'Yo‘nalish',
  'lid.balanceAfter': 'Balans (keyin)',
  'lid.source': 'Manba',
  'lid.sourceRef': '{table} #{id}',
  'lid.reversal': 'Storno',
  'lid.reversed': 'Stornolangan',
  'lid.dir.earn': 'Yig‘ildi',
  'lid.dir.redeem': 'Sarflandi',
  'lid.dir.adjust': 'Tuzatish',
  'lid.dir.expire': 'Kuydi',
  'lid.redemptions': 'Almashtirishlar',
  'lid.redemptionsEmpty': 'Bu usta hali sovg‘a so‘ramagan',
  'lid.reconOk': 'Balans daftar bilan mos: {balance} = {ledger}',
  'lid.reconFailedTitle': 'BALANS DAFTAR BILAN MOS EMAS',
  'lid.reconNumbers': 'Balans {balance}, daftar yig‘indisi {ledger}, farq {diff} ball',
  'lid.reconFailedBody':
    'Bu KO‘RSATISH xatosi emas, ma‘lumot xatosi. Ko‘rinib turgan balans — tezkor o‘qish uchun saqlanadigan nusxa, haqiqat esa harakatlar tarixida; ikkisi ajralib ketgan bo‘lsa, ustaga ko‘rsatilayotgan balans ham, majburiyat hisoboti ham noto‘g‘ri. Sababi topilmaguncha bu ustaning almashtirishlarini tasdiqlamang va tuzatishni alohida tuzatuv harakati bilan kiriting, balansni qo‘lda yozib emas.',

  // --- Nazorat navbati (firibgarlik) ---
  'lfr.title': 'Nazorat navbati',
  'lfr.description':
    'RAD ETILGAN skanerlash urinishlari. Firibgarlik naqshlari aynan shu yerda ko‘rinadi — muvaffaqiyatli skanerlarda emas.',
  'lfr.days': 'Oyna, kun',
  'lfr.minAttempts': 'Signal chegarasi',
  'lfr.minAttemptsHint': 'Undan kam urinish navbatga tushmaydi (2…1000).',
  'lfr.limit': 'Satr chegarasi',
  'lfr.window': 'Oxirgi {days} kun · chegara {min} urinish',
  'lfr.summary': 'Rad etish sabablari',
  'lfr.summaryTotal': 'Jami rad etish',
  'lfr.reason.not_found': 'Kod topilmadi',
  'lfr.reason.already_scanned': 'Allaqachon skanerlangan',
  'lfr.reason.not_activated': 'Faollashtirilmagan',
  'lfr.reason.void': 'Bekor qilingan kod',
  'lfr.reason.installer_blocked': 'Usta bloklangan',
  'lfr.reason.rate_limited': 'Limit oshdi',
  'lfr.reason.no_points_rule': 'Ball qoidasi yo‘q',
  'lfr.summaryMeaning':
    '«Kod topilmadi» ulushi yuqori bo‘lsa — kodlar TAXMIN qilinmoqda. «Ball qoidasi yo‘q» ulushi esa firibgarlik emas, SOZLAMA xatosi: halol usta ball olmaydi va sabab ball qoidalari ekranida.',
  'lfr.byInstaller': 'Usta bo‘yicha',
  'lfr.byInstallerMeaning':
    'Bitta hisobdan ko‘p rad etish. «Kod topilmadi» ulushi yuqori bo‘lsa — u kodlarni TAXMIN qilmoqda: halol usta noto‘g‘ri kod terganda ham 200 marta xato qilmaydi.',
  'lfr.byCode': 'Kod bo‘yicha',
  'lfr.byCodeMeaning':
    'Bitta kod ko‘p marta kelgan. Har quti kodi UNIKAL, ya‘ni bitta kod ko‘p HISOBDAN kelsa — u TARQATILGAN: surati chatga tashlangan yoki stiker ko‘chirib olingan.',
  'lfr.byIp': 'IP manzil bo‘yicha',
  'lfr.byIpMeaning':
    'Bitta manzildan ko‘p HISOB. Bitta telefonda o‘nlab hisob ochib har biriga daqiqa limitini alohida yeb chiqish — chegarani chetlab o‘tishning eng oddiy yo‘li («hisob fermasi»).',
  'lfr.recent': 'Oxirgi urinishlar',
  'lfr.recentMeaning':
    'Yig‘masiz, xom ko‘rinish. Tergov har doim «bu odam aynan nima qildi?» degan savoldan boshlanadi va uni yig‘ma jadvallardan tiklab bo‘lmaydi.',
  'lfr.attempts': 'Urinish',
  'lfr.distinctCodes': 'Turli kod',
  'lfr.distinctInstallers': 'Turli usta',
  'lfr.lastAt': 'Oxirgi urinish',
  'lfr.reasons': 'Sabablar',
  'lfr.code': 'Kod',
  'lfr.ip': 'IP',
  'lfr.installer': 'Usta',
  'lfr.notFoundShare': 'Topilmadi',
  'lfr.signal': 'Signal',
  'lfr.signal.guessing': 'Kod taxmin qilinmoqda',
  'lfr.signal.shared': 'Tarqatilgan kod',
  'lfr.signal.farming': 'Hisob fermasi',
  'lfr.unknownInstaller': 'Ro‘yxatdan o‘tmagan',
  'lfr.empty': 'Bu oyna va chegara bo‘yicha signal yo‘q',
  'lfr.emptyHint': 'Oynani kengaytiring yoki chegarani pasaytiring.',
  'lfr.loadError': 'Nazorat navbatini yuklab bo‘lmadi',
  'lfr.blockFromHere': 'Ustani bloklash — «Ustalar» ekranida.',

  // Skanerni teskarilash
  'lfr.reverseTitle': 'Skanerni teskarilash',
  'lfr.reverseWhy':
    'Berilgan ballni teskari yozuv bilan qaytarib oladi. Kod holati O‘ZGARMAYDI — u ball berilganining DALILI va tergov uchun kerak. Ustani BLOKLASHNING O‘ZI yetarli emas: blok skanerlashni to‘xtatadi, lekin yig‘ilgan ball qolaveradi va sovg‘aga almashtiriladi.',
  'lfr.reverseSearch': 'Kod bo‘yicha skanerni topish',
  'lfr.reverseSearchPlaceholder': 'To‘liq kod yoki uning bir qismi',
  'lfr.reverseSearchHint':
    'Qidiruv qism satr bo‘yicha ham ishlaydi — stiker dumidagi bir necha belgi yetarli. Ro‘yxatda faqat BALL BERILGAN skanerlar bor: rad etilgan urinishlar yuqoridagi jadvallarda.',
  'lfr.reverseSearchShort': 'Kamida {min} belgi kiriting',
  'lfr.reverseSearchError': 'Skanerlarni qidirib bo‘lmadi',
  'lfr.reverseNoScans': 'Bu kod bo‘yicha ball berilgan skaner topilmadi',
  'lfr.reverseSelect': 'Tanlash',
  'lfr.reverseAlready': 'Teskarilangan',
  'lfr.reverseSelected':
    '{code} — {points} ball, usta: {installer}. Ball teskari yozuv bilan qaytarib olinadi.',
  'lfr.scannedAt': 'Skanerlangan',
  'lfr.reverseReason': 'Teskarilash sababi',
  'lfr.reverseReasonRequired': 'Sabab kamida 3 ta belgidan iborat bo‘lishi kerak',
  'lfr.reverseSubmit': 'Ballni qaytarib olish',
  'lfr.reverseDone':
    '{code}: {points} ball qaytarib olindi. Usta #{installer} yangi balansi — {balance} ball.',
  'lfr.reverseNoPermission':
    'Skanerni teskarilash huquqi sizda yo‘q — u ustani bloklash huquqi bilan AYNI: ikkalasi bitta jazo choraning qismlari. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'lfr.reverseExceeds':
    'Ball yetarli emas — usta uni ALLAQACHON sovg‘aga sarflagan. Bu texnik xato emas: kompaniya zararni ko‘rgan va qisman teskarilash uni YASHIRARDI. Sovg‘a bo‘yicha alohida qaror kerak.',

  // --- Yangi menyu bandlari ---
  'nav.goodsReceipts': 'Tovar qabuli',
  'nav.supplierInvoices': 'Ta’minotchi invoyslari',
  'nav.import': 'Fayldan yuklash',
  'nav.roles': 'Rollar',
  'nav.systemSettings': 'Tizim sozlamalari',
  'nav.organization': 'Tashkiliy tuzilma',
  'nav.group.loyalty': 'Usta dasturi',
  'nav.loyaltyStatus': 'Dastur holati',
  'nav.loyaltyPointRules': 'Ball qoidalari',
  'nav.loyaltyQrBatches': 'QR partiyalar',
  'nav.loyaltyRewards': 'Sovg‘a katalogi',
  'nav.loyaltyRedemptions': 'Almashtirishlar',
  'nav.loyaltyInstallers': 'Ustalar',
  'nav.loyaltyFraud': 'Nazorat navbati',
  'nav.dealers': 'Dillerlar',
  'nav.bonusAccounts': 'Bonus hisoblari',
  'nav.bonusLedger': 'Bonus daftari',
  'nav.deliveries': 'Yetkazishlar',
  'nav.reportAgentActivity': 'Agent faoliyati',

  // --- Vozvrat / RMA / QC / Utilizatsiya ------------------------------------
  //
  // Matnlar «nima bo'lishini» aytadi, «nima bosilganini» emas: bu ekranda har
  // tugma ombordagi tovarni qimirlatadi yoki qimirlatmaydi va odam buni
  // BOSISHDAN OLDIN bilishi kerak.
  'ret.title': 'Qaytarishlar',
  'ret.quarantineTitle': 'Karantindagi tovarlar',
  'ret.description':
    'Mijozdan qaytgan tovar: qabul, ko‘rik va taqdir. Ko‘rik talab qilinadigan tovar KARANTIN omboriga tushadi va sotuvga chiqmaydi.',
  'ret.new': 'Yangi qaytarish',
  'ret.empty': 'Qaytarish hujjatlari yo‘q',
  'ret.emptyHint': 'Mijoz tovar qaytarganda shu yerda hujjat ochiladi.',
  'ret.docNo': 'Hujjat',
  'ret.date': 'Sana',
  'ret.customer': 'Mijoz',
  'ret.invoice': 'Hisob-faktura',
  'ret.warehouse': 'Ombor',
  'ret.quarantineWarehouse': 'Karantin ombori',
  'ret.reason': 'Sabab',
  'ret.settlement': 'Hisob-kitob',
  'ret.total': 'Summa',
  'ret.status': 'Holat',
  'ret.lineCount': 'Satrlar',
  'ret.qcRequired': 'Ko‘rik talab qilinadi',
  'ret.qcRequiredYes': 'Karantinga tushadi',
  'ret.qcRequiredNo': 'To‘g‘ridan-to‘g‘ri asosiy omborga',
  'ret.qcRequiredHint':
    'Sabab bo‘yicha standart qiymat. O‘zgartirsangiz, tovar qayerga tushishi ham o‘zgaradi.',
  'ret.filterStatus': 'Holat',
  'ret.filterReason': 'Sabab',
  'ret.filterAll': 'Hammasi',
  'ret.searchPlaceholder': 'Hujjat raqami yoki mijoz nomi',

  'ret.status.draft': 'Qoralama',
  'ret.status.approved': 'Tasdiqlangan',
  'ret.status.received': 'Qabul qilingan',
  'ret.status.inspected': 'Ko‘rikdan o‘tgan',
  'ret.status.settled': 'Yopilgan',
  'ret.status.cancelled': 'Bekor qilingan',

  'ret.reason.defect': 'Brak',
  'ret.reason.damaged': 'Shikastlangan',
  'ret.reason.warranty': 'Kafolat',
  'ret.reason.wrong_item': 'Noto‘g‘ri tovar',
  'ret.reason.customer_change': 'Mijoz fikridan qaytdi',
  'ret.reason.other': 'Boshqa',

  'ret.settlement.credit_note': 'Kredit-nota',
  'ret.settlement.refund': 'Pulni qaytarish',
  'ret.settlement.replacement': 'Almashtirish',

  'ret.qc.pass': 'Yaroqli',
  'ret.qc.fail': 'Yaroqsiz',
  'ret.qc.conditional': 'Shartli yaroqli',
  'ret.qc.pending': 'Ko‘rikdan o‘tmagan',

  'ret.disp.resale': 'Javonga qaytadi',
  'ret.disp.repair': 'Ta’mirga',
  'ret.disp.replacement': 'Almashtiriladi',
  'ret.disp.supplier_claim': 'Zavodga da’vo',
  'ret.disp.quarantine': 'Qaror yo‘q',
  'ret.disp.scrap': 'Utilizatsiya',

  'ret.disp.resaleHint':
    'Karantindan asosiy omborga ko‘chiriladi va yana sotiladi. Bajarilgach ombor qoldig‘i o‘zgaradi.',
  'ret.disp.repairHint': 'Usta tuzatgunicha karantinda qoladi — ombor harakati yo‘q.',
  'ret.disp.replacementHint':
    'Mijozga yangisi beriladi, eskisi bizda karantinda qoladi — ombor harakati yo‘q.',
  'ret.disp.supplier_claimHint':
    'Zavodga da’vo uchun DALIL. Hisobdan chiqarilmaydi: aks holda qaytariladigan pul ortida hech narsa turmaydi.',
  'ret.disp.quarantineHint': 'Qaror hali qabul qilinmagan — tovar karantinda kutadi.',
  'ret.disp.scrapHint':
    'Hisobdan chiqariladi va bu QAYTARIB BO‘LMAYDI. Moliyachining tasdig‘i kerak — unga murojaat qiling.',

  'ret.defect.burnt': 'Kuygan / yonmaydi',
  'ret.defect.not_working': 'Umuman ishlamaydi',
  'ret.defect.low_output': 'Yorqinligi past',
  'ret.defect.flicker': 'Miltillaydi',
  'ret.defect.physical_damage': 'Korpus shikastlangan',
  'ret.defect.packaging_damage': 'Faqat qadoq shikastlangan',
  'ret.defect.wrong_spec': 'Xarakteristika mos emas',
  'ret.defect.incomplete': 'Komplekt to‘liq emas',
  'ret.defect.other': 'Boshqa (izoh majburiy)',

  // --- Kartochka ---
  'ret.detail.approve': 'Tasdiqlash',
  'ret.detail.receive': 'Tovarni qabul qilish',
  'ret.detail.dispose': 'Taqdirni bajarish',
  'ret.detail.settle': 'Pul tomonini yopish',
  'ret.detail.cancel': 'Bekor qilish',
  'ret.detail.approveHint':
    'Tasdiqlangandan keyin hujjat tahrirlanmaydi — omborchi unga tayanib tovarni kutadi.',
  'ret.detail.receiveHint':
    'Tovar OMBORGA kiradi: ko‘rik talab qilinsa karantinga, aks holda asosiy omborga. Bu ombor qoldig‘ini o‘zgartiradi.',
  'ret.detail.disposeHint':
    'Har satr uchun qabul qilingan qaror BAJARILADI: «javonga qaytadi» — ko‘chiriladi, «utilizatsiya» — hisobdan chiqariladi, qolganlarida tovar karantinda qoladi.',
  'ret.detail.settleHint':
    'Hujjat yopiladi. Tizimda ikki yozuvli buxgalteriya hali yo‘q — kredit-nota yoki pul qaytarishni moliya bo‘limi QO‘LDA rasmiylashtiradi.',
  'ret.detail.cancelReason': 'Bekor qilish sababi',
  'ret.detail.cancelReasonHint': 'Sabab hujjatda va audit jurnalida qoladi',
  'ret.detail.pendingDisposition': 'Taqdiri belgilanmagan satrlar: {count}',
  'ret.detail.settledAt': 'Yopilgan',
  'ret.detail.approvedAt': 'Tasdiqlangan',
  'ret.detail.noPermission': 'Bu amal uchun ruxsatingiz yo‘q',

  // --- Satrlar ---
  'ret.line.sku': 'SKU',
  'ret.line.name': 'Nomi',
  'ret.line.qty': 'Miqdor',
  'ret.line.price': 'Narx',
  'ret.line.amount': 'Summa',
  'ret.line.cost': 'Tannarx',
  'ret.line.qc': 'Ko‘rik',
  'ret.line.defect': 'Nuqson',
  'ret.line.disposition': 'Taqdir',
  'ret.line.state': 'Tovar',
  'ret.line.inStock': 'Omborda',
  'ret.line.notReceived': 'Kelmagan',
  'ret.line.done': 'Bajarilgan',
  'ret.line.saveQc': 'Ko‘rikni saqlash',
  'ret.line.qcTitle': '{sku} — ko‘rik natijasi',
  'ret.line.notes': 'Izoh',
  'ret.line.add': 'Satr qo‘shish',
  'ret.line.remove': 'Olib tashlash',
  'ret.line.empty': 'Satr qo‘shing',

  // --- Yangi hujjat formasi ---
  'ret.form.title': 'Yangi qaytarish hujjati',
  'ret.form.hint':
    'Hujjat QORALAMA bo‘lib yaratiladi: ombor hali tegilmaydi. Tovar faqat «qabul qilish» bosqichida omborga kiradi.',
  'ret.form.customer': 'Mijoz',
  'ret.form.warehouse': 'Qaysi omborga qaytadi',
  'ret.form.warehouseHint':
    'Tovar OXIR-OQIBAT tegishli bo‘lgan ombor. Ko‘rik talab qilinsa, u avval karantinga tushadi.',
  'ret.form.submit': 'Qaytarishni yaratish',
  'ret.form.priceRequired':
    'Hisob-faktura ko‘rsatilmasa, narx qo‘lda kiritiladi — qaytariladigan summa shundan hisoblanadi.',

  // --- Karantin ro‘yxati ---
  'ret.qr.description':
    'Karantinda turgan va hali taqdiri bajarilmagan tovarlar. Zavod javobini kutayotgan satr ham shu yerda — u eng ko‘p unutiladigan qism.',
  'ret.qr.empty': 'Karantin bo‘sh',
  'ret.qr.emptyHint': 'Ko‘rik talab qiladigan qaytarish qabul qilinganda tovar shu yerda paydo bo‘ladi.',
  'ret.qr.days': 'Karantinda, kun',
  'ret.qr.daysLong': '{days} kundan beri',
  'ret.qr.minDays': 'Kamida shuncha kun',
  'ret.qr.open': 'Hujjatni ochish',
  'ret.qr.searchPlaceholder': 'Hujjat, mijoz, SKU yoki nom',

  // --- Ta'minotchilar (`/suppliers`) ---
  'supplier.description':
    'Zavod va yetkazib beruvchilar. Lead time — qayta zakaz formulasining asosiy parametri: 120–150 kunlik siklda buyurtma tovar tugashidan chorak yil oldin berilishi kerak.',
  'supplier.new': 'Yangi ta’minotchi',
  'supplier.code': 'Kod',
  'supplier.name': 'Nomi',
  'supplier.country': 'Mamlakat',
  'supplier.address': 'Manzil',
  'supplier.phone': 'Telefon',
  'supplier.email': 'Email',
  'supplier.taxId': 'Soliq raqami',
  'supplier.currency': 'Valyuta',
  'supplier.paymentTerm': 'To‘lov sharti',
  'supplier.leadTime': 'Lead time',
  'supplier.leadTimeHint':
    'Buyurtmadan tovar kelgunicha o‘tadigan kun. Qayta zakaz hisobi shu songa tayanadi.',
  'supplier.days': '{days} kun',
  'supplier.status': 'Holat',
  'supplier.active': 'Faol',
  'supplier.archived': 'Arxivlangan',
  'supplier.contactOnlyNote':
    'Sizga ta’minotchining nomi va kontaktlari ochiq. Valyuta, to‘lov sharti, lead time va narxlar ko‘rsatilmaydi — ular tijorat ma’lumoti va boshqa ruxsat talab qiladi.',
  'supplier.filterSearch': 'Qidiruv',
  'supplier.filterSearchHint': 'Kod yoki nom',
  'supplier.filterCountry': 'Mamlakat kodi',
  /*
   * Namuna qiymatlar ham lug'atda.
   *
   * `CN`, `12900`, `7.25` — bular kod va raqam, ya'ni tarjima talab
   * qilmaydigandek ko'rinadi. Lekin qoida ISTISNOSIZ: JSX da qattiq yozilgan
   * matn bo'lmaydi. Istisno qo'yilsa, keyingi dasturchi «bu ham kod-ku» deb
   * yana bittasini qo'shadi va chegara asta-sekin yo'qoladi. Bundan tashqari
   * namuna kurs bir kun eskiradi va uni bitta joydan almashtirish qulay.
   */
  'supplier.countryPlaceholder': 'CN',
  'supplier.filterStatus': 'Holat',
  'supplier.filterStatusAll': 'Hammasi',
  'supplier.empty': 'Ta’minotchi topilmadi',
  'supplier.emptyHint': 'Filtrni o‘zgartiring yoki yangi ta’minotchi qo‘shing.',
  'supplier.contacts': 'Kontaktlar',
  'supplier.noContacts': 'Kontakt kiritilmagan',
  'supplier.primaryContact': 'Asosiy',
  'supplier.products': 'Biriktirilgan mahsulotlar',
  'supplier.productsHint':
    'Zavodning o‘z SKU si, eng kam partiya (MOQ) va oxirgi kelishilgan narx. Bu satrlar xarid buyurtmasi tuzilganda ishlatiladi.',
  'supplier.noProducts': 'Mahsulot biriktirilmagan',
  'supplier.supplierSku': 'Zavod SKU si',
  'supplier.productRef': 'Katalogdagi ID',
  /*
   * Bizning katalogimizdagi mahsulot ID si.
   *
   * Server `supplierProducts` qatorlarida `sku`/`name` BERMAYDI (faqat
   * `productId`), shuning uchun bu yerda OCHIQ id ko'rsatiladi — «—» emas.
   * Satr qaysidir mahsulotga tegishli ekani aniq, kimligini mahsulot
   * ekranidan topish mumkin. Kalit sifatida yozilgan, chunki `#` belgisi
   * ham matn: boshqa tilda u boshqacha bo'lishi mumkin.
   */
  'supplier.productRefValue': '#{id}',
  'supplier.moq': 'MOQ',
  'supplier.moqHint': 'Zavod qabul qiladigan eng kam partiya',
  'supplier.lastPrice': 'Oxirgi narx',
  'supplier.lastPriceDate': 'Narx sanasi',
  'supplier.defectRate': 'Brak %',
  'supplier.formCreate': 'Yangi ta’minotchi',
  'supplier.formEdit': 'Ta’minotchini tahrirlash',

  // --- Hisob-fakturalar (`/invoices`) ---
  'invoice.description':
    'Mijozga chiqarilgan hisob-fakturalar. Muddati o‘tgan va qarzi qolganlari qizil bilan belgilanadi.',
  'invoice.docNo': 'Raqam',
  'invoice.customer': 'Mijoz',
  'invoice.date': 'Sana',
  'invoice.dueDate': 'To‘lov muddati',
  'invoice.total': 'Summa (QQS bilan)',
  /*
   * «Soliqsiz» — «netto» emas. Buxgalter «netto» so'zini og'irlik ma'nosida
   * ham ishlatadi (netto/brutto), pul kontekstida esa u chalkashtiradi.
   * «Soliqsiz summa» bir ma'noli va tushuntirishga muhtoj emas.
   */
  'invoice.net': 'Soliqsiz summa',
  /** Stavka sarlavhaning O'ZIDA: «QQS (12%)» — raqam o'zini tushuntiradi. */
  'invoice.vat': 'QQS ({rate})',
  'invoice.vatShort': 'QQS',
  'invoice.vatBase': 'QQS (USD)',
  'invoice.lineVatRate': 'QQS %',
  'invoice.lineVat': 'QQS',
  'invoice.paid': 'To‘langan',
  /*
   * «Kreditlangan» — «kredit-nota bilan yopilgan» ning qisqasi.
   *
   * «Chegirma» yoki «hisobdan chiqarilgan» deb yozish rad etildi: ikkalasi
   * ham kredit-notaning FAQAT bitta sababi (`price_correction`, `write_off`),
   * ustun esa hammasini birga ko'rsatadi — vozvratni ham. Ustun nomi
   * sababni emas, HODISANI atashi kerak.
   */
  'invoice.credited': 'Kreditlangan',
  'invoice.balance': 'Qoldiq',
  'invoice.statusLabel': 'Holat',
  'invoice.overdueDays': '{days} kun kechikdi',
  'invoice.fxRate': 'Hujjat kursi',
  'invoice.totalBase': 'Summa (USD)',
  'invoice.notes': 'Izoh',
  'invoice.status.draft': 'Qoralama',
  'invoice.status.issued': 'Chiqarilgan',
  'invoice.status.partially_paid': 'Qisman to‘langan',
  'invoice.status.paid': 'To‘langan',
  'invoice.status.cancelled': 'Bekor qilingan',
  'invoice.filterSearch': 'Qidiruv',
  'invoice.filterSearchHint': 'Hisob-faktura raqami yoki mijoz',
  'invoice.filterStatus': 'Holat',
  'invoice.filterStatusAll': 'Hammasi',
  // --- Chop etish ---
  'print.action': 'Chop etish',
  /*
   * Til haqidagi eslatma ATAYLAB tugmada turadi.
   *
   * Dastur o'zbekcha, qog'oz esa ruscha chiqadi va bu KUTILMAGAN natija:
   * foydalanuvchi buni oldindan bilmasa, chop etilgan накладнойni «xato»
   * deb hisoblaydi. Sabab — O'zbekistonda rasmiy hujjat aylanishi rus
   * tilida yuritiladi va buxgalter aynan shu variantni kutadi.
   */
  'print.hint': 'Rasmiy shakl — rus tilida chiqadi',
  'print.invoice': 'Hisob-fakturani chop etish',
  'print.deliveryNote': 'Yuk xatini chop etish',
  'print.cashReceipt': 'Kassa orderini chop etish',
  'print.priceList': 'Narx-ro‘yxatini chop etish',
  'print.barcodeLabel': 'Yorliq chop etish',

  'invoice.filterFrom': 'Sanadan',
  'invoice.filterTo': 'Sanagacha',
  'invoice.filterOpenOnly': 'Faqat qarzi borlar',
  'invoice.filterOverdue': 'Faqat muddati o‘tganlar',
  'invoice.empty': 'Hisob-faktura topilmadi',
  'invoice.emptyHint': 'Filtrni o‘zgartiring. Hisob-faktura post qilingan yuk xatidan yaratiladi.',
  'invoice.lines': 'Satrlar',
  'invoice.linesHint':
    'Satrlar POST QILINGAN yuk xatidan quriladi — ya’ni bu yerda ombordan haqiqatda chiqqan tovar turadi, buyurtmadagi reja emas.',
  'invoice.lineSku': 'SKU',
  'invoice.lineName': 'Nomi',
  'invoice.lineQty': 'Miqdor',
  'invoice.linePrice': 'Narx',
  'invoice.lineAmount': 'Summa',
  'invoice.fxGapTitle': 'To‘lov bo‘lgan, lekin qarz qolgan',
  'invoice.fxGapBody':
    'Hisob-faktura {total}, to‘langan {paid}, qoldiq {balance}.',
  'invoice.fxGapWhy':
    'Sabab odatda kurs farqi: mijoz kelishilgan so‘m summasini to‘liq to‘laydi, lekin u to‘lov kunidagi kurs bo‘yicha USD ga aylantiriladi va qarzni to‘liq yopmaydi. Aniq hisobni to‘lov kartochkasida ko‘rish mumkin.',
  'invoice.fxGapUnexplained':
    'Diqqat: to‘langan va qoldiq summasi hisob-faktura summasiga to‘g‘ri kelmadi. Hujjatga qaytarish yoki hisobdan chiqarish qo‘llanilgan bo‘lishi mumkin — to‘lovlar va qaytarishlarni tekshiring.',
  /*
   * BALANS TENGLAMASI.
   *
   * `equationTotal` ATAYLAB `invoice.total` dan alohida: u yerdagi matn
   * «Summa (QQS bilan)» va tenglama qatorida u ikki marta uzunroq bo'lib,
   * arifmetikani ko'rinmas qilardi. Bu yerda kerak bo'lgani — eng qisqa
   * so'z, chunki raqamlarning O'ZI gapiradi.
   */
  'invoice.equationHint': 'To‘langan, kreditlangan va qoldiq — birgalikda hisob-faktura summasini beradi.',
  'invoice.equationTotal': 'Jami',
  'invoice.equationBrokenTitle': 'Raqamlar bir-biriga mos kelmadi',
  'invoice.equationBroken':
    'To‘langan, kreditlangan va qoldiq summasi hisob-faktura summasiga teng emas. Bu ma’lumot nosozligi — hujjatni buxgalteriyaga ko‘rsating, o‘zingiz tuzatishga urinmang.',
  'invoice.creditsHidden':
    'Bu hisob-fakturaning bir qismi kredit-nota bilan yopilgan. Qaysi hujjat yopgani sizga ko‘rsatilmaydi — summaning o‘zi yuqorida turibdi.',
  'invoice.customerPayments': 'Mijozning to‘lovlari',
  'invoice.customerPaymentsHint':
    'Bu — MIJOZNING barcha to‘lovlari, faqat shu hisob-fakturaniki emas: API to‘lovni hisob-fakturaga bog‘lab bermaydi. Qaysi to‘lov qaysi hisobni yopgani to‘lov kartochkasida ko‘rinadi.',
  'invoice.noPayments': 'To‘lov yo‘q',

  // --- To'lovlar (`/payments`) ---
  'payment.description':
    'Mijozdan kelgan pul. To‘lov avval qoralama bo‘lib yaratiladi, keyin post qilinadi — o‘shanda pul kassaga kiradi va qarz yopiladi.',
  'payment.new': 'Yangi to‘lov',
  'payment.docNo': 'Raqam',
  'payment.date': 'Sana',
  'payment.customer': 'Mijoz',
  'payment.amount': 'Summa',
  'payment.currency': 'Valyuta',
  'payment.amountBase': 'USD da',
  'payment.methodLabel': 'Usul',
  'payment.statusLabel': 'Holat',
  'payment.reference': 'Hujjat/izoh raqami',
  'payment.cashAccount': 'Kassa/bank hisobi',
  'payment.notes': 'Izoh',
  'payment.status.draft': 'Qoralama',
  'payment.status.posted': 'Post qilingan',
  'payment.status.cancelled': 'Bekor qilingan',
  'payment.method.cash': 'Naqd',
  'payment.method.bank_transfer': 'Bank o‘tkazmasi',
  'payment.method.card': 'Karta',
  'payment.method.other': 'Boshqa',
  'payment.filterSearch': 'Qidiruv',
  'payment.filterSearchHint': 'To‘lov raqami yoki mijoz',
  'payment.filterStatus': 'Holat',
  'payment.filterStatusAll': 'Hammasi',
  'payment.filterFrom': 'Sanadan',
  'payment.filterTo': 'Sanagacha',
  'payment.filterUnallocated': 'Faqat biriktirilmaganlar (avans)',
  'payment.empty': 'To‘lov topilmadi',
  'payment.emptyHint': 'Filtrni o‘zgartiring yoki yangi to‘lov kiriting.',
  'payment.emptyHintReadOnly':
    'Filtrni o‘zgartiring. To‘lovni moliyachi kiritadi — sizga to‘lov FAKTI ko‘rinadi.',
  'payment.post': 'Post qilish',
  'payment.allocate': 'Qarzga biriktirish',
  'payment.autoAllocate': 'Qarzga avtomatik biriktirilsin',
  'payment.autoAllocateHint':
    'Eng eski muddatli hisob-fakturadan boshlab yopiladi. O‘chirilsa, pul avans bo‘lib turadi va keyin qo‘lda biriktiriladi.',
  'payment.chainTitle': 'Hisob zanjiri',
  'payment.chainReceived': 'Kelgan summa',
  'payment.chainRate': 'Kurs',
  'payment.chainRateHint': 'Hujjatga muhrlangan — keyin o‘zgarmaydi',
  'payment.chainBase': 'USD ekvivalenti',
  'payment.chainBaseHint': 'Qarz shu summaga kamayadi',
  'payment.chainRemaining': 'Mijozning qolgan qarzi',
  'payment.chainWhyFx':
    'Qarz USD da, to‘lov esa boshqa valyutada keldi. Summa to‘lov kunidagi kurs bo‘yicha USD ga aylantirildi va natija qarzga to‘liq teng chiqmadi — qolgani qarz bo‘lib turaveradi. Mijoz kelishilgan summani to‘liq to‘lagan bo‘lishi mumkin: farq kursda, to‘lovda emas.',
  'payment.chainWhyPartial':
    'To‘lov qarzni to‘liq yopmadi — qolgan qismi keyingi to‘lovda yopiladi.',
  'payment.unallocatedNote':
    'Biriktirilmagan qism: {amount}. Bu pul mijozning avansi — u kelgan, lekin hali hech qaysi hisob-fakturaga tegmagan.',
  'payment.allocations': 'Qarzga biriktirish',
  'payment.allocationsHint':
    'Bu to‘lov qaysi hisob-fakturani qancha yopgani. «Oldin» va «keyin» ustunlari birga o‘qiladi: farqi — yopilgan qism, «keyin» — qolgan qarz.',
  'payment.notPostedYet': 'To‘lov hali post qilinmagan — qarz yopilmagan.',
  'payment.noAllocations': 'Hech qaysi hisob-fakturaga biriktirilmagan (avans).',
  'payment.allocInvoice': 'Hisob-faktura',
  'payment.allocDueDate': 'Muddat',
  'payment.allocAmount': 'Yopildi',
  'payment.allocAmountBase': 'Yopildi (USD)',
  'payment.allocBefore': 'Qarz — oldin',
  'payment.allocAfter': 'Qarz — keyin',
  'payment.allocFx': 'Kurs farqi',
  'payment.writtenOff':
    '{amount} qoldiq kurs farqi sifatida yopildi — chegaradan past bo‘lgani uchun undirilmaydi.',
  'payment.allocFxHint':
    'Nol bo‘lishi «farq yo‘q» degani emas: mijozning siyosati «to‘lov kuni» bo‘lsa, farq alohida yozilmaydi va qoldiqda qoladi.',
  'payment.formTitle': 'Yangi to‘lov',
  'payment.formHint':
    'To‘lov QORALAMA bo‘lib yaratiladi: pul hali kassaga kirmaydi va qarz yopilmaydi. Ikkinchi qadam — «Post qilish».',
  'payment.formSubmit': 'Qoralama yaratish',
  'payment.manualRate': 'Qo‘lda kurs',
  'payment.manualRatePlaceholder': 'kunlik kurs',
  'payment.manualRateHint':
    'Bo‘sh qoldirsangiz kunlik kurs ishlatiladi. Bank real kursi kunlik kursdan farq qilsa, aynan bank kursini kiriting — pul shu kursda tushgan. Kurs hujjatga muhrlanadi va keyin o‘zgarmaydi.',

  // --- To'lovni teskarilash (storno) ---
  'payment.reverseAction': 'Teskarilash',
  'payment.reverseTitle': '{docNo} ni teskarilash',
  'payment.reverseHint':
    'To‘lov O‘CHIRILMAYDI — teskari (storno) yozuv yaratiladi va ikkalasi tarixda qoladi. Pul kassaga qaytadi, yopilgan hisob-fakturalarning qoldig‘i tiklanadi, daftarga esa asl provodkaning ko‘zgusi yoziladi.',
  'payment.reverseReason': 'Teskarilash sababi',
  'payment.reverseReasonPlaceholder': 'Masalan: mijoz noto‘g‘ri tanlangan; bank o‘tkazmasi qaytdi',
  'payment.reverseReasonHint':
    'Nima xato bo‘lganini yozing — kamida {min} belgi. «Xato» degan javob bir oydan keyin hech narsani tushuntirmaydi; sabab auditda qoladi.',
  'payment.reverseSubmit': 'Ha, teskarilansin',
  'payment.reverseDone': 'Teskarilandi',
  'payment.reverseDoneHint':
    '{docNo} bekor qilindi va uning o‘rniga storno yozuvi yaratildi. Asl hujjat tarixda qoladi — kecha chop etilgan kassa hisoboti bugun ham o‘zgarmaydi.',
  'payment.reverseReturned': 'Kassaga qaytdi',
  'payment.reverseCashAfter': 'Kassa qoldig‘i',
  'payment.reverseRestoredCount': 'Tiklangan hujjat',
  'payment.reverseRestoredDoc': 'Hujjat',
  'payment.reverseRestoredAmount': 'Qoldiq tiklandi',

  // --- Ta'minotchiga to'lov (`/finance/supplier-payments`) ---
  // `supplierPay.title` — eksport faylining nomi va varaq sarlavhasi. Bu fayl
  // zavodga yuboriladi yoki to'lov yig'ilishiga olib boriladi, ya'ni uni
  // ochgan odam menyu yorlig'ini ko'rmaydi va hujjat o'zini tanitishi kerak.
  'supplierPay.title': 'Ta’minotchiga to‘lov — kimga qarzmiz',
  'supplierPay.description':
    'Zavodga qarzimiz va unga to‘lov. Bu ekrandagi pul kompaniyadan CHIQADI: kassa yoki bank hisobidan yechilib, ta’minotchining invoyslari yopiladi. Satrni bosing — o‘sha zavodning ochiq invoyslari ochiladi.',
  'supplierPay.tileOutstanding': 'Jami ochiq qarz',
  'supplierPay.tileOutstandingHint': '{count} ta ta’minotchi bo‘yicha, USD da',
  'supplierPay.tileOverdue': 'Muddati o‘tgan',
  'supplierPay.tileOverdueHint': 'Bugun to‘lash shart bo‘lgan summa',
  'supplierPay.tileAdvance': 'Ochiq avans',
  'supplierPay.tileAdvanceHint': 'To‘langan, lekin hali invoysga biriktirilmagan pul',
  'supplierPay.tileInvoices': 'Ochiq invoys',
  'supplierPay.tileInvoicesHint': '{asOf} holatiga',
  'supplierPay.filterSearch': 'Qidiruv',
  'supplierPay.filterSearchHint': 'Invoys raqami yoki zavod nomi',
  'supplierPay.filterOverdue': 'Faqat muddati o‘tganlar',
  // Ekranda kod nom yonida turadi; faylda esa alohida ustun — ro'yxat kod
  // bo'yicha saralanadi va boshqa jadval bilan solishtiriladi.
  'supplierPay.colCode': 'Kod',
  'supplierPay.colSupplier': 'Ta’minotchi',
  'supplierPay.colOutstanding': 'Ochiq qarz',
  'supplierPay.colOverdue': 'Muddati o‘tgan',
  'supplierPay.colAdvance': 'Avans',
  'supplierPay.colOldestDue': 'Eng eski muddat',
  'supplierPay.colInvoiceCount': 'Invoys',
  'supplierPay.empty': 'Hamma invoys yopilgan',
  'supplierPay.emptyHint':
    'Bironta ta’minotchining ochiq qarzi yo‘q. Yangi invoys tan olinganda (xarid bo‘limi) u shu yerda paydo bo‘ladi.',
  'supplierPay.emptyFiltered': 'Filtrga mos qarz topilmadi',
  'supplierPay.emptyFilteredHint':
    'Qidiruvni yoki «faqat muddati o‘tganlar» filtrini o‘zgartiring — qarz bor, lekin u bu kesimga tushmadi.',
  'supplierPay.noInvoices': 'Ochiq invoys yo‘q',
  'supplierPay.noInvoicesHint':
    'Bu zavodga to‘langan pul bor, invoys esa hali kelmagan — ya’ni pul AVANS bo‘lib turibdi. Import siklida bu odatiy holat: 30% deposit invoysdan oldin to‘lanadi.',
  'supplierPay.invoices': 'Ochiq invoyslar',
  'supplierPay.invoicesHint':
    'Eng eski muddatdan boshlab. Avtomatik biriktirish ham aynan shu tartibda ishlaydi — muddatsiz invoyslar oxirida.',
  'supplierPay.invDoc': 'Invoys',
  'supplierPay.invDate': 'Sana',
  'supplierPay.invDue': 'Muddat',
  'supplierPay.invTotal': 'Summa',
  'supplierPay.invPaid': 'To‘langan',
  'supplierPay.invBalance': 'Qoldiq',
  'supplierPay.invBalanceBase': 'Qoldiq (USD)',
  'supplierPay.invOverdue': '{days} kun kechikdi',
  'supplierPay.invNoDue': 'muddatsiz',
  'supplierPay.pay': 'To‘lov qilish',
  'supplierPay.formTitle': 'Zavodga to‘lov',
  'supplierPay.formHint':
    'Hujjat bank o‘tkazmasi BAJARILGANDAN keyin kiritiladi — shuning uchun qoralama bosqichi yo‘q. Keyingi qadamda pul qaysi hisobdan va qancha chiqishi tasdiqlash uchun ko‘rsatiladi.',
  'supplierPay.account': 'Kassa/bank hisobi',
  'supplierPay.accountPick': 'Hisobni tanlang',
  'supplierPay.amount': 'Summa',
  'supplierPay.rate': 'Bank kursi',
  'supplierPay.rateHint':
    'Bankning O‘SHA KUNGI real kursi — kunlik kurs emas. Pul so‘m hisobidan yechilib, boshqa valyutada zavodga ketadi, ya’ni konvertatsiya haqiqatda sodir bo‘ladi va farq katta o‘tkazmada yuzlab dollarga teng. Kurs hujjatga muhrlanadi.',
  'supplierPay.date': 'To‘lov sanasi',
  'supplierPay.method': 'Usul',
  'supplierPay.reference': 'To‘lov topshirig‘i',
  'supplierPay.referenceHint': 'SWIFT yoki topshiriq raqami',
  'supplierPay.notes': 'Izoh',
  'supplierPay.allocTitle': 'Qaysi invoyslar yopilsin',
  'supplierPay.allocAuto': 'Avtomatik — eng eski muddatdan boshlab',
  'supplierPay.allocAutoHint':
    'Eng eski qarz eng xavflisi: zavod jo‘natmani to‘xtatadi. Muddatsiz invoyslar oxirida qoladi.',
  'supplierPay.allocPick': 'Men tanlayman',
  'supplierPay.allocPickHint':
    'Aniq invoysni ko‘rsating — masalan konteyner chiqishi aynan shunga bog‘liq bo‘lsa.',
  'supplierPay.allocAdvance': 'Avans — hech qaysi invoysga biriktirilmasin',
  'supplierPay.allocAdvanceHint':
    'Zavod invoys yozishdan oldin deposit talab qilgan holat. Pulni majburan biror invoysga yopishtirish qarz hisobotini yolg‘on qilardi.',
  'supplierPay.currencyUnsupported':
    'Bu hisob {currency} valyutasida va u tizimning to‘lov valyutalari ro‘yxatida yo‘q. Boshqa hisobni tanlang.',
  'supplierPay.insufficient': 'Hisobda yetarli pul yo‘q',
  'supplierPay.insufficientHint':
    '«{code}» hisobida qoldiq {balance}, to‘lov esa {amount}. Avval hisobga pul kiriting (hisoblararo o‘tkazma) yoki summani tuzating.',
  'supplierPay.continue': 'Davom etish',
  'supplierPay.confirmTitle': 'Pul kassadan CHIQADI — tasdiqlang',
  'supplierPay.confirmHint':
    'Bu amalning bekor qilish tugmasi yo‘q: u kassa qoldig‘ini, zavod qarzini va daftarni birdaniga o‘zgartiradi. Quyidagi uchta raqamni tekshiring.',
  'supplierPay.confirmFrom': 'Qaysi hisobdan',
  'supplierPay.confirmAmount': 'Qancha chiqadi',
  'supplierPay.confirmRateHint': 'Hujjatga muhrlanadi',
  'supplierPay.confirmBalance': 'Qoldiq',
  'supplierPay.confirmBalanceHint': 'Hozir → to‘lovdan keyin',
  'supplierPay.confirmAuto': 'Invoyslar avtomatik yopiladi — eng eski muddatdan boshlab.',
  'supplierPay.confirmAdvance':
    'To‘lov hech qaysi invoysga biriktirilmaydi — u avans bo‘lib turadi.',
  'supplierPay.confirmPicked': 'Yopiladigan invoyslar: {docs}',
  'supplierPay.confirmSubmit': 'Tasdiqlayman — pul chiqsin',
  'supplierPay.resultDone': 'To‘lov yozildi',
  'supplierPay.resultPaid': 'To‘landi',
  'supplierPay.resultBase': 'USD ekvivalenti',
  'supplierPay.resultAdvance': 'Avans bo‘lib qoldi',
  'supplierPay.resultCash': '«{code}» qoldig‘i',
  'supplierPay.resultSupplierBalance': 'Zavodga qolgan qarz',
  'supplierPay.allocInvoice': 'Invoys',
  'supplierPay.allocClosed': 'Yopildi',
  'supplierPay.allocSpent': 'Sarflandi',
  'supplierPay.allocBefore': 'Qoldiq — oldin',
  'supplierPay.allocAfter': 'Qoldiq — keyin',
  'supplierPay.allocFx': 'Kurs farqi',
  'supplierPay.allocFxHint':
    'Musbat — FOYDA: majburiyatni sarflagan pulimizdan ko‘proq o‘chirdik. Mijoz to‘lovida ayni shu tenglik ZARAR bo‘ladi.',

  // --- Mijoz qarzlari (`/receivables`) ---
  'ar.title': 'Mijoz qarzlari',
  'ar.description':
    'Kim qancha qarzdor va qaysi hisob-faktura ortida. Satrni bosing — mijozning ochiq hisob-fakturalari ochiladi.',
  'ar.code': 'Kod',
  'ar.customer': 'Mijoz',
  'ar.total': 'Jami qarz',
  'ar.overdue': 'Kechikkan',
  'ar.notDue': 'Muddati kelmagan',
  'ar.d0_30': '0–30 kun',
  'ar.d31_60': '31–60 kun',
  'ar.d61_90': '61–90 kun',
  'ar.d90plus': '90+ kun',
  'ar.oldestDue': 'Eng eski muddat',
  'ar.invoiceCount': 'Hisob-fakturalar',
  'ar.invoiceCountShort': '{count} ta hujjat',
  'ar.filterOverdue': 'Faqat kechikkanlar',
  'ar.tileTotal': 'Jami qarz',
  'ar.tileTotalHint': '{count} ta mijoz bo‘yicha',
  'ar.tileOverdue': 'Muddati o‘tgan',
  'ar.tileOverdueHint': 'Bugun undirish kerak bo‘lgan summa',
  'ar.tile90': '90 kundan oshgan',
  'ar.tile90Hint': 'Bu undirish emas, yo‘qotish ehtimoli',
  'ar.empty': 'Qarzi bor mijoz yo‘q',
  'ar.emptyHint': 'Barcha hisob-fakturalar yopilgan yoki filtr juda tor.',
  'ar.blocked': 'Bloklangan',
  'ar.overLimit': 'Limit oshgan',
  'ar.balance': 'Qarz',
  'ar.advance': 'Avans (biriktirilmagan to‘lov)',
  'ar.net': 'Sof pozitsiya',
  'ar.netHint': 'Qarz − avans. Manfiy bo‘lsa — biz mijozga qarzdormiz.',
  'ar.creditLimit': 'Kredit limiti',
  'ar.availableCredit': 'Yana berish mumkin',
  'ar.overLimitHint': 'Limit allaqachon oshgan — yangi buyurtma tasdiq talab qiladi.',
  'ar.paymentTerm': 'To‘lov muddati',
  'ar.days': '{days} kun',
  'ar.fxPolicy': 'Kurs siyosati',
  'ar.fxPolicyPayment': 'To‘lov kunidagi kurs',
  'ar.fxPolicySale': 'Sotuv kunidagi kurs',
  'ar.fxPolicyHint': 'Qarz qaysi kun kursida o‘lchanishini belgilaydi — kurs farqi shu yerdan chiqadi.',
  'ar.buckets': 'Yosh guruhlari',
  'ar.openInvoices': 'Ochiq hisob-fakturalar',
  'ar.openInvoicesHint': 'Eng eski muddatdan boshlab. To‘lov ham shu tartibda biriktiriladi.',
  'ar.noOpenInvoices': 'Ochiq hisob-faktura yo‘q',

  // --- Ta'minotchi qarzlari (`/payables`) ---
  // --- Ta'minotchi (zavod) invoysi ---
  'supplierInvoice.title': 'Ta’minotchi invoyslari',
  'supplierInvoice.description':
    'Zavod chiqargan hisob-faktura. Tan olinganda «tovar keldi, hisob-faktura kelmadi» (GRNI) majburiyati ta’minotchiga qarzga o‘tadi.',
  'supplierInvoice.new': 'Yangi invoys',
  'supplierInvoice.save': 'Qoralama sifatida saqlash',
  'supplierInvoice.docNo': 'Invoys raqami',
  'supplierInvoice.docNoPlaceholder': 'Masalan: SZ-2026-0417',
  'supplierInvoice.docNoHint':
    'Raqamni ZAVOD beradi — tizim o‘zinikini bermaydi. Aynan shu raqam bank o‘tkazmasida va bojxona hujjatida turadi.',
  'supplierInvoice.supplier': 'Ta’minotchi',
  'supplierInvoice.date': 'Invoys sanasi',
  'supplierInvoice.dateHint': 'Kurs SHU sanaga yozib olinadi va keyin o‘zgarmaydi.',
  'supplierInvoice.dueDate': 'To‘lov muddati',
  'supplierInvoice.currency': 'Valyuta',
  'supplierInvoice.total': 'Jami (QQS bilan)',
  'supplierInvoice.totalBase': 'Jami (USD)',
  'supplierInvoice.net': 'Soliqsiz',
  'supplierInvoice.vat': 'QQS',
  'supplierInvoice.vatRate': 'QQS stavkasi, %',
  'supplierInvoice.vatRateHint':
    'Soliq «Jami» ning ICHIDAN ajratiladi, ustiga qo‘shilmaydi. Bo‘sh qoldirilsa — 0%.',
  'supplierInvoice.grossHint':
    '«Jami» katagiga zavod invoysining pastidagi summani yozing — QQS BILAN. Bank o‘tkazmasi ham aynan shu raqam bo‘yicha qilinadi.',
  'supplierInvoice.previewHint': 'Taxminiy hisob. Hujjatdagi aniq raqamni server yozadi.',
  'supplierInvoice.purchaseOrder': 'Xarid buyurtmasi',
  'supplierInvoice.receipt': 'Qabul',
  'supplierInvoice.receiptHint':
    'Tan olish uchun MAJBURIY: GRNI aynan qabul bo‘yicha yopiladi. Tovar hali kelmagan bo‘lsa, hujjat qoralama bo‘lib tursin.',
  'supplierInvoice.noLink': 'Bog‘lanmagan',
  'supplierInvoice.notes': 'Izoh',

  // --- Logistika invoysi va kontragent turi (0054) ---
  'supplier.kind': 'Kontragent turi',
  'supplier.kind.goods': 'Zavod / tovar',
  'supplier.kind.logistics': 'Logistika / ekspeditor',
  'supplier.kind.service': 'Xizmat',
  'supplier.kindAll': 'Barcha turlar',
  'supplier.kindHint':
    'Tur hisobot va tanlagichlarni ajratadi: zavod invoysi qabul bo‘yicha, logistika invoysi konteyner bo‘yicha yopiladi.',
  'si.kind.factory': 'Zavod invoysi (qabul bo‘yicha)',
  'si.kind.logistics': 'Logistika invoysi (konteyner bo‘yicha)',
  'si.kindTitle': 'Hujjat turi',
  'si.kindHint':
    'Ikkalasi daftarda BOSHQA-BOSHQA hisobni yopadi, shuning uchun bitta hujjat faqat bittasi bo‘ladi.',
  'si.shipment': 'Konteyner',
  'si.shipmentSelect': 'Konteynerni tanlang',
  'si.shipmentRequired': 'Logistika invoysi uchun konteyner majburiy',
  'si.costs': 'Qoplanadigan xarajatlar',
  'si.costsHint':
    'Taxminiy qatorlar tanlanmaydi — avval hujjat summasini kiriting',
  'si.costsEmpty': 'Bu konteynerda biriktirish mumkin bo‘lgan xarajat yo‘q',
  'si.costsSelected': '{count} ta qator tanlandi · {amount}',
  'si.costsRequired': 'Kamida bitta xarajat qatori tanlansin',
  'si.dueFromTerms': 'Muddat shartnoma bo‘yicha: {days} kun',
  'si.dueOverride': 'Bu hujjat uchun boshqa muddat',
  'si.dueNoTerms': 'Shartnomada muddat ko‘rsatilmagan — sanani qo‘lda kiriting',
  'si.error.estimateCost':
    'Taxminiy xarajat qarz yaratmaydi — «taxminiy» belgisini oling va tannarxni qayta hisoblang',
  'si.error.lcNotPosted':
    'Tannarx post qilinmagan — hisoblangan majburiyat hali daftarda yo‘q',
  'si.error.costTaken': 'Bu xarajat bo‘yicha boshqa invoys allaqachon tan olingan',
  'si.error.shapeConflict': 'Bitta hujjat ham qabulni, ham konteynerni yopa olmaydi',
  'si.copy': 'Nusxa olish',
  'si.copyHint':
    'Maydonlar shu hujjatdan ko‘chiriladi, raqam va biriktirilgan xarajatlar esa BO‘SH qoladi — ular har hujjatda o‘ziniki.',
  'si.copied': 'Nusxa olindi — raqamni kiriting va tekshirib saqlang',
  'si.docsTitle': 'Hujjat fayllari',
  'si.docsHint':
    'Ekspeditor hisob-fakturasi, konosament va bojxona qog‘ozi KONTEYNER kartochkasiga yuklanadi — invoys o‘sha konteynerga bog‘langan.',
  'si.docsOpen': 'Konteyner kartochkasini ochish',
  'ap.logistics': 'Logistikaning uchoti',
  'ap.kindNeedsSupplierView':
    'Tur bo‘yicha ajratish uchun kontragent ma’lumotini ko‘rish huquqi kerak.',
  'supplierInvoice.statusLabel': 'Holat',
  'supplierInvoice.status.draft': 'Qoralama',
  'supplierInvoice.status.received': 'Tan olingan',
  'supplierInvoice.status.cancelled': 'Bekor qilingan',
  'supplierInvoice.receive': 'Tan olish',
  'supplierInvoice.cancel': 'Bekor qilish',
  'supplierInvoice.cancelPrompt': 'Bekor qilish sababi (kamida 3 belgi):',
  'supplierInvoice.filterStatus': 'Holat',
  'supplierInvoice.filterStatusAll': 'Hammasi',
  'supplierInvoice.empty': 'Ta’minotchi invoysi yo‘q',
  'supplierInvoice.emptyHint':
    'Zavod invoysi kelganda uni shu yerda kiriting. Tan olinmaguncha daftarga hech narsa yozilmaydi.',

  'ap.title': 'Ta’minotchi qarzlari',
  'ap.description':
    'Zavodlarga qancha qarzmiz va qaysi avans osilib turibdi. Avans — chiqib ketgan, lekin hali tovarga aylanmagan pul.',
  'ap.code': 'Kod',
  'ap.supplier': 'Ta’minotchi',
  'ap.currency': 'Valyuta',
  'ap.openPoCount': 'Ochiq buyurtma',
  'ap.ordered': 'Buyurtma qilingan',
  'ap.paid': 'To‘langan',
  /* «Buyurtma bo'yicha» — hujjat bo'yicha qarz bilan chalkashmasligi uchun. */
  'ap.outstanding': 'Qarz (buyurtma bo‘yicha)',
  'ap.invoiceOpen': 'Qarz (invoys bo‘yicha)',
  'ap.notDue': 'Muddati kelmagan',
  'ap.d0_30': '0–30 kun',
  'ap.d31_60': '31–60 kun',
  'ap.d61_90': '61–90 kun',
  'ap.d90plus': '90+ kun',
  'ap.oldestDue': 'Eng eski muddat',
  'ap.openInvoiceCount': 'Ochiq invoys',
  'ap.advance': 'Ochiq avans',
  'ap.advanceAge': 'Avans yoshi',
  'ap.oldestAdvance': 'Eng eski avans',
  'ap.nearestExpected': 'Eng yaqin kutilma',
  'ap.paymentTerm': 'To‘lov sharti',
  'ap.days': '{days} kun',
  'ap.filterAdvances': 'Faqat avansi borlar',
  'ap.tileOutstanding': 'Jami qarz',
  'ap.tileOutstandingHint': '{count} ta ta’minotchi bo‘yicha',
  'ap.tileInvoiceOpen': 'Invoys bo‘yicha qarz',
  'ap.tileInvoiceOpenHint':
    'Zavod yozgan va biz tan olgan invoyslarning to‘lanmagan qismi. Daftardagi «Ta’minotchiga qarz» hisobi bilan bir xil ta’rif.',
  'ap.tileOverdue': 'Muddati o‘tgan',
  'ap.tileOverdueHint':
    'To‘lov muddati kelib o‘tgan invoyslar. To‘lov aniq invoysga biriktirilmagani uchun eng eski invoysdan boshlab qoplanadi.',
  'ap.tileAdvance': 'Ochiq avans',
  'ap.tileAdvanceHint': 'To‘langan, lekin hali tovarga aylanmagan pul',
  'ap.tileStale': '{days} kundan uzoq osilgan avans',
  'ap.tileStaleHint': 'Import sikli tugagan, avans esa yopilmagan — tekshirish kerak',
  'ap.empty': 'Ochiq qarz yoki avans yo‘q',
  'ap.emptyHint': 'Barcha xarid buyurtmalari yopilgan yoki hali ochiq buyurtma yaratilmagan.',

  // --- Valyuta kurslari (`/fx-rates`) ---
  'fxRates.description':
    'Kunlik kurs kuniga bir marta kiritiladi va dastur tepasida turadi. Sotuv USD da, kassa so‘mda, xarid yuanda — kurs noto‘g‘ri bo‘lsa o‘sha kunning barcha hujjatlari noto‘g‘ri hisoblanadi.',
  'fxRates.frozenTitle': 'Kurs o‘zgarishi eski hujjatlarga TEGMAYDI',
  'fxRates.frozenBody':
    'Hujjat yaratilganda kurs unga yozib olinadi va u yerda qotib qoladi. Bu yerda kursni o‘zgartirsangiz, faqat KEYINGI hujjatlar yangi kurs bo‘yicha hisoblanadi — kechagi hisob-fakturalar, to‘lovlar va yopilgan davr foydasi qayta hisoblanmaydi.',
  'fxRates.uzsLabel': '1 USD = ? so‘m',
  'fxRates.cnyLabel': '1 USD = ? ¥',
  'fxRates.missing': 'Kurs umuman kiritilmagan',
  'fxRates.stale': 'Bugungi emas',
  'fxRates.locked': 'Kun yopilgan',
  'fxRates.formTitle': 'Kurs kiritish',
  'fxRates.currency': 'Valyuta',
  'fxRates.rate': 'Kurs',
  // Namuna qiymatlar — `supplier.countryPlaceholder` dagi bir xil sabab.
  'fxRates.uzsPlaceholder': '12900',
  'fxRates.cnyPlaceholder': '7.25',
  'fxRates.rateDate': 'Qaysi kunga',
  'fxRates.saved': '{currency}: {rate} — {date} kuniga saqlandi',
  'fxRates.formHint':
    'Har valyuta alohida saqlanadi. Yopilgan kun kursini o‘zgartirib bo‘lmaydi. O‘zgarish audit jurnaliga yoziladi: kim va qachon o‘zgartirgani izlanadigan bo‘lishi kerak.',
  'fxRates.historyTitle': 'Kurs tarixi',
  'fxRates.historyCurrency': 'Valyuta tanlash',
  'fxRates.historySource':
    'Tarix AUDIT JURNALIDAN quriladi: har kun uchun o‘sha kundagi oxirgi kurs ko‘rsatiladi, kun ichidagi tuzatishlar esa to‘liq jurnalda.',
  'fxRates.historyNoPermission':
    'Kurs tarixi audit jurnalidan olinadi va u alohida ruxsat talab qiladi (audit jurnalini ko‘rish). Sizda bu ruxsat yo‘q, shuning uchun tarix ko‘rsatilmaydi — bu «tarix yo‘q» degani emas.',
  'fxRates.historyEmpty': 'Jurnalda bu valyuta bo‘yicha kurs o‘zgarishi topilmadi.',
  'fxRates.chartLabel': '{currency} kursining kunlik harakati',
  'fxRates.chartHint':
    'Ustunlar noldan o‘lchanadi — shuning uchun bir necha foizlik o‘zgarish deyarli bilinmaydi. Aniq farq pastdagi «O‘zgarish» ustunida; ustun ustiga sichqonchani olib borsangiz o‘sha kunning kursi chiqadi.',
  'fxRates.change': 'O‘zgarish',
  'fxRates.actor': 'Kim',
  'fxRates.changedAt': 'Qachon',
  'fxRates.openAudit': 'To‘liq jurnalni ochish',

  // --- Xatoliklar ---
  'error.403': 'Bu amal uchun ruxsatingiz yo‘q',
  'error.404': 'Topilmadi',
  'error.500': 'Server xatosi',
  'error.pageNotFound': 'Bunday sahifa yo‘q',
  'error.screenFailed': 'Ekranni ochib bo‘lmadi',
  'error.screenFailedHint':
    'Tarmoq uzilgan yoki dastur yangilangan bo‘lishi mumkin. Qayta urinib ko‘ring, yordam bermasa sahifani qayta yuklang.',

  // ==========================================================================
  // BUXGALTERIYA — hisoblar, davrlar, provodkalar va moliyaviy hisobotlar
  // ==========================================================================
  //
  // Kalitlar `acc.` prefiksi bilan: `report.` prefiksi `/api/reports/*`
  // ekranlariga tegishli va u yerda «hisobot» so'zi boshqa ma'noda — savdo
  // kesimi. Bu yerdagi hisobotlar esa DAFTARDAN chiqadi va ular boshqa
  // ruxsat bilan yopilgan (`accounting.report.view`).

  'nav.group.accounting': 'Buxgalteriya',
  'nav.accJournals': 'Provodkalar',
  'nav.accPeriods': 'Davrlar',
  'nav.accAccounts': 'Hisoblar rejasi',
  'nav.accIncomeStatement': 'Foyda va zarar',
  'nav.accBalanceSheet': 'Balans',
  'nav.accEquity': 'Sof kapital',

  // --- Umumiy: hisob tushunchalari ---
  'acc.account.account': 'Hisob',
  'acc.account.code': 'Kod',
  'acc.account.name': 'Nomi',
  'acc.account.type': 'Turi',
  'acc.account.roles': 'Rollar',
  'acc.account.contra': 'kontr',
  'acc.account.group': 'yig‘uvchi',
  'acc.account.inactive': 'faolsiz',
  'acc.account.debitSide': 'debet qoldiqli',
  'acc.account.creditSide': 'kredit qoldiqli',
  'acc.type.asset': 'Aktiv',
  'acc.type.liability': 'Majburiyat',
  'acc.type.equity': 'Kapital',
  'acc.type.income': 'Daromad',
  'acc.type.expense': 'Xarajat',

  // --- Foyda va zarar (P&L) ---
  'acc.pnl.title': 'Foyda va zarar',
  'acc.pnl.description':
    'Daftardan chiqadigan hisobot: tushumdan sof foydagacha. Har satr joriy davr, OLDINGI davr va farq bilan — bitta davrning o‘zi hech narsa anglatmaydi.',
  'acc.pnl.line': 'Ko‘rsatkich',
  'acc.pnl.current': 'Joriy davr',
  'acc.pnl.previous': 'Oldingi davr',
  'acc.pnl.previousShort': 'oldingi:',
  'acc.pnl.previousValue': 'oldingi: {value}',
  'acc.pnl.delta': 'Farq',
  'acc.pnl.trend': 'O‘zgarish',
  'acc.pnl.vsPrevious': 'oldingi davrga nisbatan',
  'acc.pnl.comparedWith': 'Solishtirilayotgan davr: {from} — {to}',
  'acc.pnl.expenseMix': 'Operatsion xarajatlar tarkibi',
  'acc.pnl.revenue': 'Tushum',
  'acc.pnl.returns': 'Qaytarishlar',
  'acc.pnl.discounts': 'Berilgan chegirmalar',
  'acc.pnl.netRevenue': 'Sof tushum',
  'acc.pnl.cogs': 'Sotilgan tovar tannarxi',
  'acc.pnl.grossProfit': 'YALPI FOYDA',
  'acc.pnl.operatingExpense': 'Operatsion xarajatlar',
  'acc.pnl.operatingProfit': 'OPERATSION FOYDA',
  'acc.pnl.fxResult': 'Kurs farqi (foyda − zarar)',
  'acc.pnl.otherResult': 'Boshqa daromad',
  'acc.pnl.netProfit': 'SOF FOYDA',
  'acc.pnl.checkFailed': 'Hisobot daftar bilan mos kelmadi',
  'acc.pnl.checkFailedDetail':
    'Hisobotdagi sof foyda {statement}, daftardagi (daromad − xarajat) esa {ledger}. Farq: {difference}. Bu biror hisob hisobot guruhiga tushmaganini bildiradi.',

  // --- Balans ---
  'acc.bs.title': 'Balans',
  'acc.bs.description':
    'Ma’lum bir sanadagi holat: aktivlar, majburiyatlar va kapital. Tenglik tekshiriladi va natijasi ochiq ko‘rsatiladi.',
  'acc.bs.equation': 'AKTIVLAR = MAJBURIYATLAR + KAPITAL',
  'acc.bs.balanced': 'Tenglik bajarildi',
  'acc.bs.notBalanced': 'TENGLIK BUZILDI',
  'acc.bs.differenceIs': 'Farq: {value}.',
  'acc.bs.section': 'Bo‘lim',
  'acc.bs.amount': 'Summa',
  'acc.bs.assets': 'AKTIVLAR',
  'acc.bs.liabilities': 'MAJBURIYATLAR',
  'acc.bs.equity': 'KAPITAL',
  'acc.bs.totalAssets': 'Aktivlar jami',
  'acc.bs.totalLiabilities': 'Majburiyatlar jami',
  'acc.bs.totalEquity': 'Kapital jami',
  'acc.bs.unclosedResult': 'Joriy yil natijasi (yopilmagan)',
  'acc.bs.unclosedHint':
    'Daromad {income} − xarajat {expense}. Yil yopilgandan keyin bu satr nolga tushadi va summa «Taqsimlanmagan foyda» ga o‘tadi.',

  // --- Sof kapital ---
  'acc.equity.title': 'Sof kapital harakati',
  'acc.equity.description':
    'Boshlang‘ich kapitaldan yakuniy kapitalgacha bo‘lgan yo‘l: davr natijasi, kiritmalar va olib qo‘yishlar.',
  'acc.equity.line': 'Ko‘rsatkich',
  'acc.equity.amount': 'Summa',
  'acc.equity.opening': 'Boshlang‘ich sof kapital',
  'acc.equity.closing': 'Yakuniy sof kapital',
  'acc.equity.ofAccounts': 'shundan: kapital hisoblari',
  'acc.equity.ofUnclosed': 'shundan: yopilmagan natija',
  'acc.equity.periodResult': 'Joriy davr natijasi (foyda / zarar)',
  'acc.equity.contributions': 'Qo‘shimcha kiritmalar',
  'acc.equity.withdrawals': 'Olib qo‘yishlar',
  'acc.equity.otherEquity': 'Kapital hisoblaridagi boshqa harakat',
  'acc.equity.checkFailed': 'Kapital hisoboti yopilmadi',
  'acc.equity.checkFailedDetail': 'Kutilgan yakuniy qiymat {expected}, haqiqiy {actual}.',
  'acc.equity.profitCheckFailed': 'Davr natijasi «Foyda va zarar» bilan mos kelmadi',
  'acc.equity.profitCheckDetail':
    'Kapital hisobotidagi natija {equity}, foyda va zarar hisobotidagi sof foyda {pnl}. Ikkalasi bir xil provodkalardan chiqadi — farq bo‘lsa, ishora xatosi bor.',

  // --- Hisoblar rejasi va rol bog‘lami ---
  'acc.accounts.title': 'Hisoblar rejasi',
  'acc.accounts.description':
    'Buxgalteriya hisoblari daraxti va ularning semantik rollarga bog‘lanishi. Kod hech qachon hisob raqamini bilmaydi — u faqat ROLNI biladi, rol esa shu yerda hisobga bog‘lanadi.',
  'acc.accounts.chart': 'Hisoblar daraxti',
  'acc.accounts.chartHint':
    'Yig‘uvchi hisobga provodka yozilmaydi — u faqat bolalarini yig‘adi.',
  'acc.mapping.title': 'Rol → hisob bog‘lami',
  'acc.mapping.hint':
    'Har rol AYNAN bitta hisobga bog‘lanadi. Bog‘lanmagan rol bilan provodka yozib bo‘lmaydi va hodisa navbatda qoladi.',
  'acc.mapping.role': 'Rol',
  'acc.mapping.expectedType': 'Kutilgan tur',
  'acc.mapping.entityScoped': 'yuridik shaxsga xos',
  'acc.mapping.typeMismatch': 'haqiqiy tur: {actual}',
  'acc.mapping.unmappedTitle': 'Bog‘lanmagan rollar: {count} ta',
  'acc.mapping.unmappedHint':
    'Bu rollarga tegishli hodisalar provodkaga AYLANMAYDI — ular navbatda qoladi va davrni yopib bo‘lmaydi. Rolni hisobga bog‘lang.',

  // --- Davrlar ---
  'acc.periods.title': 'Buxgalteriya davrlari',
  'acc.periods.description':
    'Oy yopilgandan keyin unga provodka yozib bo‘lmaydi. Yopishdan oldin tekshiruv ro‘yxati bajariladi: post qilinmagan qoralamalar, teng kelmagan provodkalar va navbatdagi hodisalar.',
  'acc.periods.list': '{year} yil davrlari',
  'acc.periods.period': 'Davr',
  'acc.periods.status': 'Holat',
  'acc.periods.journals': 'Provodkalar',
  'acc.periods.drafts': 'Qoralamalar',
  'acc.periods.closedAt': 'Yopilgan',
  'acc.periods.select': 'Tanlash',
  'acc.periods.selectHint': 'Tekshiruv ro‘yxatini ko‘rish uchun davrni tanlang.',
  'acc.periods.statusOpen': 'ochiq',
  'acc.periods.statusClosed': 'yopilgan',
  'acc.periods.statusLocked': 'qulflangan',
  'acc.periods.checklistTitle': '{period} — yopishdan oldingi tekshiruv',
  'acc.periods.checklistHint':
    'To‘siqlar hal qilinmaguncha davr yopilmaydi. Ogohlantirishlarni operator ongli ravishda o‘tkazib yuborishi mumkin.',
  'acc.periods.checklistClean': 'To‘siq ham, ogohlantirish ham yo‘q — davrni yopish mumkin.',
  'acc.periods.blocker': 'To‘siq',
  'acc.periods.warning': 'Ogohlantirish',
  'acc.periods.totals': 'Davr aylanmasi:',
  'acc.periods.debit': 'debet',
  'acc.periods.credit': 'kredit',
  'acc.periods.balanced': 'teng',
  'acc.periods.notBalanced': 'TENG EMAS, farq {value}',
  'acc.periods.closeAction': 'Davrni yopish',
  'acc.periods.noClosePermission':
    'Davrni yopish huquqi sizda yo‘q — ro‘yxatni ko‘rishingiz mumkin. Yopish kerak bo‘lsa bosh buxgalteringizga murojaat qiling.',

  // --- Yil yopish provodkasi ---
  'acc.yearClose.title': '{year} yilni yopish',
  'acc.yearClose.description':
    'Daromad va xarajat hisoblari nolga tushiriladi, natija «Taqsimlanmagan foyda» ga o‘tkaziladi. Amal QAYTARILMAYDI — avval quruq yurishni bajaring.',
  'acc.yearClose.dryRun': 'Quruq yurish (yozilmaydi)',
  'acc.yearClose.commit': 'HAQIQIY yopish — provodkani yozish',
  'acc.yearClose.dryRunTitle': 'Quruq yurish — hech narsa yozilmadi',
  'acc.yearClose.doneTitle': 'Yil yopildi — provodkalar daftarga yozildi',
  'acc.yearClose.income': 'Daromad jami',
  'acc.yearClose.expense': 'Xarajat jami',
  'acc.yearClose.profit': 'Foyda',
  'acc.yearClose.loss': 'Zarar',
  'acc.yearClose.notBalanced': 'TENG EMAS',

  // --- Provodkalar ---
  'acc.journal.title': 'Provodkalar',
  'acc.journal.cardTitle': 'Provodka',
  'acc.journal.description':
    'Har bir hujjat daftarga debet va kredit bo‘lib tushadi.',
  'acc.journal.about': 'Bu sahifa haqida',
  'acc.journal.aboutBody':
    'Daftarga tushgan provodka o‘zgartirilmaydi va o‘chirilmaydi. Xato bo‘lsa uning o‘rniga teskari provodka yoziladi, ikkala yozuv ham daftarda qoladi — shuning uchun hisobotni istalgan kunga qaytarib ko‘rish mumkin. Ro‘yxatdagi raqamni bossangiz provodkaning satrlari va manba hujjati ochiladi.',
  'acc.journal.docNo': 'Raqam',
  'acc.journal.entryDate': 'Hodisa sanasi',
  'acc.journal.postingDate': 'Daftar sanasi',
  'acc.journal.period': 'Davr',
  'acc.journal.status': 'Holat',
  'acc.journal.statusAll': 'Hammasi',
  'acc.journal.statusDraft': 'Qoralama',
  'acc.journal.statusPosted': 'Daftarda',
  'acc.journal.statusReversed': 'Teskarilangan',
  'acc.journal.descriptionField': 'Tavsif',
  'acc.journal.source': 'Manba',
  'acc.journal.sourceDoc': 'Hujjat #{id}',
  'acc.journal.sourceUnknown': 'Boshqa hodisa',
  'acc.journal.eventCode': 'Hodisa kodi',
  'acc.journal.manual': 'qo‘lda',
  'acc.journal.amount': 'Summa',
  'acc.journal.total': 'Jami',
  'acc.journal.postedAt': 'Daftarga kiritilgan',
  'acc.journal.lines': 'Provodka satrlari',
  'acc.journal.debit': 'Debet',
  'acc.journal.credit': 'Kredit',
  'acc.journal.docCurrency': 'Hujjat valyutasi / kurs',
  'acc.journal.lineNote': 'Izoh',
  'acc.journal.filterStatus': 'Holat bo‘yicha:',
  'acc.journal.filterAccount': 'Hisob #{id}',
  'acc.journal.backToList': 'Provodkalar ro‘yxatiga',
  'acc.journal.empty': 'Provodka topilmadi',
  'acc.journal.emptyHint':
    'Filtrni kengaytiring yoki boshqa davrni tanlang.',
  'acc.journal.reversedTitle': 'Bu provodka teskarilangan',
  'acc.journal.reversedHint':
    'Yozuv daftarda QOLADI va hisobotlarga kiradi — teskari provodka uni nolga tushiradi.',

  // --- Provodka manbalari (hodisa kodi → odam o'qiydigan nom) ---
  //
  // Ilgari «Manba» ustunida hodisa kodining O'ZI va jadval nomi chiqardi
  // (`inventory.receipt · inventory_transactions#1`). Buxgalter uchun bu
  // ma'nosiz: u qaysi hujjatdan kelganini biladigan nom kutadi.
  'acc.src.inventory.receipt': 'Ombor kirimi',
  'acc.src.inventory.issue': 'Ombor chiqimi',
  'acc.src.inventory.transfer': 'Omborlar aro ko‘chirish',
  'acc.src.inventory.revaluation': 'Ombor qayta baholandi',
  'acc.src.inventory.count': 'Inventarizatsiya',
  'acc.src.inventory.giveaway': 'Namuna va vitrina',
  'acc.src.inventory.return': 'Tovar qaytishi',
  'acc.src.invoice.issued': 'Hisob-faktura',
  'acc.src.credit_note.issued': 'Kredit-nota',
  'acc.src.payment.received': 'Mijozdan to‘lov',
  'acc.src.payment.supplier': "Ta'minotchiga to‘lov",
  'acc.src.supplier_advance.applied': "Ta'minotchi avansi yopildi",
  'acc.src.purchase.invoice_received': "Ta'minotchi hisob-fakturasi",
  'acc.src.landed_cost.cogs_variance': 'Tannarx farqi',
  'acc.src.fx.revaluation': 'Kurs qayta baholandi',
  'acc.src.expense.posted': 'Xarajat',
  'acc.src.bonus.accrual': 'Bonus hisoblandi',
  'acc.src.bonus.payout': 'Bonus to‘landi',
  'acc.src.charity.accrued': 'Xayriya hisoblandi',
  'acc.src.charity.paid': 'Xayriya to‘landi',
  'acc.src.employee.advance': 'Xodimga avans',
  'acc.src.employee.debt': 'Xodim qarzi',
  'acc.src.employee.debt.writeoff': 'Xodim qarzi hisobdan chiqarildi',
  'acc.src.payroll.accrued': 'Ish haqi hisoblandi',
  'acc.src.payroll.paid': 'Ish haqi to‘landi',

  // ==========================================================================
  // HUJJATLAR VA FAYLLAR (DMS) — TZ v8.0 §29
  // ==========================================================================
  //
  // Alohida «Hujjatlar» ekrani YO'Q va bo'lmaydi ham: hujjat o'z-o'zicha
  // ma'noga ega emas — u konteynerga, vozvratga yoki mijozga tegishli.
  // Shuning uchun kalitlar PANEL uchun yozilgan va ular o'nlab ekranda
  // qayta ishlatiladi. Yagona ro'yxat ekrani — muddati yaqinlashayotganlar.

  'nav.documentsExpiring': 'Muddati tugayotgan hujjatlar',

  'doc.panel.title': 'Hujjatlar',
  'doc.panel.hint':
    'Fayl shu obyektga biriktiriladi va shu yerdan qidiriladi. Bir xil fayl ikki marta yuklansa — takrori yaratilmaydi, mavjudi qaytariladi.',
  'doc.empty': 'Hujjat yo‘q',
  'doc.emptyHint': 'Faylni shu yerga tashlang yoki «Fayl tanlash» tugmasini bosing.',
  'doc.loadError': 'Hujjatlarni yuklab bo‘lmadi',

  'doc.upload': 'Fayl tanlash',
  'doc.uploading': 'Yuklanmoqda…',
  'doc.dropHere': 'Faylni shu yerga tashlang',
  'doc.dropHint':
    'Ruxsat etilgan turlar: rasm (JPG, PNG, WEBP), PDF, Word, Excel, PowerPoint, CSV. Eng katta hajm — 25 MB.',
  'doc.uploaded': '«{fileName}» yuklandi',
  'doc.duplicateNotice':
    '«{fileName}» allaqachon shu yerda bor edi — takror nusxa yaratilmadi. Bu xato emas: bir xil faylni ikki odam ikki manbadan yuklashi odatiy hol.',

  'doc.kind': 'Turi',
  'doc.kind.invoice': 'Invoys',
  'doc.kind.packing_list': 'Packing list',
  'doc.kind.customs': 'Bojxona hujjati',
  'doc.kind.contract': 'Shartnoma',
  'doc.kind.certificate': 'Sertifikat',
  'doc.kind.photo': 'Foto',
  'doc.kind.act': 'Dalolatnoma',
  'doc.kind.other': 'Boshqa',

  'doc.fileName': 'Fayl',
  'doc.size': 'Hajmi',
  'doc.uploadedAt': 'Yuklangan',
  'doc.uploadedBy': 'Kim yuklagan',
  'doc.expiresOn': 'Amal qilish muddati',
  'doc.expiresOnHint':
    'Sertifikat va shartnoma uchun. Muddati o‘tgan sertifikat bilan bojxonadan o‘tib bo‘lmaydi — tizim muddat yaqinlashganda eslatadi.',
  'doc.titleField': 'Sarlavha',
  'doc.titlePlaceholder': 'Ixtiyoriy — bo‘sh qoldirilsa fayl nomi ko‘rsatiladi',

  'doc.download': 'Yuklab olish',
  'doc.replace': 'Yangi versiya',
  'doc.replaceHint':
    'Eski nusxa O‘CHIRILMAYDI — u arxivga o‘tadi va joyida qoladi: landed cost o‘sha eski raqamlar bilan hisoblangan bo‘lishi mumkin.',
  'doc.archive': 'Arxivlash',
  'doc.archiveConfirm': 'Hujjat arxivga o‘tadi. Fayl o‘chirilmaydi va uni arxivdan ochish mumkin. Davom etamizmi?',
  'doc.archived': 'Arxivda',
  'doc.showArchived': 'Arxivni ham ko‘rsatish',
  'doc.replacesLine': '#{id} hujjatning yangi versiyasi',

  'doc.preview': 'Ko‘rish',
  'doc.previewFailed': 'Oldindan ko‘rishni ochib bo‘lmadi',

  // --- Obyekt turlari (panel qaysi kartochkada turganini ko'rsatadi) ---
  'doc.entity.shipments': 'Konteyner',
  'doc.entity.purchase_orders': 'Xarid buyurtmasi',
  'doc.entity.goods_receipts': 'Tovar qabuli',
  'doc.entity.sales_returns': 'Qaytarish',
  'doc.entity.sales_return_lines': 'Qaytarish satri',
  'doc.entity.sales_orders': 'Sotuv buyurtmasi',
  'doc.entity.invoices': 'Hisob-faktura',
  'doc.entity.payments': 'To‘lov',
  'doc.entity.customers': 'Mijoz',
  'doc.entity.suppliers': 'Ta’minotchi',
  'doc.entity.products': 'Mahsulot',
  'doc.entity.users': 'Xodim',
  'doc.entity.stock_counts': 'Inventarizatsiya',
  'doc.entity.deliveries': 'Yetkazish',

  // --- Muddati yaqinlashayotganlar (`/documents/expiring`) ---
  'doc.expiring.title': 'Muddati tugayotgan hujjatlar',
  'doc.expiring.description':
    'Sertifikat va shartnomalar muddati bo‘yicha. Muddati o‘tgan sertifikat bilan bojxonadan o‘tib bo‘lmaydi va konteyner portda turib qoladi — demurrage kuniga hisoblanadi.',
  'doc.expiring.window': 'Oyna',
  'doc.expiring.windowDays': '{days} kun',
  'doc.expiring.daysLeft': 'Qolgan',
  'doc.expiring.left': '{days} kun',
  'doc.expiring.today': 'Bugun tugaydi',
  'doc.expiring.overdue': '{days} kun oldin tugagan',
  'doc.expiring.entity': 'Tegishli',
  'doc.expiring.empty': 'Muddati yaqinlashayotgan hujjat yo‘q',
  'doc.expiring.emptyHint':
    'Oynani kengaytiring yoki hujjatlarga amal qilish muddatini kiriting — muddatsiz hujjat bu ro‘yxatga tushmaydi.',

  /*
   * --- Tasdiqlash dvigateli (TZ v8.0 §12, §21) ---
   *
   * Matnlar ATAYLAB «nima bo'ldi» emas, «endi nima qilish kerak» ni aytadi:
   * tasdiqlash navbati kuniga bir necha marta ochiladi va har qatorda odam
   * bitta qaror qabul qiladi. Tushuntirish kerak bo'lgan har bir joyda u
   * ekranning O'ZIDA turadi — qoida hujjatida emas.
   */
  'nav.approvals': 'Mening navbatim',
  'nav.approvalRules': 'Tasdiqlash qoidalari',
  'nav.delegations': 'Vakolat berish',

  'appr.queueDescription':
    'Sizdan imzo kutilayotgan hujjatlar. Ro‘yxatga faqat sizga yoki sizning rolingizga yozilgan, yoki sizga vakolat berilgan imzolar tushadi — boshqa odamning navbati bu yerda ko‘rinmaydi.',
  'appr.loadError': 'Tasdiqlash ma’lumotlarini olib bo‘lmadi',
  'appr.empty': 'Sizdan kutilayotgan imzo yo‘q',

  'appr.metric.pending': 'Kutilmoqda',
  'appr.metric.pendingHint': 'sizdan imzo kutayotgan hujjatlar',
  'appr.metric.overdue': 'Muddati o‘tdi',
  'appr.metric.overdueHint': 'eskalatsiya muddati tugagan',
  'appr.metric.oldest': 'Eng uzoq kutgan',
  'appr.metric.oldestHint': 'bosqich boshlanganidan beri',
  'appr.metric.topAmount': 'Eng katta summa',
  'appr.metric.topAmountHint': 'navbatdagi eng qimmat hujjat',

  'appr.col.document': 'Hujjat',
  'appr.col.amount': 'Summa',
  'appr.col.waitingOn': 'Kimdan kutilmoqda',
  'appr.col.waitingTime': 'Qancha vaqt',
  'appr.col.stage': 'Bosqich',

  'appr.hours': '{hours} soat',
  'appr.stageOf': '{stage} / {total}',
  'appr.stageShort': '{stage}-bosqich',
  'appr.roleTarget': '{role} (rol)',
  'appr.onBehalfOf': '{name} nomidan',
  'appr.escalated': 'Eskalatsiya',
  'appr.discountOf': 'chegirma {pct}%',
  'appr.waiting': 'kutilmoqda',
  'appr.notYet': 'navbati kelmagan',

  'appr.approve': 'Tasdiqlash',
  'appr.reject': 'Rad etish',
  'appr.rejectConfirm': 'Rad etishni tasdiqlash',
  'appr.rejectReason': 'Rad etish sababi',
  'appr.rejectReasonHint': 'Nima tuzatilishi kerakligini yozing — sabab hujjat egasiga boradi',
  'appr.raceLost':
    'Bu imzoni sizdan oldin kimdir qo‘ydi. Ro‘yxat yangilandi — qayta ko‘rib chiqing.',

  'appr.docType.purchaseOrder': 'Xarid buyurtmasi',
  'appr.docType.salesDiscount': 'Sotuv chegirmasi',

  'appr.state.pending': 'Imzo kutilmoqda',
  'appr.state.approved': 'Tasdiqlangan',
  'appr.state.rejected': 'Rad etilgan',
  'appr.state.notRequired': 'Tasdiqlash talab qilinmaydi',

  'appr.panelTitle': 'Tasdiqlash',
  'appr.panelSubtitle': '{amount} · hujjat egasi: {author}',
  'appr.historyTitle': 'Imzolar tarixi',
  'appr.act.approved': 'Tasdiqladi',
  'appr.act.rejected': 'Rad etdi',

  // --- Qoidalar ---
  'appr.rulesDescription':
    'Qaysi hujjatga qanday shartda kimning imzosi kerakligi. Qoida yo‘q bo‘lsa tasdiqlash talab qilinmaydi va hujjatlar bugungidek o‘tadi.',
  'appr.rule.code': 'Kod',
  'appr.rule.name': 'Nomi',
  'appr.rule.docType': 'Hujjat turi',
  'appr.rule.condition': 'Shart',
  'appr.rule.steps': 'Bosqichlar',
  'appr.rule.fourEyes': 'Four-eyes',
  'appr.rule.status': 'Holat',
  'appr.rule.active': 'Faol',
  'appr.rule.inactive': 'O‘chirilgan',
  'appr.rule.enable': 'Yoqish',
  'appr.rule.disable': 'O‘chirish',
  'appr.rule.enabled': '«{code}» qoidasi yoqildi',
  'appr.rule.disabled': '«{code}» qoidasi o‘chirildi',
  'appr.rule.empty':
    'Qoida yo‘q — hozir tasdiqlash talab qilinmaydi va hujjatlar bugungi tartibda o‘tadi.',
  'appr.rule.new': 'Yangi qoida',
  'appr.rule.editTitle': '«{code}» qoidasini tahrirlash',
  'appr.rule.saved': '«{code}» qoidasi saqlandi',
  'appr.rule.create': 'Qoidani yaratish',
  'appr.rule.created': '«{code}» qoidasi yaratildi',
  'appr.rule.minAmount': 'Summa (dan, USD)',
  'appr.rule.maxAmount': 'Summa (gacha, USD)',
  'appr.rule.minDiscount': 'Chegirma (dan, %)',
  'appr.rule.fromAmount': '{amount} dan',
  'appr.rule.toAmount': '{amount} gacha',
  'appr.rule.fromDiscount': 'chegirma {pct}% dan',
  'appr.rule.noCondition': 'shartsiz — barcha hujjatlarga',
  'appr.rule.rangeHint':
    'Oraliq: pastki chegara QO‘SHIB, yuqorigisi QO‘SHMAY olinadi. Ya‘ni 0–10 000 va 10 000–∞ oraliqlarida $10 000 faqat ikkinchisiga tushadi. Bo‘sh katak — shart qo‘yilmagan.',
  'appr.rule.fourEyesLabel': 'Hujjatni yozgan odam uni o‘zi tasdiqlay olmasin',
  'appr.rule.fourEyesHint':
    'Bir necha qoida mos kelsa, ulardan BIRORTASI shu talabni qo‘ysa u qo‘llanadi — yumshoqroq qoida qo‘shib chetlab bo‘lmaydi.',
  'appr.rule.unionHint':
    'Bir necha qoida bir hujjatga mos kelsa — HAMMASI qo‘llanadi, bittasi tanlanmaydi. Qoidani tahrirlash ochiq navbatga tegmaydi: reja so‘rov ochilganda suratga olinadi.',
  'appr.rule.addStep': 'Bosqich qo‘shish',
  'appr.rule.seq': 'Tartib',
  'appr.rule.approver': 'Kim imzolaydi',
  'appr.rule.escHours': 'Eskalatsiya (soat)',
  'appr.rule.escTarget': 'Eskalatsiya kimga',
  'appr.rule.escalateAfter': '{hours} soatdan keyin {target} ga',
  'appr.rule.seqHint':
    'Bir xil tartib raqami — parallel (ikkalasi ham imzolaydi), turlicha — ketma-ket. Eskalatsiya muddati qo‘yilsa, kimga ketishi ham ko‘rsatilishi shart.',

  // --- Vakolat ---
  'appr.deleg.description':
    'Ta’til yoki xizmat safari vaqtida imzo huquqini vaqtincha boshqa xodimga berish. Vakolat huquqni olib qo‘ymaydi — u faqat qo‘shadi.',
  'appr.deleg.from': 'Kimning nomidan',
  'appr.deleg.to': 'Kimga',
  'appr.deleg.self': 'O‘zim',
  'appr.deleg.docType': 'Hujjat turi',
  'appr.deleg.allDocTypes': 'Barchasi',
  'appr.deleg.period': 'Muddat',
  'appr.deleg.validFrom': 'Boshlanish',
  'appr.deleg.validTo': 'Tugash',
  'appr.deleg.reasonHint': 'Ta’til, xizmat safari…',
  'appr.deleg.new': 'Yangi vakolat',
  'appr.deleg.create': 'Vakolat berish',
  'appr.deleg.created': 'Vakolat yozildi',
  'appr.deleg.empty': 'Vakolat yo‘q',
  'appr.deleg.revoke': 'Bekor qilish',
  'appr.deleg.inclusiveHint':
    'Muddatning ikkala uchi ham qo‘shib olinadi: «25-avgustgacha» degani 25-avgust kuni ham imzo qo‘yish mumkin.',
  'appr.deleg.noChainHint':
    'Zanjir ishlamaydi: A → B → C. Vakolatni faqat uning asl egasi bera oladi — aks holda «kim tasdiqladi?» savoliga javob berib bo‘lmasdi.',
  'appr.deleg.needUserView':
    'Vakolat yozish uchun xodimlar ro‘yxatini ko‘rish huquqi kerak. Administratorga murojaat qiling — u sizning nomingizdan vakolat yoza oladi.',

  // =========================================================================
  // ODDIY SAVDO (do'kon kassasi) va «Mening kassam»
  // =========================================================================
  'nav.group.pos': 'Kassa',
  'nav.directSale': 'Savdo',
  'nav.myCash': 'Mening kassam',

  'pos.title': 'Savdo',
  'pos.subtitle': 'Mahsulot → mijoz → to‘lov. Hammasi bitta ekranda.',

  // --- Mahsulot kiritish ---
  'pos.scan.label': 'Kod yoki nom',
  'pos.scan.placeholder': 'SKU/shtrix-kodni tering yoki skanerlang, nomdan qidiring…',
  'pos.scan.hint':
    'Kod aniq mos kelsa satr DARHOL qo‘shiladi (skaner shunday ishlaydi). Nom bo‘yicha — ro‘yxatdan tanlang.',
  'pos.scan.notFound': 'Bunday kod topilmadi',
  'pos.scan.qty': 'Miqdor',
  'pos.scan.add': 'Qo‘shish',

  // --- Satrlar ---
  'pos.lines.title': 'Savdo satrlari',
  'pos.lines.product': 'Mahsulot',
  'pos.lines.qty': 'Miqdor',
  'pos.lines.price': 'Narx',
  'pos.lines.amount': 'Summa',
  'pos.lines.remove': 'O‘chirish',
  'pos.lines.empty': 'Satr yo‘q — mahsulot kodini tering yoki skanerlang',
  /*
   * Eski matn «Narx savdo yakunlanganda serverdan keladi» edi va u endi
   * YOLG‘ON: narx satr qo‘shilgan zahoti chiqadi. Yangi matn narx QAYERDAN
   * kelganini aytadi — sotuvchi uni «taxminiy» deb o‘ylamasligi kerak.
   */
  'pos.lines.priceList':
    'Narx — kompaniya prays ro‘yxatidan. Mijoz tanlanganda kelishilgan narx va shartnomaviy chegirma qo‘llanadi.',

  // --- Yakun ---
  'pos.total.title': 'Yakun',
  'pos.total.subtotal': 'Jami',
  'pos.total.discount': 'Chegirma',
  'pos.total.vat': 'QQS',
  'pos.total.payable': 'TO‘LOVGA',
  'pos.total.preview':
    'Bu OLDINDAN KO‘RISH. Yakuniy summani server hisoblaydi — narx va QQS hujjat yozilganda qotadi.',

  // --- Mijozning qarzi (ar.view) ---
  'pos.debt.current': 'Mijozning qarzi',
  'pos.debt.overdue': 'Muddati o‘tgan',
  'pos.debt.blocked': 'Mijoz BLOKLANGAN — savdo o‘tmaydi',
  'pos.debt.loadError': 'Qarzni yuklab bo‘lmadi',

  // --- Mijoz ---
  'pos.customer.title': 'Mijoz',
  'pos.customer.required': 'Mijozni tanlang',
  'pos.customer.new': 'Yangi mijoz',
  'pos.customer.newTitle': 'Tezkor mijoz',
  'pos.customer.name': 'Nomi',
  'pos.customer.phone': 'Telefon',
  'pos.customer.code': 'Kod',
  'pos.customer.codeHint':
    'Kod telefondan taklif qilindi — kerak bo‘lsa o‘zgartiring. Bir xil kod bilan ikkinchi karta ochilmaydi.',
  'pos.customer.create': 'Yaratish',
  'pos.customer.created': 'Mijoz yaratildi',

  // --- To'lov ---
  'pos.pay.title': 'To‘lov',
  'pos.pay.cash': 'Naqd',
  'pos.pay.card': 'Plastik',
  'pos.pay.transfer': 'O‘tkazma',
  'pos.pay.amount': 'Summa',
  'pos.pay.full': 'To‘liq',
  'pos.pay.fullHint':
    'Bo‘sh qoldiring — server to‘liq summani o‘zi hisoblaydi (kassa valyutasida, hujjat kursi bo‘yicha).',
  'pos.pay.partialWarning':
    'Summa kiritildi: qolgan qism MIJOZ QARZI bo‘lib qoladi va kredit limitidan o‘tishi kerak.',
  'pos.pay.reference': 'Chek / hujjat raqami',
  'pos.pay.noneWarning':
    'To‘lov tanlanmadi — butun summa QARZ bo‘lib yoziladi va kredit limitiga tushadi.',

  // --- Sotish ---
  'pos.sell': 'SOTISH',
  'pos.selling': 'Sotilmoqda…',
  'pos.reset': 'Tozalash',
  'pos.keyboardHint':
    'Klaviatura: kod maydoni doim fokusda · Enter — satr qo‘shish · Alt+S — sotish · Alt+N — yangi savdo',

  // --- Natija ---
  'pos.done.title': 'Savdo o‘tdi',
  'pos.done.duplicate': 'Bu savdo allaqachon yozilgan — takroriy bosish yangi hujjat ochmadi',
  'pos.done.order': 'Buyurtma',
  'pos.done.delivery': 'Yuk xati',
  'pos.done.invoice': 'Hisob-faktura',
  'pos.done.paid': 'To‘landi',
  'pos.done.debt': 'QARZ QOLDI',
  'pos.done.newSale': 'Yangi savdo',

  // --- Xatolar ---
  'pos.err.accountMissing':
    'Kassa hisobi sozlanmagan. Bu sozlamani administrator qo‘yadi — quyidagi xabarni unga ko‘rsating.',
  'pos.err.stock': 'Omborda tovar yetarli emas — savdo o‘tmadi',
  'pos.err.credit': 'Kredit limiti: to‘lanmagan qism limitdan oshdi',
  'pos.err.price': 'Narx topilmadi — mahsulot narx ro‘yxatida yo‘q',
  'pos.err.noLines': 'Kamida bitta satr kerak',

  // --- Mening kassam ---
  'cash.title': 'Mening kassam',
  'cash.subtitle': 'Bugun qancha va nima bilan yig‘ildi',
  'cash.date': 'Sana',
  'cash.total': 'Jami',
  'cash.saleCount': '{count} ta savdo',
  'cash.noSales': 'Bugun hali savdo yo‘q',
  'cash.method': 'Usul',
  'cash.amount': 'Summa',
  'cash.count': 'Soni',
  'cash.salesTitle': 'Bugungi savdolar',
  'cash.time': 'Vaqt',
  'cash.doc': 'Hujjat',
  'cash.customer': 'Mijoz',
  'cash.invoice': 'Hisob-faktura',
  'cash.debt': 'Qarz',
  'cash.baseHint':
    'Umumiy yig‘indi USD da: usullar turli valyutada bo‘lishi mumkin (naqd — so‘m, o‘tkazma — dollar) va ularni to‘g‘ridan-to‘g‘ri qo‘shib bo‘lmaydi.',
  // Matn YANGILANDI: kun yopish endi bor («Filial kassasi» bo‘limi), smena esa
  // umuman yo‘q — egasi «1 smena bo‘ladi» degani uchun birlik KUN qilib olindi.
  'cash.notShift':
    'Bu smena hisoboti EMAS — bizda smena yo‘q, birlik KUN. Kunni yopish va inkassatsiya alohida hujjat: «Filial kassasi» bo‘limida.',

  // --- Ta'minot bo'limining ish maydoni ---
  'nav.procurementWorkspace': 'Ta’minot ish maydoni',
  'proc.ws.title': 'Ta’minot bo‘limi',
  'proc.ws.subtitle':
    'Kun boshida ochiladigan bitta ekran: nima shoshilinch, zakazlar qayerda, qachon qancha to‘lash kerak.',
  'proc.ws.asOf': 'Holat sanasi: {date}',
  'proc.ws.recalculated':
    '{count} ta to‘lov muddati qayta hisoblandi — asos sanasi (jo‘natish yoki tayyor bo‘lish kuni) siljigan.',
  'proc.ws.loadError': 'Ish maydonini yuklab bo‘lmadi',
  'proc.ws.forbidden':
    'Bu ekran ta’minot va moliya bo‘limlari uchun: unda ta’minotchi narxlari va to‘lov shartlari ko‘rsatiladi.',

  // Diqqat bloki
  'proc.ws.attention': 'Diqqat talab qiladi',
  'proc.ws.attention.clear': 'Bugun shoshilinch ish yo‘q',
  'proc.ws.attention.clearHint':
    'Muddati o‘tgan to‘lov, kechikkan ishlab chiqarish va kechikkan konteyner yo‘q. Bo‘sh ro‘yxat — javobning o‘zi.',
  'proc.ws.kind.payment_overdue': 'Muddati o‘tgan to‘lovlar',
  'proc.ws.kind.payment_due_soon': 'Yaqin 3 kunda to‘lanadi',
  'proc.ws.kind.production_late': 'Tayyor bo‘lish kuni o‘tdi, hali tayyor emas',
  'proc.ws.kind.arrival_late': 'ETA o‘tdi, konteyner kelmadi',
  'proc.ws.countUnit': '{count} ta',

  // Zanjir
  'proc.ws.pipeline': 'Zakazlar holati',
  'proc.ws.pipelineHint':
    'Xitoydan omborgacha zanjir. Summa — USD ekvivalenti, hujjat kursi bo‘yicha.',

  // To'lov taqvimi
  'proc.ws.calendar': 'To‘lov taqvimi',
  'proc.ws.calendarHint':
    'Yaqin {days} kun. Guruhlash sana × ta’minotchi bo‘yicha: bitta o‘tkazma bitta zavodga ketadi.',
  'proc.ws.calendarEmpty': 'Yaqin {days} kunda to‘lov rejalashtirilmagan',
  'proc.ws.calendarTotal': 'Jami: {amount}',
  'proc.ws.dueDate': 'Muddat',
  'proc.ws.supplier': 'Ta’minotchi',
  'proc.ws.terms': 'Bosqich',
  'proc.ws.amount': 'Summa (USD)',

  // Muddati o'tganlar
  'proc.ws.overdue': 'Muddati o‘tgan to‘lovlar',
  'proc.ws.overdueDays': '{days} kun',
  'proc.ws.doc': 'Hujjat',

  // Ta'minotchi ishonchliligi
  'proc.ws.reliability': 'Ta’minotchi ko‘rsatkichi',
  'proc.ws.reliabilityHint':
    'Zavod aytgan kun (reja) bilan haqiqiy tayyor bo‘lgan kun farqi. Kema kechikishi bu yerga ARALASHMAYDI — u alohida o‘lchanadi.',
  'proc.ws.reliabilityEmpty':
    'Hali o‘lchov yo‘q: buyurtmalarda tayyor bo‘lish kuni (reja va fakt) kiritilmagan.',
  'proc.ws.measured': 'O‘lchangan',
  'proc.ws.avgDelay': 'O‘rtacha kechikish',
  'proc.ws.worstDelay': 'Eng yomoni',
  'proc.ws.lateNow': 'Hozir kechikkan',
  'proc.ws.days': '{days} kun',

  // Qayta zakaz
  'proc.ws.reorder': 'Qayta zakaz — eng shoshilinch 10 ta',
  'proc.ws.reorderHint':
    'Yetkazish sikli 120-150 kun: qaror tovar tugashidan to‘rt oy oldin qabul qilinadi.',
  'proc.ws.reorderEmpty': 'Hozircha shoshilinch buyurtma kerak emas',
  'proc.ws.reorderError': 'Qayta zakaz tahlilini yuklab bo‘lmadi',
  'proc.ws.sku': 'Kod',
  'proc.ws.product': 'Mahsulot',
  'proc.ws.onHand': 'Qoldiq',
  'proc.ws.daysOfCover': 'Yetadi (kun)',
  'proc.ws.suggested': 'Tavsiya',

  // --- To'lov jadvali (xarid buyurtmasi kartochkasida) ---
  'poTerms.title': 'To‘lov jadvali',
  'poTerms.hint':
    'Import bosqichma-bosqich to‘lanadi. Muddat SANAGA emas, HODISAGA bog‘lanadi: «jo‘natishdan 5 kun oldin» sharti jo‘natish sanasi siljiganda O‘ZI siljiydi.',
  'poTerms.empty': 'To‘lov jadvali kiritilmagan',
  'poTerms.emptyHint':
    'Jadvalsiz buyurtma to‘lov taqvimiga tushmaydi va qarzdorlik ogohlantirishi ham chiqmaydi.',
  'poTerms.loadError': 'To‘lov jadvalini yuklab bo‘lmadi',
  'poTerms.seq': '№',
  'poTerms.label': 'Bosqich',
  'poTerms.share': 'Ulush',
  'poTerms.amountBase': 'USD',
  'poTerms.basis': 'Asos',
  'poTerms.offset': 'Siljish',
  'poTerms.dueDate': 'Muddat',
  'poTerms.status': 'Holat',
  'poTerms.percentTotal': 'Jami ulush: {percent}',
  'poTerms.percentIncomplete':
    'Ulushlar jami 100% dan kam — jadval to‘liq emas va qolgan summa taqvimga tushmaydi.',
  'poTerms.undated':
    '{count} ta bosqich muddatsiz: asos sanasi hali noma’lum (konteyner yo‘q yoki tayyor bo‘lish kuni kiritilmagan). Sana TAXMIN QILINMAYDI.',
  'poTerms.recalculated':
    'Asos sanasi siljigan — {count} ta muddat qayta hisoblandi.',
  'poTerms.overdue': '{days} kun kechikdi',
  'poTerms.noDate': 'Muddat hali noma’lum',
  'poTerms.edit': 'Jadvalni o‘zgartirish',
  'poTerms.add': 'Bosqich qo‘shish',
  'poTerms.remove': 'O‘chirish',
  'poTerms.save': 'Jadvalni saqlash',
  'poTerms.saved': 'To‘lov jadvali saqlandi',
  'poTerms.saveError': 'Jadvalni saqlab bo‘lmadi',
  'poTerms.cancelEdit': 'Bekor qilish',
  'poTerms.percentPlaceholder': '30.00',
  'poTerms.labelPlaceholder': 'Avans 30%',
  'poTerms.offsetHint': 'Manfiy son — HODISADAN OLDIN (masalan −5)',
  'poTerms.preset': 'Namuna: 30% avans / 70% jo‘natishdan oldin',

  'poTerms.basis.order': 'Buyurtma sanasi',
  'poTerms.basis.ready': 'Tayyor bo‘lish kuni',
  'poTerms.basis.shipment': 'Jo‘natish',
  'poTerms.basis.arrival': 'Kelish',

  'poTerms.source.order_date': 'buyurtma sanasi',
  'poTerms.source.ready_date': 'tayyor bo‘lish REJASI',
  'poTerms.source.actual_ready_date': 'HAQIQIY tayyor bo‘lgan kun',
  'poTerms.source.shipment_etd': 'rejadagi jo‘natish (ETD)',
  'poTerms.source.shipment_atd': 'HAQIQIY jo‘natilish (ATD)',
  'poTerms.source.shipment_eta': 'rejadagi kelish (ETA)',
  'poTerms.source.shipment_ata': 'HAQIQIY kelish (ATA)',

  'poTerms.status.planned': 'Rejada',
  'poTerms.status.due': 'Muddati keldi',
  'poTerms.status.paid': 'To‘langan',
  'poTerms.status.cancelled': 'Bekor qilingan',
  'poTerms.notLedger':
    '«To‘langan» belgisi REJA holati — u daftarga provodka yozmaydi. Haqiqiy pul harakati moliya bo‘limida qayd etiladi.',

  // --- Tayyor bo'lish sanalari ---
  'poReady.title': 'Zavod tayyorlaydigan kun',
  'poReady.hint':
    'Bu KELISH kuni emas. Zavod 40 kunda tayyorlaydi, konteyner esa yana 90-110 kun yuradi. Ikkalasi alohida yuritilmasa, kechikish SABABI yo‘qoladi.',
  'poReady.plan': 'Reja',
  'poReady.actual': 'Fakt',
  /*
   * Sarlavha va QIYMAT alohida kalit.
   *
   * Avval sarlavha `t('poReady.delay', { days: '' })` dan olinardi va u
   * ekranda «Farq: kun» bo'lib chiqdi — jonli tekshiruvda ko'rindi.
   * Formatlangan matndan sarlavha yasash har doim shunday tugaydi.
   */
  'poReady.delayLabel': 'Reja va fakt farqi',
  'poReady.delay': 'Farq: {days} kun',
  'poReady.early': 'Erta tayyor bo‘ldi: {days} kun',
  'poReady.onTime': 'Rejada tayyor bo‘ldi',
  'poReady.pending': 'Hali tayyor emas',
  'poReady.late': 'Tayyor bo‘lish kuni {days} kun oldin o‘tgan',
  'poReady.save': 'Sanalarni saqlash',
  'poReady.saved': 'Sanalar saqlandi',
  'poReady.saveError': 'Sanalarni saqlab bo‘lmadi',
  'poReady.notSet': 'Kiritilmagan',

  // =========================================================================
  // KUN YOPISH va FILIAL XARAJATI (0028)
  //
  // ⚠️ `cash.*` prefiksi ATAYLAB ishlatilmadi: u allaqachon ikki xil ekranda
  // band (kassa kartotekasi va «Mening kassam»). Uchinchi ma'noni o'sha
  // prefiksga qo'shish kalitlarni bir-biriga aralashtirib yuborardi.
  // =========================================================================
  'nav.group.branchCash': 'Filial kassasi',
  'nav.dayClosing': 'Kun yopish',
  'nav.expenses': 'Filial xarajatlari',

  // --- Kun yopish ---
  'closing.account': 'Kassa',
  'closing.accountPick': 'Kassani tanlang…',
  'closing.date': 'Ish kuni',
  'closing.opening': 'Kun boshidagi qoldiq',
  'closing.cashIn': 'Bugungi kirim',
  'closing.cashOut': 'Bugungi chiqim',
  'closing.expected': 'Kutilgan qoldiq',
  'closing.counted': 'Sanalgan (fakt)',
  'closing.countedPlaceholder': 'Qo‘lda sanang',
  'closing.countedHint':
    'Sanalgan summani tizim to‘ldirmaydi va bu ataylab: kutilgan raqamni ko‘chirib qo‘ysangiz, yopish marosimga aylanadi va kamomad hech qachon topilmaydi.',
  'closing.difference': 'Farq',
  'closing.kind.match': 'Farq yo‘q',
  'closing.kind.shortage': 'KAMOMAD — kassada pul kam',
  'closing.kind.surplus': 'ORTIQCHA — kassada pul ko‘p',
  'closing.reason': 'Farq sababi',
  'closing.reasonPlaceholder': 'Nima uchun farq chiqdi?',
  'closing.reasonHint':
    'Kamida 5 belgi. Sababsiz farq «yaxlitladik» degan javobga aylanadi va bir necha oydan keyin hech kim qaysi kunda nima bo‘lganini ayta olmaydi.',
  'closing.notes': 'Izoh',
  'closing.countTitle': 'Pulni sanang',
  'closing.closeAction': 'Kunni yopish',
  'closing.noClosePerm': 'Sizda kun yopish huquqi yo‘q — faqat ko‘rish.',
  'closing.closedTitle': 'Kun yopilgan',
  'closing.reopenAction': 'Qayta ochish',
  'closing.reopenReason': 'Qayta ochish sababi',
  'closing.reopenHint':
    'Faqat rahbar va moliyachi qayta ochadi. Zanjir oxiridan boshlab ochiladi: o‘rtadagi kunni ochish keyingi kunlarning boshlang‘ich qoldig‘ini jimgina o‘zgartirardi.',
  'closing.previous': 'Oldingi yopilish',
  'closing.previousDiff': 'Qoplanmagan farq: {diff}',
  'closing.breakdown': 'Kun ichidagi harakatlar',
  'closing.direction': 'Yo‘nalish',
  'closing.item': 'DDS maqolasi',
  'closing.count': 'Soni',
  'closing.amount': 'Summa',
  'closing.in': 'Kirim',
  'closing.out': 'Chiqim',
  'closing.noMovements': 'Bu kunda kassa harakati bo‘lmagan.',
  'closing.status': 'Holat',
  'closing.status.open': 'Ochiq',
  'closing.status.closed': 'Yopilgan',
  'closing.status.reopened': 'Qayta ochilgan',
  'closing.history': 'Oxirgi yopilishlar',
  'closing.historyEmpty': 'Hali birorta kun yopilmagan.',
  'closing.noAccounts': 'Sizga biriktirilgan filial kassasi yo‘q',
  'closing.noAccountsHint':
    'Kun yopish filialga BOG‘LANGAN kassa uchun bajariladi. Kassani filialga biriktirish kerak (Sozlamalar → Kassa va bank) yoki sizga o‘sha filial ko‘lami berilishi kerak.',
  'closing.genericError': 'Amalni bajarib bo‘lmadi',
  'closing.notTransferHint':
    'Kun yopish — PUL KO‘CHIRISH EMAS, HISOB-KITOB. Yopilgandan keyin pul o‘sha filial kassasida qoladi. Markazga topshirish (inkassatsiya) alohida hujjat: Moliya → Hisoblararo o‘tkazma.',
  'closing.moneyStaysHint':
    'Pul markazga AVTOMAT ketmadi — u shu kassada qoldi. Markazga topshirganingizda hisoblararo o‘tkazma yozing.',
  'closing.driftTitle': 'Zanjir uzilgan',
  'closing.driftHint':
    'Kutilgan qoldiq kassa daftaridagi yig‘indiga mos kelmayapti (farq {drift}). Bu odatda yopilgan kunga orqaga qarab yozuv kirganidan bo‘ladi. Moliyachiga murojaat qiling — yopishdan oldin sabab topilishi kerak.',

  // --- Filial xarajati ---
  'expense.intro':
    'Filial o‘z kassasidan qilgan xarajatlar. Qoralama pulni harakatlantirmaydi — pul faqat POST qilinganda kassadan chiqadi.',
  'expense.new': 'Yangi xarajat',
  'expense.saveDraft': 'Qoralamani saqlash',
  'expense.draftHint': 'Saqlangandan keyin pul hali chiqmaydi: post qilinishi kerak.',
  'expense.docNo': 'Hujjat',
  'expense.date': 'Sana',
  'expense.branch': 'Filial',
  'expense.account': 'Kassa',
  'expense.accountPick': 'Kassani tanlang…',
  'expense.item': 'Xarajat turi (DDS)',
  'expense.itemPick': 'Maqolani tanlang…',
  'expense.amount': 'Summa',
  'expense.payee': 'Kimga to‘landi',
  'expense.documentRef': 'Chek/kvitansiya',
  'expense.description': 'Izoh',
  'expense.descriptionPlaceholder': 'Masalan: Avgust oyi uchun do‘kon ijarasi',
  'expense.descriptionHint':
    'Kamida 5 belgi. DDS maqolasi turkumni beradi («Ijara»), izoh esa aniq faktni — «xarajat 500 000» degan yozuv oy oxirida hech narsani tushuntirmaydi.',
  'expense.status': 'Holat',
  'expense.statusAll': 'Hammasi',
  'expense.status.draft': 'Qoralama',
  'expense.status.posted': 'Post qilingan',
  'expense.status.cancelled': 'Bekor qilingan',
  'expense.post': 'Post qilish',
  'expense.awaitingPost': 'Post qilishni kutmoqda',
  'expense.cancelAction': 'Bekor qilish',
  'expense.cancelReason': 'Bekor qilish sababi',
  'expense.confirm': 'Tasdiqlash',
  'expense.actions': 'Amallar',
  'expense.empty': 'Xarajat topilmadi.',
  'expense.noAccounts':
    'Sizga biriktirilgan filial kassasi yo‘q. Xarajat faqat FILIAL kassasidan yoziladi.',
  'expense.noItems':
    'Xarajat maqolalari topilmadi. Moliyachi DDS daraxtida chiqim maqolalarini sozlashi kerak (Moliya → Pul oqimi maqolalari).',
  'expense.genericError': 'Amalni bajarib bo‘lmadi',

  // =========================================================================
  // DAVR OXIRIDAGI QAYTA BAHOLASH (kurs farqi)
  //
  // ⚠️ `fx.*` prefiksi ATAYLAB ishlatilmadi: u kunlik kurs vidjeti va kurslar
  // ekranida band. Qayta baholash boshqa narsa — u DAFTARGA yozadi, kurs esa
  // shunchaki ma'lumotnoma. Ikkalasini bir prefiksga solish «kursni
  // o'zgartirsam qayta baholash ham o'zgaradimi?» degan savolni tug'dirardi.
  // =========================================================================
  'nav.fxRevaluation': 'Qayta baholash (kurs farqi)',

  'fxreval.intro':
    'Davr oxirida valyutadagi qoldiqlar (kassa, bank, mijoz qarzi, ta’minotchiga qarz) yopilish kursi bo‘yicha qayta hisoblanadi. Avval HISOBLANG va satrlarni tekshiring — daftarga yozish alohida qadam.',
  'fxreval.legalEntity': 'Yuridik shaxs',
  'fxreval.pickEntity': 'Yuridik shaxsni tanlang.',
  'fxreval.currency': 'Valyuta',
  'fxreval.currencyHint':
    '{base} ro‘yxatda yo‘q: u baza valyuta va uni o‘ziga o‘tkazish har doim nol farq beradi.',
  'fxreval.date': 'Sana',
  'fxreval.dateHint': 'Odatda oyning oxirgi kuni. Shu sanadagi yopilish kursi olinadi.',
  'fxreval.previewAction': 'Hisoblash (ko‘rish)',
  'fxreval.staleHint':
    'Tanlov o‘zgardi — quyidagi raqamlar ESKI. «Hisoblash» tugmasini qayta bosing.',

  'fxreval.closingRate': 'Yopilish kursi',
  'fxreval.gain': 'Kurs farqi foydasi',
  'fxreval.loss': 'Kurs farqi zarari',
  'fxreval.net': 'Sof natija',
  'fxreval.netGain': 'FOYDA — baza valyutada qoldiq qimmatlashdi',
  'fxreval.netLoss': 'ZARAR — baza valyutada qoldiq arzonlashdi',
  'fxreval.netZero': 'Farq yo‘q',

  'fxreval.warningsTitle': 'Bu qoldiqlar qayta baholanmadi',
  'fxreval.existingTitle': 'Bu sanaga qayta baholash ALLAQACHON bor',
  'fxreval.existingHint':
    '{date} sanasiga yozuv mavjud (holati: {status}, sof natija: {net}). Yangisini yozishdan oldin eskisini teskarilang — aks holda bitta kurs farqi daftarga ikki marta tushadi.',

  'fxreval.linesTitle': 'Qayta baholanadigan qoldiqlar',
  'fxreval.role': 'Turi',
  'fxreval.role.cash': 'Kassa',
  'fxreval.role.bank': 'Bank',
  'fxreval.role.ar': 'Mijoz qarzi',
  'fxreval.role.ap': 'Ta’minotchiga qarz',
  'fxreval.account': 'Hisob',
  'fxreval.subject': 'Nima qayta baholandi',
  'fxreval.foreignAmount': 'Valyutadagi qoldiq',
  'fxreval.previousBase': 'Oldingi baza',
  'fxreval.newBase': 'Yangi baza',
  'fxreval.differenceBase': 'FARQ',
  'fxreval.noLines':
    'Bu valyutada qayta baholanadigan qoldiq topilmadi — farq ham, provodka ham bo‘lmaydi.',

  'fxreval.postTitle': 'Daftarga yozish',
  'fxreval.postHint':
    'Yozilgandan keyin summa shu oyning foyda-zarar hisobotiga tushadi. Xato bo‘lsa uni o‘chirib bo‘lmaydi — faqat sabab bilan teskarilash mumkin.',
  'fxreval.postAction': 'Daftarga yozish',
  'fxreval.postAgainAction': 'Bu sanaga yozuv bor — baribir yozish',
  'fxreval.notes': 'Izoh',
  'fxreval.notesPlaceholder': 'Masalan: avgust oyi yopilishi',
  'fxreval.noRunPerm': 'Sizda daftarga yozish huquqi yo‘q — faqat ko‘rish.',

  'fxreval.resultTitle': 'Yozildi',
  'fxreval.journal': 'Provodka',
  'fxreval.journalWritten': 'Provodka daftarga yozildi',
  'fxreval.journalLine': 'Hujjat {docNo}, holati: {status}',
  'fxreval.journalPendingTitle': 'Qayta baholash saqlandi, provodka navbatda',
  'fxreval.journalPendingHint':
    'Bu XATO EMAS. Provodkani tizim navbat orqali yozadi va u odatda bir necha soniya oladi. Tugmani qayta bosmang — sahifani yangilab ko‘ring, hujjat raqami tarixda paydo bo‘ladi.',
  'fxreval.journalPendingShort': 'Navbatda',

  'fxreval.status': 'Holat',
  'fxreval.status.draft': 'Qoralama',
  'fxreval.status.posted': 'Yozilgan',
  'fxreval.status.reversed': 'Teskarilangan',
  'fxreval.actions': 'Amallar',
  'fxreval.history': 'Oldingi qayta baholashlar',
  'fxreval.historyEmpty': 'Hali birorta qayta baholash bajarilmagan.',

  'fxreval.reverseAction': 'Teskarilash',
  'fxreval.reverseReason': 'Teskarilash sababi',
  'fxreval.reverseReasonPlaceholder': 'Nima uchun teskarilanmoqda?',
  'fxreval.reverseHint':
    'Kamida 3 belgi. Teskarilash yopilgan davr raqamini o‘zgartiradi va ko‘pincha «hisobot chiroyli chiqmadi» degan bosim ostida bosiladi — sabab bir necha oydan keyin ham o‘qiladigan bo‘lsin.',
  'fxreval.genericError': 'Amalni bajarib bo‘lmadi',

  // =========================================================================
  // YUQORI PANELDAGI IXCHAM KURS CHIPI
  //
  // Egasi: «tepada kurs turibdi — u katta, uzun yozuv. Oddiy `$ 12 800`
  // yetadi». Shuning uchun ekranda faqat raqam qoladi, tushuntirish esa
  // `title` ga o‘tadi: u kerak bo‘lganda chiqadi va joy egallamaydi.
  //
  // Mavjud `fx.missing` / `fx.rateLine` kalitlari O‘CHIRILMADI — ular kurslar
  // ekranida va boshqa joylarda to‘liq gap sifatida kerak. Chip uchun esa
  // ALOHIDA, qisqa variant kerak: 30 belgili gap 100 px li chipga sig‘maydi.
  // =========================================================================
  'fx.missingShort': 'Kurs yo‘q',
  'fx.chipTitle': 'Kunlik kurs: 1 USD = {rate} so‘m ({date})',
  'fx.cnyHint':
    '¥ faqat xarid uchun — Xitoydan konteyner kelganda. U kunlik emas, shuning uchun yuqori panelda ko‘rsatilmaydi.',

  // =========================================================================
  // BOSH SAHIFA — SALOM BLOKI VA KO‘RSATKICH PLITKALARI
  //
  // Egasi: «kirganda biznes holati ko‘rinib, zamonaviy, ruhiyat ko‘taradigan,
  // motivatsiya beradigan bo‘lsin».
  //
  // Shuning uchun bu yerdagi matnlar HISOBOT tili emas: «Bugun 12 ta savdo,
  // $4 200 tushum» — gap, «Savdo: 4200» — jadval katagi. Mavjud
  // `dashboard.*` kalitlari O‘CHIRILMADI: ular plitka SARLAVHALARI bo‘lib
  // qolaveradi va boshqa ekranlarda ham ishlatiladi.
  //
  // Salom kalitlari `{name}` bilan: ism `AuthUser.fullName` dan olinadi
  // (`components/dashboard/greeting.ts`), tarjimon esa uni gap ichida
  // qayerga qo‘yishni o‘zi hal qiladi — rus tilida tartib boshqacha.
  // =========================================================================
  'dashboard.hero.morning': 'Xayrli tong, {name}',
  'dashboard.hero.day': 'Xayrli kun, {name}',
  'dashboard.hero.evening': 'Xayrli kech, {name}',
  'dashboard.hero.night': 'Xayrli tun, {name}',

  // ISMSIZ variant — hisob nomidan ism chiqmaganda.
  //
  // «Xayrli kech, Tizim» degan salom ekranda aynan shu tariqa turardi:
  // hisobning nomi «Tizim administratori» edi. Bo‘sh {name} bilan
  // ishlatish esa «Xayrli kech, » degan osilgan vergul berardi —
  // shuning uchun matn ALOHIDA, vergulsiz.
  'dashboard.hero.morningPlain': 'Xayrli tong',
  'dashboard.hero.dayPlain': 'Xayrli kun',
  'dashboard.hero.eveningPlain': 'Xayrli kech',
  'dashboard.hero.nightPlain': 'Xayrli tun',

  'dashboard.hero.weekday.sun': 'Yakshanba',
  'dashboard.hero.weekday.mon': 'Dushanba',
  'dashboard.hero.weekday.tue': 'Seshanba',
  'dashboard.hero.weekday.wed': 'Chorshanba',
  'dashboard.hero.weekday.thu': 'Payshanba',
  'dashboard.hero.weekday.fri': 'Juma',
  'dashboard.hero.weekday.sat': 'Shanba',

  // Summa gapdan OLIB TASHLANDI: u yonginasidagi «Bugun» raqamida turadi
  // va tasmada bitta raqam ikki marta o‘qilardi.
  'dashboard.hero.sales': 'Bugun {lines} ta savdo satri.',
  'dashboard.hero.noSalesYet': 'Bugun hali sotuv yo‘q — kun endi boshlanmoqda.',
  'dashboard.hero.trendUp': 'Shu oy o‘tgan oyning shu kunigacha bo‘lgan davridan yuqori.',
  'dashboard.hero.trendDown': 'Shu oy o‘tgan oyning shu kunigacha bo‘lgan davridan past.',
  'dashboard.hero.trendFlat': 'Shu oy o‘tgan oyning shu kunigacha bo‘lgan davri bilan teng.',
  'dashboard.hero.tasks': 'Diqqatingizni kutayotgan {count} ta ish bor.',
  'dashboard.hero.allClear': 'Diqqat talab qiladigan ish yo‘q — hammasi joyida.',
  'dashboard.hero.plain': 'Ish kuningiz barakali o‘tsin.',
  // Xato holati ALOHIDA: ma'lumot kelmaganda «bugun sotuv yo‘q» deb yozish —
  // yolg‘on. Ikkalasi tashqaridan bir xil ko‘rinadi, oqibati esa boshqacha.
  'dashboard.hero.dataError': 'Ba’zi ko‘rsatkichlar yuklanmadi — sabab quyidagi bo‘limlarda.',
  'dashboard.hero.today': 'Bugun',
  'dashboard.hero.thisMonth': 'Shu oy',

  'dashboard.kpi.salesToday': 'Bugungi savdo',
  'dashboard.kpi.salesTodayHint': '{count} ta savdo satri',
  'dashboard.kpi.revenueMonth': 'Shu oy tushumi',
  'dashboard.kpi.overdue': 'Muddati o‘tgan qarz',
  'dashboard.kpi.overdueHint': 'Jami qarz: {amount}',
  'dashboard.kpi.cashHint': 'Kirim {in} · chiqim {out}',
  'dashboard.kpi.tasksHint': 'Ko‘chirish {transfers} · sanoq {counts}',
  'dashboard.kpi.tasksNone': 'Yopilmagan ish yo‘q',

  'dashboard.attention.allClearTitle': 'Hammasi joyida',
  'dashboard.attention.allClearBody':
    'Kechikkan qarz ham, qabul qilinmagan hujjat ham yo‘q. Bugun tinch ishlashingiz mumkin.',

  'dashboard.section.ranking': 'Kim va nima olib kelyapti',
  'dashboard.section.rankingHint': 'Shu oy tushumi bo‘yicha, birinchi beshtasi',
  'dashboard.section.ar': 'Qarz nazorati',
  'dashboard.section.arHint': 'Muddati o‘tgan qarzi bor mijozlar, eng kattasidan',
  'dashboard.section.stock': 'Ombor qiymati',
  'dashboard.section.stockHint': 'Har bir ombor bo‘yicha, landed cost hisobida',

  'dashboard.arRowHint': 'Jami qarzi: {amount}',
  'dashboard.arNoOverdue': 'Muddati o‘tgan qarz yo‘q',
  'dashboard.arNoOverdueHint':
    'Barcha hisob-fakturalar muddati ichida. Bugun qarz uchun qo‘ng‘iroq qilish shart emas.',
  'dashboard.stockEmpty': 'Ombor qiymati hisoblanmadi',
  'dashboard.stockEmptyHint':
    'Qoldiq bor omborlar ko‘rinadi. Ro‘yxat bo‘sh bo‘lsa — hali birorta qabul post qilinmagan.',
  'dashboard.emptySales': 'Shu oyda hali sotuv yo‘q',
  'dashboard.emptySalesHint':
    'Raqamlar yuk xati POST qilinganda paydo bo‘ladi — buyurtmaning o‘zi hisobotga tushmaydi.',

  // --- Xarajatni teskarilash (storno) ---
  'expense.reverseAction': 'Teskarilash',
  'expense.reverseTitle': '{docNo} ni teskarilash',
  'expense.reverseHint':
    'Xarajat O‘CHIRILMAYDI — teskari (storno) hujjat yaratiladi va ikkalasi ro‘yxatda qoladi. {amount} «{account}» kassasiga QAYTADI, ya’ni kunning kutilgan qoldig‘i shu summaga ko‘tariladi. Asl hujjat esa «bekor qilingan» holatga o‘tadi.',
  'expense.reverseReason': 'Teskarilash sababi',
  'expense.reverseReasonPlaceholder':
    'Masalan: ijara ikki marta yozilgan; summa 500 000 emas, 50 000 edi',
  'expense.reverseReasonHint':
    'Nima xato bo‘lganini yozing — kamida {min} belgi. Storno kassaga pulni QAYTARADI va kutilgan qoldiqni ko‘taradi: sababsiz bunday yozuv kassadagi ortiqcha pulni jimgina yopib qo‘yadigan vositaga aylanadi. Sabab auditda qoladi.',
  'expense.reverseSubmit': 'Ha, teskarilansin',
  'expense.reverseDone': 'Teskarilandi',
  'expense.reverseDoneHint':
    '{docNo} bekor qilindi va uning o‘rniga storno hujjati yaratildi. Asl hujjat tarixda qoladi — kecha chop etilgan kassa hisoboti bugun ham o‘zgarmaydi.',
  'expense.reverseReturned': 'Kassaga qaytdi',
  'expense.reverseReturnedHint': '«{account}» hisobiga, kirim harakati bilan',
  'expense.reverseCashAfter': 'Kassa qoldig‘i',
  'expense.reverseCashBefore': 'Storno oldidan: {amount}',
  'expense.reverseOriginal': 'Bekor qilingan hujjat',
  'expense.reverseOriginalHint': 'Ro‘yxatda qoladi, o‘chirilmaydi',
  'expense.reversalRow': 'Storno',
  'expense.reversedRow': 'Teskarilangan',

  // --- Bonus to'lovini teskarilash (storno) ---
  'bnl.actions': 'Amallar',
  'bnl.reverseAction': 'Teskarilash',
  'bnl.reverseTitle': '{docNo} ni teskarilash',
  'bnl.reverseHint':
    'To‘lov O‘CHIRILMAYDI — daftarga teskari (storno) satr qo‘shiladi va ikkalasi ko‘rinib turadi. {amount} kassaga QAYTADI, bonus qoldig‘i esa to‘lovdan oldingi holatiga tiklanadi.',
  'bnl.reverseHintInstaller':
    'To‘lov O‘CHIRILMAYDI — daftarga teskari (storno) satr qo‘shiladi va ikkalasi ko‘rinib turadi. IKKI narsa qaytadi: {amount} kassaga va {points} ball ustaning hisobiga. Ball qaytgach, usta uni qaytadan naqdga chiqarishi yoki sovg‘aga almashtirishi mumkin — shuning uchun bu amal bonusni «bekor qilish» emas, uni TO‘LANMAGAN holatiga qaytarish.',
  'bnl.reverseReason': 'Teskarilash sababi',
  'bnl.reverseReasonPlaceholder':
    'Masalan: usta o‘rniga boshqa odam tanlangan; ball soni noto‘g‘ri kiritilgan',
  'bnl.reverseReasonHint':
    'Nima xato bo‘lganini yozing — kamida {min} belgi. Storno kassaga pulni QAYTARADI va kutilgan qoldiqni ko‘taradi: sababsiz bunday yozuv kassadagi ortiqcha pulni jimgina yopib qo‘yadigan vositaga aylanadi. Sabab auditda qoladi.',
  'bnl.reverseSubmit': 'Ha, teskarilansin',
  'bnl.reverseDone': 'Teskarilandi',
  'bnl.reverseDoneHint':
    '{docNo} teskarilandi va uning o‘rniga storno satri yozildi. Asl satr daftarda qoladi — kecha chop etilgan hisobot bugun ham o‘zgarmaydi.',
  'bnl.reverseReturned': 'Kassaga qaytdi',
  'bnl.reverseReturnedHint': 'Kirim harakati bilan, asl to‘lov sanasiga',
  'bnl.reverseCashAfter': 'Kassa qoldig‘i',
  'bnl.reverseCashBefore': 'Storno oldidan: {amount}',
  'bnl.reversePoints': 'Ustaga ball qaytdi',
  'bnl.reversePointsHint': 'Balans tiklandi — ball qaytadan ishlatilishi mumkin',
  'bnl.reverseOriginal': 'Teskarilangan hujjat',
  'bnl.reverseOriginalHint': 'Daftarda qoladi, o‘chirilmaydi',

  // --- Filial filtri (yuqori paneldagi tanlov ro'yxatga qo'llanganda) ---
  'branchFilter.active': 'Filial: {branch}',
  'branchFilter.clear': 'Filtrni olib tashlash',
  'branchFilter.hint': 'Ro‘yxat yuqorida tanlangan filial bo‘yicha toraytirilgan.',
  'branchFilter.cleared': 'Barcha filiallar ko‘rsatilmoqda.',
  'branchFilter.restore': 'Faqat «{branch}» ni ko‘rsatish',

  // --- Diller rebate pog'onalari (narvon) ---
  'rebate.column': 'Rebate',
  'rebate.toggle': 'Pog‘onalar',
  'rebate.toggleClose': 'Yopish',
  'rebate.title': '{dealer} — yillik rebate pog‘onalari',
  'rebate.what':
    'Yil yakunida dillerga qaytariladigan foiz shu narvondan olinadi: yillik hajm qaysi pog‘ona summasidan katta yoki teng bo‘lsa, o‘sha pog‘onaning foizi qo‘llanadi.',
  'rebate.year': 'Yil',
  'rebate.loadError': 'Pog‘onalarni yuklab bo‘lmadi',
  'rebate.emptyTitle': '{year} yil uchun pog‘ona qo‘yilmagan',
  'rebate.emptyBody':
    'Pog‘ona narvoni — «qancha olsa, qancha qaytadi» degan shartnoma qoidasi: masalan 0 dan 1%, 1 000 dan 3%, 50 000 dan 5%. Narvonsiz bonus hisoblanmaydi — server mos pog‘ona topa olmay hisoblashni rad etadi. Birinchi pog‘onani quyidagi formadan qo‘ying.',
  'rebate.rungFrom': 'shu summadan boshlab',
  'rebate.rungUntil': 'keyingi pog‘ona:',
  'rebate.rungTop': 'yuqori chegara yo‘q — eng yuqori pog‘ona',
  'rebate.inactive': 'O‘chirilgan',
  'rebate.noZeroTitle': 'Narvon noldan boshlanmaydi',
  'rebate.noZeroBody':
    'Eng past pog‘ona {amount} dan boshlanadi. Yillik hajmi shundan kam diller HECH QANDAY pog‘onaga tushmaydi va bonus hisoblash rad etiladi. Agar bu ataylab bo‘lsa — hech narsa qilish shart emas; aks holda 0 dan boshlanadigan pog‘ona qo‘shing.',
  'rebate.turnoverUnknown':
    'Dillerning joriy hajmi bu yerda ko‘rsatilmaydi: uni server bonus hisoblash paytida hisob-fakturalardan o‘zi hisoblaydi va alohida bermaydi. Ya’ni narvon SHART, hajm esa yil yakunidagi FAKT.',
  'rebate.addTitle': 'Pog‘ona qo‘shish yoki foizini o‘zgartirish',
  'rebate.upsertHint':
    'Mavjud summa qayta kiritilsa — o‘sha pog‘onaning foizi YANGILANADI, ikkinchi nusxa paydo bo‘lmaydi.',
  'rebate.fromAmount': 'Qaysi summadan',
  'rebate.fromAmountHint':
    'Bazaviy valyutada ({currency}). Chegara qo‘shib olinadi: aynan shu summa ham shu pog‘onaga kiradi.',
  'rebate.pct': 'Rebate foizi',
  'rebate.pctHint': '0 dan 100 gacha, 2 tagacha kasr. Nol ham mumkin — «bu pog‘onada bonus yo‘q».',
  'rebate.fromAmountInvalid': 'Summa manfiy bo‘lmagan son bo‘lishi kerak, 4 tagacha kasr xona',
  'rebate.pctInvalid': 'Foiz 0 dan 100 gacha, 2 tagacha kasr xona',
  'rebate.save': 'Pog‘onani saqlash',
  'rebate.saved': 'Saqlandi: {amount} dan boshlab {pct}',
  'rebate.frozenHint':
    'Pog‘onani o‘zgartirish ALLAQACHON hisoblangan bonusga tegmaydi — daftardagi foiz muzlatilgan nusxa va o‘tgan hisoblar qayta yozilmaydi.',
  'rebate.noManage':
    'Rebate pog‘onasini o‘zgartirish huquqi sizda yo‘q — u moliyachi va administratorda. Ko‘rish esa hammaga ochiq.',

  // --- Mijozning shartnoma sharti (chegirma + muddat) ---
  'customer.contract.title': 'Shartnoma sharti',
  'customer.contract.discount': 'Shartnoma chegirmasi',
  'customer.contract.discountHint': '0 dan 100 gacha, 2 tagacha kasr. Bo‘sh qoldirilsa — tegilmaydi.',
  'customer.contract.no': 'Shartnoma raqami',
  'customer.contract.noHint': 'Qog‘ozdagi raqam bilan AYNAN bir xil bo‘lsin.',
  'customer.contract.from': 'Amal qiladi',
  'customer.contract.to': 'Amal qilish tugaydi',
  'customer.contract.toHint': 'Shu sanadan keyin chegirma qo‘llanmaydi.',
  'customer.contract.period': 'Amal qilish muddati',
  'customer.contract.status': 'Holat',
  'customer.contract.statusNone': 'Muddat ko‘rsatilmagan',
  'customer.contract.statusOpen': 'Muddat yarim ochiq',
  'customer.contract.statusActive': 'Amalda',
  'customer.contract.statusExpired': 'Muddati tugagan',
  'customer.contract.statusFuture': 'Hali kuchga kirmagan',
  'customer.contract.noDiscount': 'Chegirma yo‘q',
  'customer.contract.noDiscountHint': 'Narx umumiy narxnoma bo‘yicha hisoblanadi.',
  'customer.contract.appliedHint': 'Har bir satrga standart chegirma sifatida taklif qilinadi.',
  'customer.contract.notApplied': 'QO‘LLANMAYDI — shartnoma muddati tugagan',
  'customer.contract.expiredTitle': 'Shartnoma muddati tugagan — chegirma kuchda emas',
  'customer.contract.expiredBody':
    'Muddat {date} da tugagan. Quyidagi foiz TARIX sifatida ko‘rsatilmoqda va uni narx taklifiga qo‘yish mumkin emas: mijoz aytilgan narxni yozib oladi, keyin esa yo chegirma zarar bilan beriladi, yo kelishuv buziladi. Shartnoma uzaytirilgan bo‘lsa — yangi sanani kiriting.',
  'customer.contract.futureTitle': 'Shartnoma hali kuchga kirmagan',
  'customer.contract.futureBody':
    'Chegirma {date} dan boshlab qo‘llanadi. Bugungi savdoga u tegishli emas.',
  'customer.contract.openTitle': 'Shartnoma muddati yarim ochiq',
  'customer.contract.openBody':
    'Boshlanish yoki tugash sanasi ko‘rsatilmagan, ya’ni chegirma muddatsiz ishlayveradi. Bu ONGLI qaror bo‘lishi kerak — aks holda ikkala sanani ham to‘ldiring.',
  'customer.contract.pendingTitle': 'Shartnoma maydonlari hali tayyor emas',
  'customer.contract.pendingBody':
    'Chegirma, shartnoma raqami va muddati bu ekranda hali mavjud emas. Ular tayyor bo‘lgach bu bo‘lim o‘zi to‘ladi va tahrirlash formasi ochiladi — ekranda boshqa hech narsa o‘zgarmaydi.',
  'customer.contract.edit': 'Shartnoma shartini o‘zgartirish',
  'customer.contract.editHint':
    'Chegirma — shartnoma sharti, kayfiyat emas: u har bir savdo satriga tushadi va yillik hajmda sezilarli summaga aylanadi. Sanasiz chegirma esa hech qachon tugamaydi.',
  'customer.contract.saved': 'Shartnoma sharti saqlandi',
  'customer.contract.noChanges': 'Hech narsa o‘zgarmadi',
  'customer.contract.pctInvalid': 'Chegirma 0 dan 100 gacha, 2 tagacha kasr xona',
  'customer.contract.dateInvalid': 'Sana 2026-08-13 ko‘rinishida bo‘lishi kerak',
  'customer.contract.rangeInvalid': 'Tugash sanasi boshlanish sanasidan oldin bo‘lolmaydi',
  'customer.contract.noPermission':
    'Mijozning kredit shartini o‘zgartirish huquqi sizda yo‘q. Kerak bo‘lsa rahbaringizga murojaat qiling.',
  'nav.employees': 'Xodimlar',
  'hr.employees.title': 'Xodimlar',
  'hr.employees.total': 'Jami xodim',
  'hr.employees.active': 'Ishlayotgan',
  'hr.employees.expiredContracts': 'Muddati o‘tgan shartnoma',
  'hr.employees.expiredHint': 'Xodim rasman himoyasiz',
  'hr.employees.searchHint': 'Ism, tabel raqami yoki lavozim',
  'hr.employees.emptyTitle': 'Xodim yo‘q',
  'hr.employees.emptyBody': 'Filtrni tozalang yoki yangi xodim qo‘shing.',
  'hr.employees.no': 'Tabel',
  'hr.employees.name': 'Ism-familiya',
  'hr.employees.position': 'Lavozim',
  'hr.employees.branch': 'Filial',
  'hr.employees.contract': 'Shartnoma',
  'hr.employees.salary': 'Oylik stavka',
  'hr.employees.salaryHint': 'shartnomadagi summa',
  'hr.employees.central': 'Markaziy',
  'hr.employees.card': 'Karta',
  'hr.employees.new': 'Yangi xodim',
  'hr.employees.hiredAt': 'Ishga kirgan sana',
  'hr.employees.statusCol': 'Holat',
  'hr.employees.all': 'Hammasi',
  'hr.status.active': 'Ishlayapti',
  'hr.status.suspended': 'To‘xtatilgan',
  'hr.status.fired': 'Bo‘shatilgan',
  'hr.contract.none': 'Yo‘q',
  'hr.contract.open': 'Muddatsiz',
  'hr.contract.active': 'Amalda',
  'hr.contract.future': 'Hali boshlanmagan',
  'hr.contract.expired': 'Muddati o‘tgan',
  'hr.contract.expiredTitle': 'Shartnoma muddati o‘tgan',
  'hr.contract.expiredBody': 'Xodim shartnomasiz ishlayapti. Tugagan sana:',
  'hr.duties.duties': 'Vazifalar',
  'hr.duties.dutiesHint': 'Har kuni nima qiladi — KPI ga aylanadi',
  'hr.duties.obligations': 'Shartnoma majburiyatlari',
  'hr.duties.obligationsHint': 'Nimaga qo‘l qo‘ygan — nizoda dalil',
  'hr.duties.empty': 'Hali kiritilmagan',
  'hr.duties.add': 'Vazifa yoki majburiyat qo‘shish',
  'hr.duties.kind': 'Turi',
  'hr.duties.titleField': 'Sarlavha',
  'hr.duties.titleHint': 'masalan: kassani har kuni yopish',
  'hr.duties.kpiLinked': 'KPI rejasiga bog‘langan:',
  'hr.fire.title': 'Ishdan bo‘shatish',
  'hr.fire.hint': 'Sana oylik hisoblashning asosi — usiz xodim jimgina hisoblanaveradi.',
  'hr.fire.date': 'Bo‘shatish sanasi',
  'hr.fire.reason': 'Sabab',
  'hr.fire.reasonShort': 'Kamida 5 belgi',
  'hr.fire.submit': 'Bo‘shatish',
  'nav.payroll': 'Oylik va avans',
  'hr.payroll.title': 'Oylik, avans va qarzdorlik',
  'hr.payroll.runs': 'Oylik hisoblari',
  'hr.payroll.run': 'Oylikni hisoblash',
  'hr.payroll.runHint': 'Xarajat yoziladi, pul CHIQMAYDI — to\'lov alohida.',
  'hr.payroll.period': 'Davr',
  'hr.payroll.year': 'Yil',
  'hr.payroll.month': 'Oy',
  'hr.payroll.gross': 'Hisoblangan',
  'hr.payroll.advance': 'Avans',
  'hr.payroll.deduction': 'Ushlangan',
  'hr.payroll.net': 'Qo\'lga',
  'hr.payroll.pay': 'To\'lash',
  'hr.payroll.payConfirm': 'Tasdiqlayman — pul chiqsin',
  'hr.payroll.chooseAccount': 'Kassani tanlang',
  'hr.payroll.account': 'Kassa',
  'hr.payroll.amount': 'Summa',
  'hr.payroll.noRuns': 'Hali oylik hisoblanmagan',
  'hr.payroll.noRunsBody': 'Davrni tanlab, «Oylikni hisoblash» tugmasini bosing.',
  'hr.payroll.advances': 'Avanslar',
  'hr.payroll.advancesHint': 'Oy o\'rtasida berilgan pul — oylikda yopiladi',
  'hr.payroll.noAdvances': 'Avans berilmagan',
  'hr.payroll.giveAdvance': 'Avans berish',
  'hr.payroll.openAdvances': 'Yopilmagan avans',
  'hr.payroll.openAdvancesHint': 'keyingi oylikda ushlanadi',
  'hr.payroll.debts': 'Qarzdorliklar',
  'hr.payroll.debtsHint': 'Kamomad, buzilgan tovar, berilgan qarz pul',
  'hr.payroll.noDebts': 'Qarzdorlik yo\'q',
  'hr.payroll.addDebt': 'Qarz yozish',
  'hr.payroll.openDebts': 'Ochiq qarz',
  'hr.payroll.openDebtsHint': 'oylikdan ushlanadi',
  'hr.payroll.doc': 'Hujjat',
  'hr.payroll.source': 'Manba',
  'hr.payroll.sourceHint': 'provodkani ham belgilaydi',
  'hr.payroll.balance': 'Qoldiq',
  'hr.payroll.advance.posted': 'Yopilmagan',
  'hr.payroll.advance.settled': 'Yopilgan',
  'hr.payroll.advance.reversed': 'Teskarilangan',
  'hr.debt.shortfall': 'Kassa kamomadi',
  'hr.debt.damage': 'Buzilgan tovar',
  'hr.debt.loan': 'Berilgan qarz pul',
  'hr.debt.other': 'Boshqa',
  'hr.debt.status.open': 'Ochiq',
  'hr.debt.status.settled': 'Yopilgan',
  'hr.debt.status.written_off': 'Hisobdan chiqarilgan',
  'nav.charity': 'Ehson fondi',
  'charity.title': 'Ehson fondi',
  'charity.accrued': 'Yig\'ilgan',
  'charity.paid': 'Berilgan',
  'charity.available': 'Fondda qoldiq',
  'charity.availableHint': 'majburiyat — kapitalga qo\'shilmaydi',
  'charity.accrue': 'Foydadan ajratish',
  'charity.accrueHint': 'Sof foydaning foizi. Zarar bo\'lsa ajratma bo\'lmaydi.',
  'charity.pct': 'Foiz',
  'charity.baseProfit': 'Baza foyda',
  'charity.amount': 'Ajratma',
  'charity.give': 'Yordam berish',
  'charity.recipient': 'Kimga',
  'charity.recipientHint': 'ism yoki tashkilot — pul iz qoldirishi kerak',
  'charity.purpose': 'Maqsad',
  'charity.appropriations': 'Ajratmalar',
  'charity.payouts': 'Berilgan yordamlar',
  'charity.noAppropriations': 'Hali ajratma qilinmagan',
  'charity.noPayouts': 'Hali yordam berilmagan',
  'nav.control': 'Nazorat bo\'limi',
  'hr.control.title': 'Nazorat bo\'limi',
  'hr.control.subtitle': 'Shartnoma, vazifa, avans, qarz va oylik — bitta ro\'yxatda. Bu ekran hech narsani o\'zgartirmaydi.',
  'hr.control.includeLeft': 'Bo\'shaganlar ham',
  'hr.control.employees': 'Xodimlar',
  'hr.control.critical': 'Jiddiy holat',
  'hr.control.criticalHint': 'kamida bitta jiddiy signal',
  'hr.control.openAdvance': 'Yopilmagan avans',
  'hr.control.openAdvanceHint': 'pul chiqqan, hali ushlanmagan',
  'hr.control.openDebt': 'Ochiq qarz',
  'hr.control.openDebtHint': 'oylikdan ushlanadi',
  'hr.control.board': 'Nazorat jadvali',
  'hr.control.employee': 'Xodim',
  'hr.control.signals': 'Signallar',
  'hr.control.money': 'Avans / qarz',
  'hr.control.noSignals': 'Muammo yo\'q',
  'hr.control.clean': 'Nazoratda muammo yo\'q',
  'hr.control.cleanBody': 'Barcha shartnomalar kuchda, yopilmagan avans va qarz yo\'q.',
  'hr.control.left': 'ishdan bo\'shagan',
  'hr.control.lastPayroll': 'Oxirgi oylik',
  'hr.control.neverPaid': 'Oylik hisoblanmagan',
  'hr.control.ai': 'AI xulosa',
  'hr.control.aiPending': 'AI o\'ylayapti...',
  'hr.control.aiTitle': 'AI yordamchining xulosasi',
  'hr.control.aiConfidence': 'ishonch',
  'hr.control.signal.contract_missing': 'Shartnomasiz ishlayapti',
  'hr.control.signal.contract_expired': 'Shartnoma muddati o\'tgan',
  'hr.control.signal.contract_expiring': 'Shartnoma tugayapti (kun)',
  'hr.control.signal.contract_future': 'Shartnoma hali boshlanmagan',
  'hr.control.signal.no_duties': 'Vazifasi yozilmagan',
  'hr.control.signal.no_obligations': 'Majburiyati yozilmagan',
  'hr.control.signal.advance_open': 'Yopilmagan avans',
  'hr.control.signal.advance_stale': 'Avans yopilmagan (kun)',
  'hr.control.signal.advance_after_leave': 'Bo\'shagan, avansi qaytmagan',
  'hr.control.signal.debt_open': 'Ochiq qarz',
  'hr.control.signal.debt_heavy': 'Og\'ir qarz',
  'hr.control.signal.debt_after_leave': 'Bo\'shagan, qarzi qolgan',
  'hr.control.signal.payroll_missing': 'Oylik hisoblanmagan',
  'hr.control.signal.salary_zero': 'Oyligi nol',
  'hr.control.signal.no_kpi': 'KPI rejasi yo\'q',
  'hr.payroll.reverse': 'Teskarilash',
  'hr.payroll.reverseTitle': 'Avansni qaytarish',
  'hr.payroll.reverseHint': 'Pul kassaga QAYTADI. Sabab yoziladi va o\'chmaydi.',
  'hr.payroll.writeOff': 'Hisobdan chiqarish',
  'hr.payroll.writeOffTitle': 'Qarzni kechirish',
  'hr.payroll.writeOffHint': 'Bu korxonaning zarari — undirishdan voz kechiladi.',
  'hr.payroll.reasonPlaceholder': 'Sabab (kamida 5 belgi)',
  'hr.payroll.reverseRunTitle': 'Oylik hisobini bekor qilish',
  'hr.payroll.reverseRunHint': 'To\'langan bo\'lsa pul kassaga qaytadi, avans va qarzlar tiklanadi.',
  'hr.control.signal.no_branch': 'Filialga bog\'lanmagan — puli daftarga tushmaydi',
  'charity.reverse': 'Qaytarish',
  'charity.reverseTitle': 'Yordamni bekor qilish',
  'charity.reverseHint': 'Pul kassaga qaytadi, fond qoldig\'i tiklanadi.',
  'charity.reasonPlaceholder': 'Sabab (kamida 5 belgi)',
  'nav.discounts': 'Chegirmalar',
  'reports.discounts.title': 'Chegirmalar — mijoz kesimida',
  'reports.discounts.subtitle': 'Kimga qancha berdik: fakturadagi zudlik chegirmasi va yig\'ilayotgan yillik.',
  'reports.discounts.byCustomer': 'Mijozlar bo\'yicha',
  'reports.discounts.customer': 'Mijoz',
  'reports.discounts.list': 'Ro\'yxat summasi',
  'reports.discounts.instant': 'Zudlik chegirmasi',
  'reports.discounts.instantHint': 'fakturada berilgan — mijoz kamroq to\'lagan',
  'reports.discounts.annual': 'Yillik chegirma',
  'reports.discounts.annualHint': 'majburiyat — hali to\'lanmagan, yig\'ilib boradi',
  'reports.discounts.total': 'Jami chegirma',
  'reports.discounts.pct': 'Foiz',
  'reports.discounts.pctHint': 'ro\'yxat summasiga nisbatan',
  'reports.discounts.invoices': 'faktura',
  'reports.discounts.noInvoices': 'Bu davrda savdo bo\'lmagan',
  'reports.discounts.empty': 'Chegirma berilmagan',
  'reports.discounts.emptyBody': 'Bu davrda hech kimga chegirma yozilmagan.',
  'reports.discounts.pnlNote': 'Bu yerdagi «zudlik chegirmasi» foyda-zarar hisobotidagi «Berilgan chegirmalar» satri bilan teng EMAS va bu to\'g\'ri: zudlik chegirmasi fakturaning o\'zida ushlanadi, ya\'ni tushum allaqachon kamaytirilgan holda yoziladi. Foyda-zarardagi satr esa keyin berilgan bonuslarni ko\'rsatadi. Yillik chegirma ikkala joyda ham bir xil.',
  'dashboard.attention.control': 'Nazoratda jiddiy holat',
  'nav.creditNotes': 'Kredit-notalar',
  'creditNote.title': 'Kredit-notalar',
  'creditNote.subtitle': 'Mijoz tovarni qaytarganda uning qarzini kamaytiradigan hujjat.',
  'creditNote.list': 'Ro\'yxat',
  'creditNote.docNo': 'Hujjat',
  'creditNote.customer': 'Mijoz',
  'creditNote.amount': 'Summa',
  'creditNote.balance': 'Qoldiq',
  'creditNote.statusCol': 'Holat',
  'creditNote.allStatuses': 'Barcha holatlar',
  'creditNote.issue': 'Tan olish',
  'creditNote.cancel': 'Bekor qilish',
  'creditNote.cancelTitle': 'Qoralamani bekor qilish',
  'creditNote.cancelHint': 'Faqat qoralama bekor qilinadi — tan olingan nota daftarda qoladi.',
  'creditNote.empty': 'Kredit-nota yo\'q',
  'creditNote.emptyBody': 'Mijoz tovar qaytarganda vozvrat kartasidan kredit-nota chiqariladi.',
  'creditNote.status.draft': 'Qoralama',
  'creditNote.status.issued': 'Tan olingan',
  'creditNote.status.applied': 'Qo\'llanilgan',
  'creditNote.status.cancelled': 'Bekor qilingan',
  'creditNote.issueDate': 'Sana',
  'creditNote.reason': 'Sabab',
  /*
   * Sabab KODLARI (`CREDIT_NOTE_REASONS`) — ekranda kod chiqmasligi uchun.
   *
   * «Hisobdan chiqarish» (`write_off`) qasddan «bekor qilish» emas: nota
   * bekor qilinmagan, aksincha — u qarzni QOPLAGAN, faqat pul kelmagan.
   * Ikkovini bir so'z bilan atash buxgalter uchun jiddiy chalkashlik.
   */
  'creditNote.reason.return': 'Tovar qaytdi',
  'creditNote.reason.price_correction': 'Narx tuzatildi',
  'creditNote.reason.discount': 'Chegirma',
  'creditNote.reason.write_off': 'Hisobdan chiqarildi',
  'creditNote.applied': 'Qo‘llanilgan',
  'creditNote.fromReturnDoc': 'Vozvrat hujjati',
  'creditNote.notes': 'Izoh',
  'creditNote.lines': 'Satrlar',
  'creditNote.lineName': 'Nomi',
  'creditNote.lineQty': 'Miqdor',
  'creditNote.linePrice': 'Narx',
  'creditNote.lineAmount': 'Summa',
  'creditNote.allocations': 'Qaysi fakturalarga qo‘llanildi',
  'creditNote.allocInvoice': 'Faktura',
  'creditNote.allocDate': 'Sana',
  'creditNote.fromReturn': 'Kredit-nota chiqarish',
  'creditNote.fromReturnHint': 'Satrlar vozvratdan ko\'chiriladi — qo\'lda kiritilmaydi.',
  'creditNote.created': 'Kredit-nota qoralamasi yaratildi',
  'nav.treasury': 'G\'aznachilik',
  'treasury.title': 'G\'aznachilik',
  'treasury.subtitle': 'Pul qayerda, qancha va qachon tugaydi.',
  'treasury.gapTitle': 'Pul yetishmaydi',
  'treasury.gapBody': '{date} kuni ({days} kundan keyin) {amount} yetishmaydi.',
  'treasury.driftTitle': 'Kassa qoldig\'i daftarga mos emas',
  'treasury.total': 'Jami pul',
  'treasury.totalHint': 'barcha kassa va bank hisoblari',
  'treasury.expectedIn': 'Kutilayotgan kirim',
  'treasury.expectedOut': 'Kutilayotgan chiqim',
  'treasury.horizonHint': '90 kun ichida',
  'treasury.lowest': 'Eng past nuqta',
  'treasury.byCurrency': 'Valyutalar bo\'yicha',
  'treasury.currency': 'Valyuta',
  'treasury.balance': 'Qoldiq',
  'treasury.inBase': 'Bazada',
  'treasury.accounts': 'hisob',
  'treasury.calendar': 'To\'lov taqvimi',
  'treasury.calendarHint': 'Yaqin kunlarda nima kiradi va nima chiqadi',
  'treasury.calendarEmpty': 'Yaqin kunlarda kutilayotgan to\'lov yo\'q.',
  'treasury.date': 'Sana',
  'treasury.in': 'Kirim',
  'treasury.out': 'Chiqim',
  'treasury.net': 'Sof',
  'treasury.workingCapital': 'Aylanma kapital',
  'treasury.netWorkingCapital': 'Sof aylanma kapital',
  'treasury.days': 'kun',
  'treasury.dso': 'qarz qancha kunda undiriladi',
  'treasury.dio': 'tovar qancha kun omborda turadi',
  'treasury.dpo': 'ta\'minotchiga qancha kunda to\'laymiz',
  'treasury.ccc': 'pul aylanish davri',
  'nav.mySettings': 'Mening sozlamalarim',
  'mySettings.title': 'Mening sozlamalarim',
  'mySettings.telegram': 'Telegram ulash',
  'mySettings.telegramHint': 'Ogohlantirishlar shu chatga keladi: muddati o\'tgan qarz, tugayotgan tovar, tasdiq so\'rovi.',
  'mySettings.notLinked': 'Telegram hali ulanmagan — ogohlantirishlar kelmaydi.',
  'mySettings.connect': 'Ulash kodini olish',
  'mySettings.unlink': 'Uzish',
  'mySettings.linkedAt': 'Ulangan',
  'mySettings.codeTitle': 'Ulash kodi',
  'mySettings.codeExpires': 'Kod {minutes} daqiqa amal qiladi.',
  'mySettings.quietHours': 'Tinch soatlar',
  'mySettings.quietHoursHint': 'Bu oraliqda xabar yuborilmaydi — ertalab yig\'ib beriladi.',
  'mySettings.quietEnabled': 'Yoqilgan',
  'mySettings.from': 'Dan',
  'mySettings.to': 'Gacha',
  'mySettings.timezone': 'Vaqt mintaqasi',
  'treasury.transfer': 'Pul ko\'chirish',
  'treasury.transferDo': 'Ko\'chirish',
  'treasury.fromAccount': 'Qayerdan',
  'treasury.toAccount': 'Qayerga',
  'treasury.amount': 'Summa',
  'treasury.converts': '{from} → {to}: summa kunlik kurs bilan konvertatsiya qilinadi.',
  'notif.title': 'Bildirishnomalar',
  'notif.readAll': 'Hammasini o\'qilgan qilish',
  'notif.empty': 'Yangi xabar yo\'q',
  'dashboard.myKpi': 'Mening natijam',
  'dashboard.myKpiHint': 'Shu oydagi rejangiz va bajarilishi',
  'nav.dealerControl': 'Dillerlar nazorati',
  'dealerControl.title': 'Dillerlar nazorati',
  'dealerControl.subtitle': 'Diller bizga qarzdor. O\'sha pul omborida turibdimi, mijozlarida qarzmi — yoki yo\'qolganmi.',
  'dealerControl.gapTitle': 'Ochiq risk',
  'dealerControl.gapBody': '{count} ta dillerda qarz qoplanmaydi. Jami ochiq risk: {amount}.',
  'dealerControl.owedToUs': 'Bizga qarzi',
  'dealerControl.owedToUsHint': 'ochiq hisob-fakturalar',
  'dealerControl.customerDebt': 'Mijozlaridagi qarz',
  'dealerControl.customerDebtHint': 'diller sotgan, puli hali olinmagan',
  'dealerControl.stock': 'Omborida turgan tovar',
  'dealerControl.stockHint': 'bizning tovarimiz, hali sotilmagan',
  'dealerControl.atRisk': 'Xavfli dillerlar',
  'dealerControl.atRiskHint': 'qoplama yetmaydi yoki signal bor',
  'dealerControl.board': 'Dillerlar',
  'dealerControl.dealer': 'Diller',
  'dealerControl.coverage': 'Qoplama',
  'dealerControl.gap': 'Farq',
  'dealerControl.signals': 'Holat',
  'dealerControl.open': 'Ochish',
  'dealerControl.lastSale': 'oxirgi sotuv',
  'dealerControl.noSales': 'sotuv yo\'q',
  'dealerControl.empty': 'Diller yo\'q',
  'dealerControl.emptyBody': 'Diller kartasi ochilgandan keyin bu yerda uning holati ko\'rinadi.',
  'dealerControl.risk.ok': 'Sog\'lom',
  'dealerControl.risk.watch': 'Kuzatuvda',
  'dealerControl.risk.high': 'Xavfli',
  'dealerControl.signal.coverage_gap': 'Qarz qoplanmaydi',
  'dealerControl.signal.coverage_thin': 'Qoplama yupqa',
  'dealerControl.signal.overdue_heavy': 'Muddati o\'tgan qarz ko\'p',
  'dealerControl.signal.stock_idle': 'Tovar sotilmayapti',
  'dealerControl.signal.no_customers': 'Mijozi yo\'q',
  'dealerControl.customers': 'Dilerning mijozlari',
  'dealerControl.customersHint': 'Kim qancha qarzdor — pul shu yerda turibdi',
  'dealerControl.customer': 'Mijoz',
  'dealerControl.debt': 'Qarzi',
  'dealerControl.overdue': 'Muddati o\'tgan',
  'dealerControl.blocked': 'bloklangan',
  'dealerControl.noCustomers': 'Mijoz kiritilmagan',
  'dealerControl.stockCard': 'Dilerning ombori',
  'dealerControl.stockCardHint': 'Bizning tovarimiz — hali sotilmagan qismi',
  'dealerControl.noStock': 'Ombor bo\'sh yoki kiritilmagan',
  'dealerControl.product': 'Mahsulot',
  'dealerControl.qty': 'Miqdor',
  'dealerControl.value': 'Qiymati',

  // --- DDS maqolalari (`settings/cash-flow-items.tsx`) ---
  'nav.cashFlowItems': 'DDS maqolalari',
  'cfi.description':
    "Har bir pul harakati maqolaga bog'lanadi — DDS hisoboti aynan shu bog'lanishdan quriladi.",
  'cfi.code': 'Kod',
  'cfi.codeHint': 'Katta harf, raqam va tire. Kod keyin o\'zgartirilmaydi.',
  'cfi.name': 'Nomi',
  'cfi.flowType': "Bo'lim",
  'cfi.direction': "Yo'nalish",
  'cfi.parent': 'Ota maqola',
  'cfi.parentNone': "Ildiz (ota yo'q)",
  'cfi.transactions': 'Harakatlar',
  'cfi.status': 'Holati',
  'cfi.system': 'Tizim',
  'cfi.active': 'Faol',
  'cfi.archived.badge': 'Arxivda',
  'cfi.new': 'Yangi maqola',
  'cfi.create': "Qo'shish",
  'cfi.created': '{code} qo\'shildi.',
  'cfi.saved': "O'zgarish saqlandi.",
  'cfi.archive': 'Arxivlash',
  'cfi.archived': 'Maqola arxivlandi.',
  'cfi.empty': "Maqola yo'q",
  'cfi.loadError': "Maqolalarni yuklab bo'lmadi",
  'cfi.flow.operating': 'Operatsion',
  'cfi.flow.investing': 'Investitsion',
  'cfi.flow.financing': 'Moliyaviy',
  'cfi.flow.internal': "Ichki o'tkazma",
  'cfi.dir.in': 'Kirim',
  'cfi.dir.out': 'Chiqim',
  'cfi.dir.both': 'Ikkalasi',
  'cfi.dir.any': 'Belgilanmagan',
  'cfi.unclassifiedTitle': "Maqolaga bog'lanmagan harakatlar bor",
  'cfi.unclassifiedBody':
    "{count} ta pul harakati maqolaga bog'lanmagan — ular DDS hisobotida «Turkumlanmagan» satrida turadi.",
  'cfi.reclassify': "Bog'lash",
  'cfi.reclassified': "{linked} ta harakat maqolaga bog'landi.",
  'cfi.reclassifiedPartial':
    "{linked} ta harakat bog'landi, {left} tasiga mos maqola topilmadi — ularni qo'lda bog'lash kerak.",
  'cfi.allClassified': "Barcha pul harakatlari maqolaga bog'langan.",
  'invoice.credits': 'Kredit-notalar',
  /*
   * Sabab RO'YXAT bilan aytiladi, bittasi bilan emas.
   *
   * Ilgari bu yerda «mijoz tovar qaytarganda» deb yozilgan edi va u
   * `CREDIT_NOTE_REASONS` ning to'rttadan FAQAT BITTASI. Jadvalga «Sabab»
   * ustuni qo'shilgach, ekran o'z-o'ziga zid bo'lib qoldi: izohda «tovar
   * qaytarganda», satrda esa «Hisobdan chiqarildi» (jonli: CN-2026-00013).
   */
  'invoice.creditsHint':
    "Bu hujjatlar faktura qoldig'ini to'lovsiz kamaytiradi: tovar qaytarilganda, narx tuzatilganda, chegirma berilganda yoki qarz hisobdan chiqarilganda.",
  // --- Alight'dan so'rash (`routes/ai/ask.tsx`) ---
  'nav.aiAsk': "Alight'dan so'rash",
  'ai.description':
    "Savolni oddiy tilda yozing. Javob qayerdan kelgani — bazadanmi yoki modeldanmi — javobning tepasida ko'rsatiladi.",
  'ai.askTitle': 'Savol',
  'ai.question': 'Savolingiz',
  'ai.questionPlaceholder': "Masalan: eng katta qarzdor mijozlar kimlar?",
  'ai.skill': "Ko'nikma",
  'ai.skillAuto': "Avtomatik tanlansin",
  'ai.skillHint':
    "Ko'nikma tanlansa, javob darajasi faqat KO'TARILADI — ya'ni javob sifati oshadi va narxi ham.",
  'ai.ask': "So'rash",
  'ai.answer': 'Javob',
  'ai.confidence': 'Ishonch',
  'ai.cost': 'Narx',
  'ai.model': 'Model',
  'ai.tokens': 'Matn hajmi (savol / javob)',
  'ai.usedTools': "Ishlatilgan manbalar:",
  'ai.tier': 'Daraja',
  'ai.calls': "So'rovlar",
  'ai.latency': 'Vaqt',
  'ai.freeShare': "Pulsiz javoblar",
  'ai.monthBudget': 'Oylik byudjet',
  'ai.usageTitle': 'Mening sarfim',
  'ai.usagePeriod': '{from} — {to}',
  'ai.toolsTitle': 'Menga ochiq manbalar',
  'ai.toolsHint':
    "AI faqat shu manbalardan o'qiy oladi va ular sizning ruxsatlaringizga qarab tanlangan.",
  'ai.notConfiguredTitle': 'AI kaliti sozlanmagan',
  'ai.notConfiguredBody':
    "Savollar baribir ishlaydi: javob to'g'ridan-to'g'ri bazadan olinadi (L0 darajasi). Model javoblari uchun kalit kerak.",
  'ai.budgetOutTitle': 'Byudjet tugadi',
  'ai.budgetOutBody': "Bugungi yoki oylik chegara to'ldi — javoblar L0 darajasida beriladi.",
  // --- Suhbat rejimi ---
  'ai.chatPlaceholder': "Savolingizni yozing — masalan «bugun biznes qalay?»",
  'ai.send': 'Yuborish',
  'ai.newChat': 'Yangi suhbat',
  'ai.thinking': "O'ylanyapti…",
  'ai.you': 'Siz',
  'ai.evo': 'Alight',
  'ai.sendHint': "Enter — yuborish, Shift+Enter — yangi qator",
  'ai.starters': 'Nimadan boshlaymiz?',
  'ai.starter.today': 'Bugun biznes qalay?',
  'ai.starter.debts': 'Kim eng ko‘p qarzdor?',
  'ai.starter.stock': 'Qaysi tovar tugayapti?',
  'ai.starter.profit': 'Shu oyda foyda qancha?',
  'ai.contextHint':
    "Suhbat faqat shu oynada turadi — sahifa yangilansa yo‘qoladi va serverda saqlanmaydi.",
  'ai.details': 'Tafsilot',
  'ai.sources': 'Manbalar',
  'ai.micStart': '🎤 Gapirish',
  'ai.micStop': '⏹ To‘xtatish',
  'ai.micListening': 'Tinglanyapti… gapiring, keyin «To‘xtatish» ni bosing.',
  'ai.micDenied':
    'Mikrofonga ruxsat berilmadi. Brauzer manzil qatoridagi qulf belgisini bosib, mikrofonni yoqing.',
  'ai.micError': 'Ovozni tanib bo‘lmadi. Yana urinib ko‘ring yoki savolni yozing.',
  'ai.speak': '🔊 Tinglash',
  'ai.speakPreparing': 'Ovoz tayyorlanmoqda…',
  'ai.speakTruncated':
    'Javob uzun bo‘lgani uchun ovozda faqat boshi o‘qildi — to‘lig‘i ekranda.',
  'ai.speakStop': '⏹ To‘xtatish',
  'ai.agents': 'Agentlar — har biri o‘z sohasi bo‘yicha xulosa beradi',
  'ai.agentSources': '{count} ta manba',
  'ai.briefing': 'Kunlik xulosa',
  'ai.briefingHint':
    "Pul, qarz, savdo, ombor va xavflar — bitta qisqa xulosada. Bir bosishda tayyor bo‘ladi.",
  // --- Chop etish shablonlari ---
  'nav.printTemplates': 'Chop etish shablonlari',
  'printTpl.description':
    "Mijozga ketadigan blankalar: hisob-faktura, yuk xati, kassa orderi. Matn va rekvizitlar shu yerda o'zgartiriladi.",
  'printTpl.code': 'Kod',
  'printTpl.name': 'Nomi',
  'printTpl.locale': 'Til',
  'printTpl.paper': "Qog'oz",
  'printTpl.size': 'Hajmi',
  'printTpl.updated': "O'zgartirilgan",
  'printTpl.default': 'Asosiy',
  'printTpl.body': 'Shablon matni (HTML)',
  'printTpl.bodyHint':
    "Qiymatlar {{qavs}} ichida yoziladi. Grammatika saqlashda serverda tekshiriladi — buzilgan shablon qabul qilinmaydi.",
  'printTpl.saved': 'Shablon saqlandi.',
  'printTpl.reset': "Saqlanmagan o'zgarishni bekor qilish",
  'printTpl.empty': "Shablon yo'q",
  'printTpl.loadError': "Shablonlarni yuklab bo'lmadi",
  // --- Aylanma-qoldiq va sverka ---
  'nav.accTrialBalance': 'Aylanma-qoldiq',
  'nav.accReconciliation': 'Sverka',
  // `tb.title` — EKRANDA emas, FAYLDA: eksport qilingan `.xlsx` ning
  // sarlavhasi va nomi. Menyudagi «Aylanma-qoldiq» qisqartma sifatida
  // yaxshi, pochtaga biriktirilgan faylda esa hujjat to'liq atalishi kerak.
  'tb.title': 'Aylanma-qoldiq vedomosti',
  'tb.description':
    "Har hisobning boshlang'ich qoldig'i, davr aylanmasi va yakuniy qoldig'i. Jami debet jami kreditga teng bo'lishi shart.",
  'tb.from': 'Sanadan',
  'tb.to': 'Sanagacha',
  'tb.hideEmpty': "Harakatsiz hisoblarni yashirish",
  'tb.account': 'Hisob',
  // Ekranda kod va nom BITTA katakda; faylda ular ikkita ustun bo'lgani
  // uchun har biriga alohida sarlavha kerak (`trial-balance.tsx` ramkasi).
  'tb.accountCode': 'Hisob kodi',
  'tb.accountName': 'Hisob nomi',
  'tb.openingDebit': 'Boshl. debet',
  'tb.openingCredit': 'Boshl. kredit',
  'tb.turnoverDebit': 'Aylanma debet',
  'tb.turnoverCredit': 'Aylanma kredit',
  'tb.closingDebit': 'Yakuniy debet',
  'tb.closingCredit': 'Yakuniy kredit',
  'tb.total': 'JAMI',
  'tb.empty': "Bu davrda provodka yo'q",
  'tb.balanced': 'Debet va kredit teng — vedomost yopiladi.',
  'tb.unbalancedTitle': 'Debet kreditga TENG EMAS',
  'tb.unbalancedBody':
    "Farq: {difference}. Bunday holatda quyidagi jadvaldagi hech bir raqamga ishonib bo'lmaydi — avval sverkani oching.",
  'recon.description':
    "Daftar operatsion tomon bilan mos keladimi. Bu hisobot emas, diagnostika: «raqamlarga ishonsa bo'ladimi» degan savolga javob beradi.",
  'recon.checks': 'Tekshiruvlar',
  'recon.check': 'Tekshiruv',
  'recon.ledger': 'Daftarda',
  'recon.source': 'Operatsiyada',
  'recon.difference': 'Farq',
  'recon.status': 'Holat',
  'recon.ok': 'Mos',
  'recon.gap': 'Farq bor',
  'recon.allOk': 'Daftar operatsion tomon bilan to‘liq mos.',
  'recon.gapTitle': 'Daftar bilan operatsiya orasida farq bor',
  'recon.gapBody':
    "Navbat bo'sh, ya'ni farqning sababi kechikish EMAS. Quyidagi jadvalda qaysi tekshiruv yiqilganini ko'ring.",
  'recon.pendingTitle': "Navbatda qayta ishlanmagan hodisalar bor",
  'recon.pendingBody':
    "{count} ta hodisa hali daftarga yozilmagan — farq ko'rinishi TABIIY. Avval navbatni bo'shating.",
  'recon.drain': "Navbatni bo'shatish",
  'recon.drained': "{posted} ta hodisa daftarga yozildi, navbatda {remaining} ta qoldi.",
  'recon.cashTitle': 'Kassa va bank sverkasi',
  'recon.cashHint':
    "Har hisob O'Z VALYUTASIDA solishtiriladi: yozib qo'yilgan qoldiq harakatlar yig'indisiga teng bo'lishi shart. Farq chiqsa — pul harakat qilgan, lekin DDS dan o'tmagan.",
  'recon.account': 'Hisob',
  'recon.stored': 'Yozilgan qoldiq',
  'recon.computed': 'Harakatlardan',
  // --- Ombor tuzatishi ---
  'adj.new': 'Tuzatish',
  'adj.create': 'Tuzatish yaratish',
  'adj.created': "{docNo} yaratildi — tasdiqlangandan keyin qoldiq o'zgaradi.",
  'adj.reason': 'Sabab',
  'adj.direction': "Yo'nalish",
  'adj.increase': 'Ortiqcha topildi (+)',
  'adj.decrease': 'Hisobdan chiqarish (−)',
  'adj.hint':
    "Tuzatish bitta aniq hodisa uchun: quti sindi, tovar topildi, o'g'irlandi. Butun omborni sanash uchun sanoq varag'idan foydalaning.",
  // --- G'aznachilik: ssenariylar va kutilayotgan oqim ---
  'treasury.scenarios': 'Ssenariylar',
  'treasury.scenariosHint':
    "Bitta prognoz «shunday bo'ladi» degan va'da beradi va u har doim yolg'on. Uchta ssenariy savolni to'g'ri qo'yadi: mijozlar kechiksa nima bo'ladi?",
  'treasury.scenario': 'Ssenariy',
  'treasury.scenario.base': 'Asosiy',
  'treasury.scenario.conservative': 'Konservativ',
  'treasury.scenario.aggressive': 'Optimistik',
  'treasury.lowestDate': 'Eng past kuni',
  'treasury.shortfall': 'Yetishmaydi',
  'treasury.noGap': 'Yetadi',
  'treasury.expectedInList': 'Kutilayotgan kirim',
  'treasury.expectedInHint': "90 kun ichida qaysi hujjatdan qancha pul kutilyapti",
  'treasury.expectedOutList': 'Kutilayotgan chiqim',
  'treasury.expectedOutHint': "90 kun ichida qaysi hujjat bo'yicha qancha to'lash kerak",
  'treasury.expectedTotal': 'Jami kutilmoqda',
  'treasury.overdue': "Muddati o'tgan",
  'treasury.expectedEmpty': "Yaqin 90 kunda kutilayotgan harakat yo'q",
  'treasury.doc': 'Hujjat',
  'treasury.party': 'Kim bilan',
  'treasury.expectedDate': 'Kutilgan sana',
  'mySettings.templates': 'Qanday xabarlar keladi',
  'mySettings.templatesHint':
    "Ro'yxat faqat ma'lumot uchun: shablon matni tizim sozlamasi va u hammaga birdek ta'sir qiladi.",
  'mySettings.everyTime': 'har safar keladi',
  'mySettings.cooldown': 'takroran {value}da bir marta',
  'mySettings.days': '{n} kun',
  'mySettings.hours': '{n} soat',
  'mySettings.urgent': 'Shoshilinch',
  'customer.telegram': 'Telegram xabarlari',
  'customer.telegramHint':
    "To'lov tasdig'i mijozning Telegram chatiga ketadi. Chatni ulash uchun quyidagi kodni mijozga bering — u botga yuboradi.",
  'customer.telegramCode': 'Kod olish',
  'customer.telegramExpires': 'Kod {minutes} daqiqa amal qiladi.',
  'fxRates.cbuImport': 'MB dan olish',
  'fxRates.cbu.created': 'yozildi',
  'fxRates.cbu.updated': 'yangilandi',
  'fxRates.cbu.unchanged': "o'zgarmadi",
  'fxRates.cbu.kept': "tegilmadi — qo'lda qo'yilgan",
  'fxRates.cbu.locked': 'kun yopilgan',

  /*
   * --- Kiruvchi yuk (`routes/supply/incoming.tsx`) ---
   *
   * ╔══════════════════════════════════════════════════════════════════════╗
   * ║ MATNLARDA «XABARNOMA» EMAS, «YUK» — ATAYLAB                          ║
   * ║                                                                      ║
   * ║ Ichkarida hujjat «ta'minot xabarnomasi» deb ataladi. Ekranda esa     ║
   * ║ omborchi kutayotgan narsa — TOVAR, hujjat emas: u mashinani kutadi,  ║
   * ║ yozuvni emas. Shuning uchun sarlavha ham, bo'sh holat matni ham      ║
   * ║ «yuk» so'zi bilan yozilgan.                                          ║
   * ║                                                                      ║
   * ║ «Ta'minotchi» so'zi ham ehtiyotkorlik bilan: bu ekranni ko'radigan   ║
   * ║ tashkilot uchun BIZ ta'minotchimiz, ya'ni so'z uning nuqtai          ║
   * ║ nazaridan yozilgan.                                                  ║
   * ╚══════════════════════════════════════════════════════════════════════╝
   */
  'incoming.title': 'Kiruvchi yuk',
  'incoming.description':
    "Ta'minotchi hisob-faktura yozganda yuk shu ro'yxatga tushadi. Tovar yetib kelgach uni qabul qilasiz — shundan keyingina u omboringizdagi qoldiqqa qo'shiladi.",
  'incoming.docNo': 'Hujjat',
  'incoming.issuedDate': 'Yozilgan sana',
  'incoming.statusCol': 'Holati',
  'incoming.total': 'Jami summa',
  'incoming.receivedAt': 'Qabul qilingan',
  'incoming.lineCount': 'Satrlar soni',
  'incoming.status.pending': 'Kutilmoqda',
  'incoming.status.received': 'Qabul qilingan',
  'incoming.status.cancelled': 'Bekor qilingan',
  'incoming.filterStatus': 'Holati',
  'incoming.searchPlaceholder': 'Hujjat raqami…',
  'incoming.loadError': "Kiruvchi yuk ro'yxatini yuklab bo'lmadi",
  /* Bo'sh holat UCH XIL, chunki uchta sabab bor va ular bir-biriga
     o'xshamaydi: yuk yo'q / tarix bo'sh / qidiruv topmadi. Bittasi bilan
     cheklansak, omborchi «yuk kelmadi» ni «dastur ishlamadi» deb o'qirdi. */
  'incoming.empty': "Hozircha kutilayotgan yuk yo'q",
  'incoming.emptyHint':
    "Ta'minotchi hisob-faktura yozishi bilan yuk shu yerda o'zi paydo bo'ladi — hech narsa so'rash yoki yaratish kerak emas. Oldin kelgan yuklarni tarixdan ko'rasiz.",
  'incoming.emptyHistory': "Bu holatda hujjat yo'q",
  'incoming.emptyHistoryHint':
    "Bu ro'yxat faqat tanlangan holatdagi hujjatlarni ko'rsatadi. Kutilayotgan yuklarga qaytib, hozir nima kelayotganini ko'ring.",
  'incoming.emptySearch': 'Hujjat topilmadi',
  'incoming.emptySearchHint':
    "Qidiruv hujjat raqami bo'yicha ishlaydi. Raqamni tekshiring yoki qidiruvni tozalab, butun ro'yxatni ko'ring.",
  'incoming.showHistory': "Qabul qilinganlarni ko'rish",
  'incoming.showPending': "Kutilayotgan yuklarga qaytish",
  'incoming.lines': 'Yuk tarkibi',
  'incoming.linesHint':
    "Narx ta'minotchining hujjatidan keladi va shu narxda kirim qilinadi — uni bu yerda o'zgartirib bo'lmaydi.",
  'incoming.lineSku': 'Kod',
  'incoming.lineName': 'Mahsulot',
  'incoming.lineQty': 'Miqdor',
  'incoming.lineCost': 'Narxi',
  'incoming.lineAmount': 'Summa',
  'incoming.receiveTitle': 'Yukni qabul qilish',
  'incoming.receiveHint':
    "Tovar yetib kelgan bo'lsa, qaysi omboringizga tushganini tanlang. Miqdor va narx hujjatdagidek qoladi.",
  'incoming.warehouse': 'Ombor',
  'incoming.notes': 'Izoh',
  'incoming.notesHint':
    "Ixtiyoriy. Bo'sh qoldirsangiz ombor yozuvida hujjat raqami turadi.",
  'incoming.receiveSubmit': 'Qabul qilish',
  'incoming.receiveWarning':
    "Qabul qilingandan keyin qoldiq va tannarx darhol o'zgaradi; buni faqat teskari hujjat bilan tuzatib bo'ladi.",
  'incoming.received': "«{docNo}» qabul qilindi — tovar omboringizga kirdi.",
  'incoming.alreadyReceived':
    "Bu yuk allaqachon qabul qilingan: tovar omboringizda va qoldiqqa qo'shilgan.",
  'incoming.cancelledHint':
    "Bu hujjat bekor qilingan — uni qabul qilib bo'lmaydi. Tovar kelgan bo'lsa, ta'minotchidan yangi hujjat so'rang.",

  // --- Partner tashkilotlar (`settings/organizations.tsx`, `organization-modules.tsx`) ---
  'nav.partnerOrgs': 'Partner tashkilotlar',
  'porg.title': 'Partner tashkilotlar',
  'porg.description':
    "Partner tashkilot — shu dasturdan O'ZI savdo qiladigan mijoz yoki diler: o'z ombori, o'z narxi, o'z foydasi. Biz faqat unga qaysi bo'limlar ochiq bo'lishini belgilaymiz.",
  /* Ikkala ekranning sarlavha qismida turadi — faktni bir marta emas, ko'rilgan
     har joyda aytish kerak: «ular bizning omborni ko'radimi?» eng ko'p
     beriladigan savol. */
  'porg.isolation':
    "Bizning ombor va hisobotlarimiz ularga ko'rinmaydi: har tashkilot faqat o'z ma'lumotini ko'radi.",
  'porg.code': 'Kod',
  'porg.name': 'Nomi',
  'porg.moduleCount': "Bo'limlar",
  'porg.userCount': 'Foydalanuvchilar',
  'porg.status': 'Holati',
  'porg.active': 'Faol',
  'porg.inactive': "To'xtatilgan",
  'porg.createdAt': 'Ochilgan sana',
  'porg.empty': "Partner tashkilot yo'q",
  'porg.emptyHint':
    "Birinchi tashkilotni shu yerdan ochasiz — kodi, administratori va paketi bitta formada beriladi.",
  'porg.loadError': "Tashkilotlarni yuklab bo'lmadi",
  'porg.rowHint': "Satrni bosing — o'sha tashkilotning paketi ochiladi.",
  'porg.new': 'Yangi tashkilot',
  'porg.create': 'Tashkilot ochish',
  'porg.codeHint': "Butun bazada unikal bo'lishi shart va keyin o'zgartirilmaydi.",
  /* Mijoz kartasi — ro'yxatdagi ustun, formadagi bo'lim va ikkala ogohlantirish.
     Matnlar «nima ishlamaydi» ni AYNAN aytadi: «bog'lanmagan» so'zining o'zi
     xodimga hech narsa demasdi, chunki nosozlik ko'rinmaydigan joyda. */
  'porg.customerSection': 'Mijoz kartasi',
  'porg.customer': 'Mijoz',
  'porg.customerHint':
    "Bu tashkilot bizning qaysi mijozimiz ekanini ko'rsatadi: qarz va hisob-kitob o'sha kartada yuritiladi, biz yozgan hisob-faktura esa ularning omboriga kirim xabarnomasi bo'lib tushadi.",
  'porg.customerMissing': "Bog'lanmagan",
  'porg.customerMissingWarning':
    "Mijoz kartasi tanlanmadi. Tashkilot ochiladi va ishlaydi, lekin biz unga hisob-faktura yozganda tovar ULARNING omboriga tushmaydi — hech qanday xato ham chiqmaydi, shunchaki hech narsa bo'lmaydi. Kartani keyin bog'lash mumkin.",
  'porg.supplyRequired':
    "Mijoz kartasiga bog'langan tashkilot paketida «supply» bo'limi BO'LISHI SHART. Bog'lanish bo'lsa, har hisob-fakturamizdan ularga ta'minot xabarnomasi yoziladi; bo'lim yopiq bo'lsa ular uni ko'rmaydi — yuk kelgani bilan ekran bo'sh turadi.",
  'porg.adminSection': 'Administratori',
  'porg.adminHint':
    "Tashkilotning birinchi foydalanuvchisi. Qolgan xodimlarni u o'zi qo'shadi — biz aralashmaymiz.",
  'porg.adminFullName': 'F.I.Sh.',
  'porg.adminEmail': 'Email',
  'porg.packageSection': "Boshlang'ich paket",
  'porg.created.title': "«{code}» tashkiloti ochildi",
  'porg.password': 'Vaqtinchalik parol',
  'porg.passwordWarning':
    'Bu parol shu yerda faqat BIR MARTA ko‘rsatiladi — u hech qayerda saqlanmaydi. Sahifa yopilsa qayta olib bo‘lmaydi. Hoziroq ko‘chirib oling va administratorga ishonchli yo‘l bilan (yuzma-yuz yoki telefonda) topshiring; xat yoki umumiy chatga tashlamang.',
  'porg.passwordLogin': "Kirish emaili: {email}",
  'porg.openModules': 'Paketni ochish',

  'porg.modules.title': "Paket — qaysi bo'limlar ochiq",
  'porg.modules.note':
    "Bu ro'yxat o'sha tashkilotda qaysi bo'lim UMUMAN mavjud bo'lishini hal qiladi. Bo'lim ichida kim nimani ko'rishini esa ularning O'Z rollari hal qiladi — bu ikki qaror bir-birining o'rnini bosmaydi.",
  'porg.modules.hint':
    "Bo'lim kodlari server katalogidan keladi: ular ruxsatlar ro'yxatidan hosila qilinadi, qo'lda yozilmaydi.",
  'porg.modules.selected': "{count} ta bo'lim tanlandi",
  'porg.modules.permissions': '{count} ta ruxsat',
  'porg.modules.emptyWarning':
    "Bironta bo'lim tanlanmagan. Shu holda saqlansa, tashkilot tizimga kiradi-yu, hech qanday bo'lim ko'rmaydi — bo'sh ekran qoladi.",
  'porg.modules.save': 'Paketni saqlash',
  'porg.modules.saved': "Paket saqlandi: {count} ta bo'lim ochiq.",
  'porg.modules.empty': "Katalog bo'sh",
  'porg.modules.loadError': "Modul katalogini yuklab bo'lmadi",
  'porg.notFound': 'Tashkilot topilmadi',

  // --- Partner tashkilotiga KIRIB KO'RISH (`components/layout/partner-view.tsx`) ---
  'partnerView.enter': "Kirib ko'rish",
  'partnerView.enterHint':
    "Tashkilotning o'z ma'lumoti FAQAT O'QISH uchun ochiladi va tashrif o'sha tashkilotning jurnaliga ham yoziladi.",
  'partnerView.enterFailed': "Tashkilotga kirib bo'lmadi",
  'partnerView.banner.title': "PARTNER TASHKILOT KO'RINISHI",
  'partnerView.banner.org': '{code} — {name}',
  'partnerView.banner.notYours':
    "Ekrandagi ma'lumot SIZNIKI EMAS — u shu tashkilotniki.",
  'partnerView.banner.readOnly':
    "Faqat o'qish: hech narsa yozib, o'zgartirib yoki tasdiqlab bo'lmaydi.",
  'partnerView.banner.audited': "Bu tashrif o'sha tashkilotning o'z jurnaliga yozilgan.",
  'partnerView.banner.window': "Ko'rish oynasi: {window}. Tugagach qaytadan kirish kerak.",
  'partnerView.exit': 'Chiqish',
  'partnerView.expired':
    "Ko'rish oynasi tugadi — siz o'z tashkilotingizga qaytdingiz. Kerak bo'lsa qaytadan kiring.",
} as const;

export type TranslationKey = keyof typeof uz;

/** Almashtiriladigan qiymatlar: `t('fx.rateLine', { rate: '12 800' })` */
export type TranslationParams = Readonly<Record<string, string | number>>;

type Dictionary = Partial<Record<TranslationKey, string>>;

/*
 * RU va EN lug'atlari ALOHIDA FAYLLARDA (`i18n.ru.ts`, `i18n.en.ts`).
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ NIMA UCHUN SHU FAYLDA EMAS                                               │
 * │                                                                          │
 * │ `uz` lug'ati 3 400 dan ortiq kalit — bu fayl allaqachon 4 000 qatordan   │
 * │ oshgan. Uchala tilni shu yerga qo'shsak, u 12 000 qatorga chiqardi va    │
 * │ har tarjima tuzatishi butun faylni «o'zgargan» qilardi: yangi kalit      │
 * │ qo'shayotgan dasturchi bilan tarjimon doim bir-birining yo'lida bo'lardi.│
 * │                                                                          │
 * │ Ajratilgandan keyin ular bir-biriga tegmaydi: kalit `uz` ga qo'shiladi,  │
 * │ tarjima esa o'z faylida.                                                 │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * MEXANIZM ISHLAYDI va TEKSHIRILGAN: `translate()` da
 * `DICTIONARIES[locale][key] ?? uz[key] ?? key` — ya'ni lug'at bo'sh yoki
 * yarim to'ldirilgan bo'lsa ham ekran to'liq ishlaydi, bo'sh joy qolmaydi.
 * `Dictionary = Partial<...>` bo'lgani uchun tarjima BO'LAKLAB kelishi
 * mumkin va hech qachon «yarim buzilgan» holat bermaydi.
 *
 * Yagona shart: yangi kalit AVVAL `uz` ga qo'shiladi (`TranslationKey`
 * o'sha yerdan hosil bo'ladi), keyin tarjimalarga.
 */


const DICTIONARIES: Record<Locale, Dictionary> = { uz, ru, en };

/**
 * Modul darajasidagi joriy til.
 *
 * React'dan tashqarida ham tarjima kerak bo'ladi (masalan `api.ts` dagi xato matni),
 * shuning uchun tanlov modulda saqlanadi. React tomonda `useT()` ishlatiladi —
 * u til o'zgarganda qayta render qiladi.
 */
let currentLocale: Locale = DEFAULT_LOCALE;

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale): void {
  currentLocale = locale;
}

function interpolate(template: string, params?: TranslationParams): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}

/**
 * Tarjima. Kalit topilmasa — `uz`, u ham bo'lmasa kalitning o'zi qaytadi
 * (ekran hech qachon bo'sh qolmaydi, lekin xato ko'zga tashlanadi).
 */
export function translate(
  locale: Locale,
  key: TranslationKey,
  params?: TranslationParams,
): string {
  const template = DICTIONARIES[locale][key] ?? uz[key] ?? key;
  return interpolate(template, params);
}

/** Modul darajasidagi til bo'yicha tarjima — React'dan tashqarida ishlatiladi. */
export function t(key: TranslationKey, params?: TranslationParams): string {
  return translate(currentLocale, key, params);
}
